export const isDevelop =
  window.location.hostname.includes('test') ||
  window.location.hostname.includes('localhost')
export const AUTH_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-auth'
  : 'https://asterx.kz/api-auth'
export const SEO_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-seo'
  : 'https://asterx.kz/api-seo'
export const CS_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-sale'
  : 'https://asterx.kz/api-sale'
export const CP_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-cp'
  : 'https://asterx.kz/api-cp'
export const CLIENT_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-client'
  : 'https://asterx.kz/api-client'
export const FB_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-fb'
  : 'https://asterx.kz/api-fb'
//export const FB_API_URL = "http://localhost:8091";
export const CSNEW_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-sale-new-auto'
  : 'https://asterx.kz/api-sale-new-auto'

export function isAdmin(token) {
  console.log(
    parseJwt(token).roleList.filter(
      role =>
        (role.code === 'ADMIN' ||
          role.code === 'MANAGER_ASTER' ||
          role.code === 'MANAGER_NEWCAR') &&
        role.project.code === 'FB'
    ).length > 0
  )
  return (
    parseJwt(token).roleList.filter(
      role =>
        (role.code === 'ADMIN' ||
          role.code === 'MANAGER_ASTER' ||
          role.code === 'MANAGER_NEWCAR') &&
        role.project.code === 'FB'
    ).length > 0
  )
}

export const getDigitGroupSeparator = number =>
  number !== undefined && number !== null
    ? `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    : ''

export function hasSeoRole(token) {
  console.log(
    parseJwt(token).roleList.filter(
      role =>
        (role.code === 'ADMIN' ||
          role.code === 'MANAGER_ASTER' ||
          role.code === 'MANAGER_NEWCAR') &&
        role.project.code === 'FB'
    ).length > 0
  )
  return (
    parseJwt(token).roleList.filter(
      role =>
        (role.code === 'ADMIN' ||
          role.code === 'MANAGER_ASTER' ||
          role.code === 'MANAGER_NEWCAR') &&
        role.project.code === 'FB'
    ).length > 0
  )
}

export function getDateOfBirthFromIIN(iin) {
  //1987-02-26
  let year = ''
  let century = iin.substr(6, 1)
  if (['1', '2'].includes(century)) {
    year = '18'
  } else if (['3', '4'].includes(century)) {
    year = '19'
  } else if (['5', '6'].includes(century)) {
    year = '20'
  }

  return (
    year + iin.substr(0, 2) + '-' + iin.substr(2, 2) + '-' + iin.substr(4, 2)
  )
}

export function parseJwt(token) {
  if (!token) {
    return null
  }
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
  return JSON.parse(jsonPayload)
}

export function getUserBranches(token) {
  let userRoles = parseJwt(token)
  let branches = []
  console.log(userRoles)
  for (let role of userRoles.roleList) {
    if (role.project.code === 'FB') {
      for (let branch of role.branchList) {
        if (branch === 'ALA_BESAGASH') {
          branches.push({
            branchCode: 'ALA_BESAGASH',
            branchName: 'Алматы (Бесагаш)'
          })
        } else if (branch === 'ALA_SUYUNBAI') {
          branches.push({
            branchCode: 'ALA_SUYUNBAI',
            branchName: 'Алматы (Суюнбая)'
          })
        } else if (branch === 'ALA_APORT') {
          branches.push({
            branchCode: 'ALA_APORT',
            branchName: 'Алматы (Апорт)'
          })
        } else if (branch === 'ASTANA') {
          branches.push({
            branchCode: 'ASTANA',
            branchName: 'Астана'
          })
        } else if (branch === 'AST_KAR') {
          branches.push({
            branchCode: 'AST_KAR',
            branchName: 'Астана Карагандинка'
          })
        } else if (branch === 'ASTANA_METRO') {
          branches.push({
            branchCode: 'ASTANA_METRO',
            branchName: 'Астана Метро'
          })
        } else if (branch === 'SHYMKENT') {
          branches.push({
            branchCode: 'SHYMKENT',
            branchName: 'Шымкент'
          })
        } else if (branch === 'KARAGANDA') {
          branches.push({
            branchCode: 'KARAGANDA',
            branchName: 'Караганда'
          })
        } else if (branch === 'KOSTANAY') {
          branches.push({
            branchCode: 'KOSTANAY',
            branchName: 'Костанай'
          })
        } else if (branch === 'PAVLODAR') {
          branches.push({
            branchCode: 'PAVLODAR',
            branchName: 'Павлодар'
          })
        } else if (branch === 'OSKEMEN') {
          branches.push({
            branchCode: 'OSKEMEN',
            branchName: 'Усть-Каменогорск'
          })
        } else if (branch === 'AKTAU') {
          branches.push({
            branchCode: 'AKTAU',
            branchName: 'Актау'
          })
        } else if (branch === 'AKTOBE') {
          branches.push({
            branchCode: 'AKTOBE',
            branchName: 'Актобе'
          })
        } else if (branch === 'ATYRAU') {
          branches.push({
            branchCode: 'ATYRAU',
            branchName: 'Атырау'
          })
        } else if (branch === 'KORDA') {
          branches.push({
            branchCode: 'KORDA',
            branchName: 'Кызылорда'
          })
        } else if (branch === 'KOKSHETAU') {
          branches.push({
            branchCode: 'KOKSHETAU',
            branchName: 'Кокшетау'
          })
        } else if (branch === 'PETROPAVL') {
          branches.push({
            branchCode: 'PETROPAVL',
            branchName: 'Петропавловск'
          })
        } else if (branch === 'EKIBASTUZ') {
          branches.push({
            branchCode: 'EKIBASTUZ',
            branchName: 'Екибастуз'
          })
        } else if (branch === 'SARYAGASH') {
          branches.push({
            branchCode: 'SARYAGASH',
            branchName: 'Сарыагаш'
          })
        } else if (branch === 'SEMEY') {
          branches.push({
            branchCode: 'SEMEY',
            branchName: 'Семей'
          })
        } else if (branch === 'URALSK') {
          branches.push({
            branchCode: 'URALSK',
            branchName: 'Уральск'
          })
        } else if (branch === 'TARAZ') {
          branches.push({
            branchCode: 'TARAZ',
            branchName: 'Тараз'
          })
        } else if (branch === 'URALSK') {
          branches.push({
            branchCode: 'URALSK',
            branchName: 'Уральск'
          })
        } else if (branch === 'TALDYKURGAN') {
          branches.push({
            branchCode: 'TALDYKURGAN',
            branchName: 'Талдыкорган'
          })
        } else if (branch === 'SHYMKENT_AIRPORT') {
          branches.push({
            branchCode: 'SHYMKENT_AIRPORT',
            branchName: 'Шымкент Аэропорт'
          })
        } else if (branch === 'KOSTANAY_ANNIVERSARY') {
          branches.push({
            branchCode: 'KOSTANAY_ANNIVERSARY',
            branchName: 'Костанай Юбилейный'
          })
        }
      }
      break
    }
  }
  return branches
}

export function getCompanyName(branchCode) {
  if (branchCode === 'ALA_BESAGASH') {
    return 'ТОО ASTER AUTO (АСТЭР АВТО)'
  } else if (branchCode === 'ALA_SUYUNBAI') {
    return 'ТОО ASTER AUTO (АСТЭР АВТО)'
  } else if (branchCode === 'ASTANA') {
    return 'ТОО "ASTER AUTO ASTANA (АСТЭР АВТО АСТАНА)'
  } else if (branchCode === 'ASTANA_GS') {
    return 'ТОО «Gold Star Motors»'
  } else if (branchCode === 'SHYMKENT') {
    return 'ТОО «ASTER AUTO Шымкент»'
  } else if (branchCode === 'KARAGANDA') {
    return 'ТОО "Караганда Авто 09"'
  } else if (branchCode === 'KOSTANAY') {
    return 'ТОО "ASTER AUTO ASTANA (АСТЭР АВТО АСТАНА)'
  } else if (branchCode === 'PAVLODAR') {
    return 'ТОО "Павлодар Автосупермаркет"'
  } else if (branchCode === 'OSKEMEN') {
    return 'ТОО «ASTER AUTO Усть-Каменогорск»'
  } else if (branchCode === 'AKTAU') {
    return 'ТОО «ASTER AUTO Актау»'
  } else if (branchCode === 'AKTOBE') {
    return 'ТОО "Актобе Автодрайв"'
  } else if (branchCode === 'ATYRAU') {
    return 'ТОО «ASTER AUTO Атырау»'
  } else if (branchCode === 'KORDA') {
    return 'ТОО «ASTER AUTO Шымкент»'
  } else if (branchCode === 'KOKSHETAU') {
    return 'ТОО "Кокшетау Автоцентр"'
  } else if (branchCode === 'PETROPAVL') {
    return 'ТОО "Петропавловск Автосити"'
  } else if (branchCode === 'EKIBASTUZ') {
    return 'ТОО "Павлодар Автосупермаркет"'
  } else if (branchCode === 'URALSK') {
    return 'ТОО "Уральск Авторегион"'
  } else {
    return null
  }
}

export const WARRANTIES = [
  { name: 'Расширенный пакет', price: 200000 }
  // { name: 'Полный пакет', price: 400000 }
]

export const TECHNICAL_SUPPORT = [
  { company: 'Litro', name: 'Premium', price: 70000 },
  { company: 'Litro', name: 'Full', price: 110000 },
  { company: 'Litro', name: 'Extra', price: 140000 },
  { company: 'Litro', name: 'Premium 2 года', price: 126000 },
  { company: 'Litro', name: 'Full 2 года', price: 198000 },
  { company: 'Litro', name: 'Extra 2 года', price: 252000 },
  { company: 'Litro', name: 'Premium 3 года', price: 168000 },
  { company: 'Litro', name: 'Full 3 года', price: 264000 },
  { company: 'Litro', name: 'Extra 3 года', price: 336000 }
]

export const BCC_PRODUCTS_CALC = [
  { name: '', code: '' },
  { name: 'Б.У.', code: false },
  { name: 'Новый', code: true }
]

export const SHF_PRODUCTS_CALC = [
  { name: '', code: '' },
  { name: 'Б.У.', code: false },
  { name: 'Новый', code: true }
]

export const EVRAZ_PRODUCTS_CALC = [
  { name: '', code: '' },
  { name: 'Продукт 5', code: true },
  { name: 'Продукт 6', code: false }
]

export const RGL_PRODUCTS_CALC = [
  { name: '', code: '' },
  { name: 'СС Basic', code: 0.031 }
]

export const COUNTRIES = [
  { countryName: 'Австралия' },
  { countryName: 'Австрия' },
  { countryName: 'Азербайджан' },
  { countryName: 'Албания' },
  { countryName: 'Алжир' },
  { countryName: 'Ангола' },
  { countryName: 'Андорра' },
  { countryName: 'Антигуа и Барбуда' },
  { countryName: 'Аргентина' },
  { countryName: 'Армения' },
  { countryName: 'Афганистан' },
  { countryName: 'Багамские Острова' },
  { countryName: 'Бангладеш' },
  { countryName: 'Барбадос' },
  { countryName: 'Бахрейн' },
  { countryName: 'Белоруссия' },
  { countryName: 'Белиз' },
  { countryName: 'Бельгия' },
  { countryName: 'Бенин' },
  { countryName: 'Болгария' },
  { countryName: 'Боливия' },
  { countryName: 'Босния и Герцеговина' },
  { countryName: 'Ботсвана' },
  { countryName: 'Бразилия' },
  { countryName: 'Бруней' },
  { countryName: 'Буркина-Фасо' },
  { countryName: 'Бурунди' },
  { countryName: 'Бутан' },
  { countryName: 'Вануату' },
  { countryName: 'Великобритания' },
  { countryName: 'Венгрия' },
  { countryName: 'Венесуэла' },
  { countryName: 'Восточный Тимор' },
  { countryName: 'Вьетнам' },
  { countryName: 'Габон' },
  { countryName: 'Гаити' },
  { countryName: 'Гайана' },
  { countryName: 'Гамбия' },
  { countryName: 'Гана' },
  { countryName: 'Гватемала' },
  { countryName: 'Гвинея' },
  { countryName: 'Гвинея-Бисау' },
  { countryName: 'Германия' },
  { countryName: 'Гондурас' },
  { countryName: 'Гренада' },
  { countryName: 'Греция' },
  { countryName: 'Грузия' },
  { countryName: 'Дания' },
  { countryName: 'Джибути' },
  { countryName: 'Доминика' },
  { countryName: 'Доминиканская Республика' },
  { countryName: 'Египет' },
  { countryName: 'Замбия' },
  { countryName: 'Зимбабве' },
  { countryName: 'Израиль' },
  { countryName: 'Индия' },
  { countryName: 'Индонезия' },
  { countryName: 'Иордания' },
  { countryName: 'Ирак' },
  { countryName: 'Иран' },
  { countryName: 'Ирландия' },
  { countryName: 'Исландия' },
  { countryName: 'Испания' },
  { countryName: 'Италия' },
  { countryName: 'Йемен' },
  { countryName: 'Кабо-Верде' },
  { countryName: 'Казахстан' },
  { countryName: 'Камбоджа' },
  { countryName: 'Камерун' },
  { countryName: 'Канада' },
  { countryName: 'Катар' },
  { countryName: 'Кения' },
  { countryName: 'Кипр' },
  { countryName: 'Киргизия' },
  { countryName: 'Кирибати' },
  { countryName: 'Китай' },
  { countryName: 'Колумбия' },
  { countryName: 'Коморы' },
  { countryName: 'Республика Конго' },
  { countryName: 'Демократическая Республика Конго' },
  { countryName: 'КНДР' },
  { countryName: 'Республика Корея' },
  { countryName: 'Коста-Рика' },
  { countryName: 'Кот-д’Ивуар' },
  { countryName: 'Куба' },
  { countryName: 'Кувейт' },
  { countryName: 'Лаос' },
  { countryName: 'Латвия' },
  { countryName: 'Лесото' },
  { countryName: 'Либерия' },
  { countryName: 'Ливан' },
  { countryName: 'Ливия' },
  { countryName: 'Литва' },
  { countryName: 'Лихтенштейн' },
  { countryName: 'Люксембург' },
  { countryName: 'Маврикий' },
  { countryName: 'Мавритания' },
  { countryName: 'Мадагаскар' },
  { countryName: 'Малави' },
  { countryName: 'Малайзия' },
  { countryName: 'Мали' },
  { countryName: 'Мальдивы' },
  { countryName: 'Мальта' },
  { countryName: 'Марокко' },
  { countryName: 'Маршалловы Острова' },
  { countryName: 'Мексика' },
  { countryName: 'Мозамбик' },
  { countryName: 'Молдавия' },
  { countryName: 'Монако' },
  { countryName: 'Монголия' },
  { countryName: 'Мьянма' },
  { countryName: 'Намибия' },
  { countryName: 'Науру' },
  { countryName: 'Непал' },
  { countryName: 'Нигер' },
  { countryName: 'Нигерия' },
  { countryName: 'Нидерланды' },
  { countryName: 'Никарагуа' },
  { countryName: 'Новая Зеландия' },
  { countryName: 'Норвегия' },
  { countryName: 'ОАЭ' },
  { countryName: 'Оман' },
  { countryName: 'Пакистан' },
  { countryName: 'Палау' },
  { countryName: 'Панама' },
  { countryName: 'Папуа — Новая Гвинея' },
  { countryName: 'Парагвай' },
  { countryName: 'Перу' },
  { countryName: 'Польша' },
  { countryName: 'Португалия' },
  { countryName: 'Россия' },
  { countryName: 'Руанда' },
  { countryName: 'Румыния' },
  { countryName: 'Сальвадор' },
  { countryName: 'Самоа' },
  { countryName: 'Сан-Марино' },
  { countryName: 'Сан-Томе и Принсипи' },
  { countryName: 'Саудовская Аравия' },
  { countryName: 'Северная Македония' },
  { countryName: 'Сейшельские Острова' },
  { countryName: 'Сенегал' },
  { countryName: 'Сент-Винсент и Гренадины' },
  { countryName: 'Сент-Китс и Невис' },
  { countryName: 'Сент-Люсия' },
  { countryName: 'Сербия' },
  { countryName: 'Сингапур' },
  { countryName: 'Сирия' },
  { countryName: 'Словакия' },
  { countryName: 'Словения' },
  { countryName: 'США' },
  { countryName: 'Соломоновы Острова' },
  { countryName: 'Сомали' },
  { countryName: 'Судан' },
  { countryName: 'Суринам' },
  { countryName: 'Сьерра-Леоне' },
  { countryName: 'Таджикистан' },
  { countryName: 'Таиланд' },
  { countryName: 'Танзания' },
  { countryName: 'Того' },
  { countryName: 'Тонга' },
  { countryName: 'Тринидад и Тобаго' },
  { countryName: 'Тувалу' },
  { countryName: 'Тунис' },
  { countryName: 'Туркмения' },
  { countryName: 'Турция' },
  { countryName: 'Уганда' },
  { countryName: 'Узбекистан' },
  { countryName: 'Украина' },
  { countryName: 'Уругвай' },
  { countryName: 'Федеративные Штаты Микронезии' },
  { countryName: 'Фиджи' },
  { countryName: 'Филиппины' },
  { countryName: 'Финляндия' },
  { countryName: 'Франция' },
  { countryName: 'Хорватия' },
  { countryName: 'Центральноафриканская Республика' },
  { countryName: 'Чад' },
  { countryName: 'Черногория' },
  { countryName: 'Чехия' },
  { countryName: 'Чили' },
  { countryName: 'Швейцария' },
  { countryName: 'Швеция' },
  { countryName: 'Шри-Ланка' },
  { countryName: 'Эквадор' },
  { countryName: 'Экваториальная Гвинея' },
  { countryName: 'Эритрея' },
  { countryName: 'Эсватини' },
  { countryName: 'Эстония' },
  { countryName: 'Эфиопия' },
  { countryName: 'ЮАР' },
  { countryName: 'Южный Судан' },
  { countryName: 'Ямайка' },
  { countryName: 'Япония' }
]

export const EMPLOYER_ACTIVITY = [
  {
    name: 'ВОДОСНАБЖЕНИЕ; КАНАЛИЗАЦИОННАЯ СИСТЕМА, КОНТРОЛЬ НАД СБОРОМ И РАСПРЕДЕЛЕНИЕМ ОТХОДОВ'
  },
  { name: 'ГОРНОДОБЫВАЮЩАЯ ПРОМЫШЛЕННОСТЬ И РАЗРАБОТКА КАРЬЕРОВ' },
  {
    name: 'ГОСУДАРСТВЕННОЕ УПРАВЛЕНИЕ И ОБОРОНА; ОБЯЗАТЕЛЬНОЕ СОЦИАЛЬНОЕ ОБЕСПЕЧЕНИЕ'
  },
  {
    name: 'ДЕЯТЕЛЬНОСТЬ В ОБЛАСТИ АДМИНИСТРАТИВНОГО И ВСПОМОГАТЕЛЬНОГО ОБСЛУЖИВАНИЯ'
  },
  {
    name: 'ДЕЯТЕЛЬНОСТЬ ДОМАШНИХ ХОЗЯЙСТВ, НАНИМАЮЩИХ ДОМАШНЮЮ ПРИСЛУГУ И ПРОИЗВОДЯЩИХ ТОВАРЫ И УСЛУГИ ДЛЯ СОБСТВЕННОГО ПОТРЕБЛЕНИЯ'
  },
  { name: 'ДЕЯТЕЛЬНОСТЬ ЭКСТЕРРИТОРИАЛЬНЫХ ОРГАНИЗАЦИЙ И ОРГАНОВ' },
  { name: 'ЗДРАВООХРАНЕНИЕ И СОЦИАЛЬНЫЕ УСЛУГИ' },
  { name: 'ИНФОРМАЦИЯ И СВЯЗЬ' },
  { name: 'ИСКУССТВО, РАЗВЛЕЧЕНИЯ И ОТДЫХ' },
  { name: 'ОБРАБАТЫВАЮЩАЯ ПРОМЫШЛЕННОСТЬ' },
  { name: 'ОБРАЗОВАНИЕ' },
  { name: 'ОПЕРАЦИИ С НЕДВИЖИМЫМ ИМУЩЕСТВОМ' },
  { name: 'ОПТОВАЯ И РОЗНИЧНАЯ ТОРГОВЛЯ; РЕМОНТ АВТОМОБИЛЕЙ И МОТОЦИКЛОВ' },
  { name: 'ПРЕДОСТАВЛЕНИЕ ПРОЧИХ ВИДОВ УСЛУГ' },
  { name: 'ПРОФЕССИОНАЛЬНАЯ, НАУЧНАЯ И ТЕХНИЧЕСКАЯ ДЕЯТЕЛЬНОСТЬ' },
  { name: 'СЕЛЬСКОЕ, ЛЕСНОЕ И РЫБНОЕ ХОЗЯЙСТВО' },
  { name: 'СТРОИТЕЛЬСТВО' },
  { name: 'ТРАНСПОРТ И СКЛАДИРОВАНИЕ' },
  { name: 'УСЛУГИ ПО ПРОЖИВАНИЮ И ПИТАНИЮ' },
  { name: 'ФИНАНСОВАЯ И СТРАХОВАЯ ДЕЯТЕЛЬНОСТЬ' },
  { name: 'ЭЛЕКТРОСНАБЖЕНИЕ, ПОДАЧА ГАЗА, ПАРА И ВОЗДУШНОЕ КОНДИЦИОНИРОВАНИЕ' },
  { name: 'ВОЕННОСЛУЖАЩИЙ/ПРАВООХРАНИТЕЛЬНЫЕ ОРГАНЫ' }
]

export const TOWNS = [
  { code: '1100', name: 'с.Косшы', regionCode: '11', districtCode: '66' },
  {
    code: '113441600',
    name: 'ст.Разъезд 42',
    regionCode: '11',
    districtCode: '34'
  },
  {
    code: '113453100',
    name: 'ст.Сарыоба',
    regionCode: '11',
    districtCode: '34'
  },
  {
    code: '116659100',
    name: 'с.Жанаесиль (Новоишимка)',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '116649200', name: 'с.Бирлик', regionCode: '11', districtCode: '66' },
  { code: '116645800', name: 'с.Шубары', regionCode: '11', districtCode: '66' },
  {
    code: '116672500',
    name: 'с.Разъезд 96',
    regionCode: '11',
    districtCode: '66'
  },
  {
    code: '116842100',
    name: 'п.Научный',
    regionCode: '11',
    districtCode: '68'
  },
  {
    code: '116855300',
    name: 'с.Гуляй поле',
    regionCode: '11',
    districtCode: '68'
  },
  {
    code: '116855500',
    name: 'с.Новографское',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '20100', name: 'г.Державинск', regionCode: '11', districtCode: '54' },
  {
    code: '114020100',
    name: 'г.Макинск',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '39100', name: 'а.Азат', regionCode: '11', districtCode: '32' },
  { code: '41100', name: 'а.Кына', regionCode: '11', districtCode: '32' },
  { code: '41200', name: 'а.Карасай', regionCode: '11', districtCode: '32' },
  { code: '41300', name: 'с.Минское', regionCode: '11', districtCode: '32' },
  { code: '43100', name: 'а.Домбыралы', regionCode: '11', districtCode: '32' },
  { code: '43200', name: 'с.Кенес', regionCode: '11', districtCode: '32' },
  {
    code: '43300',
    name: 'с.Красный Горняк',
    regionCode: '11',
    districtCode: '32'
  },
  {
    code: '43400',
    name: 'с.Малый Барап',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '47100', name: 'с.Hаумовка', regionCode: '11', districtCode: '32' },
  {
    code: '47200',
    name: 'с.Виноградовка',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '47300', name: 'с.Орнек', regionCode: '11', districtCode: '32' },
  { code: '47400', name: 'с.Филипповка', regionCode: '11', districtCode: '32' },
  {
    code: '49100',
    name: 'с.Hоворыбинка',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '49200', name: 'с.Кара-Озек', regionCode: '11', districtCode: '32' },
  { code: '49300', name: 'с.Курылыс', regionCode: '11', districtCode: '32' },
  {
    code: '51100',
    name: 'а.Жалгызкарагай',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '51200', name: 'а.Кайнар', regionCode: '11', districtCode: '32' },
  { code: '51300', name: 'а.Тастыадыр', regionCode: '11', districtCode: '32' },
  { code: '53100', name: 'с.Енбек', regionCode: '11', districtCode: '32' },
  { code: '53300', name: 'с.Кирово', regionCode: '11', districtCode: '32' },
  { code: '53400', name: 'с.Подлесное', regionCode: '11', districtCode: '32' },
  { code: '55100', name: 'с.Урюпинка', regionCode: '11', districtCode: '32' },
  { code: '55200', name: 'с.Амангельды', regionCode: '11', districtCode: '32' },
  { code: '55500', name: 'с.Ерофеевка', regionCode: '11', districtCode: '32' },
  { code: '55600', name: 'а.Талкара', regionCode: '11', districtCode: '32' },
  {
    code: '55700',
    name: 'с.Малоалександровка',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '57100', name: 'с.Кырыккудык', regionCode: '11', districtCode: '32' },
  { code: '30100', name: 'п.Аршалы', regionCode: '11', districtCode: '34' },
  { code: '31100', name: 'а.Акбулак', regionCode: '11', districtCode: '34' },
  { code: '31180', name: 'с.Актасты', regionCode: '11', districtCode: '34' },
  { code: '33100', name: 'а.Жибек жолы', regionCode: '11', districtCode: '34' },
  { code: '33200', name: 'а.Жалтырколь', regionCode: '11', districtCode: '34' },
  { code: '33300', name: 'рзд.41', regionCode: '11', districtCode: '34' },
  { code: '33400', name: 'рзд.102', regionCode: '11', districtCode: '34' },
  { code: '35100', name: 'ст.Анар', regionCode: '11', districtCode: '34' },
  { code: '35500', name: 'с.Донецкое', regionCode: '11', districtCode: '34' },
  { code: '37100', name: 'а.Берсуат', regionCode: '11', districtCode: '34' },
  { code: '37200', name: 'с.Байдала', regionCode: '11', districtCode: '34' },
  {
    code: '41100',
    name: 'с.Волгодоновка',
    regionCode: '11',
    districtCode: '34'
  },
  { code: '41300', name: 'с.Береке', regionCode: '11', districtCode: '34' },
  { code: '41500', name: 'с.Койгельды', regionCode: '11', districtCode: '34' },
  { code: '41600', name: 'рзд.42', regionCode: '11', districtCode: '34' },
  { code: '42100', name: 'а.Арнасай', regionCode: '11', districtCode: '34' },
  { code: '42200', name: 'ст.Бабатай', regionCode: '11', districtCode: '34' },
  { code: '43200', name: 'ст.Шоптиколь', regionCode: '11', districtCode: '34' },
  {
    code: '45100',
    name: 'с.Константиновка',
    regionCode: '11',
    districtCode: '34'
  },
  { code: '45200', name: 'с.Белоярка', regionCode: '11', districtCode: '34' },
  { code: '45400', name: 'с.Шортанды', regionCode: '11', districtCode: '34' },
  { code: '4', name: 'с.Красный Яр', regionCode: '11', districtCode: '11' },
  { code: '5', name: 'п.Станционный', regionCode: '11', districtCode: '11' },
  { code: '6', name: 'с.Карабулак', regionCode: '11', districtCode: '11' },
  { code: '7', name: 'с.Коксал', regionCode: '11', districtCode: '11' },
  { code: '8', name: 'с.Первомайка', regionCode: '11', districtCode: '11' },
  { code: '9', name: 'п.Шантобе', regionCode: '11', districtCode: '11' },
  {
    code: '10',
    name: 'с.Новокронштадка',
    regionCode: '11',
    districtCode: '11'
  },
  { code: '11', name: 'с.Степногорское', regionCode: '11', districtCode: '11' },
  { code: '20100', name: 'г.Атбасар', regionCode: '11', districtCode: '38' },
  {
    code: '2500',
    name: 'с.Ыбырай Алтынсарин',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '100', name: 'с.Акмол', regionCode: '11', districtCode: '66' },
  { code: '116665500', name: 'с.Нура', regionCode: '11', districtCode: '66' },
  { code: '20100', name: 'Ерейментау', regionCode: '11', districtCode: '46' },
  { code: '20100', name: 'Есиль', regionCode: '11', districtCode: '48' },
  { code: '49100', name: 'с.Лесное', regionCode: '11', districtCode: '64' },
  { code: '43100', name: 'с.Ижевское', regionCode: '11', districtCode: '34' },
  { code: '40100', name: 'с.Кенашы', regionCode: '11', districtCode: '45' },
  { code: '40500', name: 'с.Карасор', regionCode: '11', districtCode: '45' },
  {
    code: '41100',
    name: 'с.Краснофлотское',
    regionCode: '11',
    districtCode: '45'
  },
  { code: '43100', name: 'с.Макинка', regionCode: '11', districtCode: '45' },
  { code: '43200', name: 'с.Буланды', regionCode: '11', districtCode: '45' },
  { code: '43380', name: 'с.Каратал', regionCode: '11', districtCode: '45' },
  { code: '43400', name: 'с.Когам', regionCode: '11', districtCode: '45' },
  { code: '43500', name: 'с.Макпал', regionCode: '11', districtCode: '45' },
  { code: '43600', name: 'а.Карагай', regionCode: '11', districtCode: '45' },
  { code: '44100', name: 'с.Мамай', regionCode: '11', districtCode: '45' },
  { code: '45100', name: 'с.Валиханово', regionCode: '11', districtCode: '45' },
  { code: '45300', name: 'с.Алга', regionCode: '11', districtCode: '45' },
  { code: '45680', name: 'с.Кудабас', regionCode: '11', districtCode: '45' },
  { code: '47100', name: 'а.Ульги', regionCode: '11', districtCode: '45' },
  { code: '47200', name: 'с.Жукей', regionCode: '11', districtCode: '45' },
  { code: '47300', name: 'с.Карловка', regionCode: '11', districtCode: '45' },
  { code: '47500', name: 'с.Кызылуюм', regionCode: '11', districtCode: '45' },
  { code: '47700', name: 'с.Трамбовка', regionCode: '11', districtCode: '45' },
  { code: '47800', name: 'с.Уюмшил', regionCode: '11', districtCode: '45' },
  { code: '33100', name: 'а.Акмырза', regionCode: '11', districtCode: '46' },
  { code: '33300', name: 'с.Жолбасшы', regionCode: '11', districtCode: '46' },
  { code: '35100', name: 'а.Бестогай', regionCode: '11', districtCode: '46' },
  { code: '35200', name: 'с.Байсары', regionCode: '11', districtCode: '46' },
  { code: '35400', name: 'с.Кызылту', regionCode: '11', districtCode: '46' },
  {
    code: '37100',
    name: 'а.Олжабай батыра',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '37200', name: 'с.Алгабас', regionCode: '11', districtCode: '46' },
  {
    code: '37400',
    name: 'с.Hовокаменка',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '39100', name: 'с.Бозтал', regionCode: '11', districtCode: '46' },
  { code: '41100', name: 'а.Тайбай', regionCode: '11', districtCode: '46' },
  { code: '41200', name: 'с.Ельтай', regionCode: '11', districtCode: '46' },
  { code: '41300', name: 'с.Жарык', regionCode: '11', districtCode: '46' },
  { code: '41400', name: 'с.Малтабар', regionCode: '11', districtCode: '46' },
  { code: '43100', name: 'с.Изобильное', regionCode: '11', districtCode: '46' },
  { code: '45100', name: 'а.Куншалган', regionCode: '11', districtCode: '46' },
  { code: '45200', name: 'с.Каратал', regionCode: '11', districtCode: '46' },
  { code: '45300', name: 'с.Шакей', regionCode: '11', districtCode: '46' },
  { code: '46100', name: 'с.Койтас', regionCode: '11', districtCode: '46' },
  { code: '46200', name: 'с.Ажы', regionCode: '11', districtCode: '46' },
  { code: '47100', name: 'аул Аксуат', regionCode: '11', districtCode: '46' },
  {
    code: '51100',
    name: 'с.Hовомарковка',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '53100', name: 'с.Уленты', regionCode: '11', districtCode: '46' },
  {
    code: '53500',
    name: 'ст.Коржинколь',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '53700', name: 'ст.Уленты', regionCode: '11', districtCode: '46' },
  {
    code: '55100',
    name: 'аул Еркиншилик',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '55200', name: 'с.Веренка', regionCode: '11', districtCode: '46' },
  { code: '55300', name: 'с.Енбек', regionCode: '11', districtCode: '46' },
  {
    code: '57100',
    name: 'с.Селетинское',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '59100', name: 'с.Тургай', regionCode: '11', districtCode: '46' },
  { code: '59180', name: 'с.Жанажол', regionCode: '11', districtCode: '46' },
  {
    code: '59200',
    name: 'с.Hижний Торгай',
    regionCode: '11',
    districtCode: '46'
  },
  { code: '59300', name: 'а. Балыкты', regionCode: '11', districtCode: '46' },
  { code: '59400', name: 'а.Карагайлы', regionCode: '11', districtCode: '46' },
  { code: '59500', name: 'ст.Тургай', regionCode: '11', districtCode: '46' },
  { code: '33100', name: 'с.Аксай', regionCode: '11', districtCode: '48' },
  { code: '37100', name: 'с.Бузулук', regionCode: '11', districtCode: '48' },
  { code: '37300', name: 'с.Сурган', regionCode: '11', districtCode: '48' },
  { code: '10100', name: 'г.Кокшетау', regionCode: '11', districtCode: '1' },
  { code: '18100', name: 'г.Степногорск', regionCode: '11', districtCode: '2' },
  { code: '20100', name: 'г.Акколь', regionCode: '11', districtCode: '32' },
  {
    code: '20200',
    name: 'лесхоз Алексеевский',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '20300', name: 'с.Ерназар', regionCode: '11', districtCode: '32' },
  { code: '20400', name: 'с.Радовка', regionCode: '11', districtCode: '32' },
  {
    code: '35100',
    name: 'с.Степногорское',
    regionCode: '11',
    districtCode: '32'
  },
  { code: '35300', name: 'с.Богембай', regionCode: '11', districtCode: '32' },
  { code: '57500', name: 'с.Сосновка', regionCode: '11', districtCode: '70' },
  {
    code: '59100',
    name: 'а.Hаурызбай батыра',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '61100', name: 'с.Урумкай', regionCode: '11', districtCode: '70' },
  { code: '61200', name: 'с.Дмитриевка', regionCode: '11', districtCode: '70' },
  { code: '61300', name: 'с.Корнекты', regionCode: '11', districtCode: '70' },
  {
    code: '61400',
    name: 'с.Красный Кордон',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '61500', name: 'с.Кульстан', regionCode: '11', districtCode: '70' },
  {
    code: '61600',
    name: 'с.Киндиккарагай',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '61700', name: 'с.Карашилик', regionCode: '11', districtCode: '70' },
  { code: '61900', name: 'с.Ынталы', regionCode: '11', districtCode: '70' },
  {
    code: '63100',
    name: 'с.Успено-юрьевка',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '63300', name: 'с.Карагай', regionCode: '11', districtCode: '70' },
  { code: '63380', name: 'с.Клинцы', regionCode: '11', districtCode: '70' },
  { code: '63580', name: 'с.Hиколаевка', regionCode: '11', districtCode: '70' },
  { code: '63600', name: 'с.Улге-алган', regionCode: '11', districtCode: '70' },
  { code: '63800', name: 'с.Райгородок', regionCode: '11', districtCode: '70' },
  { code: '43700', name: 'с.Суворовка', regionCode: '11', districtCode: '40' },
  { code: '45100', name: 'с.Hикольское', regionCode: '11', districtCode: '40' },
  { code: '45200', name: 'с.Улытоган', regionCode: '11', districtCode: '40' },
  {
    code: '47100',
    name: 'с.Hовобратское',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '47200', name: 'с.Буденновка', regionCode: '11', districtCode: '40' },
  {
    code: '47300',
    name: 'с.Добровольное',
    regionCode: '11',
    districtCode: '40'
  },
  {
    code: '47400',
    name: 'с.Красносельское',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '51100', name: 'а.Айнаколь', regionCode: '11', districtCode: '40' },
  {
    code: '51500',
    name: 'с.Острогорское',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '53100', name: 'с.Партизанка', regionCode: '11', districtCode: '40' },
  { code: '53300', name: 'с.Ортакшыл', regionCode: '11', districtCode: '40' },
  { code: '55100', name: 'а.Караозек', regionCode: '11', districtCode: '40' },
  {
    code: '55300',
    name: 'с.Еруслановка',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '55600', name: 'с.Купчановка', regionCode: '11', districtCode: '40' },
  { code: '55700', name: 'а.Байсуат', regionCode: '11', districtCode: '40' },
  { code: '30100', name: 'с.Егиндыколь', regionCode: '11', districtCode: '44' },
  { code: '33100', name: 'с.Абай', regionCode: '11', districtCode: '44' },
  { code: '35100', name: 'с.Полтавское', regionCode: '11', districtCode: '44' },
  { code: '35200', name: 'с.Коркем', regionCode: '11', districtCode: '44' },
  {
    code: '37100',
    name: 'с.Спиридоновка',
    regionCode: '11',
    districtCode: '44'
  },
  { code: '39100', name: 'с.Бауманское', regionCode: '11', districtCode: '44' },
  {
    code: '41100',
    name: 'с.Буревестник',
    regionCode: '11',
    districtCode: '44'
  },
  {
    code: '45100',
    name: 'с.Жалманкулак',
    regionCode: '11',
    districtCode: '44'
  },
  { code: '45200', name: 'с.Жулдыз', regionCode: '11', districtCode: '44' },
  { code: '45300', name: 'с.Коныртубек', regionCode: '11', districtCode: '44' },
  { code: '46100', name: 'с.Коржинколь', regionCode: '11', districtCode: '44' },
  {
    code: '47100',
    name: 'с.Узункольское',
    regionCode: '11',
    districtCode: '44'
  },
  { code: '47200', name: 'аул Тоганас', regionCode: '11', districtCode: '44' },
  { code: '20100', name: 'г.Степняк', regionCode: '11', districtCode: '45' },
  { code: '20600', name: 'с.Пригорхоз', regionCode: '11', districtCode: '45' },
  { code: '31100', name: 'а.Аксу', regionCode: '11', districtCode: '45' },
  { code: '31600', name: 'с.Сапак', regionCode: '11', districtCode: '45' },
  {
    code: '32100',
    name: 'а.Ангал батыра',
    regionCode: '11',
    districtCode: '45'
  },
  { code: '32300', name: 'с.Жаналык', regionCode: '11', districtCode: '45' },
  { code: '33100', name: 'с.Бирсуат', regionCode: '11', districtCode: '45' },
  { code: '33500', name: 'с.Сауле', regionCode: '11', districtCode: '45' },
  { code: '34100', name: 'с.Баймырза', regionCode: '11', districtCode: '45' },
  { code: '34500', name: 'с.Шошкалы', regionCode: '11', districtCode: '45' },
  {
    code: '35100',
    name: 'а.Андыкожа батыра',
    regionCode: '11',
    districtCode: '45'
  },
  { code: '35500', name: 'с.Hевское', regionCode: '11', districtCode: '45' },
  {
    code: '37100',
    name: 'с.Енбекшильдерское',
    regionCode: '11',
    districtCode: '45'
  },
  { code: '37300', name: 'с.Атансор', regionCode: '11', districtCode: '45' },
  { code: '37600', name: 'а.Акбулак', regionCode: '11', districtCode: '45' },
  { code: '37800', name: 'а.Актас', regionCode: '11', districtCode: '45' },
  { code: '38100', name: 'с.Заозерное', regionCode: '11', districtCode: '45' },
  { code: '39100', name: 'с.Заураловка', regionCode: '11', districtCode: '45' },
  { code: '39400', name: 'с.Кудукагаш', regionCode: '11', districtCode: '45' },
  { code: '39600', name: 'с.Яблоновка', regionCode: '11', districtCode: '45' },
  { code: '35600', name: 'с.Степное', regionCode: '11', districtCode: '68' },
  { code: '37100', name: 'аул Бозайгыр', regionCode: '11', districtCode: '68' },
  { code: '37200', name: 'с.Ключи', regionCode: '11', districtCode: '68' },
  { code: '37500', name: 'ст.Тонкерис', regionCode: '11', districtCode: '68' },
  { code: '39100', name: 'п.Жолымбет', regionCode: '11', districtCode: '68' },
  { code: '41100', name: 'с.Бектау', regionCode: '11', districtCode: '68' },
  {
    code: '41200',
    name: 'аул Мыктыколь',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '41400', name: 'с.Конкрынка', regionCode: '11', districtCode: '68' },
  { code: '41500', name: 'с.Каражар', regionCode: '11', districtCode: '68' },
  { code: '42100', name: 'п.Hаучный', regionCode: '11', districtCode: '68' },
  {
    code: '43100',
    name: 'с.Hовокубанка',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '43200', name: 'с.Алтайское', regionCode: '11', districtCode: '68' },
  {
    code: '45100',
    name: 'с.Hовоселовка',
    regionCode: '11',
    districtCode: '68'
  },
  {
    code: '45400',
    name: 'с.Каратобинское',
    regionCode: '11',
    districtCode: '68'
  },
  {
    code: '45500',
    name: 'с.Hовопервомайское',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '45600', name: 'с.Ошак', regionCode: '11', districtCode: '68' },
  { code: '47100', name: 'с.Петровка', regionCode: '11', districtCode: '68' },
  {
    code: '47200',
    name: 'с.Белое Озеро',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '47500', name: 'ст.Караадыр', regionCode: '11', districtCode: '68' },
  {
    code: '49100',
    name: 'с.Пригородное',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '49400', name: 'с.Камышенка', regionCode: '11', districtCode: '68' },
  { code: '55100', name: 'с.Раевка', regionCode: '11', districtCode: '68' },
  { code: '55300', name: 'с.Гуляйполе', regionCode: '11', districtCode: '68' },
  { code: '55400', name: 'с.Егемен', regionCode: '11', districtCode: '68' },
  {
    code: '55500',
    name: 'с.Hовографское',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '20100', name: 'г.Щучинск', regionCode: '11', districtCode: '70' },
  { code: '33100', name: 'с.Кызылагаш', regionCode: '11', districtCode: '70' },
  { code: '33300', name: 'с.Акылбай', regionCode: '11', districtCode: '70' },
  { code: '33500', name: 'с.Мезгильсор', regionCode: '11', districtCode: '70' },
  {
    code: '33600',
    name: 'с.Hовый Карабаур',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '33800', name: 'с.Озерное', regionCode: '11', districtCode: '70' },
  { code: '35100', name: 'п.Бурабай', regionCode: '11', districtCode: '70' },
  { code: '35300', name: 'с.Окжетпес', regionCode: '11', districtCode: '70' },
  {
    code: '35500',
    name: 'аул Сарыбулак',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '37100', name: 'с.Веденовка', regionCode: '11', districtCode: '70' },
  { code: '37200', name: 'с.Жанатуган', regionCode: '11', districtCode: '70' },
  { code: '37400', name: 'с.Карабулак', regionCode: '11', districtCode: '70' },
  { code: '37700', name: 'с.Федосеевка', regionCode: '11', districtCode: '70' },
  {
    code: '49100',
    name: 'с.Зеленый Бор',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '49180', name: 'с.Жанаталап', regionCode: '11', districtCode: '70' },
  { code: '49200', name: 'с.Молбаза', regionCode: '11', districtCode: '70' },
  { code: '49500', name: 'с.Кумызынай', regionCode: '11', districtCode: '70' },
  { code: '49600', name: 'с.Мадениет', regionCode: '11', districtCode: '70' },
  { code: '51100', name: 'с.Златополье', regionCode: '11', districtCode: '70' },
  {
    code: '51200',
    name: 'с.Лесной Хутор',
    regionCode: '11',
    districtCode: '70'
  },
  {
    code: '51300',
    name: 'с.Hовоандреевка',
    regionCode: '11',
    districtCode: '70'
  },
  {
    code: '51400',
    name: 'с.Первомайское',
    regionCode: '11',
    districtCode: '70'
  },
  { code: '51500', name: 'с.Савинка', regionCode: '11', districtCode: '70' },
  { code: '51600', name: 'с.Сотниковка', regionCode: '11', districtCode: '70' },
  { code: '51700', name: 'с.Тулькули', regionCode: '11', districtCode: '70' },
  { code: '53100', name: 'а.Кенесары', regionCode: '11', districtCode: '70' },
  { code: '53200', name: 'с.Брусиловка', regionCode: '11', districtCode: '70' },
  { code: '53300', name: 'а. Баянбай', regionCode: '11', districtCode: '70' },
  { code: '53400', name: 'рзд.17', regionCode: '11', districtCode: '70' },
  { code: '53500', name: 'рзд.19', regionCode: '11', districtCode: '70' },
  { code: '55100', name: 'с.Атамекен', regionCode: '11', districtCode: '70' },
  { code: '55200', name: 'с.Жанажол', regionCode: '11', districtCode: '70' },
  { code: '55300', name: 'с.Жаркайын', regionCode: '11', districtCode: '70' },
  { code: '55400', name: 'с.Жасыл', regionCode: '11', districtCode: '70' },
  { code: '55800', name: 'с.Каражар', regionCode: '11', districtCode: '70' },
  { code: '55900', name: 'с.Шиели', regionCode: '11', districtCode: '70' },
  { code: '57100', name: 'с.Катарколь', regionCode: '11', districtCode: '70' },
  { code: '57200', name: 'с.Вишневое', regionCode: '11', districtCode: '70' },
  { code: '57300', name: 'с.Ключевое', regionCode: '11', districtCode: '70' },
  { code: '53400', name: 'с.Мысок', regionCode: '11', districtCode: '64' },
  { code: '53500', name: 'с.Смольное', regionCode: '11', districtCode: '64' },
  { code: '55100', name: 'с.Сандыктау', regionCode: '11', districtCode: '64' },
  {
    code: '55200',
    name: 'с.Hоворомановка',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '57100', name: 'с.Хлебное', regionCode: '11', districtCode: '64' },
  { code: '59100', name: 'с.Богородка', regionCode: '11', districtCode: '64' },
  { code: '59300', name: 'с.Дорогинка', regionCode: '11', districtCode: '64' },
  { code: '30100', name: 'а.Акмол', regionCode: '11', districtCode: '66' },
  { code: '30300', name: 'с.Отемис', regionCode: '11', districtCode: '66' },
  {
    code: '37100',
    name: 'с.Воздвиженка',
    regionCode: '11',
    districtCode: '66'
  },
  {
    code: '37300',
    name: 'а.Жана Жайнак',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '37500', name: 'с.Раздольное', regionCode: '11', districtCode: '66' },
  { code: '45100', name: 'с.Коянды', regionCode: '11', districtCode: '66' },
  {
    code: '45400',
    name: 'с.Малотимофеевка',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '45800', name: 'с.Шубар', regionCode: '11', districtCode: '66' },
  {
    code: '47100',
    name: 'с.Жангызкудук',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '47200', name: 'с.Красноярка', regionCode: '11', districtCode: '66' },
  {
    code: '48100',
    name: 'аул Караоткель',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '48400', name: 'с.Жанажол', regionCode: '11', districtCode: '66' },
  { code: '48700', name: 'с.Каражар', regionCode: '11', districtCode: '66' },
  { code: '49100', name: 'с.Оразак', regionCode: '11', districtCode: '66' },
  { code: '49200', name: 'с.Бирлик', regionCode: '11', districtCode: '66' },
  { code: '51100', name: 'а.Косшы', regionCode: '11', districtCode: '66' },
  { code: '51500', name: 'с.Тайтобе', regionCode: '11', districtCode: '66' },
  { code: '53100', name: 'а.Тасты', regionCode: '11', districtCode: '66' },
  { code: '53300', name: 'с.Акмечеть', regionCode: '11', districtCode: '66' },
  { code: '53400', name: 'рзд.93', regionCode: '11', districtCode: '66' },
  { code: '53700', name: 'ст.Тастак', regionCode: '11', districtCode: '66' },
  { code: '55100', name: 'с.Максимовка', regionCode: '11', districtCode: '66' },
  { code: '55180', name: 'с.Жайнак', regionCode: '11', districtCode: '66' },
  { code: '55200', name: 'ст.Косшокы', regionCode: '11', districtCode: '66' },
  { code: '55300', name: 'с.Тонкерис', regionCode: '11', districtCode: '66' },
  {
    code: '55400',
    name: 'аул Фарфоровое',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '58100', name: 'с.Маншук', regionCode: '11', districtCode: '66' },
  { code: '59100', name: 'с.Hовоишимка', regionCode: '11', districtCode: '66' },
  { code: '59200', name: 'с.Мортык', regionCode: '11', districtCode: '66' },
  { code: '59300', name: 'с.Семеновка', regionCode: '11', districtCode: '66' },
  { code: '61100', name: 'а.Родина', regionCode: '11', districtCode: '66' },
  {
    code: '61200',
    name: 'с.Зеленый Гай',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '61300', name: 'с.Садовое', regionCode: '11', districtCode: '66' },
  { code: '63100', name: 'с.Приречное', regionCode: '11', districtCode: '66' },
  { code: '63200', name: 'с.Антоновка', regionCode: '11', districtCode: '66' },
  {
    code: '65100',
    name: 'а.Кабанбай батыра',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '65400', name: 'с.Кызылжар', regionCode: '11', districtCode: '66' },
  { code: '65500', name: 'с.Hура', regionCode: '11', districtCode: '66' },
  { code: '65600', name: 'с.Сарыадыр', regionCode: '11', districtCode: '66' },
  {
    code: '67100',
    name: 'аул Рахымжана Кошкарбаева',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '67200', name: 'с.Аганас', regionCode: '11', districtCode: '66' },
  { code: '67400', name: 'аул Сарыколь', regionCode: '11', districtCode: '66' },
  {
    code: '67500',
    name: 'с.Преображенка',
    regionCode: '11',
    districtCode: '66'
  },
  { code: '67600', name: 'с.Шнет', regionCode: '11', districtCode: '66' },
  { code: '71100', name: 'с.Софиевка', regionCode: '11', districtCode: '66' },
  { code: '71400', name: 'с.Миновка', regionCode: '11', districtCode: '66' },
  { code: '72100', name: 'с.Талапкер', regionCode: '11', districtCode: '66' },
  { code: '72200', name: 'с.Кажымукан', regionCode: '11', districtCode: '66' },
  { code: '72380', name: 'с.Кызылсуат', regionCode: '11', districtCode: '66' },
  { code: '72500', name: 'рзд.96', regionCode: '11', districtCode: '66' },
  { code: '73100', name: 'а.Шалкар', regionCode: '11', districtCode: '66' },
  { code: '73200', name: 'с.Каратомар', regionCode: '11', districtCode: '66' },
  { code: '73300', name: 'с.Отаутускен', regionCode: '11', districtCode: '66' },
  { code: '30100', name: 'п.Шортанды', regionCode: '11', districtCode: '68' },
  { code: '33100', name: 'с.Андреевка', regionCode: '11', districtCode: '68' },
  {
    code: '33800',
    name: 'с.Октябрьское',
    regionCode: '11',
    districtCode: '68'
  },
  { code: '35100', name: 'с.Дамса', regionCode: '11', districtCode: '68' },
  {
    code: '71200',
    name: 'с.Березняковка',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '71300', name: 'с.Заречное', regionCode: '11', districtCode: '56' },
  { code: '73100', name: 'п.Бирлестик', regionCode: '11', districtCode: '56' },
  { code: '73300', name: 'с.Жанатлек', regionCode: '11', districtCode: '56' },
  { code: '73400', name: 'с.Караозек', regionCode: '11', districtCode: '56' },
  { code: '73500', name: 'с.Сейфуллино', regionCode: '11', districtCode: '56' },
  { code: '77100', name: 'с.Акан', regionCode: '11', districtCode: '56' },
  { code: '77300', name: 'с.Баратай', regionCode: '11', districtCode: '56' },
  { code: '77800', name: 'с.Уголки', regionCode: '11', districtCode: '56' },
  { code: '30100', name: 'с.Коргалжын', regionCode: '11', districtCode: '60' },
  { code: '30200', name: 'с.Абай', regionCode: '11', districtCode: '60' },
  { code: '30300', name: 'с.Биртабан', regionCode: '11', districtCode: '60' },
  { code: '33100', name: 'с.Уркендеу', regionCode: '11', districtCode: '60' },
  { code: '33300', name: 'с.Жумай', regionCode: '11', districtCode: '60' },
  { code: '35100', name: 'с.Арыкты', regionCode: '11', districtCode: '60' },
  { code: '35200', name: 'с.Култай', regionCode: '11', districtCode: '60' },
  { code: '35400', name: 'с.Садырбай', regionCode: '11', districtCode: '60' },
  { code: '35500', name: 'с.Сулыколь', regionCode: '11', districtCode: '60' },
  { code: '37100', name: 'с.Кенбидаик', regionCode: '11', districtCode: '60' },
  { code: '37200', name: 'с.Екпинди', regionCode: '11', districtCode: '60' },
  { code: '39100', name: 'с.Майшукур', regionCode: '11', districtCode: '60' },
  { code: '39300', name: 'с.Кумколь', regionCode: '11', districtCode: '60' },
  { code: '41100', name: 'с.Жантеке', regionCode: '11', districtCode: '60' },
  { code: '41200', name: 'с.Каргалы', regionCode: '11', districtCode: '60' },
  { code: '41400', name: 'с.Уялы', regionCode: '11', districtCode: '60' },
  { code: '45100', name: 'с.Шалкар', regionCode: '11', districtCode: '60' },
  { code: '45200', name: 'с.Алмас', regionCode: '11', districtCode: '60' },
  { code: '45500', name: 'с.Ушсарт', regionCode: '11', districtCode: '60' },
  { code: '47100', name: 'с.Сабынды', regionCode: '11', districtCode: '60' },
  { code: '47200', name: 'с.Алгабас', regionCode: '11', districtCode: '60' },
  { code: '47300', name: 'с.Караегин', regionCode: '11', districtCode: '60' },
  { code: '30100', name: 'с.Балкашино', regionCode: '11', districtCode: '64' },
  { code: '30200', name: 'Лесхоз', regionCode: '11', districtCode: '64' },
  { code: '30300', name: 'с.Петровка', regionCode: '11', districtCode: '64' },
  { code: '35100', name: 'с.Баракпай', regionCode: '11', districtCode: '64' },
  { code: '35500', name: 'с.Чашке', regionCode: '11', districtCode: '64' },
  {
    code: '37100',
    name: 'с.Белгородское',
    regionCode: '11',
    districtCode: '64'
  },
  {
    code: '37300',
    name: 'с.Преображенка',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '37500', name: 'с.Раздольное', regionCode: '11', districtCode: '64' },
  {
    code: '38100',
    name: 'с.Красная Поляна',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '38200', name: 'с.Арбузинка', regionCode: '11', districtCode: '64' },
  { code: '38600', name: 'с.Петриковка', regionCode: '11', districtCode: '64' },
  { code: '39100', name: 'с.Васильевка', regionCode: '11', districtCode: '64' },
  { code: '39200', name: 'ауыл Улан', regionCode: '11', districtCode: '64' },
  { code: '39300', name: 'с.Тучное', regionCode: '11', districtCode: '64' },
  { code: '41100', name: 'с.Веселое', regionCode: '11', districtCode: '64' },
  { code: '41200', name: 'с.Жиланды', regionCode: '11', districtCode: '64' },
  {
    code: '41300',
    name: 'с.Hовоселовка',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '43100', name: 'с.Приозерное', regionCode: '11', districtCode: '64' },
  {
    code: '43300',
    name: 'с.Кызылказахстан',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '47100', name: 'с.Каменка', regionCode: '11', districtCode: '64' },
  { code: '47200', name: 'с.Богословка', regionCode: '11', districtCode: '64' },
  {
    code: '49200',
    name: 'с.Быстримовка',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '49300', name: 'с.Граниковка', regionCode: '11', districtCode: '64' },
  { code: '49600', name: 'с.Михайловка', regionCode: '11', districtCode: '64' },
  { code: '49700', name: 'с.Речное', regionCode: '11', districtCode: '64' },
  { code: '50100', name: 'а.Мадениет', regionCode: '11', districtCode: '64' },
  { code: '51100', name: 'с.Максимовка', regionCode: '11', districtCode: '64' },
  {
    code: '51200',
    name: 'с.Владимировка',
    regionCode: '11',
    districtCode: '64'
  },
  {
    code: '51300',
    name: 'с.Hовый Городок',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '51400', name: 'с.Спасское', regionCode: '11', districtCode: '64' },
  {
    code: '53100',
    name: 'с.Hовоникольское',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '53200', name: 'с.Кумдыколь', regionCode: '11', districtCode: '64' },
  {
    code: '53300',
    name: 'с.Меньшиковка',
    regionCode: '11',
    districtCode: '64'
  },
  { code: '33400', name: 'с.Молодежное', regionCode: '11', districtCode: '56' },
  { code: '33500', name: 'с.Туполевка', regionCode: '11', districtCode: '56' },
  { code: '35100', name: 'п.Алексеевка', regionCode: '11', districtCode: '56' },
  { code: '35200', name: 'ст.Жаманаши', regionCode: '11', districtCode: '56' },
  { code: '35300', name: 'с.Чаглинка', regionCode: '11', districtCode: '56' },
  { code: '37100', name: 'с.Еленовка', regionCode: '11', districtCode: '56' },
  { code: '37400', name: 'с.Жанааул', regionCode: '11', districtCode: '56' },
  { code: '37500', name: 'с.Жылымды', regionCode: '11', districtCode: '56' },
  { code: '37600', name: 'с.Карагай', regionCode: '11', districtCode: '56' },
  { code: '37700', name: 'а.Карлыколь', regionCode: '11', districtCode: '56' },
  { code: '41100', name: 'с.Айдабол', regionCode: '11', districtCode: '56' },
  { code: '43100', name: 'с.Викторовка', regionCode: '11', districtCode: '56' },
  { code: '43480', name: 'с.Красиловка', regionCode: '11', districtCode: '56' },
  {
    code: '43600',
    name: 'а.Богенбай би',
    regionCode: '11',
    districtCode: '56'
  },
  {
    code: '47100',
    name: 'с.Куропаткино',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '47300', name: 'с.Азат', regionCode: '11', districtCode: '56' },
  { code: '47400', name: 'с.Раздольное', regionCode: '11', districtCode: '56' },
  { code: '47600', name: 'с.Жамбыл', regionCode: '11', districtCode: '56' },
  { code: '47700', name: 'а.Теректи', regionCode: '11', districtCode: '56' },
  { code: '49100', name: 'с.Конысбай', regionCode: '11', districtCode: '56' },
  {
    code: '49200',
    name: 'с.Васильковка',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '49300', name: 'с.Гранитный', regionCode: '11', districtCode: '56' },
  { code: '49400', name: 'с.Донгулагаш', regionCode: '11', districtCode: '56' },
  { code: '51100', name: 'с.Кызылсая', regionCode: '11', districtCode: '56' },
  { code: '51200', name: 'с.Биктесин', regionCode: '11', districtCode: '56' },
  { code: '51500', name: 'с.Кызылагаш', regionCode: '11', districtCode: '56' },
  { code: '52100', name: 'с.Ортак', regionCode: '11', districtCode: '56' },
  { code: '52400', name: 'с.Кызылтан', regionCode: '11', districtCode: '56' },
  { code: '52700', name: 'с.Трофимовка', regionCode: '11', districtCode: '56' },
  { code: '53100', name: 'с.Приречное', regionCode: '11', districtCode: '56' },
  { code: '53400', name: 'с.Павловка', regionCode: '11', districtCode: '56' },
  {
    code: '55100',
    name: 'а.Малика Габдуллина',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '55200', name: 'с.Дороговка', regionCode: '11', districtCode: '56' },
  { code: '55680', name: 'с.Койсалган', regionCode: '11', districtCode: '56' },
  {
    code: '55700',
    name: 'а.Малые Тюкты',
    regionCode: '11',
    districtCode: '56'
  },
  {
    code: '55800',
    name: 'с.Серафимовка',
    regionCode: '11',
    districtCode: '56'
  },
  {
    code: '57100',
    name: 'с.Симферопольское',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '57200', name: 'с.Булак', regionCode: '11', districtCode: '56' },
  { code: '57300', name: 'с.Жолдыбай', regionCode: '11', districtCode: '56' },
  { code: '58100', name: 'с.Троицкое', regionCode: '11', districtCode: '56' },
  { code: '58300', name: 'с.Кеноткель', regionCode: '11', districtCode: '56' },
  { code: '58400', name: 'с.Карсак', regionCode: '11', districtCode: '56' },
  { code: '58500', name: 'с.Кошкарбай', regionCode: '11', districtCode: '56' },
  { code: '59100', name: 'с.Чаглинка', regionCode: '11', districtCode: '56' },
  { code: '59300', name: 'аул Акадыр', regionCode: '11', districtCode: '56' },
  {
    code: '59400',
    name: 'с.Енбекбирлик',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '59700', name: 'а.Ескенежал', regionCode: '11', districtCode: '56' },
  { code: '59900', name: 'с.Уялы', regionCode: '11', districtCode: '56' },
  { code: '63100', name: 'с.Исаковка', regionCode: '11', districtCode: '56' },
  {
    code: '63400',
    name: 'с.Костомаровка',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '63700', name: 'с.Уялы', regionCode: '11', districtCode: '56' },
  {
    code: '65100',
    name: 'а.Карауыл Конай-бия',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '65300', name: 'с.Жамантуз', regionCode: '11', districtCode: '56' },
  { code: '65400', name: 'с.Игилик', regionCode: '11', districtCode: '56' },
  { code: '65800', name: 'а.Желтау', regionCode: '11', districtCode: '56' },
  { code: '67100', name: 'с.Кызылегис', regionCode: '11', districtCode: '56' },
  { code: '67500', name: 'с.Карашилик', regionCode: '11', districtCode: '56' },
  { code: '67700', name: 'с.Ортаагаш', regionCode: '11', districtCode: '56' },
  { code: '69100', name: 'аул Байтерек', regionCode: '11', districtCode: '56' },
  { code: '69300', name: 'с.Ермаковка', regionCode: '11', districtCode: '56' },
  {
    code: '69400',
    name: 'с.Красный Кордон',
    regionCode: '11',
    districtCode: '56'
  },
  { code: '69600', name: 'а.Ондирис', regionCode: '11', districtCode: '56' },
  { code: '69800', name: 'с.Ульгили', regionCode: '11', districtCode: '56' },
  { code: '71100', name: 'с.Садовое', regionCode: '11', districtCode: '56' },
  { code: '73100', name: 'с.Свободное', regionCode: '11', districtCode: '48' },
  { code: '75100', name: 'с.Юбилейное', regionCode: '11', districtCode: '48' },
  {
    code: '75200',
    name: 'с.Интернациональное',
    regionCode: '11',
    districtCode: '48'
  },
  { code: '77100', name: 'с.Ярославка', regionCode: '11', districtCode: '48' },
  { code: '30100', name: 'с.Жаксы', regionCode: '11', districtCode: '52' },
  { code: '37100', name: 'с.Белагаш', regionCode: '11', districtCode: '52' },
  {
    code: '39100',
    name: 'с.Беловодское',
    regionCode: '11',
    districtCode: '52'
  },
  { code: '39200', name: 'с.Перекатное', regionCode: '11', districtCode: '52' },
  { code: '43100', name: 'с.Жана Киима', regionCode: '11', districtCode: '52' },
  { code: '43200', name: 'с.Алгабас', regionCode: '11', districtCode: '52' },
  { code: '43300', name: 'с.Киима', regionCode: '11', districtCode: '52' },
  { code: '43400', name: 'с.Тайпак', regionCode: '11', districtCode: '52' },
  { code: '43500', name: 'с.Трудовое', regionCode: '11', districtCode: '52' },
  { code: '45100', name: 'с.Запорожье', regionCode: '11', districtCode: '52' },
  { code: '45300', name: 'с.Лозовое', regionCode: '11', districtCode: '52' },
  { code: '45500', name: 'с.Hовочудное', regionCode: '11', districtCode: '52' },
  { code: '47100', name: 'с.Ишимское', regionCode: '11', districtCode: '52' },
  { code: '47300', name: 'с.Казахстан', regionCode: '11', districtCode: '52' },
  { code: '47400', name: 'с.Монастырка', regionCode: '11', districtCode: '52' },
  {
    code: '51100',
    name: 'с.Калининское',
    regionCode: '11',
    districtCode: '52'
  },
  { code: '51400', name: 'с.Калмакколь', regionCode: '11', districtCode: '52' },
  { code: '51500', name: 'с.Моховое', regionCode: '11', districtCode: '52' },
  { code: '55100', name: 'с.Киевское', regionCode: '11', districtCode: '52' },
  { code: '61100', name: 'с.Кайракты', regionCode: '11', districtCode: '52' },
  {
    code: '61400',
    name: 'с.Старое Перекатное',
    regionCode: '11',
    districtCode: '52'
  },
  { code: '65100', name: 'с.Кызылсай', regionCode: '11', districtCode: '52' },
  { code: '65200', name: 'с.Баягиз', regionCode: '11', districtCode: '52' },
  { code: '65300', name: 'с.Кировское', regionCode: '11', districtCode: '52' },
  { code: '71100', name: 'с.Hовокиенка', regionCode: '11', districtCode: '52' },
  { code: '71300', name: 'с.Парчевка', regionCode: '11', districtCode: '52' },
  { code: '73100', name: 'с.Подгорное', regionCode: '11', districtCode: '52' },
  { code: '74100', name: 'с.Тарасовка', regionCode: '11', districtCode: '52' },
  { code: '74500', name: 'с.Казахское', regionCode: '11', districtCode: '52' },
  { code: '75100', name: 'с.Терсакан', regionCode: '11', districtCode: '52' },
  { code: '75980', name: 'с.Коксай', regionCode: '11', districtCode: '52' },
  { code: '77100', name: 'с.Чапаевское', regionCode: '11', districtCode: '52' },
  { code: '31100', name: 'с.Отрадное', regionCode: '11', districtCode: '54' },
  { code: '31200', name: 'с.Кенское', regionCode: '11', districtCode: '54' },
  { code: '37100', name: 'с.Бирсуат', regionCode: '11', districtCode: '54' },
  { code: '39100', name: 'с.Гастелло', regionCode: '11', districtCode: '54' },
  { code: '41100', name: 'а.Далабай', regionCode: '11', districtCode: '54' },
  {
    code: '43100',
    name: 'с.Тасты-Талды',
    regionCode: '11',
    districtCode: '54'
  },
  { code: '43200', name: 'с.Жанадала', regionCode: '11', districtCode: '54' },
  {
    code: '43300',
    name: 'с.Зерноградское',
    regionCode: '11',
    districtCode: '54'
  },
  { code: '51100', name: 'с.Костычево', regionCode: '11', districtCode: '54' },
  { code: '51200', name: 'с.Донское', regionCode: '11', districtCode: '54' },
  { code: '53100', name: 'с.Кумсуат', regionCode: '11', districtCode: '54' },
  { code: '54100', name: 'с.Львовское', regionCode: '11', districtCode: '54' },
  { code: '55100', name: 'с.Hахимовка', regionCode: '11', districtCode: '54' },
  { code: '55200', name: 'с.Баранкуль', regionCode: '11', districtCode: '54' },
  {
    code: '63100',
    name: 'с.Пригородное',
    regionCode: '11',
    districtCode: '54'
  },
  {
    code: '65100',
    name: 'с.Пятигорское',
    regionCode: '11',
    districtCode: '54'
  },
  { code: '69100', name: 'с.Тасоткель', regionCode: '11', districtCode: '54' },
  { code: '71100', name: 'с.Тассуат', regionCode: '11', districtCode: '54' },
  { code: '73100', name: 'с.Валиханово', regionCode: '11', districtCode: '54' },
  { code: '73200', name: 'с.Достык', regionCode: '11', districtCode: '54' },
  { code: '75100', name: 'с.Ушкарасу', regionCode: '11', districtCode: '54' },
  {
    code: '79100',
    name: 'с.Шойындыколь',
    regionCode: '11',
    districtCode: '54'
  },
  { code: '30100', name: 'с.Зеренда', regionCode: '11', districtCode: '56' },
  { code: '30280', name: 'с.Айдарлы', regionCode: '11', districtCode: '56' },
  { code: '30380', name: 'с.Коктерек', regionCode: '11', districtCode: '56' },
  { code: '33100', name: 'с.Акколь', regionCode: '11', districtCode: '56' },
  { code: '33200', name: 'с.Ивановка', regionCode: '11', districtCode: '56' },
  { code: '33300', name: 'с.Казахстан', regionCode: '11', districtCode: '56' },
  { code: '53300', name: 'с.Титовка', regionCode: '11', districtCode: '38' },
  { code: '55100', name: 'с.Сепе', regionCode: '11', districtCode: '38' },
  { code: '57100', name: 'с.Сергеевка', regionCode: '11', districtCode: '38' },
  { code: '57200', name: 'с.Ащиколь', regionCode: '11', districtCode: '38' },
  { code: '57400', name: 'с.Самарка', regionCode: '11', districtCode: '38' },
  { code: '61100', name: 'с.Сочинское', regionCode: '11', districtCode: '38' },
  { code: '63100', name: 'с.Тельмана', regionCode: '11', districtCode: '38' },
  { code: '63200', name: 'с.Поповка', regionCode: '11', districtCode: '38' },
  { code: '63300', name: 'рзд.87', regionCode: '11', districtCode: '38' },
  { code: '63400', name: 'с.Садубек', regionCode: '11', districtCode: '38' },
  { code: '63600', name: 'с.Каражар', regionCode: '11', districtCode: '38' },
  { code: '65100', name: 'а.Есенгельды', regionCode: '11', districtCode: '38' },
  { code: '67100', name: 'с.Тимашевка', regionCode: '11', districtCode: '38' },
  { code: '67300', name: 'с.Калиновка', regionCode: '11', districtCode: '38' },
  {
    code: '67400',
    name: 'с.Магдалиновка',
    regionCode: '11',
    districtCode: '38'
  },
  { code: '67500', name: 'с.Родионовка', regionCode: '11', districtCode: '38' },
  { code: '67700', name: 'с.Хрящевка', regionCode: '11', districtCode: '38' },
  { code: '31100', name: 'с.Вознесенка', regionCode: '11', districtCode: '40' },
  { code: '31200', name: 'а.Аккайын', regionCode: '11', districtCode: '40' },
  { code: '31500', name: 'а.Тастыозек', regionCode: '11', districtCode: '40' },
  { code: '35100', name: 'аул Алтынды', regionCode: '11', districtCode: '40' },
  { code: '35200', name: 'аул Алаколь', regionCode: '11', districtCode: '40' },
  { code: '35300', name: 'с.Боярка', regionCode: '11', districtCode: '40' },
  { code: '35400', name: 'с.Ельтай', regionCode: '11', districtCode: '40' },
  { code: '35500', name: 'с.Жанаталап', regionCode: '11', districtCode: '40' },
  { code: '37100', name: 'а.Токтамыс', regionCode: '11', districtCode: '40' },
  { code: '37200', name: 'с.Гордеевка', regionCode: '11', districtCode: '40' },
  { code: '37300', name: 'с.Иванковка', regionCode: '11', districtCode: '40' },
  { code: '37400', name: 'с.Hовокиевка', regionCode: '11', districtCode: '40' },
  { code: '39100', name: 'с.Журавлевка', regionCode: '11', districtCode: '40' },
  { code: '39200', name: 'с.Воробьевка', regionCode: '11', districtCode: '40' },
  { code: '39400', name: 'с.Hоводонецк', regionCode: '11', districtCode: '40' },
  { code: '39600', name: 'с.Ярославка', regionCode: '11', districtCode: '40' },
  {
    code: '41100',
    name: 'с.Капитоновка',
    regionCode: '11',
    districtCode: '40'
  },
  {
    code: '41200',
    name: 'с.им.Балуана Шолака',
    regionCode: '11',
    districtCode: '40'
  },
  { code: '41400', name: 'с.Пушкино', regionCode: '11', districtCode: '40' },
  { code: '43100', name: 'а.Шубарагаш', regionCode: '11', districtCode: '40' },
  { code: '43200', name: 'с.Мат', regionCode: '11', districtCode: '40' },
  { code: '43400', name: 'с.Отрадное', regionCode: '11', districtCode: '40' },
  { code: '39100', name: 'с.Ейское', regionCode: '11', districtCode: '48' },
  {
    code: '39200',
    name: 'с.Алматинское',
    regionCode: '11',
    districtCode: '48'
  },
  { code: '39300', name: 'с.Биртал', regionCode: '11', districtCode: '48' },
  { code: '41100', name: 'с.Двуречное', regionCode: '11', districtCode: '48' },
  { code: '41200', name: 'с.Приишимка', regionCode: '11', districtCode: '48' },
  { code: '45100', name: 'с.Жаныспай', regionCode: '11', districtCode: '48' },
  { code: '45200', name: 'с.Ковыльное', regionCode: '11', districtCode: '48' },
  { code: '47100', name: 'с.Заречное', regionCode: '11', districtCode: '48' },
  { code: '47200', name: 'с.Дальное', regionCode: '11', districtCode: '48' },
  { code: '51100', name: 'с.Знаменка', regionCode: '11', districtCode: '48' },
  { code: '51200', name: 'с.Ельтай', regionCode: '11', districtCode: '48' },
  { code: '57100', name: 'с.Красивое', regionCode: '11', districtCode: '48' },
  { code: '57200', name: 'ст.Красивая', regionCode: '11', districtCode: '48' },
  { code: '57300', name: 'с.Кумай', regionCode: '11', districtCode: '48' },
  { code: '57400', name: 'с.Ленинское', regionCode: '11', districtCode: '48' },
  { code: '57500', name: 'с.Тасоба', regionCode: '11', districtCode: '48' },
  {
    code: '59100',
    name: 'п.Красногорский',
    regionCode: '11',
    districtCode: '48'
  },
  { code: '59200', name: 'с.Иглик', regionCode: '11', districtCode: '48' },
  { code: '59300', name: 'с.Калачи', regionCode: '11', districtCode: '48' },
  { code: '61100', name: 'с.Курское', regionCode: '11', districtCode: '48' },
  { code: '63100', name: 'с.Караколь', regionCode: '11', districtCode: '48' },
  { code: '63200', name: 'с.Речное', regionCode: '11', districtCode: '48' },
  { code: '65100', name: 'с.Московское', regionCode: '11', districtCode: '48' },
  { code: '67100', name: 'с.Орловка', regionCode: '11', districtCode: '48' },
  { code: '68100', name: 'с.Раздольное', regionCode: '11', districtCode: '48' },
  { code: '47100', name: 'а.Турген', regionCode: '11', districtCode: '34' },
  {
    code: '47200',
    name: 'с.Красное Озеро',
    regionCode: '11',
    districtCode: '34'
  },
  { code: '47300', name: 'с.Родники', regionCode: '11', districtCode: '34' },
  { code: '49100', name: 'с.Михайловка', regionCode: '11', districtCode: '34' },
  { code: '49200', name: 'с.Hиколаевка', regionCode: '11', districtCode: '34' },
  { code: '49300', name: 'с.Ольгинка', regionCode: '11', districtCode: '34' },
  { code: '51100', name: 'а.Булаксай', regionCode: '11', districtCode: '34' },
  { code: '51400', name: 'а.Акжар', regionCode: '11', districtCode: '34' },
  { code: '51700', name: 'с.Костомар', regionCode: '11', districtCode: '34' },
  { code: '53100', name: 'с.Сарыоба', regionCode: '11', districtCode: '34' },
  { code: '53500', name: 'ст.Сарыоба', regionCode: '11', districtCode: '34' },
  { code: '30100', name: 'с.Астраханка', regionCode: '11', districtCode: '36' },
  { code: '30200', name: 'с.Жанабирлик', regionCode: '11', districtCode: '36' },
  { code: '30300', name: 'с.Таволжанка', regionCode: '11', districtCode: '36' },
  { code: '35100', name: 'с.Бесбидаик', regionCode: '11', districtCode: '36' },
  { code: '35200', name: 'с.Степное', regionCode: '11', districtCode: '36' },
  { code: '37100', name: 'с.Зеленое', regionCode: '11', districtCode: '36' },
  { code: '37200', name: 'с.Шиликти', regionCode: '11', districtCode: '36' },
  { code: '39100', name: 'с.Жарсуат', regionCode: '11', districtCode: '36' },
  { code: '39700', name: 'с.Ягодное', regionCode: '11', districtCode: '36' },
  { code: '40100', name: 'с.Жалтыр', regionCode: '11', districtCode: '36' },
  { code: '40300', name: 'с.Акбеит', regionCode: '11', districtCode: '36' },
  { code: '41100', name: 'с.Каменка', regionCode: '11', districtCode: '36' },
  {
    code: '45100',
    name: 'с.Жана-Турмыс',
    regionCode: '11',
    districtCode: '36'
  },
  { code: '45200', name: 'с.Акимовка', regionCode: '11', districtCode: '36' },
  { code: '45400', name: 'с.Оксановка', regionCode: '11', districtCode: '36' },
  { code: '49100', name: 'с.Петровка', regionCode: '11', districtCode: '36' },
  { code: '49200', name: 'с.Жамбыл', regionCode: '11', districtCode: '36' },
  { code: '49500', name: 'с.Орнек', regionCode: '11', districtCode: '36' },
  {
    code: '50100',
    name: 'с.Hовочеркасское',
    regionCode: '11',
    districtCode: '36'
  },
  { code: '50400', name: 'с.Ондирис', regionCode: '11', districtCode: '36' },
  { code: '50600', name: 'с.Приишимка', regionCode: '11', districtCode: '36' },
  {
    code: '51100',
    name: 'с.Hовый Колутон',
    regionCode: '11',
    districtCode: '36'
  },
  { code: '51200', name: 'аул Караколь', regionCode: '11', districtCode: '36' },
  { code: '53100', name: 'с.Первомайка', regionCode: '11', districtCode: '36' },
  { code: '53300', name: 'с.Лозовое', regionCode: '11', districtCode: '36' },
  { code: '53400', name: 'с.Камышенка', regionCode: '11', districtCode: '36' },
  {
    code: '55100',
    name: 'с.Старый Колутон',
    regionCode: '11',
    districtCode: '36'
  },
  { code: '55300', name: 'с.Зареченка', regionCode: '11', districtCode: '36' },
  { code: '55400', name: 'с.Ковыленка', regionCode: '11', districtCode: '36' },
  { code: '55600', name: 'с.Косколь', regionCode: '11', districtCode: '36' },
  { code: '56100', name: 'ст.Колутон', regionCode: '11', districtCode: '36' },
  { code: '56200', name: 'с.Бирлик', regionCode: '11', districtCode: '36' },
  { code: '57100', name: 'с.Узунколь', regionCode: '11', districtCode: '36' },
  { code: '57200', name: 'с.Алгабас', regionCode: '11', districtCode: '36' },
  { code: '57300', name: 'с.Булакты', regionCode: '11', districtCode: '36' },
  { code: '57600', name: 'с.Кайнарское', regionCode: '11', districtCode: '36' },
  {
    code: '33100',
    name: 'с.Hовомариновка',
    regionCode: '11',
    districtCode: '38'
  },
  { code: '33600', name: 'с.Шункырколь', regionCode: '11', districtCode: '38' },
  { code: '35100', name: 'с.Борисовка', regionCode: '11', districtCode: '38' },
  { code: '41100', name: 'с.Шуйское', regionCode: '11', districtCode: '38' },
  { code: '41200', name: 'с.Макеевка', regionCode: '11', districtCode: '38' },
  {
    code: '41300',
    name: 'с.Третьяковка',
    regionCode: '11',
    districtCode: '38'
  },
  { code: '43100', name: 'с.Мариновка', regionCode: '11', districtCode: '38' },
  {
    code: '43300',
    name: 'а.Бейса хазирета',
    regionCode: '11',
    districtCode: '38'
  },
  { code: '43400', name: 'ст.Адыр', regionCode: '11', districtCode: '38' },
  {
    code: '45100',
    name: 'с.Hовоалександровка',
    regionCode: '11',
    districtCode: '38'
  },
  {
    code: '49100',
    name: 'с.Hовосельское',
    regionCode: '11',
    districtCode: '38'
  },
  {
    code: '51100',
    name: 'с.Октябрьское',
    regionCode: '11',
    districtCode: '38'
  },
  { code: '51200', name: 'с.Караколь', regionCode: '11', districtCode: '38' },
  { code: '51400', name: 'с.Косбармак', regionCode: '11', districtCode: '38' },
  { code: '52100', name: 'с.Покровка', regionCode: '11', districtCode: '38' },
  { code: '52200', name: 'с.Садовое', regionCode: '11', districtCode: '38' },
  { code: '53100', name: 'с.Полтавка', regionCode: '11', districtCode: '38' },
  { code: '45100', name: 'с.Тогыз', regionCode: '15', districtCode: '64' },
  { code: '45200', name: 'с.Жылан', regionCode: '15', districtCode: '64' },
  { code: '45280', name: 'с.Копмула', regionCode: '15', districtCode: '64' },
  { code: '45400', name: 'с.Кендала', regionCode: '15', districtCode: '64' },
  { code: '45480', name: 'с.Каратал', regionCode: '15', districtCode: '64' },
  { code: '45500', name: 'с.Копатай', regionCode: '15', districtCode: '64' },
  { code: '45600', name: 'с.Тасбулак', regionCode: '15', districtCode: '64' },
  { code: '45700', name: 'с.Ушкурай', regionCode: '15', districtCode: '64' },
  { code: '47100', name: 'с.Жылтыр', regionCode: '15', districtCode: '64' },
  { code: '47300', name: 'с.Талдыкум', regionCode: '15', districtCode: '64' },
  { code: '51100', name: 'с.Каратогай', regionCode: '15', districtCode: '64' },
  { code: '51200', name: 'с.Тумалыколь', regionCode: '15', districtCode: '64' },
  { code: '51300', name: 'с.Шетиргиз', regionCode: '15', districtCode: '64' },
  { code: '30100', name: 'с.Иргиз', regionCode: '15', districtCode: '68' },
  { code: '30200', name: 'а.Акши', regionCode: '15', districtCode: '68' },
  { code: '30300', name: 'с.Калыбай', regionCode: '15', districtCode: '68' },
  { code: '30400', name: 'с.Колалыколь', regionCode: '15', districtCode: '68' },
  { code: '35100', name: 'с.Кутикул', regionCode: '15', districtCode: '68' },
  { code: '35200', name: 'с.Аманколь', regionCode: '15', districtCode: '68' },
  { code: '35300', name: 'с.Жарма', regionCode: '15', districtCode: '68' },
  { code: '37100', name: 'с.Жайсанбай', regionCode: '15', districtCode: '68' },
  { code: '39100', name: 'с.Кумтогай', regionCode: '15', districtCode: '68' },
  { code: '39200', name: 'с.Каракудук', regionCode: '15', districtCode: '68' },
  { code: '39300', name: 'с.Карасай', regionCode: '15', districtCode: '68' },
  { code: '41100', name: 'с.Курлыс', regionCode: '15', districtCode: '68' },
  { code: '41200', name: 'аул Жаныс би', regionCode: '15', districtCode: '68' },
  { code: '41400', name: 'с.Шенбертал', regionCode: '15', districtCode: '68' },
  { code: '43100', name: 'с.Hура', regionCode: '15', districtCode: '68' },
  { code: '43200', name: 'с.Белшер', regionCode: '15', districtCode: '68' },
  { code: '43300', name: 'с.Дукен', regionCode: '15', districtCode: '68' },
  { code: '43400', name: 'с.Мамыр', regionCode: '15', districtCode: '68' },
  { code: '45100', name: 'с.Куйлыс', regionCode: '15', districtCode: '68' },
  { code: '45400', name: 'с.Караколь', regionCode: '15', districtCode: '68' },
  { code: '30300', name: 'а.Казан', regionCode: '15', districtCode: '46' },
  { code: '41400', name: 'с.Мир', regionCode: '15', districtCode: '34' },
  { code: '20100', name: 'г.Хромтау', regionCode: '15', districtCode: '60' },
  { code: '33800', name: 'с.Тассай', regionCode: '15', districtCode: '60' },
  { code: '35100', name: 'с.Богетсай', regionCode: '15', districtCode: '60' },
  { code: '35400', name: 'с.Карлау', regionCode: '15', districtCode: '60' },
  { code: '35500', name: 'с.Талдыбулак', regionCode: '15', districtCode: '60' },
  { code: '35600', name: 'с.Шиликтысай', regionCode: '15', districtCode: '60' },
  { code: '36100', name: 'с.Дон', regionCode: '15', districtCode: '60' },
  { code: '36600', name: 'а.Онгар', regionCode: '15', districtCode: '60' },
  { code: '37100', name: 'с.Майтобе', regionCode: '15', districtCode: '60' },
  { code: '37500', name: 'с.Коктерек', regionCode: '15', districtCode: '60' },
  { code: '39100', name: 'с.Аккудык', regionCode: '15', districtCode: '60' },
  { code: '39200', name: 'с.Карасу', regionCode: '15', districtCode: '60' },
  { code: '39300', name: 'с.Катынадыр', regionCode: '15', districtCode: '60' },
  { code: '40100', name: 'с.Коктау', regionCode: '15', districtCode: '60' },
  { code: '40200', name: 'с.Карабаз', regionCode: '15', districtCode: '60' },
  { code: '40300', name: 'с.Кошенсай', regionCode: '15', districtCode: '60' },
  { code: '41100', name: 'с.Копа', regionCode: '15', districtCode: '60' },
  { code: '41280', name: 'с.Амангельды', regionCode: '15', districtCode: '60' },
  { code: '41400', name: 'с.Тамды', regionCode: '15', districtCode: '60' },
  { code: '43100', name: 'с.Кудуксай', regionCode: '15', districtCode: '60' },
  { code: '43500', name: 'с.Ойсылкара', regionCode: '15', districtCode: '60' },
  { code: '45100', name: 'с.Сарысай', regionCode: '15', districtCode: '60' },
  {
    code: '45300',
    name: 'с.Енбекшиказах',
    regionCode: '15',
    districtCode: '60'
  },
  { code: '45600', name: 'с.Кызылсу', regionCode: '15', districtCode: '60' },
  { code: '47100', name: 'с.Акжар', regionCode: '15', districtCode: '60' },
  {
    code: '47500',
    name: 'ст.Просторная',
    regionCode: '15',
    districtCode: '60'
  },
  { code: '48100', name: 'с.Hикельтау', regionCode: '15', districtCode: '60' },
  { code: '49100', name: 'с.Табантал', regionCode: '15', districtCode: '60' },
  { code: '49200', name: 'с.Бакай', regionCode: '15', districtCode: '60' },
  { code: '49300', name: 'с.Жайлаусай', regionCode: '15', districtCode: '60' },
  { code: '49400', name: 'с.Коптогай', regionCode: '15', districtCode: '60' },
  { code: '51100', name: 'с.Тассай', regionCode: '15', districtCode: '60' },
  { code: '51400', name: 'а.Кокпекти', regionCode: '15', districtCode: '60' },
  { code: '53100', name: 'с.Тасоткель', regionCode: '15', districtCode: '60' },
  { code: '53200', name: 'с.Акбулак', regionCode: '15', districtCode: '60' },
  { code: '53300', name: 'с.Актасты', regionCode: '15', districtCode: '60' },
  { code: '53400', name: 'с.Уйтас', regionCode: '15', districtCode: '60' },
  { code: '20100', name: 'г.Шалкар', regionCode: '15', districtCode: '64' },
  { code: '33100', name: 'с.Бегимбет', regionCode: '15', districtCode: '64' },
  { code: '33200', name: 'а.Есетата', regionCode: '15', districtCode: '64' },
  { code: '35100', name: 'с.Котртас', regionCode: '15', districtCode: '64' },
  { code: '37100', name: 'с.Бозой', regionCode: '15', districtCode: '64' },
  { code: '37200', name: 'с.Канбакты', regionCode: '15', districtCode: '64' },
  { code: '37300', name: 'а.Коянкулак', regionCode: '15', districtCode: '64' },
  { code: '38100', name: 'с.Биршогыр', regionCode: '15', districtCode: '64' },
  { code: '38200', name: 'с.Алабас', regionCode: '15', districtCode: '64' },
  { code: '38300', name: 'с.Корганжар', regionCode: '15', districtCode: '64' },
  { code: '38400', name: 'с.Сарсай', regionCode: '15', districtCode: '64' },
  { code: '38500', name: 'с.Карабулак', regionCode: '15', districtCode: '64' },
  { code: '39100', name: 'с.Байкадам', regionCode: '15', districtCode: '64' },
  { code: '39200', name: 'с.Алакозы', regionCode: '15', districtCode: '64' },
  { code: '41100', name: 'с.Аккайтым', regionCode: '15', districtCode: '64' },
  { code: '41200', name: 'с.Копасор', regionCode: '15', districtCode: '64' },
  { code: '42100', name: 'с.Шиликты', regionCode: '15', districtCode: '64' },
  { code: '42200', name: 'с.Акеспе', regionCode: '15', districtCode: '64' },
  { code: '42300', name: 'с.Карашокат', regionCode: '15', districtCode: '64' },
  { code: '42500', name: 'с.Сардулек', regionCode: '15', districtCode: '64' },
  { code: '42700', name: 'с.Шагыр', regionCode: '15', districtCode: '64' },
  { code: '42800', name: 'с.Шокысу', regionCode: '15', districtCode: '64' },
  { code: '43100', name: 'с.Кауылжыр', regionCode: '15', districtCode: '64' },
  { code: '43600', name: 'рзд.66', regionCode: '15', districtCode: '64' },
  { code: '43700', name: 'рзд.67', regionCode: '15', districtCode: '64' },
  { code: '43880', name: 'ст.Соленый', regionCode: '15', districtCode: '64' },
  { code: '43900', name: 'с.Улпан', regionCode: '15', districtCode: '64' },
  { code: '44100', name: 'с.Монке би', regionCode: '15', districtCode: '64' },
  { code: '39100', name: 'с.Аралтобе', regionCode: '15', districtCode: '34' },
  { code: '41100', name: 'а.Айке', regionCode: '15', districtCode: '34' },
  { code: '41500', name: 'с.Теренсай', regionCode: '15', districtCode: '34' },
  { code: '43100', name: 'с.Тымабулак', regionCode: '15', districtCode: '34' },
  { code: '3', name: 'с.Кенеса Нокина', regionCode: '15', districtCode: '15' },
  { code: '4', name: 'с.Акшат', regionCode: '15', districtCode: '15' },
  { code: '5', name: 'с.Белогорка', regionCode: '15', districtCode: '15' },
  {
    code: '6',
    name: 'с.Белогорский карьер',
    regionCode: '15',
    districtCode: '15'
  },
  { code: '7', name: 'с.Беккул баба', regionCode: '15', districtCode: '15' },
  { code: '8', name: 'с.Кызылжар', regionCode: '15', districtCode: '15' },
  { code: '9', name: 'с.Принородное', regionCode: '15', districtCode: '15' },
  { code: '10', name: 'с.Садовое', regionCode: '15', districtCode: '15' },
  { code: '11', name: 'с.Украинка', regionCode: '15', districtCode: '15' },
  { code: '12', name: 'с.Ольке', regionCode: '15', districtCode: '15' },
  { code: '13', name: 'с.Шилисай', regionCode: '15', districtCode: '15' },
  { code: '14', name: 'с.Каргалинское', regionCode: '15', districtCode: '15' },
  { code: '15', name: 'с.Акжар', regionCode: '15', districtCode: '15' },
  { code: '16', name: 'с.Магаджан', regionCode: '15', districtCode: '15' },
  { code: '17', name: 'с.Курайлы', regionCode: '15', districtCode: '15' },
  { code: '18', name: 'с.Георгиевка', regionCode: '15', districtCode: '15' },
  { code: '19', name: 'с.Елек', regionCode: '15', districtCode: '15' },
  { code: '20', name: 'с.Орлеу', regionCode: '15', districtCode: '15' },
  { code: '21', name: 'с.Жанаконыс', regionCode: '15', districtCode: '15' },
  { code: '22', name: 'с.Шестихатка', regionCode: '15', districtCode: '15' },
  { code: '23', name: 'с.Курашасай', regionCode: '15', districtCode: '15' },
  { code: '24', name: 'с.Женишке', regionCode: '15', districtCode: '15' },
  { code: '25', name: 'с.Сазды', regionCode: '15', districtCode: '15' },
  { code: '26', name: 'с.Лесное', regionCode: '15', districtCode: '15' },
  { code: '45300', name: 'с.Бестамак', regionCode: '15', districtCode: '52' },
  { code: '45400', name: 'с.Конырат', regionCode: '15', districtCode: '52' },
  { code: '45500', name: 'с.Шикудук', regionCode: '15', districtCode: '52' },
  { code: '47100', name: 'с.Сарыбие', regionCode: '15', districtCode: '52' },
  { code: '47200', name: 'с.Караколь', regionCode: '15', districtCode: '52' },
  { code: '21100', name: 'г.Темир', regionCode: '15', districtCode: '56' },
  { code: '21200', name: 'а.Жамбыл', regionCode: '15', districtCode: '56' },
  { code: '30100', name: 'п.Шубаркудук', regionCode: '15', districtCode: '56' },
  { code: '30300', name: 'ст.Жаксымай', regionCode: '15', districtCode: '56' },
  { code: '30400', name: 'ст.Кенжалы', regionCode: '15', districtCode: '56' },
  {
    code: '30700',
    name: 'Промысел Шубаркудук',
    regionCode: '15',
    districtCode: '56'
  },
  { code: '32100', name: 'с.Аксай', regionCode: '15', districtCode: '56' },
  { code: '33100', name: 'с.Алтыкарасу', regionCode: '15', districtCode: '56' },
  { code: '33300', name: 'с.Енбекши', regionCode: '15', districtCode: '56' },
  { code: '33400', name: 'с.Сартогай', regionCode: '15', districtCode: '56' },
  { code: '35100', name: 'с.Шыгырлы', regionCode: '15', districtCode: '56' },
  { code: '35400', name: 'с.Ащисай', regionCode: '15', districtCode: '56' },
  { code: '35500', name: 'а.Бирлик', regionCode: '15', districtCode: '56' },
  { code: '37100', name: 'с.Кумкудук', regionCode: '15', districtCode: '56' },
  { code: '37200', name: 'с.Бабатай', regionCode: '15', districtCode: '56' },
  { code: '37300', name: 'с.Шибулак', regionCode: '15', districtCode: '56' },
  { code: '39100', name: 'с.Кенкияк', regionCode: '15', districtCode: '56' },
  { code: '39200', name: 'с.Башенколь', regionCode: '15', districtCode: '56' },
  { code: '41100', name: 'с.Копа', regionCode: '15', districtCode: '56' },
  { code: '41200', name: 'с.Акжар', regionCode: '15', districtCode: '56' },
  {
    code: '41300',
    name: 'ст.Калмаккырган',
    regionCode: '15',
    districtCode: '56'
  },
  { code: '41600', name: 'с.Шитубек', regionCode: '15', districtCode: '56' },
  { code: '42100', name: 'с.Сарколь', regionCode: '15', districtCode: '56' },
  { code: '42400', name: 'с.Копа', regionCode: '15', districtCode: '56' },
  { code: '42500', name: 'с.Кумсай', regionCode: '15', districtCode: '56' },
  { code: '43100', name: 'с.Таскопа', regionCode: '15', districtCode: '56' },
  { code: '43300', name: 'а.Теректы', regionCode: '15', districtCode: '56' },
  { code: '49100', name: 'п.Шубарши', regionCode: '15', districtCode: '56' },
  { code: '33100', name: 'с.Абай', regionCode: '15', districtCode: '60' },
  { code: '33200', name: 'а.Жарбутак', regionCode: '15', districtCode: '60' },
  { code: '33300', name: 'с.Аралтобе', regionCode: '15', districtCode: '60' },
  { code: '30100', name: 'с.Уил', regionCode: '15', districtCode: '52' },
  { code: '30200', name: 'с.Акшатау', regionCode: '15', districtCode: '52' },
  { code: '30300', name: 'с.Екпетал', regionCode: '15', districtCode: '52' },
  { code: '30400', name: 'с.Каракемер', regionCode: '15', districtCode: '52' },
  { code: '35100', name: 'с.Акжар', regionCode: '15', districtCode: '52' },
  { code: '35300', name: 'с.Косембай', regionCode: '15', districtCode: '52' },
  { code: '37100', name: 'с.Караой', regionCode: '15', districtCode: '52' },
  { code: '37200', name: 'с.Жаксыколь', regionCode: '15', districtCode: '52' },
  { code: '37300', name: 'с.Кубасай', regionCode: '15', districtCode: '52' },
  { code: '39100', name: 'с.Каратал', regionCode: '15', districtCode: '52' },
  { code: '39200', name: 'с.Карасу', regionCode: '15', districtCode: '52' },
  { code: '39300', name: 'с.Кумжарган', regionCode: '15', districtCode: '52' },
  { code: '43100', name: 'с.Коптогай', regionCode: '15', districtCode: '52' },
  { code: '43200', name: 'с.Амангельды', regionCode: '15', districtCode: '52' },
  { code: '43300', name: 'с.Карасу', regionCode: '15', districtCode: '52' },
  { code: '43400', name: 'с.Шубарши', regionCode: '15', districtCode: '52' },
  { code: '45100', name: 'с.Кемер', regionCode: '15', districtCode: '52' },
  { code: '45200', name: 'с.Аккемер', regionCode: '15', districtCode: '52' },
  { code: '10100', name: 'г.Актобе', regionCode: '15', districtCode: '1' },
  { code: '20100', name: 'г.Алга', regionCode: '15', districtCode: '32' },
  {
    code: '33100',
    name: 'аул Есета батыра Кокиулы',
    regionCode: '15',
    districtCode: '32'
  },
  { code: '33300', name: 'с.Кзылту', regionCode: '15', districtCode: '32' },
  { code: '33400', name: 'с.Темрей', regionCode: '15', districtCode: '32' },
  { code: '35100', name: 'с.Бестамак', regionCode: '15', districtCode: '32' },
  { code: '35300', name: 'с.Бескоспа', regionCode: '15', districtCode: '32' },
  { code: '37100', name: 'а. Каракудык', regionCode: '15', districtCode: '32' },
  { code: '37200', name: 'а.Коктогай', regionCode: '15', districtCode: '32' },
  { code: '37300', name: 'а.Тиккайын', regionCode: '15', districtCode: '32' },
  { code: '39100', name: 'а.Акай', regionCode: '15', districtCode: '32' },
  { code: '39200', name: 'а.Булаксай', regionCode: '15', districtCode: '32' },
  { code: '39300', name: 'с.Культабан', regionCode: '15', districtCode: '32' },
  { code: '41100', name: 'а.Ушкудык', regionCode: '15', districtCode: '32' },
  { code: '41200', name: 'с.Жеруйык', regionCode: '15', districtCode: '32' },
  { code: '41300', name: 'с.Аксазды', regionCode: '15', districtCode: '32' },
  { code: '42100', name: 'с.Самбай', regionCode: '15', districtCode: '32' },
  { code: '42800', name: 'а.Нурбулак', regionCode: '15', districtCode: '32' },
  { code: '43100', name: 'с.Карабулак', regionCode: '15', districtCode: '32' },
  { code: '43200', name: 'с.Амангельды', regionCode: '15', districtCode: '32' },
  { code: '45100', name: 'с.Карахобда', regionCode: '15', districtCode: '32' },
  { code: '45300', name: 'с.Ерназар', regionCode: '15', districtCode: '32' },
  { code: '45400', name: 'а.Кумсай', regionCode: '15', districtCode: '32' },
  {
    code: '47100',
    name: 'с.Маржанбулак',
    regionCode: '15',
    districtCode: '32'
  },
  { code: '47200', name: 'а.Кайындысай', regionCode: '15', districtCode: '32' },
  {
    code: '47300',
    name: 'с.Карагандысай',
    regionCode: '15',
    districtCode: '32'
  },
  { code: '48100', name: 'а.Сарыхобда', regionCode: '15', districtCode: '32' },
  { code: '48300', name: 'с.Болгарка', regionCode: '15', districtCode: '32' },
  { code: '49100', name: 'с.Тамды', regionCode: '15', districtCode: '32' },
  { code: '49200', name: 'с.Еркинкуш', regionCode: '15', districtCode: '32' },
  { code: '49300', name: 'а.Талдысай', regionCode: '15', districtCode: '32' },
  { code: '51100', name: 'а.Кайнар', regionCode: '15', districtCode: '32' },
  { code: '51200', name: 'с.Олетты', regionCode: '15', districtCode: '32' },
  { code: '51300', name: 'с.Токмансай', regionCode: '15', districtCode: '32' },
  { code: '51400', name: 'ст.Токмансай', regionCode: '15', districtCode: '32' },
  {
    code: '30100',
    name: 'с.Комсомольское',
    regionCode: '15',
    districtCode: '34'
  },
  { code: '30200', name: 'с.Богетколь', regionCode: '15', districtCode: '34' },
  { code: '30400', name: 'с.Таскожа', regionCode: '15', districtCode: '34' },
  { code: '30500', name: 'с.Талдысай', regionCode: '15', districtCode: '34' },
  { code: '33100', name: 'с.Акколь', regionCode: '15', districtCode: '34' },
  { code: '35100', name: 'с.Актасты', regionCode: '15', districtCode: '34' },
  { code: '35300', name: 'с.Толыбай', regionCode: '15', districtCode: '34' },
  { code: '37100', name: 'с.Аралтогай', regionCode: '15', districtCode: '34' },
  { code: '37300', name: 'с.Киякты', regionCode: '15', districtCode: '34' },
  { code: '37400', name: 'с.Милысай', regionCode: '15', districtCode: '34' },
  {
    code: '37500',
    name: 'Отделение Улгайсын',
    regionCode: '15',
    districtCode: '34'
  },
  {
    code: '53300',
    name: 'с.13 лет Казахстана',
    regionCode: '15',
    districtCode: '46'
  },
  { code: '53400', name: 'с.Акмоласай', regionCode: '15', districtCode: '46' },
  {
    code: '55100',
    name: 'с.Вознесеновка',
    regionCode: '15',
    districtCode: '46'
  },
  { code: '55200', name: 'с.Веренка', regionCode: '15', districtCode: '46' },
  { code: '55300', name: 'с.Первомайка', regionCode: '15', districtCode: '46' },
  { code: '55400', name: 'а.Жанажол', regionCode: '15', districtCode: '46' },
  { code: '55500', name: 'а.Карабулак', regionCode: '15', districtCode: '46' },
  { code: '57100', name: 'с.Родниковка', regionCode: '15', districtCode: '46' },
  { code: '57200', name: 'с.Бурте', regionCode: '15', districtCode: '46' },
  { code: '57280', name: 'с.Бутак', regionCode: '15', districtCode: '46' },
  { code: '57400', name: 'с.Калиновка', regionCode: '15', districtCode: '46' },
  { code: '57500', name: 'с.Сынтас', regionCode: '15', districtCode: '46' },
  { code: '59100', name: 'с.Курмансай', regionCode: '15', districtCode: '46' },
  { code: '59200', name: 'с.Ефремовка', regionCode: '15', districtCode: '46' },
  { code: '59300', name: 'а.Егизата', regionCode: '15', districtCode: '46' },
  { code: '59400', name: 'а.Шанды', regionCode: '15', districtCode: '46' },
  { code: '59500', name: 'а.Торайгыр', regionCode: '15', districtCode: '46' },
  {
    code: '61100',
    name: 'с.Хлебодаровка',
    regionCode: '15',
    districtCode: '46'
  },
  { code: '61200', name: 'рзд.37', regionCode: '15', districtCode: '46' },
  { code: '20100', name: 'г.Кандыагаш', regionCode: '15', districtCode: '48' },
  { code: '23100', name: 'г.Эмба', regionCode: '15', districtCode: '48' },
  { code: '23400', name: 'рзд.57', regionCode: '15', districtCode: '48' },
  { code: '25100', name: 'г.Жем', regionCode: '15', districtCode: '48' },
  { code: '33100', name: 'с.Аккемир', regionCode: '15', districtCode: '48' },
  { code: '33200', name: 'а.Коктобе', regionCode: '15', districtCode: '48' },
  { code: '33300', name: 'с.Жарык', regionCode: '15', districtCode: '48' },
  { code: '33400', name: 'а.Елек', regionCode: '15', districtCode: '48' },
  { code: '33600', name: 'а.Котибар', regionCode: '15', districtCode: '48' },
  { code: '35100', name: 'с.Ащесай', regionCode: '15', districtCode: '48' },
  { code: '35300', name: 'с.Аксу', regionCode: '15', districtCode: '48' },
  { code: '35400', name: 'с.Басшили', regionCode: '15', districtCode: '48' },
  {
    code: '35500',
    name: 'с.Сабындыкуль',
    regionCode: '15',
    districtCode: '48'
  },
  { code: '37100', name: 'с.Жагабулак', regionCode: '15', districtCode: '48' },
  { code: '37200', name: 'с.Жаркемер', regionCode: '15', districtCode: '48' },
  { code: '37300', name: 'с.Кожасай', regionCode: '15', districtCode: '48' },
  { code: '37400', name: 'с.Сага', regionCode: '15', districtCode: '48' },
  { code: '39100', name: 'а. Булакты', regionCode: '15', districtCode: '48' },
  { code: '39600', name: 'с.Миялыколь', regionCode: '15', districtCode: '48' },
  { code: '41100', name: 'с.Сагашили', regionCode: '15', districtCode: '48' },
  { code: '41200', name: 'а.Басшили', regionCode: '15', districtCode: '48' },
  {
    code: '41880',
    name: 'ст.Темир-мост',
    regionCode: '15',
    districtCode: '48'
  },
  {
    code: '41900',
    name: 'а.Тепсен-Карабулак',
    regionCode: '15',
    districtCode: '48'
  },
  { code: '43100', name: 'а.Караколь', regionCode: '15', districtCode: '48' },
  { code: '43200', name: 'с.Жанатурмыс', regionCode: '15', districtCode: '48' },
  {
    code: '43300',
    name: 'а.Каралаатсай',
    regionCode: '15',
    districtCode: '48'
  },
  { code: '45100', name: 'с.Джурун', regionCode: '15', districtCode: '48' },
  { code: '45300', name: 'а. Кобелей', regionCode: '15', districtCode: '48' },
  {
    code: '45400',
    name: 'а. Колденен Темир',
    regionCode: '15',
    districtCode: '48'
  },
  { code: '45500', name: 'с.Опытное', regionCode: '15', districtCode: '48' },
  { code: '45600', name: 'рзд.53', regionCode: '15', districtCode: '48' },
  { code: '45700', name: 'ст.Изимбет', regionCode: '15', districtCode: '48' },
  { code: '47100', name: 'с.Кайынды', regionCode: '15', districtCode: '48' },
  { code: '47300', name: 'с.Алтынды', regionCode: '15', districtCode: '48' },
  { code: '51100', name: 'а.Бирлик', regionCode: '15', districtCode: '48' },
  { code: '51300', name: 'а.Кумсай', regionCode: '15', districtCode: '48' },
  { code: '51400', name: 'с.Кумжарган', regionCode: '15', districtCode: '48' },
  { code: '51500', name: 'с.Шенгельши', regionCode: '15', districtCode: '48' },
  { code: '55100', name: 'с.Кумсай', regionCode: '15', districtCode: '48' },
  { code: '55400', name: 'с.Жамбыл', regionCode: '15', districtCode: '48' },
  { code: '55600', name: 'с.Терисбутак', regionCode: '15', districtCode: '48' },
  { code: '55800', name: 'а.Шили', regionCode: '15', districtCode: '48' },
  { code: '57100', name: 'с.Мугалжар', regionCode: '15', districtCode: '48' },
  { code: '65100', name: 'с.Талдысай', regionCode: '15', districtCode: '48' },
  { code: '65400', name: 'с.Енбек', regionCode: '15', districtCode: '48' },
  { code: '30100', name: 'а.Кобда', regionCode: '15', districtCode: '42' },
  { code: '33100', name: 'с.Акраб', regionCode: '15', districtCode: '42' },
  { code: '33300', name: 'с.Карабулак', regionCode: '15', districtCode: '42' },
  { code: '35100', name: 'а.Бестау', regionCode: '15', districtCode: '42' },
  { code: '35300', name: 'с.Каратал', regionCode: '15', districtCode: '42' },
  { code: '37100', name: 'с.Сарбулак', regionCode: '15', districtCode: '42' },
  { code: '39100', name: 'аул Алия', regionCode: '15', districtCode: '42' },
  { code: '39200', name: 'с.Булак', regionCode: '15', districtCode: '42' },
  { code: '39300', name: 'с.Талдысай', regionCode: '15', districtCode: '42' },
  {
    code: '41100',
    name: 'а.им.Имангали Билтабанова',
    regionCode: '15',
    districtCode: '42'
  },
  { code: '41200', name: 'с.Косоткель', regionCode: '15', districtCode: '42' },
  { code: '41300', name: 'а.Казакай', regionCode: '15', districtCode: '42' },
  { code: '41500', name: 'а.Байтак', regionCode: '15', districtCode: '42' },
  { code: '45100', name: 'а.Жанаталап', regionCode: '15', districtCode: '42' },
  { code: '45200', name: 'а.Жайылма', regionCode: '15', districtCode: '42' },
  { code: '47100', name: 'а.Жарсай', regionCode: '15', districtCode: '42' },
  { code: '47200', name: 'а.Аксай', regionCode: '15', districtCode: '42' },
  { code: '47300', name: 'с.Караганда', regionCode: '15', districtCode: '42' },
  { code: '49100', name: 'с.Жарык', regionCode: '15', districtCode: '42' },
  { code: '49200', name: 'с.Ащыкара', regionCode: '15', districtCode: '42' },
  { code: '49300', name: 'с.Жаманколь', regionCode: '15', districtCode: '42' },
  { code: '49400', name: 'с.Канай', regionCode: '15', districtCode: '42' },
  { code: '49500', name: 'с.Ортак', regionCode: '15', districtCode: '42' },
  { code: '51100', name: 'с.Жиренкопа', regionCode: '15', districtCode: '42' },
  { code: '51300', name: 'с.Тентеккара', regionCode: '15', districtCode: '42' },
  { code: '53100', name: 'с.Жарсай', regionCode: '15', districtCode: '42' },
  { code: '55100', name: 'с.Калиновка', regionCode: '15', districtCode: '42' },
  { code: '57100', name: 'а.Кызылжар', regionCode: '15', districtCode: '42' },
  { code: '57300', name: 'а.Каракемер', regionCode: '15', districtCode: '42' },
  { code: '58100', name: 'с.Бегалы', regionCode: '15', districtCode: '42' },
  {
    code: '58500',
    name: 'а.Егиндибулак',
    regionCode: '15',
    districtCode: '42'
  },
  { code: '59100', name: 'а.Курсай', regionCode: '15', districtCode: '42' },
  { code: '61100', name: 'а.Отек', regionCode: '15', districtCode: '42' },
  { code: '63100', name: 'а.Кок Уй', regionCode: '15', districtCode: '42' },
  { code: '63200', name: 'с.Когалы', regionCode: '15', districtCode: '42' },
  { code: '63300', name: 'с.Согалы', regionCode: '15', districtCode: '42' },
  { code: '67100', name: 'а.Терисаккан', regionCode: '15', districtCode: '42' },
  { code: '30100', name: 'с.Мартук', regionCode: '15', districtCode: '46' },
  { code: '30500', name: 'с.Кумсай', regionCode: '15', districtCode: '46' },
  { code: '35100', name: 'с.Байтурасай', regionCode: '15', districtCode: '46' },
  { code: '35200', name: 'с.Дмитриевка', regionCode: '15', districtCode: '46' },
  { code: '35300', name: 'с.Покровка', regionCode: '15', districtCode: '46' },
  { code: '35400', name: 'с.Полтавка', regionCode: '15', districtCode: '46' },
  { code: '37100', name: 'с.Хазретовка', regionCode: '15', districtCode: '46' },
  { code: '37200', name: 'а.Жездибай', regionCode: '15', districtCode: '46' },
  { code: '37300', name: 'с.Кия', regionCode: '15', districtCode: '46' },
  { code: '39100', name: 'с.Яйсан', regionCode: '15', districtCode: '46' },
  { code: '39200', name: 'с.Жанатан', regionCode: '15', districtCode: '46' },
  { code: '39300', name: 'с.Казахстан', regionCode: '15', districtCode: '46' },
  { code: '39400', name: 'а.Козы', regionCode: '15', districtCode: '46' },
  { code: '39500', name: 'а.Кокпекти', regionCode: '15', districtCode: '46' },
  { code: '43100', name: 'с.Каратогай', regionCode: '15', districtCode: '46' },
  { code: '45100', name: 'с.Каратаусай', regionCode: '15', districtCode: '46' },
  { code: '45200', name: 'с.Джуса', regionCode: '15', districtCode: '46' },
  { code: '45300', name: 'а.Аккайын', regionCode: '15', districtCode: '46' },
  { code: '45500', name: 'с.Линовицкое', regionCode: '15', districtCode: '46' },
  { code: '47100', name: 'а.Кызылжар', regionCode: '15', districtCode: '46' },
  { code: '47200', name: 'а.Борте', regionCode: '15', districtCode: '46' },
  { code: '47300', name: 'с.Шевченко', regionCode: '15', districtCode: '46' },
  {
    code: '51100',
    name: 'аул Саржансай',
    regionCode: '15',
    districtCode: '46'
  },
  { code: '51200', name: 'с.Аксу', regionCode: '15', districtCode: '46' },
  { code: '51300', name: 'с.Кенсахара', regionCode: '15', districtCode: '46' },
  { code: '53100', name: 'а.Байнассай', regionCode: '15', districtCode: '46' },
  { code: '53200', name: 'с.Горноводск', regionCode: '15', districtCode: '46' },
  { code: '43600', name: 'с.Сарбулак', regionCode: '15', districtCode: '34' },
  { code: '47100', name: 'с.Жабасак', regionCode: '15', districtCode: '34' },
  { code: '47200', name: 'с.Аккум', regionCode: '15', districtCode: '34' },
  { code: '47400', name: 'с.Байжанкол', regionCode: '15', districtCode: '34' },
  { code: '47500', name: 'с.Карасу', regionCode: '15', districtCode: '34' },
  { code: '49100', name: 'с.Жамбыл', regionCode: '15', districtCode: '34' },
  { code: '51100', name: 'с.Талдык', regionCode: '15', districtCode: '34' },
  { code: '53100', name: 'с.Карабутак', regionCode: '15', districtCode: '34' },
  { code: '53300', name: 'с.Белкопа', regionCode: '15', districtCode: '34' },
  { code: '53400', name: 'с.Енбекту', regionCode: '15', districtCode: '34' },
  { code: '53500', name: 'с.Жароткель', regionCode: '15', districtCode: '34' },
  { code: '57100', name: 'с.Кумкудук', regionCode: '15', districtCode: '34' },
  { code: '58100', name: 'с.Сарат', regionCode: '15', districtCode: '34' },
  { code: '58400', name: 'с.Кырыккудук', regionCode: '15', districtCode: '34' },
  { code: '59100', name: 'с.Сулуколь', regionCode: '15', districtCode: '34' },
  { code: '73100', name: 'с.Ушкатты', regionCode: '15', districtCode: '34' },
  {
    code: '30100',
    name: 'с.Карауылкелды',
    regionCode: '15',
    districtCode: '36'
  },
  { code: '30300', name: 'с.Казахстан', regionCode: '15', districtCode: '36' },
  { code: '30400', name: 'с.Кокбулак', regionCode: '15', districtCode: '36' },
  { code: '30500', name: 'с.Косарал', regionCode: '15', districtCode: '36' },
  { code: '33100', name: 'с.Hогайты', regionCode: '15', districtCode: '36' },
  { code: '35100', name: 'с.Оймаут', regionCode: '15', districtCode: '36' },
  { code: '37100', name: 'с.Жаркамыс', regionCode: '15', districtCode: '36' },
  { code: '37200', name: 'с.Актам', regionCode: '15', districtCode: '36' },
  { code: '37400', name: 'с.Каражар', regionCode: '15', districtCode: '36' },
  { code: '41100', name: 'с.Жарлы', regionCode: '15', districtCode: '36' },
  { code: '41300', name: 'с.Кораши', regionCode: '15', districtCode: '36' },
  {
    code: '41500',
    name: 'с.Жынгылдытогай',
    regionCode: '15',
    districtCode: '36'
  },
  { code: '43100', name: 'с.Ебейты', regionCode: '15', districtCode: '36' },
  { code: '43200', name: 'с.Айрык', regionCode: '15', districtCode: '36' },
  { code: '43300', name: 'с.Коптогай', regionCode: '15', districtCode: '36' },
  { code: '43400', name: 'с.Копа', regionCode: '15', districtCode: '36' },
  { code: '49100', name: 'с.Кемерши', regionCode: '15', districtCode: '36' },
  {
    code: '49200',
    name: 'с.Булактыколь',
    regionCode: '15',
    districtCode: '36'
  },
  { code: '49300', name: 'с.Жанатан', regionCode: '15', districtCode: '36' },
  {
    code: '51100',
    name: 'аул Алтай батыра',
    regionCode: '15',
    districtCode: '36'
  },
  { code: '51200', name: 'с.Баршакум', regionCode: '15', districtCode: '36' },
  { code: '51300', name: 'с.Шукырши', regionCode: '15', districtCode: '36' },
  { code: '55100', name: 'с.Миялы', regionCode: '15', districtCode: '36' },
  { code: '55200', name: 'с.Бесбай', regionCode: '15', districtCode: '36' },
  { code: '55300', name: 'с.Дияр', regionCode: '15', districtCode: '36' },
  { code: '30100', name: 'с.Бадамша', regionCode: '15', districtCode: '40' },
  { code: '33100', name: 'а.Ащылысай', regionCode: '15', districtCode: '40' },
  { code: '33200', name: 'а.Бозтобе', regionCode: '15', districtCode: '40' },
  {
    code: '33400',
    name: 'с.Преображеновка',
    regionCode: '15',
    districtCode: '40'
  },
  { code: '33500', name: 'а.Акколь', regionCode: '15', districtCode: '40' },
  { code: '35100', name: 'с.Алимбет', regionCode: '15', districtCode: '40' },
  { code: '35200', name: 'с.Богенбай', regionCode: '15', districtCode: '40' },
  { code: '35300', name: 'с.Кызылсай', regionCode: '15', districtCode: '40' },
  { code: '35400', name: 'а.Шандыаша', regionCode: '15', districtCode: '40' },
  { code: '49100', name: 'с.Велиховка', regionCode: '15', districtCode: '40' },
  { code: '49400', name: 'а.Акжайык', regionCode: '15', districtCode: '40' },
  {
    code: '51100',
    name: 'с.Петропавловка',
    regionCode: '15',
    districtCode: '40'
  },
  {
    code: '51200',
    name: 'а.Шамши Калдаякова',
    regionCode: '15',
    districtCode: '40'
  },
  { code: '53100', name: 'с.Жосалы', regionCode: '15', districtCode: '40' },
  { code: '53200', name: 'с.Кемпирсай', regionCode: '15', districtCode: '40' },
  { code: '53300', name: 'с.Карабутак', regionCode: '15', districtCode: '40' },
  { code: '55100', name: 'с.Кос-Истек', regionCode: '15', districtCode: '40' },
  { code: '55300', name: 'а.Сарыбулак', regionCode: '15', districtCode: '40' },
  { code: '57100', name: 'с.Степное', regionCode: '15', districtCode: '40' },
  { code: '57200', name: 'а.Кайракты', regionCode: '15', districtCode: '40' },
  {
    code: '57300',
    name: 'с.Кайрактысай',
    regionCode: '15',
    districtCode: '40'
  },
  { code: '57400', name: 'с.Мамыт', regionCode: '15', districtCode: '40' },
  {
    code: '57500',
    name: 'с.Первомайское',
    regionCode: '15',
    districtCode: '40'
  },
  {
    code: '47200',
    name: 'с.Базаркельды',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '47300', name: 'с.Космос', regionCode: '19', districtCode: '40' },
  { code: '49100', name: 'с.Кызылжар', regionCode: '19', districtCode: '40' },
  { code: '49200', name: 'с.Алмалы', regionCode: '19', districtCode: '40' },
  { code: '49300', name: 'с.Коктобе', regionCode: '19', districtCode: '40' },
  { code: '49400', name: 'с.Толе би', regionCode: '19', districtCode: '40' },
  { code: '51100', name: 'с.Казахстан', regionCode: '19', districtCode: '40' },
  { code: '51200', name: 'с.Ащибулак', regionCode: '19', districtCode: '40' },
  {
    code: '51300',
    name: 'с.им.Ж.Кайыпова',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '53100', name: 'с.Каражота', regionCode: '19', districtCode: '40' },
  { code: '53200', name: 'с.Актогай', regionCode: '19', districtCode: '40' },
  { code: '53300', name: 'с.Сарыбулак', regionCode: '19', districtCode: '40' },
  { code: '55100', name: 'с.Каракемер', regionCode: '19', districtCode: '40' },
  { code: '55200', name: 'с.Сатай', regionCode: '19', districtCode: '40' },
  { code: '55300', name: 'с.Талдыбулак', regionCode: '19', districtCode: '40' },
  { code: '57100', name: 'с.Каратурык', regionCode: '19', districtCode: '40' },
  { code: '57200', name: 'с.Ащисай', regionCode: '19', districtCode: '40' },
  { code: '57300', name: 'с.Достык', regionCode: '19', districtCode: '40' },
  { code: '57400', name: 'с.Лавар', regionCode: '19', districtCode: '40' },
  {
    code: '57600',
    name: 'с.Таукаратурык',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '59100', name: 'с.Корам', regionCode: '19', districtCode: '40' },
  {
    code: '63100',
    name: 'с.Кырбалтабай',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '63200', name: 'с.Акжал', regionCode: '19', districtCode: '40' },
  { code: '63300', name: 'с.Екпинди', regionCode: '19', districtCode: '40' },
  { code: '63400', name: 'с.Кайнар', regionCode: '19', districtCode: '40' },
  { code: '63500', name: 'с.Шалкар', regionCode: '19', districtCode: '40' },
  { code: '30300', name: 'с.Карасу', regionCode: '19', districtCode: '68' },
  {
    code: '33100',
    name: 'с.Мухаметжан Туймебаева',
    regionCode: '19',
    districtCode: '68'
  },
  {
    code: '33200',
    name: 'с.Жапек батыра',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '33300', name: 'с.Коккайнар', regionCode: '19', districtCode: '68' },
  { code: '33600', name: 'с.Толе би', regionCode: '19', districtCode: '68' },
  { code: '35100', name: 'п.Боралдай', regionCode: '19', districtCode: '68' },
  { code: '37100', name: 'с.Жетыген', regionCode: '19', districtCode: '68' },
  { code: '37200', name: 'с.Енбек', regionCode: '19', districtCode: '68' },
  { code: '37300', name: 'с.Жанаарна', regionCode: '19', districtCode: '68' },
  { code: '37400', name: 'с.Кайрат', regionCode: '19', districtCode: '68' },
  { code: '37500', name: 'с.Куйган', regionCode: '19', districtCode: '68' },
  { code: '39100', name: 'с.Казцик', regionCode: '19', districtCode: '68' },
  { code: '39200', name: 'с.Комсомол', regionCode: '19', districtCode: '68' },
  { code: '43100', name: 'с.Караой', regionCode: '19', districtCode: '68' },
  { code: '43200', name: 'с.Косозен', regionCode: '19', districtCode: '68' },
  {
    code: '43300',
    name: 'с.Нургиса Тлендиев',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '45100', name: 'с.Акши', regionCode: '19', districtCode: '68' },
  { code: '45200', name: 'с.Курты', regionCode: '19', districtCode: '68' },
  { code: '47100', name: 'с.Байсерке', regionCode: '19', districtCode: '68' },
  { code: '47200', name: 'с.Али', regionCode: '19', districtCode: '68' },
  { code: '47300', name: 'с.Жанадаур', regionCode: '19', districtCode: '68' },
  { code: '47400', name: 'с.Жанаталап', regionCode: '19', districtCode: '68' },
  { code: '47500', name: 'с.Коктерек', regionCode: '19', districtCode: '68' },
  { code: '47600', name: 'с.Ынтымак', regionCode: '19', districtCode: '68' },
  {
    code: '49100',
    name: 'с.Междуреченское',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '49200', name: 'с.Екпинды', regionCode: '19', districtCode: '68' },
  { code: '49300', name: 'с.Жаугашты', regionCode: '19', districtCode: '68' },
  {
    code: '53100',
    name: 'п.Первомайский',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '53200', name: 'с.Коянкус', regionCode: '19', districtCode: '68' },
  { code: '55100', name: 'с.Чапаево', regionCode: '19', districtCode: '68' },
  { code: '37100', name: 'ст.Шамалган', regionCode: '19', districtCode: '52' },
  { code: '37400', name: 'с.Жаналык', regionCode: '19', districtCode: '46' },
  { code: '196257100', name: 'с.Нура', regionCode: '19', districtCode: '62' },
  {
    code: '196830200',
    name: 'п.Покровка',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '63100', name: 'с.Чарын', regionCode: '19', districtCode: '66' },
  { code: '59100', name: 'с.Шатырбай', regionCode: '19', districtCode: '60' },
  {
    code: '57500',
    name: 'с.Меллиоратор',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '67300', name: 'с.Жунжурек', regionCode: '19', districtCode: '34' },
  { code: '67400', name: 'с.Чимбулак', regionCode: '19', districtCode: '34' },
  { code: '69100', name: 'с.Теректы', regionCode: '19', districtCode: '34' },
  { code: '69200', name: 'с.Талдыбулак', regionCode: '19', districtCode: '34' },
  { code: '71100', name: 'с.Токжайлау', regionCode: '19', districtCode: '34' },
  { code: '73100', name: 'с.Ушбулак', regionCode: '19', districtCode: '34' },
  { code: '73200', name: 'с.Айпара', regionCode: '19', districtCode: '34' },
  { code: '73300', name: 'с.Кенес', regionCode: '19', districtCode: '34' },
  { code: '75100', name: 'с.Ынталы', regionCode: '19', districtCode: '34' },
  { code: '77100', name: 'с.Коктума', regionCode: '19', districtCode: '34' },
  { code: '77200', name: 'с.Акши', regionCode: '19', districtCode: '34' },
  { code: '30100', name: 'с.Баканас', regionCode: '19', districtCode: '36' },
  { code: '30200', name: 'с.Бояулы', regionCode: '19', districtCode: '36' },
  { code: '30300', name: 'с.Ушжарма', regionCode: '19', districtCode: '36' },
  { code: '33100', name: 'с.Акдала', regionCode: '19', districtCode: '36' },
  { code: '35100', name: 'с.Барибаева', regionCode: '19', districtCode: '36' },
  { code: '35200', name: 'с.Аралтобе', regionCode: '19', districtCode: '36' },
  { code: '37100', name: 'с.Акколь', regionCode: '19', districtCode: '36' },
  { code: '37200', name: 'с.Кокжиде', regionCode: '19', districtCode: '36' },
  { code: '43100', name: 'с.Бакбакты', regionCode: '19', districtCode: '36' },
  { code: '45100', name: 'с.Береке', regionCode: '19', districtCode: '36' },
  { code: '45200', name: 'с.Бура', regionCode: '19', districtCode: '36' },
  { code: '47100', name: 'с.Бирлик', regionCode: '19', districtCode: '36' },
  { code: '49100', name: 'с.Желторангы', regionCode: '19', districtCode: '36' },
  { code: '49200', name: 'с.Каскаогиз', regionCode: '19', districtCode: '36' },
  { code: '53100', name: 'с.Жидели', regionCode: '19', districtCode: '36' },
  { code: '53400', name: 'с.Кошкарбай', regionCode: '19', districtCode: '36' },
  {
    code: '53500',
    name: 'с.Оракты батыр',
    regionCode: '19',
    districtCode: '36'
  },
  { code: '55100', name: 'с.Коктал', regionCode: '19', districtCode: '36' },
  { code: '55300', name: 'с.Коскумбез', regionCode: '19', districtCode: '36' },
  { code: '57100', name: 'с.Караой', regionCode: '19', districtCode: '36' },
  { code: '57200', name: 'с.Аралкум', regionCode: '19', districtCode: '36' },
  { code: '57300', name: 'с.Аркар', regionCode: '19', districtCode: '36' },
  { code: '59100', name: 'с.Балатопар', regionCode: '19', districtCode: '36' },
  { code: '59300', name: 'с.Акдала', regionCode: '19', districtCode: '36' },
  { code: '63100', name: 'с.Миялы', regionCode: '19', districtCode: '36' },
  { code: '65100', name: 'с.Куйган', regionCode: '19', districtCode: '36' },
  { code: '65200', name: 'с.Караозек', regionCode: '19', districtCode: '36' },
  { code: '67100', name: 'с.Топар', regionCode: '19', districtCode: '36' },
  { code: '20100', name: 'г.Есик', regionCode: '19', districtCode: '40' },
  { code: '33100', name: 'с.Ават', regionCode: '19', districtCode: '40' },
  { code: '35100', name: 'с.Акши', regionCode: '19', districtCode: '40' },
  { code: '35200', name: 'с.Казатком', regionCode: '19', districtCode: '40' },
  { code: '35300', name: 'с.Кайрат', regionCode: '19', districtCode: '40' },
  { code: '35500', name: 'с.Сазы', regionCode: '19', districtCode: '40' },
  { code: '37100', name: 'с.Кызылшарык', regionCode: '19', districtCode: '40' },
  { code: '37200', name: 'с.Асы-Сага', regionCode: '19', districtCode: '40' },
  { code: '37300', name: 'с.Дихан', regionCode: '19', districtCode: '40' },
  { code: '37400', name: 'с.Жанашаруа', regionCode: '19', districtCode: '40' },
  { code: '37500', name: 'с.Кайрат', regionCode: '19', districtCode: '40' },
  { code: '37700', name: 'с.Сарытау', regionCode: '19', districtCode: '40' },
  { code: '37800', name: 'с.Таусугур', regionCode: '19', districtCode: '40' },
  { code: '39100', name: 'с.Балтабай', regionCode: '19', districtCode: '40' },
  { code: '39200', name: 'с.Акбастау', regionCode: '19', districtCode: '40' },
  { code: '39300', name: 'с.Актогай', regionCode: '19', districtCode: '40' },
  { code: '39400', name: 'с.Бирлик', regionCode: '19', districtCode: '40' },
  { code: '39500', name: 'с.Енбек', regionCode: '19', districtCode: '40' },
  { code: '39600', name: 'с.Куш', regionCode: '19', districtCode: '40' },
  { code: '39700', name: 'с.Орнек', regionCode: '19', districtCode: '40' },
  { code: '41100', name: 'с.Болек', regionCode: '19', districtCode: '40' },
  { code: '41200', name: 'с.Аймен', regionCode: '19', districtCode: '40' },
  { code: '41300', name: 'с.Карасай', regionCode: '19', districtCode: '40' },
  { code: '43100', name: 'с.Маловодное', regionCode: '19', districtCode: '40' },
  { code: '47100', name: 'с.Жанашар', regionCode: '19', districtCode: '40' },
  { code: '65100', name: 'с.Кызылагаш', regionCode: '19', districtCode: '32' },
  { code: '65200', name: 'с.Заречное', regionCode: '19', districtCode: '32' },
  { code: '65400', name: 'с.Копалы', regionCode: '19', districtCode: '32' },
  {
    code: '67100',
    name: 'с.Барлыбека Сырттанова',
    regionCode: '19',
    districtCode: '32'
  },
  { code: '67200', name: 'с.Копа', regionCode: '19', districtCode: '32' },
  { code: '69100', name: 'п.Матай', regionCode: '19', districtCode: '32' },
  { code: '69200', name: 'рзд.Акозек', regionCode: '19', districtCode: '32' },
  { code: '69300', name: 'рзд.Береке', regionCode: '19', districtCode: '32' },
  { code: '69400', name: 'рзд.Жасказах', regionCode: '19', districtCode: '32' },
  { code: '73100', name: 'п.Молалы', regionCode: '19', districtCode: '32' },
  { code: '73200', name: 'ст.Алажиде', regionCode: '19', districtCode: '32' },
  { code: '73400', name: 'рзд.Кайракты', regionCode: '19', districtCode: '32' },
  { code: '73500', name: 'рзд.Караой', regionCode: '19', districtCode: '32' },
  { code: '75100', name: 'с.Ойтоган', regionCode: '19', districtCode: '32' },
  { code: '75300', name: 'с.Улгили', regionCode: '19', districtCode: '32' },
  { code: '77100', name: 'с.Суыксай', regionCode: '19', districtCode: '32' },
  { code: '77200', name: 'с.Актобе', regionCode: '19', districtCode: '32' },
  { code: '77300', name: 'с.Ащыбулак', regionCode: '19', districtCode: '32' },
  { code: '77400', name: 'с.Баласаз', regionCode: '19', districtCode: '32' },
  { code: '20100', name: 'г.Ушарал', regionCode: '19', districtCode: '34' },
  { code: '20200', name: 'МТФ 3', regionCode: '19', districtCode: '34' },
  { code: '33100', name: 'с.Акжар', regionCode: '19', districtCode: '34' },
  { code: '33200', name: 'с.Коныр', regionCode: '19', districtCode: '34' },
  { code: '33300', name: 'с.Майлышат', regionCode: '19', districtCode: '34' },
  { code: '35100', name: 'с.Актубек', regionCode: '19', districtCode: '34' },
  { code: '37100', name: 'с.Архарлы', regionCode: '19', districtCode: '34' },
  { code: '39100', name: 'с.Булакты', regionCode: '19', districtCode: '34' },
  { code: '39200', name: 'с.Бесколь', regionCode: '19', districtCode: '34' },
  { code: '39300', name: 'рзд.Пятый', regionCode: '19', districtCode: '34' },
  { code: '39400', name: 'с.Каратума', regionCode: '19', districtCode: '34' },
  { code: '39500', name: 'рзд.13', regionCode: '19', districtCode: '34' },
  { code: '39600', name: 'рзд.Сайхан', regionCode: '19', districtCode: '34' },
  { code: '41100', name: 'с.Сапак', regionCode: '19', districtCode: '34' },
  { code: '41200', name: 'а.Бибакан', regionCode: '19', districtCode: '34' },
  { code: '43100', name: 'п.Достык', regionCode: '19', districtCode: '34' },
  {
    code: '43200',
    name: 'ст.Жаланашколь',
    regionCode: '19',
    districtCode: '34'
  },
  { code: '43300', name: 'ст.Коктума', regionCode: '19', districtCode: '34' },
  { code: '45100', name: 'с.Екпенди', regionCode: '19', districtCode: '34' },
  { code: '45200', name: 'с.Карлыгаш', regionCode: '19', districtCode: '34' },
  { code: '45300', name: 'с.Ушкаиын', regionCode: '19', districtCode: '34' },
  { code: '47100', name: 'с.Енбекши', regionCode: '19', districtCode: '34' },
  { code: '49100', name: 'с.Казахстан', regionCode: '19', districtCode: '34' },
  { code: '49200', name: 'с.Бесагаш', regionCode: '19', districtCode: '34' },
  { code: '51100', name: 'с.Жанама', regionCode: '19', districtCode: '34' },
  {
    code: '51200',
    name: 'с.Старая Жанама',
    regionCode: '19',
    districtCode: '34'
  },
  { code: '51300', name: 'с.Карабулак', regionCode: '19', districtCode: '34' },
  { code: '53100', name: 'с.Жайпак', regionCode: '19', districtCode: '34' },
  { code: '55100', name: 'с.Жыланды', regionCode: '19', districtCode: '34' },
  { code: '55200', name: 'с.Ашим', regionCode: '19', districtCode: '34' },
  { code: '55300', name: 'с.Кокжар', regionCode: '19', districtCode: '34' },
  { code: '55400', name: 'с.Майкан', regionCode: '19', districtCode: '34' },
  { code: '55500', name: 'с.Шынжылы', regionCode: '19', districtCode: '34' },
  { code: '57100', name: 'с.Кольбай', regionCode: '19', districtCode: '34' },
  { code: '57200', name: 'с.Алемды', regionCode: '19', districtCode: '34' },
  { code: '57300', name: 'с.Будыр', regionCode: '19', districtCode: '34' },
  { code: '57400', name: 'с.Кызылкайын', regionCode: '19', districtCode: '34' },
  { code: '59100', name: 'с.Кабанбай', regionCode: '19', districtCode: '34' },
  { code: '59200', name: 'с.Жамбыл', regionCode: '19', districtCode: '34' },
  { code: '61100', name: 'с.Кайнар', regionCode: '19', districtCode: '34' },
  { code: '63100', name: 'с.Камыскала', regionCode: '19', districtCode: '34' },
  { code: '63200', name: 'с.Алаколь', regionCode: '19', districtCode: '34' },
  {
    code: '65100',
    name: 'с.Жумахан Балапанов',
    regionCode: '19',
    districtCode: '34'
  },
  { code: '67100', name: 'с.Лепсинск', regionCode: '19', districtCode: '34' },
  { code: '67200', name: 'с.Байзерек', regionCode: '19', districtCode: '34' },
  { code: '37200', name: 'а.Какимжан', regionCode: '19', districtCode: '60' },
  { code: '37300', name: 'с.Таскудык', regionCode: '19', districtCode: '60' },
  { code: '39100', name: 'с.Екиаша', regionCode: '19', districtCode: '60' },
  { code: '39200', name: 'с.Тополевка', regionCode: '19', districtCode: '60' },
  { code: '43100', name: 'с.Алмалы', regionCode: '19', districtCode: '60' },
  { code: '43200', name: 'с.Абай', regionCode: '19', districtCode: '60' },
  { code: '45100', name: 'с.Кокжиде', regionCode: '19', districtCode: '60' },
  { code: '47100', name: 'с.Коктерек', regionCode: '19', districtCode: '60' },
  { code: '49100', name: 'с.Карабогет', regionCode: '19', districtCode: '60' },
  {
    code: '51100',
    name: 'с.им.М.Тулебаева',
    regionCode: '19',
    districtCode: '60'
  },
  { code: '51200', name: 'с.Шубартубек', regionCode: '19', districtCode: '60' },
  { code: '51300', name: 'с.Ульга', regionCode: '19', districtCode: '60' },
  { code: '53100', name: 'с.Койлык', regionCode: '19', districtCode: '60' },
  { code: '55100', name: 'п.Лепсы', regionCode: '19', districtCode: '60' },
  { code: '55200', name: 'ст.Акбалык', regionCode: '19', districtCode: '60' },
  { code: '55300', name: 'ст.Арганаты', regionCode: '19', districtCode: '60' },
  {
    code: '55400',
    name: 'рзд.Керегетас',
    regionCode: '19',
    districtCode: '60'
  },
  {
    code: '55500',
    name: 'рзд.Кокшалгын',
    regionCode: '19',
    districtCode: '60'
  },
  { code: '55600', name: 'ст.Каратас', regionCode: '19', districtCode: '60' },
  {
    code: '55700',
    name: 'рзд.Сарыкурак',
    regionCode: '19',
    districtCode: '60'
  },
  { code: '57100', name: 'с.Черкасск', regionCode: '19', districtCode: '60' },
  { code: '57200', name: 'с.Каргалы', regionCode: '19', districtCode: '60' },
  { code: '57300', name: 'с.Аккайын', regionCode: '19', districtCode: '60' },
  {
    code: '57400',
    name: 'с.Петропавловка',
    regionCode: '19',
    districtCode: '60'
  },
  { code: '57500', name: 'с.Садовое', regionCode: '19', districtCode: '60' },
  { code: '57600', name: 'с.Соколовка', regionCode: '19', districtCode: '60' },
  { code: '20100', name: 'г.Талгар', regionCode: '19', districtCode: '62' },
  {
    code: '33100',
    name: 'с.Кызылкайрат',
    regionCode: '19',
    districtCode: '62'
  },
  { code: '33200', name: 'с.Алмалык', regionCode: '19', districtCode: '62' },
  { code: '33300', name: 'с.Алтындан', regionCode: '19', districtCode: '62' },
  {
    code: '10100',
    name: 'г.Талдыкорган',
    regionCode: '19',
    districtCode: '10'
  },
  { code: '16100', name: 'г.Капчагай', regionCode: '19', districtCode: '20' },
  { code: '26100', name: 'г.Текели', regionCode: '19', districtCode: '30' },
  { code: '30100', name: 'п.Жансугуров', regionCode: '19', districtCode: '32' },
  { code: '30200', name: 'с.Алтынарык', regionCode: '19', districtCode: '32' },
  { code: '30300', name: 'с.Кокозек', regionCode: '19', districtCode: '32' },
  { code: '33100', name: 'с.Аксу', regionCode: '19', districtCode: '32' },
  {
    code: '33200',
    name: 'с.Казсельхозтехника',
    regionCode: '19',
    districtCode: '32'
  },
  { code: '33300', name: 'с.Кокжайдак', regionCode: '19', districtCode: '32' },
  { code: '33400', name: 'с.Казахстан', regionCode: '19', districtCode: '32' },
  { code: '33500', name: 'с.Оним', regionCode: '19', districtCode: '32' },
  { code: '33600', name: 'с.Шолакозек', regionCode: '19', districtCode: '32' },
  { code: '35100', name: 'с.Арасан', regionCode: '19', districtCode: '32' },
  {
    code: '35200',
    name: 'с.Арасан-Капал',
    regionCode: '19',
    districtCode: '32'
  },
  { code: '35300', name: 'с.Кызылжар', regionCode: '19', districtCode: '32' },
  { code: '37100', name: 'с.Егинсу', regionCode: '19', districtCode: '32' },
  { code: '37200', name: 'ст.Кумтобе', regionCode: '19', districtCode: '32' },
  {
    code: '39100',
    name: 'с.Есебулатова',
    regionCode: '19',
    districtCode: '32'
  },
  { code: '39200', name: 'с.Кызылкайын', regionCode: '19', districtCode: '32' },
  { code: '39300', name: 'с.Энергетик', regionCode: '19', districtCode: '32' },
  { code: '45100', name: 'с.Жаналык', regionCode: '19', districtCode: '32' },
  { code: '47100', name: 'с.Кошкентал', regionCode: '19', districtCode: '32' },
  { code: '47200', name: 'с.Колтабан', regionCode: '19', districtCode: '32' },
  { code: '49100', name: 'с.Капал', regionCode: '19', districtCode: '32' },
  { code: '53100', name: 'с.Каракоз', regionCode: '19', districtCode: '32' },
  { code: '53200', name: 'с.Кенкарын', regionCode: '19', districtCode: '32' },
  { code: '55100', name: 'с.Кенжыра', regionCode: '19', districtCode: '32' },
  { code: '55200', name: 'с.Енбек', regionCode: '19', districtCode: '32' },
  { code: '55300', name: 'с.Тарас', regionCode: '19', districtCode: '32' },
  { code: '59100', name: 'с.Сагабуйен', regionCode: '19', districtCode: '32' },
  { code: '59300', name: 'с.Карашилик', regionCode: '19', districtCode: '32' },
  { code: '59400', name: 'с.Сагакурес', regionCode: '19', districtCode: '32' },
  { code: '63100', name: 'с.Кураксу', regionCode: '19', districtCode: '32' },
  {
    code: '59200',
    name: 'с.Диханкайрат',
    regionCode: '19',
    districtCode: '56'
  },
  { code: '59300', name: 'с.Жидели', regionCode: '19', districtCode: '56' },
  { code: '30100', name: 'с.Кеген', regionCode: '19', districtCode: '58' },
  { code: '30300', name: 'с.Темирлик', regionCode: '19', districtCode: '58' },
  { code: '30400', name: 'с.Туменбай', regionCode: '19', districtCode: '58' },
  { code: '33100', name: 'с.Алгабас', regionCode: '19', districtCode: '58' },
  { code: '33200', name: 'с.Жанаталап', regionCode: '19', districtCode: '58' },
  { code: '33300', name: 'с.Жинишке', regionCode: '19', districtCode: '58' },
  { code: '35100', name: 'с.Болексаз', regionCode: '19', districtCode: '58' },
  { code: '37100', name: 'с.Жаланаш', regionCode: '19', districtCode: '58' },
  {
    code: '37200',
    name: 'с.Жайдакбулак',
    regionCode: '19',
    districtCode: '58'
  },
  { code: '37300', name: 'с.Тогызбулак', regionCode: '19', districtCode: '58' },
  { code: '39100', name: 'с.Жамбыл', regionCode: '19', districtCode: '58' },
  { code: '39200', name: 'с.Каратоган', regionCode: '19', districtCode: '58' },
  { code: '41100', name: 'с.Жылысай', regionCode: '19', districtCode: '58' },
  { code: '41200', name: 'с.Мойнак', regionCode: '19', districtCode: '58' },
  { code: '41300', name: 'с.Шыбышы', regionCode: '19', districtCode: '58' },
  { code: '45100', name: 'с.Кайнар', regionCode: '19', districtCode: '58' },
  { code: '47100', name: 'с.Какпак', regionCode: '19', districtCode: '58' },
  { code: '47200', name: 'с.Кокбел', regionCode: '19', districtCode: '58' },
  {
    code: '49100',
    name: 'с.Акай Нусипбекова',
    regionCode: '19',
    districtCode: '58'
  },
  { code: '49300', name: 'с.Карабулак', regionCode: '19', districtCode: '58' },
  { code: '51100', name: 'с.Карасаз', regionCode: '19', districtCode: '58' },
  { code: '51200', name: 'с.Тузкол', regionCode: '19', districtCode: '58' },
  { code: '53100', name: 'с.Каркара', regionCode: '19', districtCode: '58' },
  { code: '53300', name: 'с.Ереул', regionCode: '19', districtCode: '58' },
  { code: '53500', name: 'с.Мынжылкы', regionCode: '19', districtCode: '58' },
  { code: '55100', name: 'с.Hарынкол', regionCode: '19', districtCode: '58' },
  { code: '55200', name: 'с.Костобе', regionCode: '19', districtCode: '58' },
  { code: '57100', name: 'с.Сарыбастау', regionCode: '19', districtCode: '58' },
  { code: '59100', name: 'с.Сарыжаз', regionCode: '19', districtCode: '58' },
  { code: '59200', name: 'с.Акбеит', regionCode: '19', districtCode: '58' },
  { code: '59300', name: 'с.Комирши', regionCode: '19', districtCode: '58' },
  { code: '61100', name: 'с.Саты', regionCode: '19', districtCode: '58' },
  { code: '61200', name: 'с.Курмети', regionCode: '19', districtCode: '58' },
  { code: '63100', name: 'с.Сумбе', regionCode: '19', districtCode: '58' },
  {
    code: '63200',
    name: 'с.Кызылшекара',
    regionCode: '19',
    districtCode: '58'
  },
  { code: '65100', name: 'с.Тасашы', regionCode: '19', districtCode: '58' },
  { code: '65200', name: 'с.Актасты', regionCode: '19', districtCode: '58' },
  { code: '65300', name: 'с.Жанатасашы', regionCode: '19', districtCode: '58' },
  { code: '65400', name: 'с.Сарыколь', regionCode: '19', districtCode: '58' },
  { code: '67100', name: 'с.Тегистик', regionCode: '19', districtCode: '58' },
  { code: '69100', name: 'с.Текес', regionCode: '19', districtCode: '58' },
  { code: '69200', name: 'с.Жанатекес', regionCode: '19', districtCode: '58' },
  { code: '71100', name: 'п.Туюк', regionCode: '19', districtCode: '58' },
  { code: '73100', name: 'с.Узынбулак', regionCode: '19', districtCode: '58' },
  { code: '73200', name: 'с.Аксай', regionCode: '19', districtCode: '58' },
  { code: '73300', name: 'с.Жалаулы', regionCode: '19', districtCode: '58' },
  { code: '75100', name: 'с.Шалкоде', regionCode: '19', districtCode: '58' },
  { code: '75200', name: 'с.Талас', regionCode: '19', districtCode: '58' },
  { code: '77100', name: 'с.Ширганак', regionCode: '19', districtCode: '58' },
  { code: '77200', name: 'с.Кенсу', regionCode: '19', districtCode: '58' },
  { code: '77300', name: 'с.Кокпияз', regionCode: '19', districtCode: '58' },
  { code: '77400', name: 'с.Каркара', regionCode: '19', districtCode: '58' },
  { code: '77500', name: 'с.Кызылжар', regionCode: '19', districtCode: '58' },
  { code: '77600', name: 'с.Талды', regionCode: '19', districtCode: '58' },
  { code: '20100', name: 'г.Сарканд', regionCode: '19', districtCode: '60' },
  { code: '20200', name: 'с.Бирлик', regionCode: '19', districtCode: '60' },
  { code: '33100', name: 'с.Аманбоктер', regionCode: '19', districtCode: '60' },
  { code: '33200', name: 'с.Баянбай', regionCode: '19', districtCode: '60' },
  {
    code: '35100',
    name: 'с.Пограничник',
    regionCode: '19',
    districtCode: '60'
  },
  { code: '35200', name: 'с.Кокозек', regionCode: '19', districtCode: '60' },
  { code: '35400', name: 'с.Караултобе', regionCode: '19', districtCode: '60' },
  { code: '37100', name: 'с.Бакалы', regionCode: '19', districtCode: '60' },
  { code: '53100', name: 'с.Райымбек', regionCode: '19', districtCode: '52' },
  { code: '53200', name: 'с.Абай', regionCode: '19', districtCode: '52' },
  { code: '53300', name: 'с.Долан', regionCode: '19', districtCode: '52' },
  { code: '53400', name: 'с.Кумтоган', regionCode: '19', districtCode: '52' },
  { code: '53500', name: 'с.Кыргауылды', regionCode: '19', districtCode: '52' },
  { code: '53600', name: 'с. Булакты', regionCode: '19', districtCode: '52' },
  { code: '55100', name: 'с.Жалпаксай', regionCode: '19', districtCode: '52' },
  { code: '55200', name: 'с.Алмалыбак', regionCode: '19', districtCode: '52' },
  { code: '55300', name: 'с.Жамбыл', regionCode: '19', districtCode: '52' },
  { code: '55400', name: 'с.Кольди', regionCode: '19', districtCode: '52' },
  { code: '55500', name: 'с.Мерей', regionCode: '19', districtCode: '52' },
  { code: '55600', name: 'с.Улан', regionCode: '19', districtCode: '52' },
  { code: '57100', name: 'с.Алатау', regionCode: '19', districtCode: '52' },
  {
    code: '57200',
    name: 'с.Алма-Арасан',
    regionCode: '19',
    districtCode: '52'
  },
  { code: '57400', name: 'с.Ерменсай', regionCode: '19', districtCode: '52' },
  { code: '57500', name: 'с.Жайлау', regionCode: '19', districtCode: '52' },
  { code: '57600', name: 'с.Кокшокы', regionCode: '19', districtCode: '52' },
  { code: '57700', name: 'с.Нурлытау', regionCode: '19', districtCode: '52' },
  { code: '59100', name: 'с.Ушконыр', regionCode: '19', districtCode: '52' },
  { code: '59200', name: 'с.Айкым', regionCode: '19', districtCode: '52' },
  { code: '59300', name: 'с.Енбекши', regionCode: '19', districtCode: '52' },
  { code: '59400', name: 'с.Кумарал', regionCode: '19', districtCode: '52' },
  { code: '59500', name: 'с.Сауыншы', regionCode: '19', districtCode: '52' },
  { code: '59700', name: 'с.Уштерек', regionCode: '19', districtCode: '52' },
  { code: '20100', name: 'г.Жаркент', regionCode: '19', districtCode: '56' },
  { code: '33100', name: 'с.Айдарлы', regionCode: '19', districtCode: '56' },
  { code: '33200', name: 'с.Дарбазакум', regionCode: '19', districtCode: '56' },
  { code: '33300', name: 'с.Сарпылдак', regionCode: '19', districtCode: '56' },
  { code: '35100', name: 'с.Баскунши', regionCode: '19', districtCode: '56' },
  { code: '35200', name: 'с.Алмалы', regionCode: '19', districtCode: '56' },
  { code: '37100', name: 'с.Алтыуй', regionCode: '19', districtCode: '56' },
  { code: '37200', name: 'с.Hадек', regionCode: '19', districtCode: '56' },
  { code: '37400', name: 'с.Шижин', regionCode: '19', districtCode: '56' },
  {
    code: '38100',
    name: 'с.им.Головацкого',
    regionCode: '19',
    districtCode: '56'
  },
  { code: '38300', name: 'с.Суптай', regionCode: '19', districtCode: '56' },
  { code: '39100', name: 'с.Коктал', regionCode: '19', districtCode: '56' },
  { code: '39200', name: 'с.Акжазык', regionCode: '19', districtCode: '56' },
  { code: '39300', name: 'с.Аккудык', regionCode: '19', districtCode: '56' },
  { code: '43100', name: 'с.Коныролен', regionCode: '19', districtCode: '56' },
  { code: '43200', name: 'с.Кермеагаш', regionCode: '19', districtCode: '56' },
  { code: '43300', name: 'с.Сарытобе', regionCode: '19', districtCode: '56' },
  { code: '43400', name: 'с.Борибай би', regionCode: '19', districtCode: '56' },
  { code: '43500', name: 'с.Ынталы', regionCode: '19', districtCode: '56' },
  { code: '45100', name: 'с.Пиджим', regionCode: '19', districtCode: '56' },
  { code: '45200', name: 'с.Ават', regionCode: '19', districtCode: '56' },
  {
    code: '45300',
    name: 'с.Hижний Пиджим',
    regionCode: '19',
    districtCode: '56'
  },
  { code: '45400', name: 'с.Хоргос', regionCode: '19', districtCode: '56' },
  { code: '47100', name: 'с.Сарыбель', regionCode: '19', districtCode: '56' },
  { code: '47200', name: 'с.Садыр', regionCode: '19', districtCode: '56' },
  { code: '47300', name: 'с.Турпан', regionCode: '19', districtCode: '56' },
  { code: '49100', name: 'с.Лесновка', regionCode: '19', districtCode: '56' },
  { code: '49200', name: 'с.Енбекши', regionCode: '19', districtCode: '56' },
  { code: '49300', name: 'с.Hагараши', regionCode: '19', districtCode: '56' },
  { code: '53100', name: 'с.Аулиеагаш', regionCode: '19', districtCode: '56' },
  {
    code: '53200',
    name: 'с.Жаркент-Арасан',
    regionCode: '19',
    districtCode: '56'
  },
  {
    code: '53300',
    name: 'с.Коктал-Арасан',
    regionCode: '19',
    districtCode: '56'
  },
  {
    code: '55100',
    name: 'с.Улкен Шыган',
    regionCode: '19',
    districtCode: '56'
  },
  { code: '55200', name: 'с.Аккент', regionCode: '19', districtCode: '56' },
  { code: '55300', name: 'с.Кырыккудык', regionCode: '19', districtCode: '56' },
  { code: '55400', name: 'с.Киши Шыган', regionCode: '19', districtCode: '56' },
  { code: '57100', name: 'с.Ушарал', regionCode: '19', districtCode: '56' },
  { code: '57200', name: 'с.Акарал', regionCode: '19', districtCode: '56' },
  { code: '57300', name: 'с.Кызылжиде', regionCode: '19', districtCode: '56' },
  { code: '59100', name: 'с.Чулакай', regionCode: '19', districtCode: '56' },
  { code: '39100', name: 'с.Акжар', regionCode: '19', districtCode: '50' },
  { code: '39300', name: 'с.Алмалы', regionCode: '19', districtCode: '50' },
  { code: '39400', name: 'с.Дойыншы', regionCode: '19', districtCode: '50' },
  { code: '43100', name: 'с.Кальпе', regionCode: '19', districtCode: '50' },
  { code: '43200', name: 'с.Айдар', regionCode: '19', districtCode: '50' },
  { code: '43400', name: 'с.Канабек', regionCode: '19', districtCode: '50' },
  {
    code: '43500',
    name: 'с.Карашенгель',
    regionCode: '19',
    districtCode: '50'
  },
  { code: '45100', name: 'с.Копбирлик', regionCode: '19', districtCode: '50' },
  { code: '45200', name: 'с.Каракум', regionCode: '19', districtCode: '50' },
  { code: '47100', name: 'а.Бастобе', regionCode: '19', districtCode: '50' },
  { code: '47300', name: 'с.Жылыбулак', regionCode: '19', districtCode: '50' },
  { code: '47400', name: 'с.Киши Тобе', regionCode: '19', districtCode: '50' },
  {
    code: '47500',
    name: 'рзд.Курышдаласы',
    regionCode: '19',
    districtCode: '50'
  },
  { code: '47800', name: 'с.Ортатобе', regionCode: '19', districtCode: '50' },
  { code: '47880', name: 'рзд.47', regionCode: '19', districtCode: '50' },
  { code: '49100', name: 'с.Кокпекти', regionCode: '19', districtCode: '50' },
  { code: '49200', name: 'с.Айту', regionCode: '19', districtCode: '50' },
  { code: '49300', name: 'с.Жасталап', regionCode: '19', districtCode: '50' },
  { code: '49400', name: 'с.Кожбан', regionCode: '19', districtCode: '50' },
  { code: '53100', name: 'с.Тастобе', regionCode: '19', districtCode: '50' },
  { code: '53200', name: 'с.Бесагаш', regionCode: '19', districtCode: '50' },
  { code: '53300', name: 'с.Бирлик', regionCode: '19', districtCode: '50' },
  { code: '20100', name: 'г.Каскелен', regionCode: '19', districtCode: '52' },
  { code: '20200', name: 'с.Айтей', regionCode: '19', districtCode: '52' },
  { code: '20300', name: 'с.Коктобе', regionCode: '19', districtCode: '52' },
  { code: '33100', name: 'с.Береке', regionCode: '19', districtCode: '52' },
  { code: '33180', name: 'с.Аксенгир', regionCode: '19', districtCode: '52' },
  { code: '33200', name: 'с.Ельтай', regionCode: '19', districtCode: '52' },
  {
    code: '33300',
    name: 'с.Жармухамбет',
    regionCode: '19',
    districtCode: '52'
  },
  { code: '33400', name: 'с.Исаево', regionCode: '19', districtCode: '52' },
  { code: '33500', name: 'с.Кокозек', regionCode: '19', districtCode: '52' },
  { code: '33600', name: 'с.Каратобе', regionCode: '19', districtCode: '52' },
  { code: '33700', name: 'с.Мадениет', regionCode: '19', districtCode: '52' },
  { code: '33800', name: 'с.Коктоган', regionCode: '19', districtCode: '52' },
  { code: '33880', name: 'с.Рахат', regionCode: '19', districtCode: '52' },
  { code: '33900', name: 'рзд.71', regionCode: '19', districtCode: '52' },
  { code: '35100', name: 'с.Жандосово', regionCode: '19', districtCode: '52' },
  { code: '35200', name: 'с.Кайрат', regionCode: '19', districtCode: '52' },
  { code: '35300', name: 'с.Шалкар', regionCode: '19', districtCode: '52' },
  { code: '37200', name: 'с.Жынгылды', regionCode: '19', districtCode: '52' },
  { code: '37300', name: 'с.Кольащы', regionCode: '19', districtCode: '52' },
  { code: '37400', name: 'с.Кошмамбет', regionCode: '19', districtCode: '52' },
  { code: '37500', name: 'с.Куркудык', regionCode: '19', districtCode: '52' },
  { code: '37600', name: 'с.Батан', regionCode: '19', districtCode: '52' },
  { code: '37700', name: 'с.Турар', regionCode: '19', districtCode: '52' },
  { code: '39100', name: 'с.Таусамалы', regionCode: '19', districtCode: '52' },
  { code: '39200', name: 'с.Акжар', regionCode: '19', districtCode: '52' },
  { code: '39300', name: 'с.Жанатурмыс', regionCode: '19', districtCode: '52' },
  { code: '39500', name: 'с.Hаурыз', regionCode: '19', districtCode: '52' },
  { code: '39600', name: 'с.Тастыбулак', regionCode: '19', districtCode: '52' },
  { code: '39700', name: 'с.Таужолы', regionCode: '19', districtCode: '52' },
  { code: '39900', name: 'с.Шугыла', regionCode: '19', districtCode: '52' },
  { code: '43100', name: 'с.Карагайлы', regionCode: '19', districtCode: '52' },
  { code: '43200', name: 'с.Каргалы', regionCode: '19', districtCode: '52' },
  { code: '43300', name: 'с.Курамыс', regionCode: '19', districtCode: '52' },
  { code: '43400', name: 'с.Рахат', regionCode: '19', districtCode: '52' },
  { code: '45100', name: 'с.Теректы', regionCode: '19', districtCode: '52' },
  { code: '45200', name: 'с.Алгабас', regionCode: '19', districtCode: '52' },
  { code: '47100', name: 'с.Иргели', regionCode: '19', districtCode: '52' },
  { code: '47200', name: 'с.Кемертоган', regionCode: '19', districtCode: '52' },
  { code: '47400', name: 'с.Коксай', regionCode: '19', districtCode: '52' },
  {
    code: '49100',
    name: 'с.Бекболат Ашекеев',
    regionCode: '19',
    districtCode: '52'
  },
  { code: '49200', name: 'с.Кайнар', regionCode: '19', districtCode: '52' },
  { code: '49300', name: 'с.Сауыншы', regionCode: '19', districtCode: '52' },
  { code: '53400', name: 'с.Шилису', regionCode: '19', districtCode: '46' },
  { code: '55100', name: 'с.Сарыбастау', regionCode: '19', districtCode: '46' },
  { code: '55200', name: 'с.Архарлы', regionCode: '19', districtCode: '46' },
  { code: '55300', name: 'ст.Балгалы', regionCode: '19', districtCode: '46' },
  { code: '55400', name: 'с.Малайсары', regionCode: '19', districtCode: '46' },
  { code: '55500', name: 'ст.Малайсары', regionCode: '19', districtCode: '46' },
  { code: '55600', name: 'ст.Тары', regionCode: '19', districtCode: '46' },
  { code: '57100', name: 'с.Карагаш', regionCode: '19', districtCode: '46' },
  {
    code: '57200',
    name: 'Ферма 3 Казансу',
    regionCode: '19',
    districtCode: '46'
  },
  {
    code: '57300',
    name: 'Ферма 2 Сарыбулак',
    regionCode: '19',
    districtCode: '46'
  },
  {
    code: '57400',
    name: 'Ферма 1 Шилису',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '63100', name: 'с.Шанханай', regionCode: '19', districtCode: '46' },
  { code: '63200', name: 'с.Коянкоз', regionCode: '19', districtCode: '46' },
  { code: '63300', name: 'с.Майтобе', regionCode: '19', districtCode: '46' },
  { code: '67100', name: 'с.Шубар', regionCode: '19', districtCode: '46' },
  { code: '67200', name: 'с.Аралтобе', regionCode: '19', districtCode: '46' },
  { code: '67300', name: 'с.Онжас', regionCode: '19', districtCode: '46' },
  { code: '30100', name: 'п.Балпык', regionCode: '19', districtCode: '48' },
  { code: '30200', name: 'с.Акшатоган', regionCode: '19', districtCode: '48' },
  { code: '30300', name: 'с.Теректы', regionCode: '19', districtCode: '48' },
  { code: '33100', name: 'ст.Айнабулак', regionCode: '19', districtCode: '48' },
  { code: '33200', name: 'рзд.Копир', regionCode: '19', districtCode: '48' },
  { code: '33300', name: 'Подхоз ПЧ-45', regionCode: '19', districtCode: '48' },
  { code: '33400', name: 'рзд.Тауарасы', regionCode: '19', districtCode: '48' },
  { code: '35100', name: 'с.Алгабас', regionCode: '19', districtCode: '48' },
  { code: '35200', name: 'с.Кызылтоган', regionCode: '19', districtCode: '48' },
  { code: '39100', name: 'с.Амангельды', regionCode: '19', districtCode: '48' },
  { code: '39200', name: 'с.Бескайнар', regionCode: '19', districtCode: '48' },
  { code: '39300', name: 'с.Кенарал', regionCode: '19', districtCode: '48' },
  { code: '39400', name: 'с.Каратал', regionCode: '19', districtCode: '48' },
  { code: '43100', name: 'с.Мусабек', regionCode: '19', districtCode: '48' },
  { code: '43200', name: 'ст.Бакша', regionCode: '19', districtCode: '48' },
  { code: '43300', name: 'ст.Быжы', regionCode: '19', districtCode: '48' },
  { code: '43400', name: 'с.Маулимбай', regionCode: '19', districtCode: '48' },
  { code: '43500', name: 'ст.Моинкум', regionCode: '19', districtCode: '48' },
  { code: '45100', name: 'с.Актекше', regionCode: '19', districtCode: '48' },
  { code: '45200', name: 'с.Кокбастау', regionCode: '19', districtCode: '48' },
  { code: '47100', name: 'с.Мамбет', regionCode: '19', districtCode: '48' },
  {
    code: '47200',
    name: 'с.Енбекшиказах',
    regionCode: '19',
    districtCode: '48'
  },
  { code: '47300', name: 'с.Жамбыл', regionCode: '19', districtCode: '48' },
  { code: '47400', name: 'с.Талапты', regionCode: '19', districtCode: '48' },
  { code: '49100', name: 'ст.Коксу', regionCode: '19', districtCode: '48' },
  { code: '49200', name: 'с.Жетыжал', regionCode: '19', districtCode: '48' },
  {
    code: '49300',
    name: 'с.50 лет Казахстана',
    regionCode: '19',
    districtCode: '48'
  },
  { code: '49500', name: 'с.Муканши', regionCode: '19', districtCode: '48' },
  { code: '49600', name: 'с.Hадиризбек', regionCode: '19', districtCode: '48' },
  { code: '53100', name: 'с.Мукры', regionCode: '19', districtCode: '48' },
  {
    code: '53200',
    name: 'с.10 лет Казахстана',
    regionCode: '19',
    districtCode: '48'
  },
  { code: '55100', name: 'с.Жарлыозек', regionCode: '19', districtCode: '48' },
  { code: '55200', name: 'с.Бозтоган', regionCode: '19', districtCode: '48' },
  { code: '55300', name: 'с.Муканшы', regionCode: '19', districtCode: '48' },
  { code: '20100', name: 'г.Уштобе', regionCode: '19', districtCode: '50' },
  { code: '20200', name: 'с.Опытное', regionCode: '19', districtCode: '50' },
  { code: '20300', name: 'с.Ушкомей', regionCode: '19', districtCode: '50' },
  { code: '20400', name: 'с.Фрунзе', regionCode: '19', districtCode: '50' },
  { code: '33100', name: 'с.Жанаталап', regionCode: '19', districtCode: '50' },
  { code: '33200', name: 'с.Оян', regionCode: '19', districtCode: '50' },
  { code: '33400', name: 'с.Умтул', regionCode: '19', districtCode: '50' },
  { code: '35100', name: 'с.Каражиде', regionCode: '19', districtCode: '50' },
  { code: '35400', name: 'с.Сарыбулак', regionCode: '19', districtCode: '50' },
  {
    code: '37100',
    name: 'а.Ескельди би',
    regionCode: '19',
    districtCode: '50'
  },
  { code: '37200', name: 'а.Кызылжар', regionCode: '19', districtCode: '50' },
  { code: '37300', name: 'с.Кокдала', regionCode: '19', districtCode: '50' },
  { code: '37400', name: 'с.Кайнар', regionCode: '19', districtCode: '50' },
  { code: '49300', name: 'с.Коктобе', regionCode: '19', districtCode: '64' },
  { code: '53100', name: 'а.Сырымбет', regionCode: '19', districtCode: '64' },
  { code: '55100', name: 'с.Жетысу', regionCode: '19', districtCode: '64' },
  { code: '55200', name: 'с.Екпенди', regionCode: '19', districtCode: '64' },
  { code: '55300', name: 'с.Жендик', regionCode: '19', districtCode: '64' },
  { code: '57100', name: 'с.Акын Сара', regionCode: '19', districtCode: '64' },
  { code: '57200', name: 'с.Акешки', regionCode: '19', districtCode: '64' },
  { code: '57300', name: 'с.Актума', regionCode: '19', districtCode: '64' },
  { code: '57400', name: 'с.Тамбала', regionCode: '19', districtCode: '64' },
  { code: '30100', name: 'с.Чунджа', regionCode: '19', districtCode: '66' },
  { code: '33100', name: 'с.Ават', regionCode: '19', districtCode: '66' },
  {
    code: '35100',
    name: 'с.Большой Аксу',
    regionCode: '19',
    districtCode: '66'
  },
  { code: '35200', name: 'с.Долайты', regionCode: '19', districtCode: '66' },
  { code: '35300', name: 'с.Малый Аксу', regionCode: '19', districtCode: '66' },
  { code: '37100', name: 'с.Актам', regionCode: '19', districtCode: '66' },
  { code: '39100', name: 'с.Бахар', regionCode: '19', districtCode: '66' },
  { code: '39200', name: 'с.Ширин', regionCode: '19', districtCode: '66' },
  { code: '43100', name: 'с.Дардамты', regionCode: '19', districtCode: '66' },
  { code: '43200', name: 'с.Ардолайты', regionCode: '19', districtCode: '66' },
  { code: '43300', name: 'с.Добын', regionCode: '19', districtCode: '66' },
  { code: '43400', name: 'с.Сункар', regionCode: '19', districtCode: '66' },
  { code: '45100', name: 'с.Кетмень', regionCode: '19', districtCode: '66' },
  { code: '45200', name: 'с.Кепебулак', regionCode: '19', districtCode: '66' },
  {
    code: '47100',
    name: 'с.Малый Дехан',
    regionCode: '19',
    districtCode: '66'
  },
  {
    code: '47200',
    name: 'с.Большой Дехан',
    regionCode: '19',
    districtCode: '66'
  },
  { code: '49100', name: 'с.Кольжат', regionCode: '19', districtCode: '66' },
  { code: '53100', name: 'с.Кыргызсай', regionCode: '19', districtCode: '66' },
  { code: '53200', name: 'с.Рахат', regionCode: '19', districtCode: '66' },
  { code: '55100', name: 'с.Сумба', regionCode: '19', districtCode: '66' },
  { code: '55200', name: 'с.Шошанай', regionCode: '19', districtCode: '66' },
  { code: '57100', name: 'с.Таскарасу', regionCode: '19', districtCode: '66' },
  { code: '59100', name: 'с.Тигермень', regionCode: '19', districtCode: '66' },
  { code: '59200', name: 'с.Узынтам', regionCode: '19', districtCode: '66' },
  {
    code: '30100',
    name: 'п.Отеген батыра',
    regionCode: '19',
    districtCode: '68'
  },
  { code: '30200', name: 'п.Покровка', regionCode: '19', districtCode: '68' },
  { code: '39100', name: 'с.Жоламан', regionCode: '19', districtCode: '46' },
  { code: '39200', name: 'ст.Алтындала', regionCode: '19', districtCode: '46' },
  { code: '39300', name: 'ст.Архарлы', regionCode: '19', districtCode: '46' },
  { code: '39400', name: 'ст.Дала', regionCode: '19', districtCode: '46' },
  { code: '39500', name: 'ст.Жоламан', regionCode: '19', districtCode: '46' },
  { code: '39600', name: 'ст.Сайлы', regionCode: '19', districtCode: '46' },
  { code: '39700', name: 'с.Самен', regionCode: '19', districtCode: '46' },
  { code: '41100', name: 'с.Талдыбулак', regionCode: '19', districtCode: '46' },
  { code: '41200', name: 'с.Бостан', regionCode: '19', districtCode: '46' },
  { code: '41300', name: 'с.Терысаккан', regionCode: '19', districtCode: '46' },
  { code: '43100', name: 'с.Коксу', regionCode: '19', districtCode: '46' },
  { code: '43200', name: 'с.Бериктас', regionCode: '19', districtCode: '46' },
  { code: '43300', name: 'с.Коктал', regionCode: '19', districtCode: '46' },
  { code: '43400', name: 'с.Косагаш', regionCode: '19', districtCode: '46' },
  { code: '45100', name: 'с.Карашокы', regionCode: '19', districtCode: '46' },
  { code: '45200', name: 'с.Архарлы', regionCode: '19', districtCode: '46' },
  { code: '47100', name: 'с.Каспан', regionCode: '19', districtCode: '46' },
  { code: '47200', name: 'с.Водное', regionCode: '19', districtCode: '46' },
  { code: '47300', name: 'с.Коксай', regionCode: '19', districtCode: '46' },
  { code: '47400', name: 'с.Сайлыколь', regionCode: '19', districtCode: '46' },
  { code: '47500', name: 'с.Шаган', regionCode: '19', districtCode: '46' },
  { code: '49100', name: 'с.Когалы', regionCode: '19', districtCode: '46' },
  {
    code: '49200',
    name: 'с.Коноваловка',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '49300', name: 'с.Куренбел', regionCode: '19', districtCode: '46' },
  { code: '49400', name: 'с.Тастыозек', regionCode: '19', districtCode: '46' },
  { code: '49500', name: 'с.Шаган', regionCode: '19', districtCode: '46' },
  { code: '53100', name: 'с.Кызылжар', regionCode: '19', districtCode: '46' },
  {
    code: '53200',
    name: 'Дорожный участок Аксункар',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '53300', name: 'с.Желдикара', regionCode: '19', districtCode: '46' },
  { code: '37200', name: 'с.Аккайын', regionCode: '19', districtCode: '62' },
  { code: '37300', name: 'с.Актобе', regionCode: '19', districtCode: '62' },
  { code: '37400', name: 'с.Сулусай', regionCode: '19', districtCode: '62' },
  { code: '37500', name: 'с.Ремизовка', regionCode: '19', districtCode: '62' },
  { code: '39100', name: 'с.Бескайнар', regionCode: '19', districtCode: '62' },
  { code: '39300', name: 'с.Котырбулак', regionCode: '19', districtCode: '62' },
  { code: '43100', name: 'с.Бесагаш', regionCode: '19', districtCode: '62' },
  { code: '43200', name: 'с.Акбулак', regionCode: '19', districtCode: '62' },
  {
    code: '45100',
    name: 'с.Туздыбастау',
    regionCode: '19',
    districtCode: '62'
  },
  { code: '47100', name: 'с.Еркин', regionCode: '19', districtCode: '62' },
  { code: '47300', name: 'с.Достык', regionCode: '19', districtCode: '62' },
  { code: '47380', name: 'с.Еламан', regionCode: '19', districtCode: '62' },
  { code: '47400', name: 'с.Жалкамыс', regionCode: '19', districtCode: '62' },
  { code: '47480', name: 'с.Жанаарна', regionCode: '19', districtCode: '62' },
  { code: '47500', name: 'с.Жаналык', regionCode: '19', districtCode: '62' },
  { code: '47580', name: 'с.Коктал', regionCode: '19', districtCode: '62' },
  { code: '47600', name: 'с.Кайнар', regionCode: '19', districtCode: '62' },
  { code: '47700', name: 'с.Даулет', regionCode: '19', districtCode: '62' },
  { code: '47780', name: 'с.Сактан', regionCode: '19', districtCode: '62' },
  { code: '47800', name: 'с.Теренкара', regionCode: '19', districtCode: '62' },
  { code: '49100', name: 'с.Гульдала', regionCode: '19', districtCode: '62' },
  { code: '49200', name: 'с.Альмерек', regionCode: '19', districtCode: '62' },
  { code: '49300', name: 'с.Кайрат', regionCode: '19', districtCode: '62' },
  { code: '49400', name: 'с.Колхозшы', regionCode: '19', districtCode: '62' },
  {
    code: '49500',
    name: 'с.Киши Байсерке',
    regionCode: '19',
    districtCode: '62'
  },
  { code: '53100', name: 'с.Панфилово', regionCode: '19', districtCode: '62' },
  { code: '53200', name: 'с.Аркабай', regionCode: '19', districtCode: '62' },
  {
    code: '53300',
    name: 'с.Каменское плато',
    regionCode: '19',
    districtCode: '62'
  },
  { code: '53400', name: 'с.Карабулак', regionCode: '19', districtCode: '62' },
  { code: '53500', name: 'с.Кызылту', regionCode: '19', districtCode: '62' },
  { code: '53600', name: 'с.Тонкерис', regionCode: '19', districtCode: '62' },
  { code: '53700', name: 'с.Тузусай', regionCode: '19', districtCode: '62' },
  { code: '55100', name: 'с.Кендала', regionCode: '19', districtCode: '62' },
  { code: '55200', name: 'с.Акдала', regionCode: '19', districtCode: '62' },
  { code: '55300', name: 'с.Актас', regionCode: '19', districtCode: '62' },
  { code: '55400', name: 'с.Енбекши', regionCode: '19', districtCode: '62' },
  { code: '57100', name: 'с.Hура', regionCode: '19', districtCode: '62' },
  { code: '57300', name: 'с.Каратоган', regionCode: '19', districtCode: '62' },
  { code: '57400', name: 'с.Остемир', regionCode: '19', districtCode: '62' },
  { code: '57600', name: 'с.Туганбай', regionCode: '19', districtCode: '62' },
  { code: '30100', name: 'п.Карабулак', regionCode: '19', districtCode: '64' },
  { code: '30200', name: 'с.Абай', regionCode: '19', districtCode: '64' },
  {
    code: '30300',
    name: 'а.Матая Баисова',
    regionCode: '19',
    districtCode: '64'
  },
  { code: '30400', name: 'с.Ешкиольмес', regionCode: '19', districtCode: '64' },
  { code: '30500', name: 'с.Оркусак', regionCode: '19', districtCode: '64' },
  { code: '30600', name: 'с.Шымыр', regionCode: '19', districtCode: '64' },
  {
    code: '33100',
    name: 'с.Алдабергеново',
    regionCode: '19',
    districtCode: '64'
  },
  { code: '33200', name: 'с.Жаналык', regionCode: '19', districtCode: '64' },
  { code: '33300', name: 'с.Жастар', regionCode: '19', districtCode: '64' },
  {
    code: '35100',
    name: 'а.им.Бактыбая Жолбарысулы',
    regionCode: '19',
    districtCode: '64'
  },
  { code: '35200', name: 'с.Отенай', regionCode: '19', districtCode: '64' },
  { code: '35300', name: 'с.Ельтай', regionCode: '19', districtCode: '64' },
  { code: '37100', name: 'с.Жалгызагаш', regionCode: '19', districtCode: '64' },
  { code: '37200', name: 'с.Бигаш', regionCode: '19', districtCode: '64' },
  { code: '39100', name: 'с.Кокжазык', regionCode: '19', districtCode: '64' },
  { code: '39200', name: 'с.Боктерли', regionCode: '19', districtCode: '64' },
  { code: '39300', name: 'с.Тенлик', regionCode: '19', districtCode: '64' },
  { code: '43100', name: 'с.Кайнарлы', regionCode: '19', districtCode: '64' },
  { code: '43200', name: 'с.Актасты', regionCode: '19', districtCode: '64' },
  { code: '43300', name: 'с.Коржымбай', regionCode: '19', districtCode: '64' },
  {
    code: '47100',
    name: 'с.Каратальское',
    regionCode: '19',
    districtCode: '64'
  },
  { code: '47200', name: 'а.Теректы', regionCode: '19', districtCode: '64' },
  { code: '49100', name: 'с.Коныр', regionCode: '19', districtCode: '64' },
  { code: '49200', name: 'с.Алмалы', regionCode: '19', districtCode: '64' },
  { code: '51200', name: 'с.Бурган', regionCode: '19', districtCode: '42' },
  { code: '51300', name: 'с.Ушбулак', regionCode: '19', districtCode: '42' },
  { code: '53100', name: 'с.Сарыбай би', regionCode: '19', districtCode: '42' },
  {
    code: '53200',
    name: 'с.Енбекшиарал',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '53300', name: 'с.Кайназар', regionCode: '19', districtCode: '42' },
  { code: '53400', name: 'с.Карасай', regionCode: '19', districtCode: '42' },
  { code: '53500', name: 'с.Кызылсок', regionCode: '19', districtCode: '42' },
  { code: '55100', name: 'с.Матибулак', regionCode: '19', districtCode: '42' },
  { code: '55200', name: 'с.Танбалытас', regionCode: '19', districtCode: '42' },
  { code: '55300', name: 'с.Еспе', regionCode: '19', districtCode: '42' },
  { code: '55400', name: 'с.Жайлау', regionCode: '19', districtCode: '42' },
  { code: '55500', name: 'с.Жартас', regionCode: '19', districtCode: '42' },
  { code: '55600', name: 'с.Карабастау', regionCode: '19', districtCode: '42' },
  { code: '55700', name: 'с.Кызылтан', regionCode: '19', districtCode: '42' },
  { code: '55800', name: 'с.Шилибастау', regionCode: '19', districtCode: '42' },
  { code: '57100', name: 'с.Мынбаево', regionCode: '19', districtCode: '42' },
  { code: '59100', name: 'с.Самсы', regionCode: '19', districtCode: '42' },
  { code: '59200', name: 'с.Копа', regionCode: '19', districtCode: '42' },
  { code: '59300', name: 'с.Таргап', regionCode: '19', districtCode: '42' },
  { code: '61100', name: 'с.Ащису', regionCode: '19', districtCode: '42' },
  {
    code: '63100',
    name: 'с.Суранши батыр',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '63200', name: 'с.Кастек', regionCode: '19', districtCode: '42' },
  {
    code: '65100',
    name: 'с.им.Балгабека Кыдырбекулы',
    regionCode: '19',
    districtCode: '42'
  },
  {
    code: '67100',
    name: 'ст.Казыбек бека',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '73100', name: 'с.Ульгили', regionCode: '19', districtCode: '42' },
  { code: '73300', name: 'с.Каншенгель', regionCode: '19', districtCode: '42' },
  { code: '73400', name: 'ст.Саз', regionCode: '19', districtCode: '42' },
  { code: '75100', name: 'п.Улькен', regionCode: '19', districtCode: '42' },
  { code: '77100', name: 'с.Унгуртас', regionCode: '19', districtCode: '42' },
  { code: '77200', name: 'с.Акдала', regionCode: '19', districtCode: '42' },
  { code: '77300', name: 'с.Коккайнар', regionCode: '19', districtCode: '42' },
  { code: '77400', name: 'с.Сарыбастау', regionCode: '19', districtCode: '42' },
  { code: '79100', name: 'с.Каргалы', regionCode: '19', districtCode: '42' },
  { code: '81100', name: 'с.Шиен', regionCode: '19', districtCode: '42' },
  { code: '81200', name: 'с.Когамшыл', regionCode: '19', districtCode: '42' },
  {
    code: '83100',
    name: 'с.Умбеталы Карибаева',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '83200', name: 'с.Касымбек', regionCode: '19', districtCode: '42' },
  {
    code: '83300',
    name: 'с.Шолаккаргалы',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '30100', name: 'п.Сарыозек', regionCode: '19', districtCode: '46' },
  { code: '30200', name: 'ст.Дос', regionCode: '19', districtCode: '46' },
  {
    code: '30300',
    name: 'ст.Койкырыккан',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '30400', name: 'ст.Майтобе', regionCode: '19', districtCode: '46' },
  { code: '33100', name: 'с.Алтынемель', regionCode: '19', districtCode: '46' },
  { code: '33200', name: 'с.Байгазы', regionCode: '19', districtCode: '46' },
  { code: '33300', name: 'с.Карлыгаш', regionCode: '19', districtCode: '46' },
  { code: '33400', name: 'с.Кызылшкол', regionCode: '19', districtCode: '46' },
  {
    code: '33500',
    name: 'с.Тастыбастау',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '35100', name: 'с.Басши', regionCode: '19', districtCode: '46' },
  { code: '35200', name: 'с.Актобе', regionCode: '19', districtCode: '46' },
  { code: '35400', name: 'с.Hурум', regionCode: '19', districtCode: '46' },
  {
    code: '37100',
    name: 'с.Жайнак батыра',
    regionCode: '19',
    districtCode: '46'
  },
  { code: '37200', name: 'с.Акбастау', regionCode: '19', districtCode: '46' },
  { code: '37300', name: 'с.Доланалы', regionCode: '19', districtCode: '46' },
  { code: '37500', name: 'с.Карымсак', regionCode: '19', districtCode: '46' },
  { code: '33400', name: 'с.Амангельды', regionCode: '19', districtCode: '62' },
  { code: '33500', name: 'с.Байбулак', regionCode: '19', districtCode: '62' },
  { code: '33680', name: 'с.Береке', regionCode: '19', districtCode: '62' },
  { code: '33700', name: 'с.Орман', regionCode: '19', districtCode: '62' },
  { code: '33800', name: 'с.Рыскулово', regionCode: '19', districtCode: '62' },
  { code: '33900', name: 'с.Чимбулак', regionCode: '19', districtCode: '62' },
  { code: '35100', name: 'с.Белбулак', regionCode: '19', districtCode: '62' },
  { code: '35200', name: 'с.Бирлик', regionCode: '19', districtCode: '62' },
  { code: '35300', name: 'с.Талдыбулак', regionCode: '19', districtCode: '62' },
  { code: '37100', name: 'с.Кольсай', regionCode: '19', districtCode: '62' },
  { code: '4', name: 'с.Еркин', regionCode: '19', districtCode: '19' },
  { code: '5', name: 'с.Отенай', regionCode: '19', districtCode: '19' },
  { code: '6', name: 'с.Енбек', regionCode: '19', districtCode: '19' },
  { code: '7', name: 'с.Мойнак', regionCode: '19', districtCode: '19' },
  { code: '8', name: 'с.Пригородное', regionCode: '19', districtCode: '19' },
  { code: '9', name: 'с.Заречное', regionCode: '19', districtCode: '19' },
  { code: '10', name: 'с.Арна', regionCode: '19', districtCode: '19' },
  { code: '11', name: 'с.Шенгельды', regionCode: '19', districtCode: '19' },
  { code: '12', name: 'с.Акозек', regionCode: '19', districtCode: '19' },
  { code: '13', name: 'с.Кербулак', regionCode: '19', districtCode: '19' },
  { code: '14', name: 'ст.Коскудык', regionCode: '19', districtCode: '19' },
  { code: '15', name: 'с.Сарыбулак', regionCode: '19', districtCode: '19' },
  { code: '16', name: 'с.Шолак', regionCode: '19', districtCode: '19' },
  { code: '17', name: 'с.Рудничный', regionCode: '19', districtCode: '19' },
  { code: '64100', name: 'с.Малыбай', regionCode: '19', districtCode: '40' },
  { code: '65100', name: 'с.Масак', regionCode: '19', districtCode: '40' },
  { code: '65200', name: 'с.Hурлы', regionCode: '19', districtCode: '40' },
  { code: '67100', name: 'с.Байтерек', regionCode: '19', districtCode: '40' },
  { code: '67200', name: 'с.Алга', regionCode: '19', districtCode: '40' },
  { code: '67300', name: 'с.Койшибек', regionCode: '19', districtCode: '40' },
  { code: '69100', name: 'с.Hура', regionCode: '19', districtCode: '40' },
  { code: '69200', name: 'с.Кокпек', regionCode: '19', districtCode: '40' },
  {
    code: '71100',
    name: 'с.Хусаина Бижанова',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '71200', name: 'с.Байсеит', regionCode: '19', districtCode: '40' },
  { code: '73100', name: 'с.Кайназар', regionCode: '19', districtCode: '40' },
  { code: '73200', name: 'с.Азат', regionCode: '19', districtCode: '40' },
  { code: '73300', name: 'с.Орикти', regionCode: '19', districtCode: '40' },
  { code: '73400', name: 'с.Рахат', regionCode: '19', districtCode: '40' },
  { code: '75100', name: 'с.Саймасай', regionCode: '19', districtCode: '40' },
  { code: '75200', name: 'с.Амангельды', regionCode: '19', districtCode: '40' },
  { code: '77100', name: 'с.Ташкенсаз', regionCode: '19', districtCode: '40' },
  { code: '77200', name: 'с.Баяндай', regionCode: '19', districtCode: '40' },
  {
    code: '77300',
    name: 'с.Кульжинское',
    regionCode: '19',
    districtCode: '40'
  },
  { code: '79100', name: 'с.Тескенсу', regionCode: '19', districtCode: '40' },
  { code: '79200', name: 'с.Кольди', regionCode: '19', districtCode: '40' },
  { code: '79300', name: 'с.Толкын', regionCode: '19', districtCode: '40' },
  { code: '81100', name: 'с.Тургень', regionCode: '19', districtCode: '40' },
  { code: '81200', name: 'с.Таутургень', regionCode: '19', districtCode: '40' },
  { code: '83100', name: 'с.Шелек', regionCode: '19', districtCode: '40' },
  { code: '83200', name: 'с.Майское', regionCode: '19', districtCode: '40' },
  { code: '83300', name: 'с.Тургайбаза', regionCode: '19', districtCode: '40' },
  { code: '30100', name: 'с.Узынагаш', regionCode: '19', districtCode: '42' },
  {
    code: '30200',
    name: 'с.Жанакурылыс',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '30300', name: 'с.Ынтымак', regionCode: '19', districtCode: '42' },
  { code: '33100', name: 'с.Айдарлы', regionCode: '19', districtCode: '42' },
  { code: '35100', name: 'с.Аккайнар', regionCode: '19', districtCode: '42' },
  { code: '37100', name: 'с.Аксенгир', regionCode: '19', districtCode: '42' },
  { code: '37200', name: 'с.Жайсан', regionCode: '19', districtCode: '42' },
  { code: '37300', name: 'с.Жиренайгыр', regionCode: '19', districtCode: '42' },
  { code: '37400', name: 'с.Кокдала', regionCode: '19', districtCode: '42' },
  { code: '39100', name: 'с.Актерек', regionCode: '19', districtCode: '42' },
  { code: '39200', name: 'с.Архарлы', regionCode: '19', districtCode: '42' },
  { code: '41100', name: 'с.Бериктас', regionCode: '19', districtCode: '42' },
  { code: '43100', name: 'с.Бозой', regionCode: '19', districtCode: '42' },
  { code: '45100', name: 'с.Дегерес', regionCode: '19', districtCode: '42' },
  { code: '45200', name: 'с.Бесмойнак', regionCode: '19', districtCode: '42' },
  { code: '45300', name: 'с.Булак', regionCode: '19', districtCode: '42' },
  { code: '45400', name: 'с.Караарша', regionCode: '19', districtCode: '42' },
  { code: '45500', name: 'с.Сункар', regionCode: '19', districtCode: '42' },
  { code: '47100', name: 'с.Жамбыл', regionCode: '19', districtCode: '42' },
  { code: '47200', name: 'с.Бирлик', regionCode: '19', districtCode: '42' },
  {
    code: '47300',
    name: 'с.Сауырык батыра',
    regionCode: '19',
    districtCode: '42'
  },
  { code: '47400', name: 'с.Кызыласкер', regionCode: '19', districtCode: '42' },
  { code: '51100', name: 'с.Каракастек', regionCode: '19', districtCode: '42' },
  { code: '69200', name: 'с.Жасталап', regionCode: '23', districtCode: '46' },
  { code: '30100', name: 'с.Миялы', regionCode: '23', districtCode: '48' },
  { code: '35100', name: 'с.Караколь', regionCode: '23', districtCode: '48' },
  { code: '35200', name: 'с.Айдын', regionCode: '23', districtCode: '48' },
  { code: '35300', name: 'с.Мадениет', regionCode: '23', districtCode: '48' },
  {
    code: '37100',
    name: 'с.Жангельдино',
    regionCode: '23',
    districtCode: '48'
  },
  { code: '39100', name: 'с.Коныстау', regionCode: '23', districtCode: '48' },
  { code: '39300', name: 'с.Буйрек', regionCode: '23', districtCode: '48' },
  { code: '39400', name: 'с.Коскулак', regionCode: '23', districtCode: '48' },
  { code: '43100', name: 'с.Карабау', regionCode: '23', districtCode: '48' },
  { code: '47100', name: 'с.Мукур', regionCode: '23', districtCode: '48' },
  { code: '47200', name: 'с.Жамансор', regionCode: '23', districtCode: '48' },
  { code: '47300', name: 'с.Жантерек', regionCode: '23', districtCode: '48' },
  { code: '47400', name: 'с.Кенбай', regionCode: '23', districtCode: '48' },
  { code: '47500', name: 'с.Сарыкумак', regionCode: '23', districtCode: '48' },
  { code: '47600', name: 'с.Соркол', regionCode: '23', districtCode: '48' },
  { code: '47700', name: 'с.Таскудук', regionCode: '23', districtCode: '48' },
  { code: '49100', name: 'с.Жаскайрат', regionCode: '23', districtCode: '48' },
  { code: '49200', name: 'с.Аккора', regionCode: '23', districtCode: '48' },
  { code: '49300', name: 'с.Балабеит', regionCode: '23', districtCode: '48' },
  { code: '53100', name: 'с.Сагиз', regionCode: '23', districtCode: '48' },
  {
    code: '53300',
    name: 'с.Былкылдакты',
    regionCode: '23',
    districtCode: '48'
  },
  { code: '53400', name: 'с.Кенбай', regionCode: '23', districtCode: '48' },
  { code: '53500', name: 'с.Коныраулы', regionCode: '23', districtCode: '48' },
  { code: '53600', name: 'с.Шолаксай', regionCode: '23', districtCode: '48' },
  { code: '55100', name: 'с.Тасшагил', regionCode: '23', districtCode: '48' },
  { code: '55200', name: 'с.Когам', regionCode: '23', districtCode: '48' },
  { code: '55300', name: 'с.Коныстану', regionCode: '23', districtCode: '48' },
  { code: '59100', name: 'с.Тайсойган', regionCode: '23', districtCode: '48' },
  { code: '30100', name: 'п.Макат', regionCode: '23', districtCode: '52' },
  { code: '33100', name: 'с.Байчунас', regionCode: '23', districtCode: '52' },
  { code: '35100', name: 'п.Доссор', regionCode: '23', districtCode: '52' },
  { code: '37100', name: 'с.Искене', regionCode: '23', districtCode: '52' },
  { code: '30100', name: 'с.Махамбет', regionCode: '23', districtCode: '56' },
  { code: '33100', name: 'с.Акжайык', regionCode: '23', districtCode: '56' },
  { code: '34100', name: 'с.Актогай', regionCode: '23', districtCode: '56' },
  {
    code: '34200',
    name: 'аул Бала Ораза',
    regionCode: '23',
    districtCode: '56'
  },
  { code: '34300', name: 'аул Кенорис', regionCode: '23', districtCode: '56' },
  {
    code: '34500',
    name: 'аул Отешкали Атамбаева',
    regionCode: '23',
    districtCode: '56'
  },
  { code: '35100', name: 'с.Алга', regionCode: '23', districtCode: '56' },
  { code: '37100', name: 'с.Алмалы', regionCode: '23', districtCode: '56' },
  { code: '37200', name: 'а.Береке', regionCode: '23', districtCode: '56' },
  { code: '39100', name: 'с.Тандай', regionCode: '23', districtCode: '56' },
  { code: '39200', name: 'с.Есмахан', regionCode: '23', districtCode: '56' },
  { code: '39300', name: 'с.Коздикора', regionCode: '23', districtCode: '56' },
  { code: '39400', name: 'с.Томан', regionCode: '23', districtCode: '56' },
  { code: '43100', name: 'с.Ортакшыл', regionCode: '23', districtCode: '56' },
  { code: '43200', name: 'с.Енбекшил', regionCode: '23', districtCode: '56' },
  { code: '43300', name: 'с.Есбол', regionCode: '23', districtCode: '56' },
  { code: '45100', name: 'с.Жалгансай', regionCode: '23', districtCode: '56' },
  { code: '49100', name: 'с.Сарайчик', regionCode: '23', districtCode: '56' },
  {
    code: '49200',
    name: 'с.Старый Сарайчик',
    regionCode: '23',
    districtCode: '56'
  },
  { code: '53100', name: 'с.Сарытогай', regionCode: '23', districtCode: '56' },
  { code: '55100', name: 'с.Бейбарыс', regionCode: '23', districtCode: '56' },
  { code: '55200', name: 'а.Кызылжар', regionCode: '23', districtCode: '56' },
  {
    code: '55500',
    name: 'аул Талдыколь',
    regionCode: '23',
    districtCode: '56'
  },
  { code: '55600', name: 'аул Аккайын', regionCode: '23', districtCode: '56' },
  { code: '20100', name: 'г. Кульсары', regionCode: '23', districtCode: '36' },
  { code: '56100', name: 'с.Кигач', regionCode: '23', districtCode: '46' },
  { code: '47400', name: 'уч.5', regionCode: '23', districtCode: '40' },
  { code: '30100', name: 'с.Аккистау', regionCode: '23', districtCode: '42' },
  { code: '30200', name: 'с.Оркен', regionCode: '23', districtCode: '42' },
  { code: '30300', name: 'рзд.17', regionCode: '23', districtCode: '42' },
  { code: '35100', name: 'с.Жанбай', regionCode: '23', districtCode: '42' },
  { code: '37100', name: 'с.Зинеден', regionCode: '23', districtCode: '42' },
  { code: '37200', name: 'с.Амангельды', regionCode: '23', districtCode: '42' },
  { code: '39100', name: 'с.Исатай', regionCode: '23', districtCode: '42' },
  { code: '41100', name: 'с.Нарын', regionCode: '23', districtCode: '42' },
  {
    code: '41300',
    name: 'с.Жана Жанбай',
    regionCode: '23',
    districtCode: '42'
  },
  { code: '41600', name: 'с.Мынтобе', regionCode: '23', districtCode: '42' },
  {
    code: '43100',
    name: 'а.Хамита Ергалиева',
    regionCode: '23',
    districtCode: '42'
  },
  { code: '43200', name: 'с.Аукайран', regionCode: '23', districtCode: '42' },
  { code: '43300', name: 'с.Жаскайрат', regionCode: '23', districtCode: '42' },
  { code: '45100', name: 'c.Тущыкудык', regionCode: '23', districtCode: '42' },
  { code: '45200', name: 'с.Айбас', regionCode: '23', districtCode: '42' },
  { code: '45500', name: 'с.Кызылуй', regionCode: '23', districtCode: '42' },
  { code: '30100', name: 'с.Ганюшкино', regionCode: '23', districtCode: '46' },
  { code: '33100', name: 'с.Балкудук', regionCode: '23', districtCode: '46' },
  { code: '33200', name: 'с.Азгир', regionCode: '23', districtCode: '46' },
  { code: '33400', name: 'с.Коныртерек', regionCode: '23', districtCode: '46' },
  { code: '35100', name: 'с.Акколь', regionCode: '23', districtCode: '46' },
  { code: '36100', name: 'с.Асан', regionCode: '23', districtCode: '46' },
  { code: '36400', name: 'с.Уштаган', regionCode: '23', districtCode: '46' },
  { code: '37100', name: 'с.Котяевка', regionCode: '23', districtCode: '46' },
  { code: '39100', name: 'с.Бирлик', regionCode: '23', districtCode: '46' },
  { code: '39200', name: 'с.Амангельды', regionCode: '23', districtCode: '46' },
  { code: '45100', name: 'с.Жыланды', regionCode: '23', districtCode: '46' },
  {
    code: '45300',
    name: 'а.Гизата Алипова',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '47100', name: 'с.Жумекен', regionCode: '23', districtCode: '46' },
  {
    code: '47200',
    name: 'аул Даулеткерей',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '47300', name: 'с.Кадырка', regionCode: '23', districtCode: '46' },
  { code: '47400', name: 'с.Кошалак', regionCode: '23', districtCode: '46' },
  { code: '49100', name: 'с.Орлы', regionCode: '23', districtCode: '46' },
  { code: '49200', name: 'с.Каспий', regionCode: '23', districtCode: '46' },
  { code: '49300', name: 'с.Шестой', regionCode: '23', districtCode: '46' },
  { code: '51100', name: 'с.Коптогай', regionCode: '23', districtCode: '46' },
  { code: '51400', name: 'с.Балыкши', regionCode: '23', districtCode: '46' },
  { code: '53100', name: 'с.Дашино', regionCode: '23', districtCode: '46' },
  {
    code: '53200',
    name: 'с.Большой Куйген',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '53300', name: 'с.Жасарал', regionCode: '23', districtCode: '46' },
  { code: '53400', name: 'с.Шагырлы', regionCode: '23', districtCode: '46' },
  { code: '55100', name: 'с.Кудряшево', regionCode: '23', districtCode: '46' },
  { code: '55200', name: 'с.Жанаауыл', regionCode: '23', districtCode: '46' },
  { code: '55300', name: 'с. Арна', regionCode: '23', districtCode: '46' },
  {
    code: '56200',
    name: 'рзд.Hурпеисовой',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '57100', name: 'с.Алга', regionCode: '23', districtCode: '46' },
  { code: '57300', name: 'с.Алипова', regionCode: '23', districtCode: '46' },
  { code: '57400', name: 'с.Иманово', regionCode: '23', districtCode: '46' },
  { code: '57500', name: 'с.Кокарна', regionCode: '23', districtCode: '46' },
  { code: '57600', name: 'с.Караколь', regionCode: '23', districtCode: '46' },
  {
    code: '57900',
    name: 'рзд.Афанасьева',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '59100', name: 'с.Нуржау', regionCode: '23', districtCode: '46' },
  { code: '59300', name: 'с.Жамбыл', regionCode: '23', districtCode: '46' },
  { code: '63100', name: 'с.Приморье', regionCode: '23', districtCode: '46' },
  {
    code: '63200',
    name: 'аул Кумаргали',
    regionCode: '23',
    districtCode: '46'
  },
  { code: '63300', name: 'аул Даулет', regionCode: '23', districtCode: '46' },
  { code: '63400', name: 'аул Шайхы', regionCode: '23', districtCode: '46' },
  { code: '65100', name: 'с.Сафоновка', regionCode: '23', districtCode: '46' },
  { code: '67100', name: 'с.Суюндук', regionCode: '23', districtCode: '46' },
  { code: '67200', name: 'с.Батырбек', regionCode: '23', districtCode: '46' },
  { code: '67300', name: 'с.Егинкудук', regionCode: '23', districtCode: '46' },
  { code: '67400', name: 'с.Жалгызапан', regionCode: '23', districtCode: '46' },
  { code: '69100', name: 'с.Шортанбай', regionCode: '23', districtCode: '46' },
  { code: '2', name: 'Аксайский с.о.', regionCode: '23', districtCode: '23' },
  { code: '3', name: 'с.Аксай', regionCode: '23', districtCode: '23' },
  { code: '4', name: 'с.Акжар', regionCode: '23', districtCode: '23' },
  { code: '5', name: 'с.Атырау', regionCode: '23', districtCode: '23' },
  { code: '6', name: 'с.Золотенок', regionCode: '23', districtCode: '23' },
  { code: '7', name: 'Ферма', regionCode: '23', districtCode: '23' },
  { code: '8', name: 'с.Жанаталап', regionCode: '23', districtCode: '23' },
  { code: '9', name: 'с.Зарослый', regionCode: '23', districtCode: '23' },
  { code: '10', name: 'с.Курмангазы', regionCode: '23', districtCode: '23' },
  { code: '11', name: 'с.Кокарна', regionCode: '23', districtCode: '23' },
  { code: '12', name: 'с.Акжайык', regionCode: '23', districtCode: '23' },
  { code: '13', name: 'с.Водниково', regionCode: '23', districtCode: '23' },
  { code: '14', name: 'с.Курсай', regionCode: '23', districtCode: '23' },
  { code: '15', name: 'с.Бирлик', regionCode: '23', districtCode: '23' },
  { code: '16', name: 'ст.Карабатан', regionCode: '23', districtCode: '23' },
  { code: '17', name: 'с.Дамба', regionCode: '23', districtCode: '23' },
  { code: '18', name: 'с.Пешной', regionCode: '23', districtCode: '23' },
  { code: '19', name: 'с.Амангельды', regionCode: '23', districtCode: '23' },
  { code: '20', name: 'с.Еркинкала', regionCode: '23', districtCode: '23' },
  { code: '21', name: 'с.Ракуша', regionCode: '23', districtCode: '23' },
  { code: '22', name: 'с.Сарыузек', regionCode: '23', districtCode: '23' },
  { code: '23', name: 'с.Жумыскер', regionCode: '23', districtCode: '23' },
  { code: '24', name: 'с.Рембаза', regionCode: '23', districtCode: '23' },
  { code: '25', name: 'с.Таскала', regionCode: '23', districtCode: '23' },
  { code: '26', name: 'с.Томарлы', regionCode: '23', districtCode: '23' },
  { code: '27', name: 'с.Алменкайыр', regionCode: '23', districtCode: '23' },
  { code: '28', name: 'с.Грека', regionCode: '23', districtCode: '23' },
  { code: '29', name: 'с.Карталы', regionCode: '23', districtCode: '23' },
  { code: '30', name: 'с.Стандарт', regionCode: '23', districtCode: '23' },
  { code: '31', name: 'с.Талиши', regionCode: '23', districtCode: '23' },
  { code: '32', name: 'с.Тукей', regionCode: '23', districtCode: '23' },
  { code: '33', name: 'с.Шагырлы', regionCode: '23', districtCode: '23' },
  { code: '34', name: 'с.Бесикты', regionCode: '23', districtCode: '23' },
  { code: '35', name: 'с.Аспа', regionCode: '23', districtCode: '23' },
  { code: '36', name: 'с.Калмаккора', regionCode: '23', districtCode: '23' },
  { code: '37', name: 'с.Сокол', regionCode: '23', districtCode: '23' },
  { code: '38', name: 'с.Талкайран', regionCode: '23', districtCode: '23' },
  { code: '10100', name: 'г.Атырау', regionCode: '23', districtCode: '1' },
  { code: '33100', name: 'с.Аккизтогай', regionCode: '23', districtCode: '36' },
  { code: '35100', name: 'с.Тургызба', regionCode: '23', districtCode: '36' },
  { code: '35200', name: 'с.Аккудык', regionCode: '23', districtCode: '36' },
  { code: '35300', name: 'с.Караша', regionCode: '23', districtCode: '36' },
  { code: '35400', name: 'а.Койсары', regionCode: '23', districtCode: '36' },
  {
    code: '37100',
    name: 'с.Шокпартогай',
    regionCode: '23',
    districtCode: '36'
  },
  {
    code: '39100',
    name: 'п.Жана Каратон',
    regionCode: '23',
    districtCode: '36'
  },
  { code: '43100', name: 'с.Косчагил', regionCode: '23', districtCode: '36' },
  { code: '43300', name: 'с.Карагай', regionCode: '23', districtCode: '36' },
  { code: '43400', name: 'с.Тургызба', regionCode: '23', districtCode: '36' },
  { code: '45100', name: 'а.Майкомген', regionCode: '23', districtCode: '36' },
  { code: '45200', name: 'а.Аккудык', regionCode: '23', districtCode: '36' },
  {
    code: '30100',
    name: 'п.Индерборский',
    regionCode: '23',
    districtCode: '40'
  },
  { code: '33100', name: 'а.Бодене', regionCode: '23', districtCode: '40' },
  { code: '35100', name: 'с.Елтай', regionCode: '23', districtCode: '40' },
  { code: '35200', name: 'аул Аккала', regionCode: '23', districtCode: '40' },
  { code: '37100', name: 'аул Жарсуат', regionCode: '23', districtCode: '40' },
  { code: '37200', name: 'аул Актан', regionCode: '23', districtCode: '40' },
  { code: '37300', name: 'с.Бухар', regionCode: '23', districtCode: '40' },
  { code: '37500', name: 'с.Кетебай', regionCode: '23', districtCode: '40' },
  { code: '37600', name: 'с.Курылыс', regionCode: '23', districtCode: '40' },
  { code: '37700', name: 'с.Кызылжар', regionCode: '23', districtCode: '40' },
  { code: '43100', name: 'с.Коктогай', regionCode: '23', districtCode: '40' },
  { code: '45100', name: 'с.Есбол', regionCode: '23', districtCode: '40' },
  { code: '45200', name: 'с.Ынтымак', regionCode: '23', districtCode: '40' },
  { code: '47100', name: 'с.Орлик', regionCode: '23', districtCode: '40' },
  { code: '30400', name: 'с.Озерное', regionCode: '27', districtCode: '44' },
  {
    code: '30300',
    name: 'с.Калининское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '30200', name: 'с.Забродино', regionCode: '27', districtCode: '44' },
  { code: '49300', name: 'с.Кенсуат', regionCode: '27', districtCode: '32' },
  { code: '59300', name: 'с.Кайшакудук', regionCode: '27', districtCode: '48' },
  { code: '49400', name: 'с. Айнабулак', regionCode: '27', districtCode: '60' },
  { code: '30100', name: 'с.Чингирлау', regionCode: '27', districtCode: '66' },
  {
    code: '73200',
    name: 'с.Красный Урал',
    regionCode: '27',
    districtCode: '44'
  },
  {
    code: '73100',
    name: 'с.Чувашинское',
    regionCode: '27',
    districtCode: '44'
  },
  {
    code: '671000',
    name: 'с.Чеботарево',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '61100', name: 'с.Трекино', regionCode: '27', districtCode: '44' },
  { code: '55100', name: 'с.Белес', regionCode: '27', districtCode: '27' },
  { code: '45500', name: 'с.Асан', regionCode: '27', districtCode: '44' },
  { code: '45400', name: 'с.Зеленое', regionCode: '27', districtCode: '44' },
  { code: '43100', name: 'с.Макарово', regionCode: '27', districtCode: '44' },
  {
    code: '41300',
    name: 'с.Владимировка',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '31100', name: 'с.Дарьинское', regionCode: '27', districtCode: '44' },
  { code: '30600', name: 'с.Усихино', regionCode: '27', districtCode: '44' },
  {
    code: '39300',
    name: 'с.Котельниково',
    regionCode: '27',
    districtCode: '44'
  },
  {
    code: '2.74427E+12',
    name: 'с.Мичуринское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '79500', name: 'с.Чинарево', regionCode: '27', districtCode: '44' },
  { code: '79300', name: 'с.Петрово', regionCode: '27', districtCode: '44' },
  { code: '79200', name: 'с.Кирсаново', regionCode: '27', districtCode: '44' },
  { code: '77300', name: 'с.Скворкино', regionCode: '27', districtCode: '44' },
  { code: '77200', name: 'с.Богатск', regionCode: '27', districtCode: '44' },
  { code: '77100', name: 'с.Янайкино', regionCode: '27', districtCode: '44' },
  { code: '75100', name: 'с.Щапово', regionCode: '27', districtCode: '44' },
  { code: '71200', name: 'с.Балабаново', regionCode: '27', districtCode: '44' },
  { code: '71100', name: 'с.Чирово', regionCode: '27', districtCode: '44' },
  { code: '67200', name: 'с.Хамино', regionCode: '27', districtCode: '44' },
  { code: '65400', name: 'с.Павлово', regionCode: '27', districtCode: '44' },
  {
    code: '65300',
    name: 'с.Кожевниково',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '65200', name: 'с.Горбуново', regionCode: '27', districtCode: '44' },
  { code: '65100', name: 'с.Махамбет', regionCode: '27', districtCode: '44' },
  { code: '63200', name: 'с.Факел', regionCode: '27', districtCode: '44' },
  { code: '63100', name: 'с.Достык', regionCode: '27', districtCode: '44' },
  { code: '61400', name: 'с.Hовенькое', regionCode: '27', districtCode: '44' },
  { code: '61300', name: 'с.Жайык', regionCode: '27', districtCode: '44' },
  {
    code: '61200',
    name: 'с.Володарское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '59200', name: 'с.Чесноково', regionCode: '27', districtCode: '44' },
  {
    code: '59100',
    name: 'с.Егиндибулак',
    regionCode: '27',
    districtCode: '44'
  },
  {
    code: '57100',
    name: 'с.Рубежинское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '55200', name: 'с.Акжол', regionCode: '27', districtCode: '44' },
  {
    code: '53200',
    name: 'с.Красный Свет',
    regionCode: '27',
    districtCode: '44'
  },
  {
    code: '41100',
    name: 'с.Большой Чаган',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '30100', name: 'с,Переметное', regionCode: '27', districtCode: '44' },
  { code: '53100', name: 'с.Раздольное', regionCode: '27', districtCode: '44' },
  { code: '47400', name: 'с.Таловая', regionCode: '27', districtCode: '44' },
  { code: '47300', name: 'с.Карпово', regionCode: '27', districtCode: '44' },
  { code: '47100', name: 'с.Шаләай', regionCode: '27', districtCode: '44' },
  {
    code: '45600',
    name: 'с.Октябрьское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '45300', name: 'с.Жамбыл', regionCode: '27', districtCode: '44' },
  { code: '43300', name: 'с.Садовое', regionCode: '27', districtCode: '44' },
  { code: '43200', name: 'с.Мирное', regionCode: '27', districtCode: '44' },
  { code: '41700', name: 'с.Оркен', regionCode: '27', districtCode: '44' },
  {
    code: '41600',
    name: 'с.Малый Чаган',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '41500', name: 'с.Кушум', regionCode: '27', districtCode: '44' },
  { code: '41400', name: 'с.Колесово', regionCode: '27', districtCode: '44' },
  { code: '41200', name: 'с.Жаҫатаҫ', regionCode: '27', districtCode: '36' },
  { code: '39400', name: 'с.Чапурино', regionCode: '27', districtCode: '44' },
  { code: '39200', name: 'с.Астафьево', regionCode: '27', districtCode: '44' },
  { code: '39100', name: 'с.Погодаево', regionCode: '27', districtCode: '44' },
  { code: '37200', name: 'с.Спартак', regionCode: '27', districtCode: '44' },
  {
    code: '37100',
    name: 'с.Красноармейское',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '35100', name: 'с.Зеленое', regionCode: '27', districtCode: '44' },
  { code: '33300', name: 'с.Hовенький', regionCode: '27', districtCode: '44' },
  { code: '33200', name: 'с.Гремячее', regionCode: '27', districtCode: '44' },
  { code: '33100', name: 'с.Железново', regionCode: '27', districtCode: '44' },
  { code: '31200', name: 'с.Озерное', regionCode: '27', districtCode: '27' },
  { code: '30700', name: 'с.Қаражар', regionCode: '27', districtCode: '44' },
  { code: '30500', name: 'с.Поливное', regionCode: '27', districtCode: '44' },
  {
    code: '37300',
    name: 'с.Магистральное',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '37400', name: 'с.Пойма', regionCode: '27', districtCode: '62' },
  { code: '39100', name: 'с.Анкаты', regionCode: '27', districtCode: '62' },
  { code: '39200', name: 'с.Рыбцех', regionCode: '27', districtCode: '62' },
  { code: '39300', name: 'с.Ерсары', regionCode: '27', districtCode: '62' },
  { code: '39400', name: 'с.Кандык', regionCode: '27', districtCode: '62' },
  {
    code: '39500',
    name: 'с.Hовая точка',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '39600', name: 'с.Сатымшеген', regionCode: '27', districtCode: '62' },
  { code: '39700', name: 'с.Тасаншеген', regionCode: '27', districtCode: '62' },
  { code: '43100', name: 'с.Богдановка', regionCode: '27', districtCode: '62' },
  { code: '45100', name: 'с.Долинное', regionCode: '27', districtCode: '62' },
  {
    code: '47100',
    name: 'с.Конеккеткен',
    regionCode: '27',
    districtCode: '62'
  },
  {
    code: '47200',
    name: 'с.Камыстыколь',
    regionCode: '27',
    districtCode: '62'
  },
  {
    code: '49100',
    name: 'с.Hовопавловка',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '53100', name: 'с.Подстепное', regionCode: '27', districtCode: '62' },
  {
    code: '53200',
    name: 'с.Лесопитомник',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '53300', name: 'с.Тукпай', regionCode: '27', districtCode: '62' },
  { code: '53400', name: 'с.Юбилейное', regionCode: '27', districtCode: '62' },
  {
    code: '55100',
    name: 'с.Покатиловка',
    regionCode: '27',
    districtCode: '62'
  },
  {
    code: '57100',
    name: 'с.Придорожное',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '57200', name: 'с.Алгабас', regionCode: '27', districtCode: '62' },
  { code: '57300', name: 'с.Сарсеново', regionCode: '27', districtCode: '62' },
  { code: '59100', name: 'с.Приречное', regionCode: '27', districtCode: '62' },
  { code: '63100', name: 'с.Тонкерис', regionCode: '27', districtCode: '62' },
  { code: '63300', name: 'с.Коныссай', regionCode: '27', districtCode: '62' },
  { code: '63400', name: 'с.Шоптыкуль', regionCode: '27', districtCode: '62' },
  { code: '65100', name: 'с.Узунколь', regionCode: '27', districtCode: '62' },
  {
    code: '69100',
    name: 'с.Hовая Жизнь',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '69200', name: 'с.Бекей', regionCode: '27', districtCode: '62' },
  { code: '69300', name: 'с.Социализм', regionCode: '27', districtCode: '62' },
  { code: '73100', name: 'с.Шагатай', regionCode: '27', districtCode: '62' },
  { code: '73200', name: 'с.Карабас', regionCode: '27', districtCode: '62' },
  {
    code: '73300',
    name: 'с.Когалытобек',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '73400', name: 'с.Кутсиык', regionCode: '27', districtCode: '62' },
  { code: '73500', name: 'с.Кызылжар', regionCode: '27', districtCode: '62' },
  { code: '75100', name: 'с.Сарыомир', regionCode: '27', districtCode: '62' },
  { code: '75200', name: 'с.Дуана', regionCode: '27', districtCode: '62' },
  { code: '75300', name: 'с.Шалкар', regionCode: '27', districtCode: '62' },
  { code: '33100', name: 'с.Тасмола', regionCode: '27', districtCode: '66' },
  { code: '33400', name: 'с.Кутантал', regionCode: '27', districtCode: '66' },
  { code: '35100', name: 'с.Алмазное', regionCode: '27', districtCode: '66' },
  { code: '35200', name: 'с.Аккудык', regionCode: '27', districtCode: '66' },
  { code: '35300', name: 'с.Сегизсай', regionCode: '27', districtCode: '66' },
  { code: '37100', name: 'с.Ащысай', regionCode: '27', districtCode: '66' },
  { code: '37200', name: 'с.Амангельды', regionCode: '27', districtCode: '66' },
  { code: '37300', name: 'с.Женишке', regionCode: '27', districtCode: '66' },
  { code: '37400', name: 'с.Мырзагара', regionCode: '27', districtCode: '66' },
  { code: '37500', name: 'с.Талдысай', regionCode: '27', districtCode: '66' },
  { code: '39100', name: 'с.Белогорка', regionCode: '27', districtCode: '66' },
  { code: '39200', name: 'с.Торыатбас', regionCode: '27', districtCode: '66' },
  { code: '43100', name: 'с.Карагаш', regionCode: '27', districtCode: '66' },
  { code: '43200', name: 'с.Аксуат', regionCode: '27', districtCode: '66' },
  { code: '43400', name: 'с.Кайынды', regionCode: '27', districtCode: '66' },
  { code: '43500', name: 'с.Каргалы', regionCode: '27', districtCode: '66' },
  { code: '45100', name: 'с.Кызылкуль', regionCode: '27', districtCode: '66' },
  { code: '45200', name: 'с.Аксугум', regionCode: '27', districtCode: '66' },
  { code: '45300', name: 'с.Жанакуш', regionCode: '27', districtCode: '66' },
  { code: '45400', name: 'с.Ўрысай', regionCode: '27', districtCode: '66' },
  { code: '45600', name: 'с.Шоктыбай', regionCode: '27', districtCode: '66' },
  { code: '47100', name: 'с.Лубенка', regionCode: '27', districtCode: '66' },
  { code: '47300', name: 'с.Сулукуль', regionCode: '27', districtCode: '66' },
  { code: '49100', name: 'с.Полтавка', regionCode: '27', districtCode: '66' },
  {
    code: '69100',
    name: 'с. Сулу кызыл',
    regionCode: '27',
    districtCode: '44'
  },
  { code: '79100', name: 'с.Январцево', regionCode: '27', districtCode: '44' },
  { code: '45100', name: 'с.Косарал', regionCode: '27', districtCode: '58' },
  { code: '45200', name: 'с.Акоба', regionCode: '27', districtCode: '58' },
  { code: '45300', name: 'с.Жетыколь', regionCode: '27', districtCode: '58' },
  { code: '45400', name: 'с.Каракудук', regionCode: '27', districtCode: '58' },
  { code: '47100', name: 'с.Коныр', regionCode: '27', districtCode: '58' },
  { code: '47200', name: 'с.Былкылдак', regionCode: '27', districtCode: '58' },
  { code: '47300', name: 'с.Кенаша', regionCode: '27', districtCode: '58' },
  { code: '47400', name: 'с.Тамды', regionCode: '27', districtCode: '58' },
  { code: '53100', name: 'с.Кособа', regionCode: '27', districtCode: '58' },
  { code: '53200', name: 'с.Жыракудук', regionCode: '27', districtCode: '58' },
  { code: '55100', name: 'с.Шагырлой', regionCode: '27', districtCode: '58' },
  { code: '55200', name: 'с.Жанаконыс', regionCode: '27', districtCode: '58' },
  { code: '55300', name: 'с.Коздикара', regionCode: '27', districtCode: '58' },
  { code: '55400', name: 'с.Кызылтан', regionCode: '27', districtCode: '58' },
  { code: '57100', name: 'с.Талдыбулак', regionCode: '27', districtCode: '58' },
  { code: '57400', name: 'с.Казахстан', regionCode: '27', districtCode: '58' },
  { code: '59100', name: 'с.Тоганас', regionCode: '27', districtCode: '58' },
  { code: '59200', name: 'с.Анкаты', regionCode: '27', districtCode: '58' },
  { code: '59300', name: 'с.Караганды', regionCode: '27', districtCode: '58' },
  { code: '59400', name: 'с.Куспанколь', regionCode: '27', districtCode: '58' },
  { code: '59500', name: 'с.Сегизуй', regionCode: '27', districtCode: '58' },
  { code: '30100', name: 'с.Таскала', regionCode: '27', districtCode: '60' },
  { code: '30200', name: 'с.Жігер', regionCode: '27', districtCode: '60' },
  { code: '30300', name: 'с.Бірлік', regionCode: '27', districtCode: '60' },
  { code: '33100', name: 'с.Актау', regionCode: '27', districtCode: '60' },
  { code: '33200', name: 'с.Беленькое', regionCode: '27', districtCode: '60' },
  { code: '33400', name: 'с.Кызылбас', regionCode: '27', districtCode: '60' },
  {
    code: '33500',
    name: 'с.Черная Впадина',
    regionCode: '27',
    districtCode: '60'
  },
  { code: '35100', name: 'с.Амангельды', regionCode: '27', districtCode: '60' },
  { code: '35400', name: 'с.Чижа 1', regionCode: '27', districtCode: '60' },
  { code: '37100', name: 'с.Достык', regionCode: '27', districtCode: '60' },
  { code: '37200', name: 'с.Бастау', regionCode: '27', districtCode: '60' },
  { code: '37300', name: 'с.Ынтымақ', regionCode: '27', districtCode: '60' },
  { code: '43100', name: 'с.Оян', regionCode: '27', districtCode: '60' },
  { code: '43400', name: 'с.Кеҫжайлау', regionCode: '27', districtCode: '60' },
  { code: '45100', name: 'а.Атамекен', regionCode: '27', districtCode: '60' },
  {
    code: '45300',
    name: 'с.Калмакшабын',
    regionCode: '27',
    districtCode: '60'
  },
  { code: '45400', name: 'с.Алмалы', regionCode: '27', districtCode: '60' },
  { code: '45500', name: 'с.Кисыксай', regionCode: '27', districtCode: '60' },
  { code: '47100', name: 'а.Мереке', regionCode: '27', districtCode: '60' },
  { code: '47500', name: 'с.Калмак', regionCode: '27', districtCode: '60' },
  { code: '49100', name: 'с.Мерей', regionCode: '27', districtCode: '60' },
  { code: '49200', name: 'с.Аққайнар', regionCode: '27', districtCode: '60' },
  { code: '49300', name: 'с.Оркен', regionCode: '27', districtCode: '60' },
  { code: '49600', name: 'с.Тоәайлы', regionCode: '27', districtCode: '60' },
  { code: '53100', name: 'с.Чижа 2', regionCode: '27', districtCode: '60' },
  { code: '53200', name: 'с.Ермольчево', regionCode: '27', districtCode: '60' },
  { code: '53300', name: 'с.Талдыбулак', regionCode: '27', districtCode: '60' },
  { code: '30100', name: 'с.Федоровка', regionCode: '27', districtCode: '62' },
  { code: '30300', name: 'с.Донецк', regionCode: '27', districtCode: '62' },
  { code: '30400', name: 'с.Яик', regionCode: '27', districtCode: '62' },
  { code: '30500', name: 'с.Кабылтобе', regionCode: '27', districtCode: '62' },
  { code: '33100', name: 'с.Акжаик', regionCode: '27', districtCode: '62' },
  { code: '33200', name: 'с.Абай', regionCode: '27', districtCode: '62' },
  {
    code: '33300',
    name: 'санаторий Акжаик',
    regionCode: '27',
    districtCode: '62'
  },
  { code: '33400', name: 'с.Подхоз', regionCode: '27', districtCode: '62' },
  { code: '33500', name: 'с.Суттигенды', regionCode: '27', districtCode: '62' },
  { code: '33600', name: 'с.Талпын', regionCode: '27', districtCode: '62' },
  { code: '35100', name: 'с.Аксогым', regionCode: '27', districtCode: '62' },
  { code: '35200', name: 'с.Бозай', regionCode: '27', districtCode: '62' },
  { code: '35300', name: 'с.Табынбай', regionCode: '27', districtCode: '62' },
  { code: '35400', name: 'с.Улкененбек', regionCode: '27', districtCode: '62' },
  { code: '37100', name: 'с.Аксуат', regionCode: '27', districtCode: '62' },
  { code: '37200', name: 'с.Айтиево', regionCode: '27', districtCode: '62' },
  { code: '30100', name: 'с.Каратобе', regionCode: '27', districtCode: '50' },
  { code: '33100', name: 'с.Коржын', regionCode: '27', districtCode: '50' },
  { code: '33200', name: 'с.Аккозы', regionCode: '27', districtCode: '50' },
  { code: '33300', name: 'с.Бесоба', regionCode: '27', districtCode: '50' },
  { code: '33400', name: 'с.Косбаз', regionCode: '27', districtCode: '50' },
  { code: '35100', name: 'с.Егендыколь', regionCode: '27', districtCode: '50' },
  { code: '37100', name: 'с.Жусандой', regionCode: '27', districtCode: '50' },
  { code: '37200', name: 'с.Ханколь', regionCode: '27', districtCode: '50' },
  { code: '39100', name: 'с.Актай', regionCode: '27', districtCode: '50' },
  { code: '39200', name: 'с.Алаколь', regionCode: '27', districtCode: '50' },
  { code: '39400', name: 'с.Косколь', regionCode: '27', districtCode: '50' },
  { code: '45100', name: 'с.Косколь', regionCode: '27', districtCode: '50' },
  { code: '45200', name: 'с.Шалгын', regionCode: '27', districtCode: '50' },
  { code: '47100', name: 'с.Каракамыс', regionCode: '27', districtCode: '50' },
  { code: '47400', name: 'с.Сауле', regionCode: '27', districtCode: '50' },
  { code: '49100', name: 'с.Сулыколь', regionCode: '27', districtCode: '50' },
  { code: '49300', name: 'с.Темирбек', regionCode: '27', districtCode: '50' },
  { code: '49400', name: 'с.Толен', regionCode: '27', districtCode: '50' },
  { code: '49500', name: 'с.Ушана', regionCode: '27', districtCode: '50' },
  { code: '53100', name: 'с.Шоптыколь', regionCode: '27', districtCode: '50' },
  { code: '53300', name: 'с.Соналы', regionCode: '27', districtCode: '50' },
  { code: '53400', name: 'с.Ушагаш', regionCode: '27', districtCode: '50' },
  { code: '30100', name: 'с.Сайхин', regionCode: '27', districtCode: '54' },
  { code: '30200', name: 'с.Большевик', regionCode: '27', districtCode: '54' },
  { code: '30300', name: 'а.Жарменке', regionCode: '27', districtCode: '54' },
  { code: '30400', name: 'с.Шонай', regionCode: '27', districtCode: '54' },
  { code: '33100', name: 'с.Бисен', regionCode: '27', districtCode: '54' },
  { code: '33200', name: 'с.Жамбыл', regionCode: '27', districtCode: '54' },
  { code: '33300', name: 'с.Жиеккум', regionCode: '27', districtCode: '54' },
  { code: '33400', name: 'с.Коктерек', regionCode: '27', districtCode: '54' },
  { code: '35100', name: 'с.Уялы', regionCode: '27', districtCode: '54' },
  { code: '35200', name: 'с.Кеной', regionCode: '27', districtCode: '54' },
  { code: '35300', name: 'с.Hауша', regionCode: '27', districtCode: '54' },
  { code: '37100', name: 'с.Борли', regionCode: '27', districtCode: '54' },
  { code: '37200', name: 'с.Куйбышев', regionCode: '27', districtCode: '54' },
  { code: '37300', name: 'с.Теренкудук', regionCode: '27', districtCode: '54' },
  { code: '39100', name: 'с.Муратсай', regionCode: '27', districtCode: '54' },
  { code: '39200', name: 'с.Ажен', regionCode: '27', districtCode: '54' },
  { code: '39300', name: 'с.Коккамыс', regionCode: '27', districtCode: '54' },
  { code: '39400', name: 'с.Тайгара', regionCode: '27', districtCode: '54' },
  { code: '43100', name: 'с.Хан Ордасы', regionCode: '27', districtCode: '54' },
  { code: '43200', name: 'с.Карасай', regionCode: '27', districtCode: '54' },
  { code: '43300', name: 'с.Карасу', regionCode: '27', districtCode: '54' },
  { code: '43400', name: 'с.Сейткали', regionCode: '27', districtCode: '54' },
  { code: '43500', name: 'с.Уштерек', regionCode: '27', districtCode: '54' },
  { code: '47100', name: 'с.Саралжын', regionCode: '27', districtCode: '54' },
  { code: '47200', name: 'с.Бесколь', regionCode: '27', districtCode: '54' },
  { code: '30100', name: 'с.Жымпиты', regionCode: '27', districtCode: '58' },
  {
    code: '30200',
    name: 'с.Биринши Май',
    regionCode: '27',
    districtCode: '58'
  },
  { code: '30400', name: 'с.Оленти', regionCode: '27', districtCode: '58' },
  { code: '33100', name: 'с.Алгабас', regionCode: '27', districtCode: '58' },
  { code: '33300', name: 'с.Жанаонир', regionCode: '27', districtCode: '58' },
  { code: '33500', name: 'с.Сасыкколь', regionCode: '27', districtCode: '58' },
  { code: '35100', name: 'с.Аралтобе', regionCode: '27', districtCode: '58' },
  { code: '35200', name: 'с.Кызылагаш', regionCode: '27', districtCode: '58' },
  { code: '37100', name: 'с.Булан', regionCode: '27', districtCode: '58' },
  { code: '37200', name: 'с.Жамбыл', regionCode: '27', districtCode: '58' },
  { code: '39100', name: 'с.Булдурта', regionCode: '27', districtCode: '58' },
  { code: '39200', name: 'с.Аккудук', regionCode: '27', districtCode: '58' },
  { code: '39300', name: 'с.Жаркамыс', regionCode: '27', districtCode: '58' },
  { code: '39400', name: 'с.Когерис', regionCode: '27', districtCode: '58' },
  { code: '39500', name: 'с.Каракудук', regionCode: '27', districtCode: '58' },
  { code: '43100', name: 'с.Таскудук', regionCode: '27', districtCode: '58' },
  { code: '43200', name: 'с.Алатау', regionCode: '27', districtCode: '58' },
  { code: '43200', name: 'с.Колтабан', regionCode: '27', districtCode: '42' },
  { code: '43300', name: 'с.Курсай', regionCode: '27', districtCode: '42' },
  { code: '43400', name: 'с.Онеге', regionCode: '27', districtCode: '42' },
  { code: '45100', name: 'с.Камысты', regionCode: '27', districtCode: '42' },
  { code: '47100', name: 'с.Таловка', regionCode: '27', districtCode: '42' },
  { code: '47200', name: 'с.Майтубек', regionCode: '27', districtCode: '42' },
  { code: '49100', name: 'с.Тау', regionCode: '27', districtCode: '42' },
  { code: '49200', name: 'с.Жигер', regionCode: '27', districtCode: '42' },
  {
    code: '49300',
    name: 'с.им.И.Жумаева',
    regionCode: '27',
    districtCode: '42'
  },
  { code: '53100', name: 'с.Узункол', regionCode: '27', districtCode: '42' },
  { code: '53200', name: 'с.Енбекши', regionCode: '27', districtCode: '42' },
  { code: '30100', name: 'с.Казталовка', regionCode: '27', districtCode: '48' },
  { code: '30200', name: 'с.Бозоба', regionCode: '27', districtCode: '48' },
  { code: '30300', name: 'с.Коныс', regionCode: '27', districtCode: '48' },
  { code: '30400', name: 'с.Сексенбаев', regionCode: '27', districtCode: '48' },
  { code: '33100', name: 'с.Акпатер', regionCode: '27', districtCode: '48' },
  {
    code: '33200',
    name: 'с.Кишкенеталдыкудук',
    regionCode: '27',
    districtCode: '48'
  },
  { code: '33300', name: 'с.Кишкенешал', regionCode: '27', districtCode: '48' },
  { code: '35100', name: 'а.Кайынды', regionCode: '27', districtCode: '48' },
  { code: '37100', name: 'с.Болашак', regionCode: '27', districtCode: '48' },
  { code: '37200', name: 'с.Копкутир', regionCode: '27', districtCode: '48' },
  { code: '37300', name: 'а.Жана тан', regionCode: '27', districtCode: '48' },
  { code: '37400', name: 'а.Аккурай', regionCode: '27', districtCode: '48' },
  { code: '39100', name: 'с.Бостандык', regionCode: '27', districtCode: '48' },
  { code: '39200', name: 'с.Караколь', regionCode: '27', districtCode: '48' },
  { code: '41100', name: 'с.Ажибай', regionCode: '27', districtCode: '48' },
  { code: '41200', name: 'с.Кызылту', regionCode: '27', districtCode: '48' },
  { code: '41300', name: 'с.Саралжын', regionCode: '27', districtCode: '48' },
  { code: '43100', name: 'с.Жалпактал', regionCode: '27', districtCode: '48' },
  { code: '43200', name: 'с.Кулак', regionCode: '27', districtCode: '48' },
  { code: '45100', name: 'с.Жанажол', regionCode: '27', districtCode: '48' },
  { code: '45200', name: 'с.Абиш', regionCode: '27', districtCode: '48' },
  { code: '45300', name: 'с.Комекши', regionCode: '27', districtCode: '48' },
  { code: '45500', name: 'с.Танат', regionCode: '27', districtCode: '48' },
  { code: '49100', name: 'с.Коктерек', regionCode: '27', districtCode: '48' },
  { code: '49200', name: 'с.Еламан', regionCode: '27', districtCode: '48' },
  { code: '49300', name: 'с.Уразгали', regionCode: '27', districtCode: '48' },
  { code: '49400', name: 'с.Саралжын', regionCode: '27', districtCode: '48' },
  { code: '49500', name: 'с.Сатыбалды', regionCode: '27', districtCode: '48' },
  { code: '51100', name: 'с.Караоба', regionCode: '27', districtCode: '48' },
  { code: '51200', name: 'с.Енбек', regionCode: '27', districtCode: '48' },
  { code: '51300', name: 'с.Конысбай', regionCode: '27', districtCode: '48' },
  { code: '53100', name: 'с.Караузен', regionCode: '27', districtCode: '48' },
  { code: '53200', name: 'с.Жас', regionCode: '27', districtCode: '48' },
  { code: '53300', name: 'с.Кулак', regionCode: '27', districtCode: '48' },
  { code: '53400', name: 'с.Серик', regionCode: '27', districtCode: '48' },
  { code: '55100', name: 'с.Карасу', regionCode: '27', districtCode: '48' },
  { code: '55200', name: 'с.Ашысай', regionCode: '27', districtCode: '48' },
  { code: '55300', name: 'с.Бостандык', regionCode: '27', districtCode: '48' },
  { code: '55400', name: 'с.Жулдыз', regionCode: '27', districtCode: '48' },
  { code: '55500', name: 'с.Торегали', regionCode: '27', districtCode: '48' },
  { code: '57100', name: 'с.Кошанколь', regionCode: '27', districtCode: '48' },
  { code: '57300', name: 'с.Ордабай', regionCode: '27', districtCode: '48' },
  { code: '59100', name: 'с.Талдыапан', regionCode: '27', districtCode: '48' },
  { code: '59200', name: 'с.Бейистерек', regionCode: '27', districtCode: '48' },
  { code: '59400', name: 'с.Кособа', regionCode: '27', districtCode: '48' },
  { code: '59500', name: 'с.Сарыкудук', regionCode: '27', districtCode: '48' },
  { code: '63100', name: 'с.Талдыкудук', regionCode: '27', districtCode: '48' },
  { code: '63300', name: 'с.Курман', regionCode: '27', districtCode: '48' },
  { code: '63400', name: 'с.Таскутур', regionCode: '27', districtCode: '48' },
  { code: '63600', name: 'с.Хайруш', regionCode: '27', districtCode: '48' },
  { code: '65100', name: 'с.Hурсай', regionCode: '27', districtCode: '48' },
  { code: '65200', name: 'с.Беспишен', regionCode: '27', districtCode: '48' },
  { code: '65300', name: 'с.Мереке', regionCode: '27', districtCode: '48' },
  { code: '33300', name: 'с.Сатайколь', regionCode: '27', districtCode: '36' },
  { code: '35100', name: 'с.Аксу', regionCode: '27', districtCode: '36' },
  { code: '35300', name: 'с.Жанаконыс', regionCode: '27', districtCode: '36' },
  {
    code: '37100',
    name: 'с.Александровка',
    regionCode: '27',
    districtCode: '36'
  },
  { code: '39100', name: 'с.Березовка', regionCode: '27', districtCode: '36' },
  { code: '39300', name: 'рзд.Сулусай', regionCode: '27', districtCode: '36' },
  { code: '43100', name: 'с.Бурлин', regionCode: '27', districtCode: '36' },
  { code: '43200', name: 'с.Масайтобе', regionCode: '27', districtCode: '36' },
  { code: '45100', name: 'с.Бумаколь', regionCode: '27', districtCode: '36' },
  { code: '45200', name: 'с.Облавка', regionCode: '27', districtCode: '36' },
  { code: '45300', name: 'с.Утвинка', regionCode: '27', districtCode: '36' },
  { code: '47100', name: 'а.Кентубек', regionCode: '27', districtCode: '36' },
  { code: '47200', name: 'а.Бактыарал', regionCode: '27', districtCode: '36' },
  { code: '47300', name: 'с.Пролетарка', regionCode: '27', districtCode: '36' },
  { code: '49100', name: 'с.Жарсуат', regionCode: '27', districtCode: '36' },
  { code: '49200', name: 'с.Димитрово', regionCode: '27', districtCode: '36' },
  {
    code: '49300',
    name: 'с.Карашыганак',
    regionCode: '27',
    districtCode: '36'
  },
  { code: '53100', name: 'с.Кирово', regionCode: '27', districtCode: '36' },
  { code: '55100', name: 'с.Канай', regionCode: '27', districtCode: '36' },
  { code: '55200', name: 'с.Даниляколь', regionCode: '27', districtCode: '36' },
  { code: '56100', name: 'с.Кызылтал', regionCode: '27', districtCode: '36' },
  { code: '56400', name: 'с.Бестау', regionCode: '27', districtCode: '36' },
  {
    code: '57100',
    name: 'с.Приуральное',
    regionCode: '27',
    districtCode: '36'
  },
  { code: '59100', name: 'с.Пугачево', regionCode: '27', districtCode: '36' },
  { code: '59200', name: 'с.Аралтал', regionCode: '27', districtCode: '36' },
  { code: '59300', name: 'с.Бесагаш', regionCode: '27', districtCode: '36' },
  { code: '63100', name: 'с.Тихоновка', regionCode: '27', districtCode: '36' },
  { code: '67100', name: 'с.Успенка', regionCode: '27', districtCode: '36' },
  { code: '67200', name: 'с.Жанаталап', regionCode: '27', districtCode: '36' },
  { code: '67300', name: 'с.Каракемпир', regionCode: '27', districtCode: '36' },
  { code: '30100', name: 'с.Жангала', regionCode: '27', districtCode: '40' },
  { code: '33100', name: 'с.Бирлик', regionCode: '27', districtCode: '40' },
  { code: '33200', name: 'с.Акбалшык', regionCode: '27', districtCode: '40' },
  { code: '33300', name: 'с.Ушкемпир', regionCode: '27', districtCode: '40' },
  { code: '35100', name: 'с.Жанажол', regionCode: '27', districtCode: '40' },
  {
    code: '35200',
    name: 'с.Киши Айдархан',
    regionCode: '27',
    districtCode: '40'
  },
  { code: '35400', name: 'с.Сарыколь', regionCode: '27', districtCode: '40' },
  { code: '35500', name: 'с.Тендик', regionCode: '27', districtCode: '40' },
  { code: '37100', name: 'с.Жанаказан', regionCode: '27', districtCode: '40' },
  { code: '37300', name: 'с.Балдырган', regionCode: '27', districtCode: '40' },
  { code: '37400', name: 'с.Жуалыой', regionCode: '27', districtCode: '40' },
  { code: '43100', name: 'с.Копжасар', regionCode: '27', districtCode: '40' },
  { code: '43200', name: 'с.Салтанат', regionCode: '27', districtCode: '40' },
  { code: '43300', name: 'с.Саралжын', regionCode: '27', districtCode: '40' },
  { code: '43400', name: 'с.Уштас', regionCode: '27', districtCode: '40' },
  { code: '45100', name: 'с.Кызылоба', regionCode: '27', districtCode: '40' },
  { code: '45200', name: 'с.Айтпай', regionCode: '27', districtCode: '40' },
  { code: '45400', name: 'с.Торткулак', regionCode: '27', districtCode: '40' },
  { code: '47100', name: 'с.Маштексай', regionCode: '27', districtCode: '40' },
  { code: '47400', name: 'с.Мукыр', regionCode: '27', districtCode: '40' },
  { code: '49100', name: 'а.Кыркопа', regionCode: '27', districtCode: '40' },
  { code: '49200', name: 'с.Балгын', regionCode: '27', districtCode: '40' },
  { code: '49300', name: 'с.Карташово', regionCode: '27', districtCode: '40' },
  { code: '53100', name: 'с.Пятимар', regionCode: '27', districtCode: '40' },
  { code: '53200', name: 'с.Аккус', regionCode: '27', districtCode: '40' },
  { code: '53400', name: 'с.Борык', regionCode: '27', districtCode: '40' },
  { code: '53500', name: 'с.Плантация', regionCode: '27', districtCode: '40' },
  { code: '30100', name: 'с.Жанибек', regionCode: '27', districtCode: '42' },
  { code: '33100', name: 'с.Акоба', regionCode: '27', districtCode: '42' },
  { code: '35100', name: 'с.Борсы', regionCode: '27', districtCode: '42' },
  { code: '35200', name: 'с.Тегисшил', regionCode: '27', districtCode: '42' },
  { code: '37100', name: 'с.Жаксыбай', regionCode: '27', districtCode: '42' },
  { code: '37300', name: 'с.Акадыр', regionCode: '27', districtCode: '42' },
  { code: '43100', name: 'с.Жаскайрат', regionCode: '27', districtCode: '42' },
  { code: '3', name: 'п.Деркул', regionCode: '27', districtCode: '27' },
  { code: '4', name: 'с.Кордон', regionCode: '27', districtCode: '27' },
  { code: '5', name: 'с.Ливкино', regionCode: '27', districtCode: '27' },
  { code: '6', name: 'с.Маштаково', regionCode: '27', districtCode: '27' },
  { code: '7', name: 'Желаевкий с.о.', regionCode: '27', districtCode: '27' },
  { code: '8', name: 'с.Желаево', regionCode: '27', districtCode: '27' },
  { code: '9', name: 'Зачаганская п.а.', regionCode: '27', districtCode: '27' },
  { code: '10', name: 'п.Зачаганск', regionCode: '27', districtCode: '27' },
  { code: '11', name: 'с.Меловые Горки', regionCode: '27', districtCode: '27' },
  {
    code: '12',
    name: 'Круглоозерновская п.а.',
    regionCode: '27',
    districtCode: '27'
  },
  { code: '13', name: 'п.Круглоозерное', regionCode: '27', districtCode: '27' },
  { code: '14', name: 'с.Серебряково', regionCode: '27', districtCode: '27' },
  { code: '10100', name: 'г.Уральск', regionCode: '27', districtCode: '1' },
  { code: '30100', name: 'с.Чапаев', regionCode: '27', districtCode: '32' },
  { code: '33100', name: 'с.Лбищенское', regionCode: '27', districtCode: '32' },
  { code: '33200', name: 'с.Битилеу', regionCode: '27', districtCode: '32' },
  { code: '33300', name: 'с.Кабыл', regionCode: '27', districtCode: '32' },
  { code: '33400', name: 'с.Тинали', regionCode: '27', districtCode: '32' },
  { code: '35100', name: 'с.Аксуат', regionCode: '27', districtCode: '32' },
  { code: '35200', name: 'с.Акбулак', regionCode: '27', districtCode: '32' },
  { code: '37100', name: 'с.Алгабас', regionCode: '27', districtCode: '32' },
  { code: '37200', name: 'с.Бесоба', regionCode: '27', districtCode: '32' },
  { code: '37300', name: 'с.Тегисжол', regionCode: '27', districtCode: '32' },
  { code: '37400', name: 'с.Карагай', regionCode: '27', districtCode: '32' },
  { code: '37500', name: 'с.Жанажол', regionCode: '27', districtCode: '32' },
  { code: '37600', name: 'с.Тоган', regionCode: '27', districtCode: '32' },
  { code: '39100', name: 'с.Алмалы', regionCode: '27', districtCode: '32' },
  { code: '39200', name: 'с.Атамекен', regionCode: '27', districtCode: '32' },
  { code: '39300', name: 'с.Жантемир', regionCode: '27', districtCode: '32' },
  { code: '43100', name: 'с.Базартобе', regionCode: '27', districtCode: '32' },
  { code: '43200', name: 'с.Кадыркул', regionCode: '27', districtCode: '32' },
  { code: '43300', name: 'с.Кызылжар', regionCode: '27', districtCode: '32' },
  { code: '45100', name: 'с.Базаршолан', regionCode: '27', districtCode: '32' },
  { code: '45200', name: 'с.Есим', regionCode: '27', districtCode: '32' },
  { code: '45300', name: 'с.Жаманкудук', regionCode: '27', districtCode: '32' },
  { code: '45500', name: 'с.Баянтобе', regionCode: '27', districtCode: '32' },
  { code: '47100', name: 'с.Бударино', regionCode: '27', districtCode: '32' },
  { code: '47200', name: 'с.Самал', regionCode: '27', districtCode: '32' },
  {
    code: '47300',
    name: 'с.Коловертное',
    regionCode: '27',
    districtCode: '32'
  },
  { code: '49100', name: 'с.Есенсай', regionCode: '27', districtCode: '32' },
  { code: '49400', name: 'с.Тасоба', regionCode: '27', districtCode: '32' },
  { code: '53100', name: 'с.Жайык', regionCode: '27', districtCode: '32' },
  { code: '55100', name: 'с.Жамбыл', regionCode: '27', districtCode: '32' },
  { code: '55200', name: 'с.Ҝштҙбе', regionCode: '27', districtCode: '32' },
  { code: '55400', name: 'с.Битик', regionCode: '27', districtCode: '32' },
  { code: '55500', name: 'с.Донгелек', regionCode: '27', districtCode: '32' },
  { code: '57100', name: 'а.Жанабулак', regionCode: '27', districtCode: '32' },
  { code: '57200', name: 'с.Косшыгыр', regionCode: '27', districtCode: '32' },
  { code: '59100', name: 'с.Первомай', regionCode: '27', districtCode: '32' },
  {
    code: '63100',
    name: 'с.Карауылтобе',
    regionCode: '27',
    districtCode: '32'
  },
  { code: '63300', name: 'с.Кырыккудук', regionCode: '27', districtCode: '32' },
  {
    code: '65100',
    name: 'а.Жубана Молдагалиева',
    regionCode: '27',
    districtCode: '32'
  },
  { code: '65200', name: 'с.Атибек', regionCode: '27', districtCode: '32' },
  { code: '65300', name: 'с.Сайкудук', regionCode: '27', districtCode: '32' },
  { code: '67100', name: 'с.Мергенево', regionCode: '27', districtCode: '32' },
  { code: '67200', name: 'с.Мойылды', regionCode: '27', districtCode: '32' },
  { code: '67300', name: 'с.Жолап', regionCode: '27', districtCode: '32' },
  { code: '69100', name: 'с.Жанама', regionCode: '27', districtCode: '32' },
  { code: '69200', name: 'с.Сарман', regionCode: '27', districtCode: '32' },
  { code: '73100', name: 'с.Тайпак', regionCode: '27', districtCode: '32' },
  { code: '73200', name: 'с.Томпак', regionCode: '27', districtCode: '32' },
  { code: '73300', name: 'с.Шабдаржап', regionCode: '27', districtCode: '32' },
  { code: '20100', name: 'г.Аксай', regionCode: '27', districtCode: '36' },
  { code: '33100', name: 'с.Акбулак', regionCode: '27', districtCode: '36' },
  { code: '47700', name: 'с.Шагалалы', regionCode: '31', districtCode: '60' },
  { code: '31100', name: 'с.Акколь', regionCode: '31', districtCode: '62' },
  { code: '32100', name: 'с.Аккум', regionCode: '31', districtCode: '62' },
  { code: '35100', name: 'с.Майтобе', regionCode: '31', districtCode: '62' },
  { code: '35200', name: 'а.Кожагаппар', regionCode: '31', districtCode: '62' },
  {
    code: '37100',
    name: 'а.Болтирик шешен',
    regionCode: '31',
    districtCode: '62'
  },
  {
    code: '37200',
    name: 'а.Кошек батыра',
    regionCode: '31',
    districtCode: '62'
  },
  { code: '38100', name: 'с.Коктал', regionCode: '31', districtCode: '62' },
  { code: '39100', name: 'а.Есей би', regionCode: '31', districtCode: '62' },
  { code: '39200', name: 'с.Караой', regionCode: '31', districtCode: '62' },
  { code: '40100', name: 'а.Каскабулак', regionCode: '31', districtCode: '62' },
  { code: '41100', name: 'с.Кызылаут', regionCode: '31', districtCode: '62' },
  { code: '41200', name: 'с.Актобе', regionCode: '31', districtCode: '62' },
  { code: '43100', name: 'с.Ойык', regionCode: '31', districtCode: '62' },
  { code: '43200', name: 'с.Турымкул', regionCode: '31', districtCode: '62' },
  { code: '43400', name: 'с.Сейлбек', regionCode: '31', districtCode: '62' },
  { code: '45100', name: 'с.Тамды', regionCode: '31', districtCode: '62' },
  { code: '47100', name: 'с.Ушарал', regionCode: '31', districtCode: '62' },
  { code: '47200', name: 'с.Арал', regionCode: '31', districtCode: '62' },
  { code: '47300', name: 'с.Кайыр', regionCode: '31', districtCode: '62' },
  { code: '49100', name: 'с.Бостандык', regionCode: '31', districtCode: '62' },
  { code: '49400', name: 'с.Талапты', regionCode: '31', districtCode: '62' },
  {
    code: '59100',
    name: 'с.им.Шакирова',
    regionCode: '31',
    districtCode: '62'
  },
  { code: '59500', name: 'а.Амангельды', regionCode: '31', districtCode: '62' },
  { code: '21100', name: 'г.Шу', regionCode: '31', districtCode: '66' },
  { code: '30100', name: 'а.Толе би', regionCode: '31', districtCode: '66' },
  {
    code: '30300',
    name: 'с.Зверохозяйство',
    regionCode: '31',
    districtCode: '66'
  },
  { code: '31100', name: 'с.Алга', regionCode: '31', districtCode: '66' },
  { code: '31180', name: 'с.Жайсан', regionCode: '31', districtCode: '66' },
  { code: '31200', name: 'а.Сауытбек', regionCode: '31', districtCode: '66' },
  { code: '32100', name: 'с.Бирлик', regionCode: '31', districtCode: '66' },
  { code: '33100', name: 'с.Далакайнар', regionCode: '31', districtCode: '66' },
  { code: '34100', name: 'с.Аксу', regionCode: '31', districtCode: '66' },
  {
    code: '34300',
    name: 'с.им.Оразалы батыра',
    regionCode: '31',
    districtCode: '66'
  },
  { code: '35100', name: 'а.Байдибек', regionCode: '31', districtCode: '66' },
  { code: '35200', name: 'с.Актасты', regionCode: '31', districtCode: '66' },
  { code: '35400', name: 'с.Болтирик', regionCode: '31', districtCode: '66' },
  {
    code: '36100',
    name: 'с.Бирликустем',
    regionCode: '31',
    districtCode: '66'
  },
  { code: '37100', name: 'с.Бельбасар', regionCode: '31', districtCode: '66' },
  { code: '37300', name: 'с.Енбекши', regionCode: '31', districtCode: '66' },
  { code: '37500', name: 'с.Тасоткель', regionCode: '31', districtCode: '66' },
  { code: '38100', name: 'с.Жанажол', regionCode: '31', districtCode: '66' },
  { code: '39100', name: 'с.Коктобе', regionCode: '31', districtCode: '66' },
  {
    code: '40100',
    name: 'с.им.Балуана Шолака',
    regionCode: '31',
    districtCode: '66'
  },
  { code: '41100', name: 'с.Шокпар', regionCode: '31', districtCode: '66' },
  { code: '41200', name: 'ст.Алайгыр', regionCode: '31', districtCode: '66' },
  { code: '41300', name: 'ст.Эспе', regionCode: '31', districtCode: '66' },
  { code: '41400', name: 'ст.Кулакшино', regionCode: '31', districtCode: '66' },
  { code: '41500', name: 'ст.Шокпар', regionCode: '31', districtCode: '66' },
  { code: '43100', name: 'с.Коккайнар', regionCode: '31', districtCode: '66' },
  { code: '45100', name: 'с.Мойынкум', regionCode: '31', districtCode: '66' },
  { code: '45300', name: 'с.Енбек', regionCode: '31', districtCode: '66' },
  { code: '45400', name: 'с.Жиенбет', regionCode: '31', districtCode: '66' },
  {
    code: '47100',
    name: 'а.Динмухамеда Кунаева',
    regionCode: '31',
    districtCode: '66'
  },
  { code: '49100', name: 'с.Абай', regionCode: '31', districtCode: '66' },
  { code: '51100', name: 'с.Тасоткель', regionCode: '31', districtCode: '66' },
  { code: '51200', name: 'ст.Аспара', regionCode: '31', districtCode: '66' },
  { code: '51300', name: 'рзд.Кумозек', regionCode: '31', districtCode: '66' },
  { code: '55100', name: 'с.Актобе', regionCode: '31', districtCode: '66' },
  { code: '59505', name: 'г.Каратау', regionCode: '31', districtCode: '62' },
  { code: '20100', name: 'г. Жанатас', regionCode: '31', districtCode: '60' },
  { code: '30100', name: 'с.Аса', regionCode: '31', districtCode: '40' },
  { code: '47100', name: 'с.Терис', regionCode: '31', districtCode: '42' },
  {
    code: '46600',
    name: 'а.Тескентоган',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '47100', name: 'с.Татти', regionCode: '31', districtCode: '54' },
  { code: '47200', name: 'с.Бельарык', regionCode: '31', districtCode: '54' },
  { code: '47300', name: 'с.Карасу', regionCode: '31', districtCode: '54' },
  { code: '47400', name: 'с.Ленинжолы', regionCode: '31', districtCode: '54' },
  {
    code: '47500',
    name: 'рзд.Тасоткель',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '47600', name: 'ст.Татти', regionCode: '31', districtCode: '54' },
  { code: '47700', name: 'рзд.Чемен', regionCode: '31', districtCode: '54' },
  { code: '51100', name: 'с.Акарал', regionCode: '31', districtCode: '54' },
  { code: '51500', name: 'с.Сыпатай', regionCode: '31', districtCode: '54' },
  { code: '53100', name: 'с.Аспара', regionCode: '31', districtCode: '54' },
  { code: '30100', name: 'а.Мойынкум', regionCode: '31', districtCode: '56' },
  { code: '32100', name: 'п.Акбакай', regionCode: '31', districtCode: '56' },
  { code: '33100', name: 'п.Аксуек', regionCode: '31', districtCode: '56' },
  { code: '34100', name: 'с.Биназар', regionCode: '31', districtCode: '56' },
  { code: '35100', name: 'с.Бирлик', regionCode: '31', districtCode: '56' },
  { code: '36100', name: 'с.Жамбыл', regionCode: '31', districtCode: '56' },
  { code: '37100', name: 'с.Карабогет', regionCode: '31', districtCode: '56' },
  { code: '37200', name: 'с.Арал', regionCode: '31', districtCode: '56' },
  { code: '37300', name: 'с.Байтал', regionCode: '31', districtCode: '56' },
  { code: '37400', name: 'с.Кумозек', regionCode: '31', districtCode: '56' },
  { code: '37500', name: 'с.Сарыозек', regionCode: '31', districtCode: '56' },
  { code: '38100', name: 'с.Кенес', regionCode: '31', districtCode: '56' },
  { code: '39100', name: 'с.Кызылту', regionCode: '31', districtCode: '56' },
  {
    code: '39400',
    name: 'с.им.Hазарбекова А.',
    regionCode: '31',
    districtCode: '56'
  },
  {
    code: '40100',
    name: 'а.им.Кылышбай Ержанулы',
    regionCode: '31',
    districtCode: '56'
  },
  { code: '41100', name: 'п.Мирный', regionCode: '31', districtCode: '56' },
  { code: '41300', name: 'а.ГРЭ 21', regionCode: '31', districtCode: '56' },
  { code: '43100', name: 'а.Кушаман', regionCode: '31', districtCode: '56' },
  { code: '45100', name: 'с.Мынарал', regionCode: '31', districtCode: '56' },
  {
    code: '45200',
    name: 'ст.Кашкантениз',
    regionCode: '31',
    districtCode: '56'
  },
  { code: '45300', name: 'ст.Мынарал', regionCode: '31', districtCode: '56' },
  { code: '47100', name: 'с.Уланбель', regionCode: '31', districtCode: '56' },
  {
    code: '47200',
    name: 'с.Малые Камкалы',
    regionCode: '31',
    districtCode: '56'
  },
  { code: '49100', name: 'п.Хантау', regionCode: '31', districtCode: '56' },
  { code: '49200', name: 'ст.Жидели', regionCode: '31', districtCode: '56' },
  { code: '49300', name: 'ст.Кияхты', regionCode: '31', districtCode: '56' },
  { code: '51100', name: 'п.Шыганак', regionCode: '31', districtCode: '56' },
  { code: '51200', name: 'с.Бурубайтал', regionCode: '31', districtCode: '56' },
  {
    code: '51300',
    name: 'ст.Бурубайтал',
    regionCode: '31',
    districtCode: '56'
  },
  { code: '33100', name: 'а.Саудакент', regionCode: '31', districtCode: '60' },
  { code: '33300', name: 'с.Жаркудук', regionCode: '31', districtCode: '60' },
  { code: '35100', name: 'а.Жайылма', regionCode: '31', districtCode: '60' },
  { code: '35200', name: 'с.Актам', regionCode: '31', districtCode: '60' },
  { code: '35600', name: 'с.Кызылдикан', regionCode: '31', districtCode: '60' },
  { code: '35700', name: 'а.Маятас', regionCode: '31', districtCode: '60' },
  { code: '36100', name: 'с.Жанаталап', regionCode: '31', districtCode: '60' },
  { code: '36600', name: 'с.Уюм', regionCode: '31', districtCode: '60' },
  {
    code: '37100',
    name: 'а.Узакбай Сыздыкбаева',
    regionCode: '31',
    districtCode: '60'
  },
  { code: '37200', name: 'с.Актогай', regionCode: '31', districtCode: '60' },
  { code: '38100', name: 'с.Ондирис', regionCode: '31', districtCode: '60' },
  { code: '38400', name: 'а.Игилик', regionCode: '31', districtCode: '60' },
  { code: '39100', name: 'с.Шыганак', regionCode: '31', districtCode: '60' },
  { code: '39200', name: 'с.Жайлауколь', regionCode: '31', districtCode: '60' },
  { code: '39300', name: 'с.Камкалы', regionCode: '31', districtCode: '60' },
  {
    code: '41100',
    name: 'с.Ашира Буркитбаева',
    regionCode: '31',
    districtCode: '60'
  },
  { code: '41200', name: 'с.Буденное', regionCode: '31', districtCode: '60' },
  { code: '41400', name: 'с.Ушбас', regionCode: '31', districtCode: '60' },
  { code: '43100', name: 'с.Тогызкент', regionCode: '31', districtCode: '60' },
  { code: '43300', name: 'с.Майлыколь', regionCode: '31', districtCode: '60' },
  { code: '43400', name: 'с.Ушарал', regionCode: '31', districtCode: '60' },
  { code: '47100', name: 'с.Досбол', regionCode: '31', districtCode: '60' },
  {
    code: '47300',
    name: 'с.Кокдала-киши',
    regionCode: '31',
    districtCode: '60'
  },
  {
    code: '47500',
    name: 'с.Кокдала-улкен',
    regionCode: '31',
    districtCode: '60'
  },
  { code: '36100', name: 'а.Кокдонен', regionCode: '31', districtCode: '50' },
  { code: '36400', name: 'а.Жаксылык', regionCode: '31', districtCode: '50' },
  { code: '36700', name: 'ст.Кумарык', regionCode: '31', districtCode: '50' },
  { code: '37100', name: 'с.Корагаты', regionCode: '31', districtCode: '50' },
  { code: '37200', name: 'с.Аккайнар', regionCode: '31', districtCode: '50' },
  { code: '37500', name: 'ст.Корагаты', regionCode: '31', districtCode: '50' },
  { code: '37700', name: 'с.Мамыртобе', regionCode: '31', districtCode: '50' },
  { code: '37900', name: 'с.Тайкудык', regionCode: '31', districtCode: '50' },
  { code: '39100', name: 'с.Когершин', regionCode: '31', districtCode: '50' },
  { code: '39600', name: 'с.Косапан', regionCode: '31', districtCode: '50' },
  { code: '40100', name: 'с.Кайынды', regionCode: '31', districtCode: '50' },
  { code: '40200', name: 'с.Алгабас', regionCode: '31', districtCode: '50' },
  {
    code: '40400',
    name: 'с.Мамай-Кайынды',
    regionCode: '31',
    districtCode: '50'
  },
  { code: '41100', name: 'а.Кумарык', regionCode: '31', districtCode: '50' },
  { code: '41200', name: 'с.Алгабас', regionCode: '31', districtCode: '50' },
  { code: '41600', name: 'с.Каракемер', regionCode: '31', districtCode: '50' },
  {
    code: '42100',
    name: 'с.им.Рахима Сабденова',
    regionCode: '31',
    districtCode: '50'
  },
  { code: '42300', name: 'а.Байтели', regionCode: '31', districtCode: '50' },
  { code: '42600', name: 'с.Кызылшаруа', regionCode: '31', districtCode: '50' },
  { code: '42800', name: 'рзд.98', regionCode: '31', districtCode: '50' },
  { code: '43100', name: 'с.Луговое', regionCode: '31', districtCode: '50' },
  { code: '45100', name: 'с.Юбилейное', regionCode: '31', districtCode: '50' },
  { code: '45200', name: 'с.Абылкаир', regionCode: '31', districtCode: '50' },
  { code: '51100', name: 'с.Орнек', regionCode: '31', districtCode: '50' },
  {
    code: '51200',
    name: 'а.им.Абжапара Жилкишиева',
    regionCode: '31',
    districtCode: '50'
  },
  { code: '51300', name: 'с.Жарлысу', regionCode: '31', districtCode: '50' },
  {
    code: '51500',
    name: 'с.Салимбай Прманов',
    regionCode: '31',
    districtCode: '50'
  },
  { code: '51600', name: 'с.Сункайты', regionCode: '31', districtCode: '50' },
  { code: '55100', name: 'с.Теренозек', regionCode: '31', districtCode: '50' },
  { code: '55280', name: 'с.Кокарык', regionCode: '31', districtCode: '50' },
  {
    code: '55800',
    name: 'с.Шолак-Кайынды',
    regionCode: '31',
    districtCode: '50'
  },
  { code: '30100', name: 'с.Мерке', regionCode: '31', districtCode: '54' },
  {
    code: '30200',
    name: 'санаторий Мерке',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '31100', name: 'с.Акермен', regionCode: '31', districtCode: '54' },
  {
    code: '31300',
    name: 'с.Аккоз-Кайнар',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '31500', name: 'с.Алтынарык', regionCode: '31', districtCode: '54' },
  { code: '32100', name: 'а.Актоган', regionCode: '31', districtCode: '54' },
  { code: '32500', name: 'с.Казахдикан', regionCode: '31', districtCode: '54' },
  { code: '33100', name: 'с.Жамбыл', regionCode: '31', districtCode: '54' },
  {
    code: '33400',
    name: 'с.Красная Заря',
    regionCode: '31',
    districtCode: '54'
  },
  {
    code: '33600',
    name: 'с.Плодовоягодное',
    regionCode: '31',
    districtCode: '54'
  },
  {
    code: '33700',
    name: 'уч.Талдыбулак',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '35100', name: 'с.Костоган', regionCode: '31', districtCode: '54' },
  { code: '35300', name: 'с.Кызылсай', regionCode: '31', districtCode: '54' },
  { code: '35400', name: 'а.Мынказан', regionCode: '31', districtCode: '54' },
  { code: '37100', name: 'с.Кенес', regionCode: '31', districtCode: '54' },
  { code: '37700', name: 'с.Жаугаш', regionCode: '31', districtCode: '54' },
  { code: '37800', name: 'с.Кентай', regionCode: '31', districtCode: '54' },
  { code: '37880', name: 'с.Кайындысай', regionCode: '31', districtCode: '54' },
  {
    code: '41100',
    name: 'с. Андас батыра',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '41200', name: 'с.Аралкишлак', regionCode: '31', districtCode: '54' },
  {
    code: '41300',
    name: 'п.Гранитогорск',
    regionCode: '31',
    districtCode: '54'
  },
  {
    code: '41400',
    name: 'с.Кызылкишлак',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '41500', name: 'ст.Чолдавар', regionCode: '31', districtCode: '54' },
  { code: '43100', name: 'с.Ойтал', regionCode: '31', districtCode: '54' },
  { code: '43300', name: 'с.Маханда', regionCode: '31', districtCode: '54' },
  { code: '43400', name: 'ст.Мерке', regionCode: '31', districtCode: '54' },
  {
    code: '44100',
    name: 'с.Т.Рыскулова',
    regionCode: '31',
    districtCode: '54'
  },
  {
    code: '44300',
    name: 'с.Интернациональное',
    regionCode: '31',
    districtCode: '54'
  },
  {
    code: '45100',
    name: 'с.Сарымолдаева',
    regionCode: '31',
    districtCode: '54'
  },
  { code: '45300', name: 'с.Екпенды', regionCode: '31', districtCode: '54' },
  { code: '45400', name: 'с.Ойтал', regionCode: '31', districtCode: '54' },
  { code: '46100', name: 'с.Сурат', regionCode: '31', districtCode: '54' },
  { code: '46200', name: 'а.Аккайнар', regionCode: '31', districtCode: '54' },
  { code: '55500', name: 'с.Интымак', regionCode: '31', districtCode: '42' },
  { code: '57100', name: 'с.Кызыларык', regionCode: '31', districtCode: '42' },
  { code: '57200', name: 'а.Актобе', regionCode: '31', districtCode: '42' },
  { code: '57300', name: 'с.Алатау', regionCode: '31', districtCode: '42' },
  { code: '57600', name: 'ст.Сурум', regionCode: '31', districtCode: '42' },
  {
    code: '57700',
    name: 'с.Терсащибулак',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '63100', name: 'а.Кольбастау', regionCode: '31', districtCode: '42' },
  { code: '63400', name: 'с.Талапты', regionCode: '31', districtCode: '42' },
  { code: '65100', name: 'с.Тогызтарау', regionCode: '31', districtCode: '42' },
  { code: '65300', name: 'с.Жанаоткель', regionCode: '31', districtCode: '42' },
  { code: '65500', name: 'с.Кумсуат', regionCode: '31', districtCode: '42' },
  { code: '30100', name: 'а.Кордай', regionCode: '31', districtCode: '48' },
  { code: '32100', name: 'с.Алга', regionCode: '31', districtCode: '48' },
  { code: '32400', name: 'с.Кокадыр', regionCode: '31', districtCode: '48' },
  { code: '32600', name: 'с.Музбель', regionCode: '31', districtCode: '48' },
  { code: '33100', name: 'а.Аухатты', regionCode: '31', districtCode: '48' },
  { code: '33200', name: 'с.Кызылсай', regionCode: '31', districtCode: '48' },
  { code: '33300', name: 'с.Рисполе', regionCode: '31', districtCode: '48' },
  { code: '35100', name: 'а.Беткайнар', regionCode: '31', districtCode: '48' },
  { code: '35500', name: 'с.Соганды', regionCode: '31', districtCode: '48' },
  { code: '36100', name: 'с.Жамбыл', regionCode: '31', districtCode: '48' },
  { code: '36300', name: 'с.Жанатурмыс', regionCode: '31', districtCode: '48' },
  { code: '37100', name: 'с.Кенен', regionCode: '31', districtCode: '48' },
  { code: '38100', name: 'а.Какпатас', regionCode: '31', districtCode: '48' },
  { code: '38200', name: 'а.Бериктас', regionCode: '31', districtCode: '48' },
  { code: '39100', name: 'с.Каракемер', regionCode: '31', districtCode: '48' },
  { code: '39200', name: 'а.Керу', regionCode: '31', districtCode: '48' },
  {
    code: '41100',
    name: 'а.им.Карасай батыра',
    regionCode: '31',
    districtCode: '48'
  },
  { code: '41200', name: 'с.Енбек', regionCode: '31', districtCode: '48' },
  { code: '43100', name: 'а.Карасу', regionCode: '31', districtCode: '48' },
  { code: '43200', name: 'с.Отеген', regionCode: '31', districtCode: '48' },
  { code: '45100', name: 'с.Касык', regionCode: '31', districtCode: '48' },
  { code: '47100', name: 'с.Масанчи', regionCode: '31', districtCode: '48' },
  { code: '47200', name: 'с.Кунбатыс 1', regionCode: '31', districtCode: '48' },
  { code: '47300', name: 'с.Кунбатыс 2', regionCode: '31', districtCode: '48' },
  { code: '49100', name: 'а.Hогайбай', regionCode: '31', districtCode: '48' },
  { code: '49300', name: 'с.Сарыбастау', regionCode: '31', districtCode: '48' },
  { code: '49400', name: 'с.Шарбакты', regionCode: '31', districtCode: '48' },
  { code: '51100', name: 'а.Отар', regionCode: '31', districtCode: '48' },
  { code: '51200', name: 'рзд.Анрахай', regionCode: '31', districtCode: '48' },
  { code: '51300', name: 'рзд.Бель', regionCode: '31', districtCode: '48' },
  {
    code: '51400',
    name: 'п.Гвардейский',
    regionCode: '31',
    districtCode: '48'
  },
  { code: '53100', name: 'с.Сарыбулак', regionCode: '31', districtCode: '48' },
  { code: '53200', name: 'а.Кайнар', regionCode: '31', districtCode: '48' },
  { code: '54100', name: 'а.Сортобе', regionCode: '31', districtCode: '48' },
  {
    code: '54200',
    name: 'а.Булар батыра',
    regionCode: '31',
    districtCode: '48'
  },
  { code: '55100', name: 'с.Степное', regionCode: '31', districtCode: '48' },
  { code: '55400', name: 'с.Калгута', regionCode: '31', districtCode: '48' },
  { code: '55500', name: 'с.Славное', regionCode: '31', districtCode: '48' },
  { code: '56100', name: 'а.Сулуторы', regionCode: '31', districtCode: '48' },
  { code: '56300', name: 'а.Коктобе', regionCode: '31', districtCode: '48' },
  {
    code: '57100',
    name: 'с.Улкенсулутор',
    regionCode: '31',
    districtCode: '48'
  },
  { code: '30100', name: 'а.Кулан', regionCode: '31', districtCode: '50' },
  { code: '30200', name: 'а.Каракат', regionCode: '31', districtCode: '50' },
  { code: '30300', name: 'с.Шенгер', regionCode: '31', districtCode: '50' },
  { code: '31100', name: 'с.Енбекши', regionCode: '31', districtCode: '50' },
  { code: '31500', name: 'с.Кокарык', regionCode: '31', districtCode: '50' },
  { code: '33100', name: 'с.Акыртобе', regionCode: '31', districtCode: '50' },
  { code: '33380', name: 'с.Малдыбай', regionCode: '31', districtCode: '50' },
  { code: '34100', name: 'с.Жанатурмыс', regionCode: '31', districtCode: '50' },
  { code: '35100', name: 'с.Каменка', regionCode: '31', districtCode: '50' },
  { code: '35300', name: 'с.Жалпаксаз', regionCode: '31', districtCode: '50' },
  { code: '35600', name: 'с.Казах', regionCode: '31', districtCode: '50' },
  { code: '35700', name: 'с.Тасшолак', regionCode: '31', districtCode: '50' },
  { code: '45200', name: 'с.Енбек', regionCode: '31', districtCode: '40' },
  { code: '45300', name: 'с.Жамбыл', regionCode: '31', districtCode: '40' },
  {
    code: '45400',
    name: 'уч.Колькайнар',
    regionCode: '31',
    districtCode: '40'
  },
  { code: '45500', name: 'с.Костобе', regionCode: '31', districtCode: '40' },
  { code: '46100', name: 'с.Каракемер', regionCode: '31', districtCode: '40' },
  { code: '46400', name: 'а.Кумтиын', regionCode: '31', districtCode: '40' },
  { code: '46600', name: 'с.Сенгирбай', regionCode: '31', districtCode: '40' },
  {
    code: '47100',
    name: 'с.Пригородное',
    regionCode: '31',
    districtCode: '40'
  },
  { code: '47300', name: 'с.Жидели', regionCode: '31', districtCode: '40' },
  { code: '47400', name: 'рзд.Казарма', regionCode: '31', districtCode: '40' },
  { code: '47800', name: 'с.Октябрь', regionCode: '31', districtCode: '40' },
  {
    code: '48100',
    name: 'с.Кызылкайнар',
    regionCode: '31',
    districtCode: '40'
  },
  { code: '48200', name: 'с.Жасоркен', regionCode: '31', districtCode: '40' },
  { code: '49100', name: 'с.Орнек', regionCode: '31', districtCode: '40' },
  { code: '49300', name: 'ст.Жума', regionCode: '31', districtCode: '40' },
  { code: '51100', name: 'с.Бектобе', regionCode: '31', districtCode: '40' },
  { code: '51300', name: 'а.Байтерек', regionCode: '31', districtCode: '40' },
  { code: '51500', name: 'с.Кызылшарык', regionCode: '31', districtCode: '40' },
  { code: '53100', name: 'с.Кумшагал', regionCode: '31', districtCode: '40' },
  { code: '53500', name: 'с.Кольтоган', regionCode: '31', districtCode: '40' },
  { code: '53700', name: 'ст.Кызылабад', regionCode: '31', districtCode: '40' },
  { code: '53800', name: 'ст.Чолдала', regionCode: '31', districtCode: '40' },
  { code: '61100', name: 'с.Пионер', regionCode: '31', districtCode: '40' },
  { code: '61800', name: 'с.Шайдана', regionCode: '31', districtCode: '40' },
  {
    code: '30100',
    name: 'с.им.Б.Момышулы',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '33100', name: 'с.Кайрат', regionCode: '31', districtCode: '42' },
  { code: '33200', name: 'с.Дехкан', regionCode: '31', districtCode: '42' },
  { code: '35100', name: 'с.Байтерек', regionCode: '31', districtCode: '42' },
  { code: '35300', name: 'с.Жанаталап', regionCode: '31', districtCode: '42' },
  {
    code: '35400',
    name: 'ст.Куркуреусу',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '35500', name: 'с.Актоган', regionCode: '31', districtCode: '42' },
  { code: '37100', name: 'с.Карабастау', regionCode: '31', districtCode: '42' },
  { code: '37200', name: 'с.Дарбаза', regionCode: '31', districtCode: '42' },
  { code: '37400', name: 'с.Жылыбулак', regionCode: '31', districtCode: '42' },
  { code: '37600', name: 'а.Абдыкадыр', regionCode: '31', districtCode: '42' },
  { code: '39100', name: 'с.Кольтоган', regionCode: '31', districtCode: '42' },
  { code: '39300', name: 'а.Ертай', regionCode: '31', districtCode: '42' },
  {
    code: '39600',
    name: 'а.им.Рысбека батыра',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '43100', name: 'а.Нурлыкент', regionCode: '31', districtCode: '42' },
  {
    code: '43300',
    name: 'рзд.Казбастау',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '43500', name: 'а.Туктибай', regionCode: '31', districtCode: '42' },
  { code: '45100', name: 'с.Карикорган', regionCode: '31', districtCode: '42' },
  { code: '45200', name: 'а.Коныртобе', regionCode: '31', districtCode: '42' },
  { code: '45300', name: 'с.Космурат', regionCode: '31', districtCode: '42' },
  { code: '45400', name: 'с.Маяк', regionCode: '31', districtCode: '42' },
  { code: '45500', name: 'с.Тасбастау', regionCode: '31', districtCode: '42' },
  { code: '45600', name: 'а.Шынбулак', regionCode: '31', districtCode: '42' },
  { code: '47200', name: 'а.Бакалы', regionCode: '31', districtCode: '42' },
  { code: '47300', name: 'с.Коктобе', regionCode: '31', districtCode: '42' },
  { code: '47400', name: 'а.Косболтек', regionCode: '31', districtCode: '42' },
  { code: '49100', name: 'с.Куренбель', regionCode: '31', districtCode: '42' },
  { code: '49200', name: 'с.Каратас', regionCode: '31', districtCode: '42' },
  { code: '53100', name: 'а.Карасаз', regionCode: '31', districtCode: '42' },
  { code: '53200', name: 'а.Акбастау', regionCode: '31', districtCode: '42' },
  { code: '53300', name: 'с.Журумбай', regionCode: '31', districtCode: '42' },
  { code: '53400', name: 'с.Карасу', regionCode: '31', districtCode: '42' },
  { code: '53500', name: 'с.Юсуповка', regionCode: '31', districtCode: '42' },
  { code: '54100', name: 'с.Кошкарата', regionCode: '31', districtCode: '42' },
  { code: '54200', name: 'а.Актасты', regionCode: '31', districtCode: '42' },
  { code: '54500', name: 'с.Кызтоган', regionCode: '31', districtCode: '42' },
  { code: '55100', name: 'а.Шакпак ата', regionCode: '31', districtCode: '42' },
  {
    code: '55200',
    name: 'а.Таттибая Дуйсебайулы',
    regionCode: '31',
    districtCode: '42'
  },
  { code: '55300', name: 'с.Амансай', regionCode: '31', districtCode: '42' },
  { code: '55400', name: 'ст.Шакпак', regionCode: '31', districtCode: '42' },
  { code: '10100', name: 'г.Тараз', regionCode: '31', districtCode: '10' },
  { code: '10000', name: 'г.Уральск', regionCode: '27', districtCode: '10' },
  { code: '30100', name: 'с.Сарыкемер', regionCode: '31', districtCode: '36' },
  { code: '30200', name: 'а.Базарбай', regionCode: '31', districtCode: '36' },
  { code: '30300', name: 'с.Кусак', regionCode: '31', districtCode: '36' },
  { code: '33100', name: 'а.Байзак', regionCode: '31', districtCode: '36' },
  { code: '33200', name: 'а.Ботамойнак', regionCode: '31', districtCode: '36' },
  { code: '33300', name: 'ст.Учбулак', regionCode: '31', districtCode: '36' },
  { code: '35100', name: 'а.Бурыл', regionCode: '31', districtCode: '36' },
  { code: '35400', name: 'а.Кумжота', regionCode: '31', districtCode: '36' },
  { code: '35500', name: 'с.Торткул', regionCode: '31', districtCode: '36' },
  { code: '37100', name: 'с.Дихан', regionCode: '31', districtCode: '36' },
  { code: '37200', name: 'а.Аймантобе', regionCode: '31', districtCode: '36' },
  { code: '37300', name: 'а.Женис', regionCode: '31', districtCode: '36' },
  { code: '39100', name: 'а.Жетыбай', regionCode: '31', districtCode: '36' },
  { code: '39300', name: 'с.Аккия', regionCode: '31', districtCode: '36' },
  { code: '39800', name: 'а.Сенкибай', regionCode: '31', districtCode: '36' },
  { code: '41100', name: 'с.Кокбастау', regionCode: '31', districtCode: '36' },
  { code: '41200', name: 'ст.Акчулак', regionCode: '31', districtCode: '36' },
  { code: '41300', name: 'с.Жанатурмыс', regionCode: '31', districtCode: '36' },
  { code: '41400', name: 'а.Жибек жолы', regionCode: '31', districtCode: '36' },
  { code: '41500', name: 'рзд.Кайнар', regionCode: '31', districtCode: '36' },
  { code: '41600', name: 'а.Тегистик', regionCode: '31', districtCode: '36' },
  { code: '41700', name: 'с.Торегельды', regionCode: '31', districtCode: '36' },
  { code: '42100', name: 'с.Кенес', regionCode: '31', districtCode: '36' },
  {
    code: '43100',
    name: 'с.Красная Звезда',
    regionCode: '31',
    districtCode: '36'
  },
  { code: '44100', name: 'а.Коктал', regionCode: '31', districtCode: '36' },
  { code: '45100', name: 'с.Талас', regionCode: '31', districtCode: '36' },
  { code: '45300', name: 'с.Костобе', regionCode: '31', districtCode: '36' },
  { code: '46100', name: 'с.Мырзатай', regionCode: '31', districtCode: '36' },
  { code: '46500', name: 'с.Дихан', regionCode: '31', districtCode: '36' },
  { code: '47100', name: 'а.Жакаш', regionCode: '31', districtCode: '36' },
  { code: '47400', name: 'с.Кокозек', regionCode: '31', districtCode: '36' },
  { code: '47500', name: 'с.Карасу', regionCode: '31', districtCode: '36' },
  { code: '48100', name: 'с.Абай', regionCode: '31', districtCode: '36' },
  { code: '48400', name: 'с.Актобе', regionCode: '31', districtCode: '36' },
  { code: '48600', name: 'с.Жанасаз', regionCode: '31', districtCode: '36' },
  { code: '49100', name: 'с.Тегистик', regionCode: '31', districtCode: '36' },
  { code: '49200', name: 'с.Сарыбарак', regionCode: '31', districtCode: '36' },
  { code: '49300', name: 'а.Шахан', regionCode: '31', districtCode: '36' },
  { code: '53100', name: 'а.Туймекент', regionCode: '31', districtCode: '36' },
  { code: '53200', name: 'а.Акжар', regionCode: '31', districtCode: '36' },
  { code: '57100', name: 'с.Ульгули', regionCode: '31', districtCode: '36' },
  { code: '63100', name: 'а.Мадимар', regionCode: '31', districtCode: '36' },
  { code: '30500', name: 'с.Рахат', regionCode: '31', districtCode: '40' },
  { code: '33100', name: 'с.Айшабиби', regionCode: '31', districtCode: '40' },
  { code: '33300', name: 'с.Каратау', regionCode: '31', districtCode: '40' },
  { code: '33400', name: 'с.Кызылтан', regionCode: '31', districtCode: '40' },
  {
    code: '34100',
    name: 'с.Бирлесу-Енбек',
    regionCode: '31',
    districtCode: '40'
  },
  { code: '34700', name: 'с.Шокай', regionCode: '31', districtCode: '40' },
  { code: '35100', name: 'с.Акбулым', regionCode: '31', districtCode: '40' },
  { code: '35200', name: 'ст.Талас', regionCode: '31', districtCode: '40' },
  { code: '37100', name: 'с.Бесагаш', regionCode: '31', districtCode: '40' },
  { code: '37200', name: 'с.Турксиб', regionCode: '31', districtCode: '40' },
  { code: '39100', name: 'с.Гродеково', regionCode: '31', districtCode: '40' },
  { code: '39300', name: 'с.Кызылдихан', regionCode: '31', districtCode: '40' },
  {
    code: '41100',
    name: 'с.Жалпак-Тобе',
    regionCode: '31',
    districtCode: '40'
  },
  { code: '42100', name: 'с.Ерназар', regionCode: '31', districtCode: '40' },
  { code: '43100', name: 'с.Шайкорык', regionCode: '31', districtCode: '40' },
  { code: '43200', name: 'с.Бесжилдык', regionCode: '31', districtCode: '40' },
  { code: '43300', name: 'с.Капал', regionCode: '31', districtCode: '40' },
  { code: '43400', name: 'с.Коныртобе', regionCode: '31', districtCode: '40' },
  { code: '43500', name: 'с.Танты', regionCode: '31', districtCode: '40' },
  { code: '43600', name: 'ст.Шайкорык', regionCode: '31', districtCode: '40' },
  { code: '45100', name: 'с.Тастобе', regionCode: '31', districtCode: '40' },
  { code: '61100', name: 'с.Коктенколь', regionCode: '35', districtCode: '64' },
  { code: '61200', name: 'с.Алихан', regionCode: '35', districtCode: '64' },
  { code: '61300', name: 'с.Жыланды', regionCode: '35', districtCode: '64' },
  {
    code: '61400',
    name: 'ст.Коктинколи',
    regionCode: '35',
    districtCode: '64'
  },
  { code: '61700', name: 'с.Целинное', regionCode: '35', districtCode: '64' },
  {
    code: '63100',
    name: 'с.Нижние Кайракты',
    regionCode: '35',
    districtCode: '64'
  },
  {
    code: '63300',
    name: 'с.Верхние Кайракты',
    regionCode: '35',
    districtCode: '64'
  },
  {
    code: '67100',
    name: 'с.Красная Поляна',
    regionCode: '35',
    districtCode: '64'
  },
  { code: '67200', name: 'с.Бекет', regionCode: '35', districtCode: '64' },
  { code: '67300', name: 'с.Дерипсал', regionCode: '35', districtCode: '64' },
  { code: '67400', name: 'с.Карамурун', regionCode: '35', districtCode: '64' },
  { code: '69100', name: 'с.Кызылтау', regionCode: '35', districtCode: '64' },
  { code: '71100', name: 'п.Мойынты', regionCode: '35', districtCode: '64' },
  { code: '71200', name: 'с.Акбулак', regionCode: '35', districtCode: '64' },
  { code: '73100', name: 'с.Кошкарбай', regionCode: '35', districtCode: '64' },
  { code: '73200', name: 'с.Аккияк', regionCode: '35', districtCode: '64' },
  { code: '73300', name: 'с.Аксу', regionCode: '35', districtCode: '64' },
  { code: '73400', name: 'с.Кызылкой', regionCode: '35', districtCode: '64' },
  { code: '73500', name: 'с.Шопа', regionCode: '35', districtCode: '64' },
  { code: '75100', name: 'с.Ортау', regionCode: '35', districtCode: '64' },
  { code: '75200', name: 'с.Босага', regionCode: '35', districtCode: '64' },
  { code: '75400', name: 'с.Сарыбулак', regionCode: '35', districtCode: '64' },
  { code: '77100', name: 'с.Успенское', regionCode: '35', districtCode: '64' },
  { code: '77200', name: 'с.Айгыржал', regionCode: '35', districtCode: '64' },
  { code: '77300', name: 'ст.Айса', regionCode: '35', districtCode: '64' },
  { code: '77400', name: 'с.Еркиндык', regionCode: '35', districtCode: '64' },
  { code: '79100', name: 'с.Акой', regionCode: '35', districtCode: '64' },
  { code: '81100', name: 'с.Кийкти', regionCode: '35', districtCode: '64' },
  { code: '83100', name: 'с.Жумыскер', regionCode: '35', districtCode: '64' },
  { code: '83200', name: 'с.Койтас', regionCode: '35', districtCode: '64' },
  { code: '83300', name: 'с.Кызылту', regionCode: '35', districtCode: '64' },
  { code: '87100', name: 'с.Унрек', regionCode: '35', districtCode: '64' },
  { code: '87200', name: 'с.Карамыс', regionCode: '35', districtCode: '64' },
  { code: '87300', name: 'с.Куттыбай', regionCode: '35', districtCode: '64' },
  { code: '87400', name: 'с.Тумсык', regionCode: '35', districtCode: '64' },
  {
    code: '20100',
    name: 'г. Каркаралинск',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '30100', name: 'п.Атасу', regionCode: '35', districtCode: '44' },
  { code: '30100', name: 'с.Аксу-Аюлы', regionCode: '35', districtCode: '64' },
  {
    code: '89300',
    name: 'с. Андренниковка',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '77100', name: 'с.Сункар', regionCode: '35', districtCode: '56' },
  { code: '77200', name: 'с.Коянды', regionCode: '35', districtCode: '56' },
  { code: '77300', name: 'с.Сельстрой', regionCode: '35', districtCode: '56' },
  {
    code: '79100',
    name: 'с.Тельманское',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '79200', name: 'с.Ахметаул', regionCode: '35', districtCode: '56' },
  { code: '79300', name: 'с.Кутумсук', regionCode: '35', districtCode: '56' },
  { code: '81100', name: 'с.Трудовое', regionCode: '35', districtCode: '56' },
  { code: '81200', name: 'с.Степное', regionCode: '35', districtCode: '56' },
  { code: '85100', name: 'с.Чапаево', regionCode: '35', districtCode: '56' },
  { code: '89100', name: 'с.Шидерты', regionCode: '35', districtCode: '56' },
  { code: '30100', name: 'с.Улытау', regionCode: '35', districtCode: '60' },
  { code: '31100', name: 'п.Актас', regionCode: '35', districtCode: '60' },
  { code: '31200', name: 'с.Пионер', regionCode: '35', districtCode: '60' },
  { code: '33100', name: 'с.Бетбулак', regionCode: '35', districtCode: '60' },
  { code: '35100', name: 'с.Борсенгир', regionCode: '35', districtCode: '60' },
  { code: '39100', name: 'с.Егинди', regionCode: '35', districtCode: '60' },
  { code: '41100', name: 'с.Байконур', regionCode: '35', districtCode: '60' },
  { code: '41200', name: 'с.Кызылуй', regionCode: '35', districtCode: '60' },
  { code: '41300', name: 'с.Талдыкудук', regionCode: '35', districtCode: '60' },
  { code: '43100', name: 'п.Жезды', regionCode: '35', districtCode: '60' },
  { code: '43200', name: 'с.Орнек', regionCode: '35', districtCode: '60' },
  { code: '49100', name: 'с.Сарлык', regionCode: '35', districtCode: '60' },
  { code: '49200', name: 'с.Боздак', regionCode: '35', districtCode: '60' },
  { code: '51100', name: 'п.Карсакпай', regionCode: '35', districtCode: '60' },
  { code: '53100', name: 'с.Коргасын', regionCode: '35', districtCode: '60' },
  { code: '53300', name: 'с.Унгирли', regionCode: '35', districtCode: '60' },
  { code: '55100', name: 'с.Косколь', regionCode: '35', districtCode: '60' },
  { code: '55400', name: 'с.Кулжанбай', regionCode: '35', districtCode: '60' },
  { code: '55500', name: 'с.Hаролген', regionCode: '35', districtCode: '60' },
  { code: '63100', name: 'с.Айыртау', regionCode: '35', districtCode: '60' },
  { code: '63200', name: 'с.Кызылуй', regionCode: '35', districtCode: '60' },
  { code: '63300', name: 'с.Талдысай', regionCode: '35', districtCode: '60' },
  { code: '65100', name: 'с.Мыйбулак', regionCode: '35', districtCode: '60' },
  { code: '65200', name: 'с.Аккенсе', regionCode: '35', districtCode: '60' },
  { code: '71100', name: 'с.Бозтумсык', regionCode: '35', districtCode: '60' },
  { code: '75100', name: 'с.Жыланды', regionCode: '35', districtCode: '60' },
  { code: '75500', name: 'с.Тюемойнак', regionCode: '35', districtCode: '60' },
  { code: '79100', name: 'с.Терсаккан', regionCode: '35', districtCode: '60' },
  { code: '79200', name: 'с.Косколь', regionCode: '35', districtCode: '60' },
  { code: '30200', name: 'с.Аксу', regionCode: '35', districtCode: '64' },
  { code: '30300', name: 'с.Актобе', regionCode: '35', districtCode: '64' },
  { code: '30400', name: 'с.Енбекшил', regionCode: '35', districtCode: '64' },
  { code: '30500', name: 'с.Кайракты', regionCode: '35', districtCode: '64' },
  { code: '31100', name: 'п.Агадырь', regionCode: '35', districtCode: '64' },
  { code: '31500', name: 'с.Сарыши', regionCode: '35', districtCode: '64' },
  { code: '35100', name: 'п.Акжал', regionCode: '35', districtCode: '64' },
  { code: '35200', name: 'с.Акжартас', regionCode: '35', districtCode: '64' },
  { code: '35300', name: 'а.Аякши', regionCode: '35', districtCode: '64' },
  { code: '37100', name: 'п.Акчатау', regionCode: '35', districtCode: '64' },
  {
    code: '38100',
    name: 'а. Жарылгап батыр',
    regionCode: '35',
    districtCode: '64'
  },
  { code: '38200', name: 'с.Каргалы', regionCode: '35', districtCode: '64' },
  { code: '39100', name: 'с.Кызылтау', regionCode: '35', districtCode: '64' },
  { code: '39300', name: 'с.Акбауыр', regionCode: '35', districtCode: '64' },
  { code: '41100', name: 'с.Батык', regionCode: '35', districtCode: '64' },
  { code: '43100', name: 'с.Босага', regionCode: '35', districtCode: '64' },
  { code: '45100', name: 'с.Бурма', regionCode: '35', districtCode: '64' },
  { code: '45300', name: 'с.Мухтар', regionCode: '35', districtCode: '64' },
  { code: '47100', name: 'п.Дарьинский', regionCode: '35', districtCode: '64' },
  { code: '49100', name: 'п.Жамбыл', regionCode: '35', districtCode: '64' },
  {
    code: '51100',
    name: 'п.С.Сейфуллин',
    regionCode: '35',
    districtCode: '64'
  },
  { code: '55100', name: 'с.Hура', regionCode: '35', districtCode: '64' },
  { code: '59100', name: 'с.Талды', regionCode: '35', districtCode: '64' },
  { code: '59200', name: 'с.Берекеши', regionCode: '35', districtCode: '64' },
  { code: '59300', name: 'с.Жанажурт', regionCode: '35', districtCode: '64' },
  { code: '57100', name: 'с.Майоровка', regionCode: '35', districtCode: '52' },
  { code: '59100', name: 'с.Жанбобек', regionCode: '35', districtCode: '52' },
  { code: '59200', name: 'с.Акколка', regionCode: '35', districtCode: '52' },
  {
    code: '61100',
    name: 'а. Карим Мынбаев',
    regionCode: '35',
    districtCode: '52'
  },
  { code: '63100', name: 'с.Куланутпес', regionCode: '35', districtCode: '52' },
  { code: '63200', name: 'с.Актубек', regionCode: '35', districtCode: '52' },
  { code: '63300', name: 'с.Hыгман', regionCode: '35', districtCode: '52' },
  { code: '65100', name: 'с.Кертинди', regionCode: '35', districtCode: '52' },
  { code: '65200', name: 'с.Алгабас', regionCode: '35', districtCode: '52' },
  { code: '67100', name: 'с.Байтуган', regionCode: '35', districtCode: '52' },
  {
    code: '67200',
    name: 'с.Жанакурылыс',
    regionCode: '35',
    districtCode: '52'
  },
  {
    code: '69100',
    name: 'с.Пржевальское',
    regionCode: '35',
    districtCode: '52'
  },
  { code: '71100', name: 'с.Ткенекты', regionCode: '35', districtCode: '52' },
  { code: '73100', name: 'с.Соналы', regionCode: '35', districtCode: '52' },
  { code: '75100', name: 'а.Ахмет', regionCode: '35', districtCode: '52' },
  { code: '77100', name: 'с.Талдысай', regionCode: '35', districtCode: '52' },
  {
    code: '79100',
    name: 'с.Шербаковское',
    regionCode: '35',
    districtCode: '52'
  },
  { code: '83100', name: 'а.Кобетей', regionCode: '35', districtCode: '52' },
  { code: '83300', name: 'с.Ондирис', regionCode: '35', districtCode: '52' },
  { code: '83400', name: 'с.Первое Мая', regionCode: '35', districtCode: '52' },
  { code: '87100', name: 'с.Шахтерское', regionCode: '35', districtCode: '52' },
  { code: '89100', name: 'п.Шубарколь', regionCode: '35', districtCode: '52' },
  { code: '30100', name: 'п.Осакаровка', regionCode: '35', districtCode: '56' },
  { code: '33100', name: 'с.Батпакты', regionCode: '35', districtCode: '56' },
  { code: '33300', name: 'с.Ошаганды', regionCode: '35', districtCode: '56' },
  { code: '33400', name: 'с.Сарыозен', regionCode: '35', districtCode: '56' },
  { code: '33500', name: 'с.Акпан', regionCode: '35', districtCode: '56' },
  { code: '35100', name: 'с.Сарыозек', regionCode: '35', districtCode: '56' },
  {
    code: '35200',
    name: 'с.Русская Ивановка',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '35300', name: 'с.Шокай', regionCode: '35', districtCode: '56' },
  { code: '35400', name: 'ст.Шокай', regionCode: '35', districtCode: '56' },
  { code: '37100', name: 'с.Дальнее', regionCode: '35', districtCode: '56' },
  { code: '37200', name: 'с.Жуантобе', regionCode: '35', districtCode: '56' },
  {
    code: '37300',
    name: 'с.Кызылтасское',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '37400', name: 'с.Лиманное', regionCode: '35', districtCode: '56' },
  { code: '37500', name: 'с.Юго-Восток', regionCode: '35', districtCode: '56' },
  { code: '43100', name: 'с.Звездное', regionCode: '35', districtCode: '56' },
  { code: '45100', name: 'с.Иртышское', regionCode: '35', districtCode: '56' },
  { code: '47100', name: 'с.Есиль', regionCode: '35', districtCode: '56' },
  { code: '47200', name: 'с.Колхозное', regionCode: '35', districtCode: '56' },
  { code: '49100', name: 'с.Сенокосное', regionCode: '35', districtCode: '56' },
  { code: '51100', name: 'с.Шункыркол', regionCode: '35', districtCode: '56' },
  { code: '53100', name: 'с.Уызбай', regionCode: '35', districtCode: '56' },
  { code: '53200', name: 'с.Куркопа', regionCode: '35', districtCode: '56' },
  { code: '55100', name: 'с.Мирное', regionCode: '35', districtCode: '56' },
  { code: '57100', name: 'п.Молодежный', regionCode: '35', districtCode: '56' },
  { code: '59100', name: 'с.Hиколаевка', regionCode: '35', districtCode: '56' },
  {
    code: '59200',
    name: 'с.Комсомольское',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '59400', name: 'с.Топан', regionCode: '35', districtCode: '56' },
  { code: '61100', name: 'с.Озерное', regionCode: '35', districtCode: '56' },
  { code: '61200', name: 'с.Ералы', regionCode: '35', districtCode: '56' },
  { code: '63100', name: 'с.Карагайлы', regionCode: '35', districtCode: '56' },
  {
    code: '63200',
    name: 'с.Коллективное',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '63300', name: 'с.Крещеновка', regionCode: '35', districtCode: '56' },
  { code: '63400', name: 'с.Окольное', regionCode: '35', districtCode: '56' },
  {
    code: '63500',
    name: 'с.Святогоровка',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '69100', name: 'с.Пионерское', regionCode: '35', districtCode: '56' },
  {
    code: '69200',
    name: 'с.Приишимское',
    regionCode: '35',
    districtCode: '56'
  },
  {
    code: '69300',
    name: 'с.Центральное',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '71100', name: 'с.Акбулак', regionCode: '35', districtCode: '56' },
  { code: '71300', name: 'с.Роднички', regionCode: '35', districtCode: '56' },
  {
    code: '73100',
    name: 'с.Родниковское',
    regionCode: '35',
    districtCode: '56'
  },
  { code: '73200', name: 'с.Карасу', regionCode: '35', districtCode: '56' },
  { code: '75100', name: 'с.Садовое', regionCode: '35', districtCode: '56' },
  { code: '39300', name: 'с.Шилдебай', regionCode: '35', districtCode: '48' },
  { code: '43100', name: 'с.Бакты', regionCode: '35', districtCode: '48' },
  { code: '43200', name: 'с.Абыз', regionCode: '35', districtCode: '48' },
  { code: '43400', name: 'с.Шолаккайын', regionCode: '35', districtCode: '48' },
  { code: '45100', name: 'с.Карабулак', regionCode: '35', districtCode: '48' },
  { code: '45200', name: 'с.Айнабулак', regionCode: '35', districtCode: '48' },
  { code: '47100', name: 'с.Бесоба', regionCode: '35', districtCode: '48' },
  { code: '47300', name: 'с.Карашокы', regionCode: '35', districtCode: '48' },
  { code: '47400', name: 'с.Кызылту', regionCode: '35', districtCode: '48' },
  {
    code: '51100',
    name: 'с.Егиндыбулак',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '53100', name: 'с.Жарлы', regionCode: '35', districtCode: '48' },
  { code: '53200', name: 'с.Акшокы', regionCode: '35', districtCode: '48' },
  { code: '53300', name: 'с.Жекежал', regionCode: '35', districtCode: '48' },
  { code: '55100', name: 'с.Жанатоган', regionCode: '35', districtCode: '48' },
  { code: '55200', name: 'с.Ежебай', regionCode: '35', districtCode: '48' },
  { code: '61100', name: 'с.Аппаз', regionCode: '35', districtCode: '48' },
  {
    code: '61200',
    name: 'с.Жалпакшилик',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '61300', name: 'с.Милыбулак', regionCode: '35', districtCode: '48' },
  { code: '61400', name: 'с.Саз', regionCode: '35', districtCode: '48' },
  { code: '63100', name: 'п.Карагайлы', regionCode: '35', districtCode: '48' },
  { code: '63300', name: 'с.Актерек', regionCode: '35', districtCode: '48' },
  { code: '65100', name: 'с.Караколь', regionCode: '35', districtCode: '48' },
  { code: '67100', name: 'с.Коктас', regionCode: '35', districtCode: '48' },
  { code: '67200', name: 'с.Hовый Путь', regionCode: '35', districtCode: '48' },
  {
    code: '67300',
    name: 'ст.Саумалколь',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '69100', name: 'с.Буркутты', regionCode: '35', districtCode: '48' },
  { code: '69200', name: 'с.Борлыбулак', regionCode: '35', districtCode: '48' },
  { code: '69300', name: 'с.Жанибек', regionCode: '35', districtCode: '48' },
  { code: '69400', name: 'с.Кент', regionCode: '35', districtCode: '48' },
  { code: '69600', name: 'ст.Буркитты', regionCode: '35', districtCode: '48' },
  { code: '71100', name: 'с.Коянды', regionCode: '35', districtCode: '48' },
  { code: '71200', name: 'с.Атантай', regionCode: '35', districtCode: '48' },
  { code: '73100', name: 'с.Акжол', regionCode: '35', districtCode: '48' },
  { code: '73300', name: 'с.Жананегиз', regionCode: '35', districtCode: '48' },
  { code: '75100', name: 'с.Осибай', regionCode: '35', districtCode: '48' },
  { code: '75300', name: 'с.Бастал', regionCode: '35', districtCode: '48' },
  { code: '75500', name: 'с.Колбасы', regionCode: '35', districtCode: '48' },
  {
    code: '77100',
    name: 'с.Тегисшилдик',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '77200', name: 'с.Жарлы', regionCode: '35', districtCode: '48' },
  { code: '77300', name: 'с.Калинино', regionCode: '35', districtCode: '48' },
  { code: '79100', name: 'с.Татан', regionCode: '35', districtCode: '48' },
  { code: '79200', name: 'с.Айнабулак', regionCode: '35', districtCode: '48' },
  { code: '79300', name: 'с.Караагаш', regionCode: '35', districtCode: '48' },
  { code: '81100', name: 'с.Томар', regionCode: '35', districtCode: '48' },
  { code: '83100', name: 'с.Матак', regionCode: '35', districtCode: '48' },
  { code: '87100', name: 'с.Теректы', regionCode: '35', districtCode: '48' },
  { code: '87180', name: 'с.Айыр', regionCode: '35', districtCode: '48' },
  { code: '87200', name: 'с.Кызылшилик', regionCode: '35', districtCode: '48' },
  { code: '87300', name: 'с.Шоптыколь', regionCode: '35', districtCode: '48' },
  { code: '89100', name: 'с.Ынталы', regionCode: '35', districtCode: '48' },
  { code: '30100', name: 'п.Киевка', regionCode: '35', districtCode: '52' },
  {
    code: '35100',
    name: 'с.Балыктыколь',
    regionCode: '35',
    districtCode: '52'
  },
  { code: '37100', name: 'с.Баршино', regionCode: '35', districtCode: '52' },
  { code: '37200', name: 'с.Бестамак', regionCode: '35', districtCode: '52' },
  { code: '41100', name: 'с.Куланотпес', regionCode: '35', districtCode: '52' },
  { code: '43100', name: 'с.Жараспай', regionCode: '35', districtCode: '52' },
  { code: '47100', name: 'с.Заречное', regionCode: '35', districtCode: '52' },
  { code: '49100', name: 'а.Акмешит', regionCode: '35', districtCode: '52' },
  { code: '49200', name: 'а.Кантай', regionCode: '35', districtCode: '52' },
  { code: '51100', name: 'с.Тассуат', regionCode: '35', districtCode: '52' },
  { code: '53100', name: 'с.Изенды', regionCode: '35', districtCode: '52' },
  { code: '53200', name: 'с.Кенжарык', regionCode: '35', districtCode: '52' },
  { code: '53300', name: 'а.Топаркол', regionCode: '35', districtCode: '52' },
  { code: '55100', name: 'с.Карой', regionCode: '35', districtCode: '52' },
  { code: '71100', name: 'с.Шешенкара', regionCode: '35', districtCode: '40' },
  { code: '71200', name: 'с.Ашису', regionCode: '35', districtCode: '40' },
  { code: '73100', name: 'с.Акбел', regionCode: '35', districtCode: '40' },
  { code: '73200', name: 'с.Алабас', regionCode: '35', districtCode: '40' },
  { code: '73300', name: 'с.Курама', regionCode: '35', districtCode: '40' },
  { code: '75100', name: 'с.Ростовка', regionCode: '35', districtCode: '40' },
  {
    code: '75200',
    name: 'с.Красная Hива',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '75300', name: 'с.Кызылжар', regionCode: '35', districtCode: '40' },
  {
    code: '77100',
    name: 'с.Центральное',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '77200', name: 'с.Урожайное', regionCode: '35', districtCode: '40' },
  { code: '79100', name: 'с.Суыксу', regionCode: '35', districtCode: '40' },
  {
    code: '81100',
    name: 'п.Габидена Мустафина',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '83100', name: 'а.Тузды', regionCode: '35', districtCode: '40' },
  {
    code: '83200',
    name: 'с.Старая Тузда',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '83300', name: 'с.Первое Мая', regionCode: '35', districtCode: '40' },
  { code: '87100', name: 'с.Уштобе', regionCode: '35', districtCode: '40' },
  { code: '87300', name: 'с.Заречное', regionCode: '35', districtCode: '40' },
  { code: '87400', name: 'с.Курылус', regionCode: '35', districtCode: '40' },
  { code: '87500', name: 'с.Сокурское', regionCode: '35', districtCode: '40' },
  { code: '89100', name: 'с.Белагаш', regionCode: '35', districtCode: '40' },
  { code: '89200', name: 'с.Аюлы', regionCode: '35', districtCode: '40' },
  { code: '33100', name: 'с.Айнабулак', regionCode: '35', districtCode: '44' },
  { code: '35100', name: 'с.Актасты', regionCode: '35', districtCode: '44' },
  { code: '37100', name: 'с.Актау', regionCode: '35', districtCode: '44' },
  { code: '37200', name: 'с.Айшырак', regionCode: '35', districtCode: '44' },
  { code: '37400', name: 'с.Клыч', regionCode: '35', districtCode: '44' },
  { code: '39100', name: 'с.Актубек', regionCode: '35', districtCode: '44' },
  { code: '39200', name: 'с.Атасу', regionCode: '35', districtCode: '44' },
  { code: '39300', name: 'ст.Мынадыр', regionCode: '35', districtCode: '44' },
  { code: '39400', name: 'с.Уркендеу', regionCode: '35', districtCode: '44' },
  {
    code: '41100',
    name: 'а.им.Мукажана Жумажанова',
    regionCode: '35',
    districtCode: '44'
  },
  { code: '41200', name: 'с.Байгул', regionCode: '35', districtCode: '44' },
  { code: '45100', name: 'с.Бидайык', regionCode: '35', districtCode: '44' },
  { code: '45200', name: 'с.Актайлак', regionCode: '35', districtCode: '44' },
  { code: '45300', name: 'с.Карамола', regionCode: '35', districtCode: '44' },
  { code: '45500', name: 'рзд.69 км', regionCode: '35', districtCode: '44' },
  { code: '49100', name: 'с.Атасу', regionCode: '35', districtCode: '44' },
  { code: '49200', name: 'с.Ленино', regionCode: '35', districtCode: '44' },
  { code: '49400', name: 'рзд.117 км', regionCode: '35', districtCode: '44' },
  { code: '53100', name: 'с.Ералиево', regionCode: '35', districtCode: '44' },
  { code: '53200', name: 'с.Акбастау', regionCode: '35', districtCode: '44' },
  { code: '53400', name: 'ст.Жомарт', regionCode: '35', districtCode: '44' },
  { code: '53500', name: 'с.Кезен', regionCode: '35', districtCode: '44' },
  { code: '53600', name: 'рзд.189 км', regionCode: '35', districtCode: '44' },
  { code: '57100', name: 'п.Кызылжар', regionCode: '35', districtCode: '44' },
  { code: '61100', name: 'с.Инталы', regionCode: '35', districtCode: '44' },
  {
    code: '61400',
    name: 'Лесхоз Караагаш',
    regionCode: '35',
    districtCode: '44'
  },
  { code: '63100', name: 'с.Интымак', regionCode: '35', districtCode: '44' },
  { code: '63200', name: 'с.Алгабас', regionCode: '35', districtCode: '44' },
  { code: '63400', name: 'с.Кирово', regionCode: '35', districtCode: '44' },
  { code: '65100', name: 'с.Тогускен', regionCode: '35', districtCode: '44' },
  {
    code: '65300',
    name: 'с.Кенжебайсамай',
    regionCode: '35',
    districtCode: '44'
  },
  { code: '69100', name: 'с.Орынбай', regionCode: '35', districtCode: '44' },
  { code: '69300', name: 'с.Бидайык', regionCode: '35', districtCode: '44' },
  { code: '31100', name: 'с.Айнабулак', regionCode: '35', districtCode: '48' },
  { code: '31300', name: 'с.Мыржык', regionCode: '35', districtCode: '48' },
  { code: '33100', name: 'с.Айрык', regionCode: '35', districtCode: '48' },
  { code: '33300', name: 'с.Едрей', regionCode: '35', districtCode: '48' },
  { code: '37100', name: 'с.Талды', regionCode: '35', districtCode: '48' },
  {
    code: '37200',
    name: 'с.Акбай-Кызылбай',
    regionCode: '35',
    districtCode: '48'
  },
  { code: '37300', name: 'с.Аккора', regionCode: '35', districtCode: '48' },
  { code: '37400', name: 'с.Белдеутас', regionCode: '35', districtCode: '48' },
  { code: '37500', name: 'с.Сарыобалы', regionCode: '35', districtCode: '48' },
  { code: '39100', name: 'с.Актасты', regionCode: '35', districtCode: '48' },
  { code: '55400', name: 'с.Жидебай', regionCode: '35', districtCode: '36' },
  { code: '55500', name: 'с.Каратал', regionCode: '35', districtCode: '36' },
  {
    code: '59100',
    name: 'с.Орта Дересин',
    regionCode: '35',
    districtCode: '36'
  },
  { code: '59200', name: 'с.Акжайдак', regionCode: '35', districtCode: '36' },
  {
    code: '59500',
    name: 'ст.Орта Дересин',
    regionCode: '35',
    districtCode: '36'
  },
  { code: '63100', name: 'с.Сарытерек', regionCode: '35', districtCode: '36' },
  { code: '63200', name: 'с.Актумсык', regionCode: '35', districtCode: '36' },
  { code: '63300', name: 'с.Жетымшокы', regionCode: '35', districtCode: '36' },
  { code: '63400', name: 'с.Кенели', regionCode: '35', districtCode: '36' },
  { code: '67100', name: 'п.Сарышаган', regionCode: '35', districtCode: '36' },
  { code: '71100', name: 'с.Тасарал', regionCode: '35', districtCode: '36' },
  { code: '75100', name: 'с.Торангылык', regionCode: '35', districtCode: '36' },
  {
    code: '77100',
    name: 'с.Шабанбай би',
    regionCode: '35',
    districtCode: '36'
  },
  { code: '77200', name: 'с.Бегазы', regionCode: '35', districtCode: '36' },
  { code: '77400', name: 'с.Касабай', regionCode: '35', districtCode: '36' },
  { code: '77500', name: 'с.Сона', regionCode: '35', districtCode: '36' },
  { code: '79100', name: 'п.Шашубай', regionCode: '35', districtCode: '36' },
  { code: '30100', name: 'п.Ботакара', regionCode: '35', districtCode: '40' },
  { code: '30200', name: 'ст.Ботакара', regionCode: '35', districtCode: '40' },
  {
    code: '31100',
    name: 'с.Доскей ауылы',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '31400', name: 'с.Трудовое', regionCode: '35', districtCode: '40' },
  { code: '33100', name: 'с.Акоре', regionCode: '35', districtCode: '40' },
  { code: '35100', name: 'с.Актобе', regionCode: '35', districtCode: '40' },
  { code: '35200', name: 'с.Интумак', regionCode: '35', districtCode: '40' },
  { code: '37100', name: 'с.Умуткер', regionCode: '35', districtCode: '40' },
  { code: '37200', name: 'с.Тортколь', regionCode: '35', districtCode: '40' },
  { code: '37300', name: 'с.Ульга', regionCode: '35', districtCode: '40' },
  { code: '39100', name: 'а.Кызылкайын', regionCode: '35', districtCode: '40' },
  { code: '39200', name: 'с.Саратовка', regionCode: '35', districtCode: '40' },
  { code: '39300', name: 'с.Тасаул', regionCode: '35', districtCode: '40' },
  { code: '41100', name: 'с.Ботакара', regionCode: '35', districtCode: '40' },
  {
    code: '43100',
    name: 'с.Бухар-Жырау',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '43200', name: 'с.Семизбуга', regionCode: '35', districtCode: '40' },
  { code: '43300', name: 'с.Шалкар', regionCode: '35', districtCode: '40' },
  {
    code: '45100',
    name: 'с.Гагаринское',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '45200', name: 'с.Садовое', regionCode: '35', districtCode: '40' },
  { code: '47100', name: 'с.Корнеевка', regionCode: '35', districtCode: '40' },
  { code: '47200', name: 'с.Акжар', regionCode: '35', districtCode: '40' },
  { code: '47300', name: 'с.Алгабас', regionCode: '35', districtCode: '40' },
  { code: '49100', name: 'с.Дубовка', regionCode: '35', districtCode: '40' },
  {
    code: '49300',
    name: 'с.Новостроика',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '51100', name: 'с.Молодецкое', regionCode: '35', districtCode: '40' },
  { code: '53100', name: 'с.Кокпекты', regionCode: '35', districtCode: '40' },
  { code: '53200', name: 'с.Байкадам', regionCode: '35', districtCode: '40' },
  { code: '53300', name: 'с.Сарытобе', regionCode: '35', districtCode: '40' },
  { code: '55100', name: 'с.Тогызкудук', regionCode: '35', districtCode: '40' },
  { code: '55300', name: 'с.Тасшокы', regionCode: '35', districtCode: '40' },
  { code: '57100', name: 'с.Каражар', regionCode: '35', districtCode: '40' },
  { code: '57200', name: 'с.Асыл', regionCode: '35', districtCode: '40' },
  { code: '57300', name: 'с.Волковское', regionCode: '35', districtCode: '40' },
  {
    code: '57400',
    name: 'с.Геологическое',
    regionCode: '35',
    districtCode: '40'
  },
  { code: '59100', name: 'с.Каракудук', regionCode: '35', districtCode: '40' },
  { code: '61100', name: 'п.Кушокы', regionCode: '35', districtCode: '40' },
  { code: '63100', name: 'с.Самарканд', regionCode: '35', districtCode: '40' },
  { code: '63200', name: 'с.Тегизжол', regionCode: '35', districtCode: '40' },
  { code: '63300', name: 'с.Чкалово', regionCode: '35', districtCode: '40' },
  { code: '65100', name: 'с.Hовоузенка', regionCode: '35', districtCode: '40' },
  { code: '65200', name: 'с.Севан', regionCode: '35', districtCode: '40' },
  { code: '65300', name: 'с.Стан', regionCode: '35', districtCode: '40' },
  { code: '67100', name: 'с.Петровка', regionCode: '35', districtCode: '40' },
  { code: '67200', name: 'с.Жанакала', regionCode: '35', districtCode: '40' },
  { code: '67300', name: 'с.Жастилек', regionCode: '35', districtCode: '40' },
  { code: '69100', name: 'с.Баймырза', regionCode: '35', districtCode: '40' },
  { code: '69200', name: 'с.Астаховка', regionCode: '35', districtCode: '40' },
  { code: '10100', name: 'г.Караганда', regionCode: '35', districtCode: '1' },
  { code: '16100', name: 'г.Балхаш', regionCode: '35', districtCode: '2' },
  { code: '18100', name: 'г.Жезказган', regionCode: '35', districtCode: '3' },
  { code: '20100', name: 'г.Каражал', regionCode: '35', districtCode: '4' },
  { code: '21100', name: 'г.Приозерск', regionCode: '35', districtCode: '5' },
  { code: '22100', name: 'г.Сарань', regionCode: '35', districtCode: '6' },
  { code: '23100', name: 'г.Сатпаев', regionCode: '35', districtCode: '7' },
  { code: '24100', name: 'г.Темиртау', regionCode: '35', districtCode: '8' },
  { code: '28100', name: 'г.Шахтинск', regionCode: '35', districtCode: '9' },
  { code: '20100', name: 'г.Абай', regionCode: '35', districtCode: '32' },
  { code: '33100', name: 'с.Акбастау', regionCode: '35', districtCode: '32' },
  { code: '37100', name: 'с.Сарепта', regionCode: '35', districtCode: '32' },
  { code: '37200', name: 'с.Койбас', regionCode: '35', districtCode: '32' },
  { code: '37300', name: 'с.Коянды', regionCode: '35', districtCode: '32' },
  { code: '41100', name: 'с.Есенгельды', regionCode: '35', districtCode: '32' },
  { code: '41200', name: 'с.Пахотное', regionCode: '35', districtCode: '32' },
  { code: '49100', name: 'с.Юбилейное', regionCode: '35', districtCode: '32' },
  { code: '49200', name: 'с.Жон', regionCode: '35', districtCode: '32' },
  { code: '49500', name: 'с.Тасзаемка', regionCode: '35', districtCode: '32' },
  { code: '53100', name: 'с.Коксун', regionCode: '35', districtCode: '32' },
  { code: '53200', name: 'с.Жартас', regionCode: '35', districtCode: '32' },
  {
    code: '53300',
    name: 'с.Зеленые Ключи',
    regionCode: '35',
    districtCode: '32'
  },
  { code: '53400', name: 'с.Северное', regionCode: '35', districtCode: '32' },
  { code: '53500', name: 'с.Южное', regionCode: '35', districtCode: '32' },
  { code: '57100', name: 'п.Карабас', regionCode: '35', districtCode: '32' },
  { code: '59100', name: 'с.Жартас', regionCode: '35', districtCode: '32' },
  { code: '59300', name: 'с.Восход', regionCode: '35', districtCode: '32' },
  { code: '59600', name: 'с.Каракога', regionCode: '35', districtCode: '32' },
  { code: '59700', name: 'с.Поливное', regionCode: '35', districtCode: '32' },
  { code: '61100', name: 'с.Кулайгыр', regionCode: '35', districtCode: '32' },
  { code: '61200', name: 'с.Жаманжол', regionCode: '35', districtCode: '32' },
  { code: '61800', name: 'с.Ялта', regionCode: '35', districtCode: '32' },
  { code: '63100', name: 'с.Курминское', regionCode: '35', districtCode: '32' },
  { code: '63200', name: 'с.Жумабек', regionCode: '35', districtCode: '32' },
  { code: '63300', name: 'с.Спасск', regionCode: '35', districtCode: '32' },
  {
    code: '67100',
    name: 'с.Агрогородок',
    regionCode: '35',
    districtCode: '32'
  },
  { code: '67200', name: 'с.Садовое', regionCode: '35', districtCode: '32' },
  { code: '67800', name: 'с.Ягодное', regionCode: '35', districtCode: '32' },
  { code: '81100', name: 'с.Самарка', regionCode: '35', districtCode: '32' },
  {
    code: '81200',
    name: 'с.Бородиновка',
    regionCode: '35',
    districtCode: '32'
  },
  { code: '81300', name: 'с.Изумрудное', regionCode: '35', districtCode: '32' },
  { code: '81400', name: 'с.Огороды', regionCode: '35', districtCode: '32' },
  { code: '81600', name: 'с.Пруды', regionCode: '35', districtCode: '32' },
  { code: '85100', name: 'п.Топар', regionCode: '35', districtCode: '32' },
  { code: '89100', name: 'п.Южный', regionCode: '35', districtCode: '32' },
  { code: '30100', name: 'с.Актогай', regionCode: '35', districtCode: '36' },
  { code: '31100', name: 'с.Абай', regionCode: '35', districtCode: '36' },
  { code: '31300', name: 'с.Акшкол', regionCode: '35', districtCode: '36' },
  { code: '33100', name: 'с.Айыртас', regionCode: '35', districtCode: '36' },
  { code: '41100', name: 'с.Сауле', regionCode: '35', districtCode: '36' },
  { code: '41200', name: 'с.Жаланаш', regionCode: '35', districtCode: '36' },
  { code: '41300', name: 'с.Ушарал', regionCode: '35', districtCode: '36' },
  { code: '41400', name: 'с.Каракой', regionCode: '35', districtCode: '36' },
  { code: '43100', name: 'с.Акший', regionCode: '35', districtCode: '36' },
  {
    code: '45100',
    name: 'аул Нарманбет',
    regionCode: '35',
    districtCode: '36'
  },
  { code: '45200', name: 'с.Дуаншы', regionCode: '35', districtCode: '36' },
  { code: '45300', name: 'с.Карасу', regionCode: '35', districtCode: '36' },
  { code: '47100', name: 'с.Актас', regionCode: '35', districtCode: '36' },
  { code: '47200', name: 'с.Куаныш', regionCode: '35', districtCode: '36' },
  { code: '49100', name: 'с.Кошкар', regionCode: '35', districtCode: '36' },
  { code: '51100', name: 'с.Акжарык', regionCode: '35', districtCode: '36' },
  { code: '55100', name: 'с.Hуркен', regionCode: '35', districtCode: '36' },
  { code: '55200', name: 'с.Аксенгир', regionCode: '35', districtCode: '36' },
  { code: '55300', name: 'с.Жалантас', regionCode: '35', districtCode: '36' },
  { code: '5588', name: 'г.Костанай', regionCode: '39', districtCode: '54' },
  { code: '4', name: 'с.Фурманова', regionCode: '39', districtCode: '39' },
  { code: '5', name: 'с.Целинное', regionCode: '39', districtCode: '39' },
  { code: '7', name: 'с.Красногорское', regionCode: '39', districtCode: '39' },
  { code: '8', name: 'п.Октябрьский', regionCode: '39', districtCode: '39' },
  { code: '10', name: 'с.Перцевка', regionCode: '39', districtCode: '39' },
  { code: '11', name: 'п.Качар', regionCode: '39', districtCode: '39' },
  {
    code: '43400',
    name: 'с.Кокпектиколь',
    regionCode: '39',
    districtCode: '34'
  },
  { code: '53100', name: 'с.Кабырга', regionCode: '39', districtCode: '34' },
  { code: '53200', name: 'с.Алаколь', regionCode: '39', districtCode: '34' },
  { code: '53400', name: 'с.Жанатай', regionCode: '39', districtCode: '34' },
  { code: '57100', name: 'с.Карынсалды', regionCode: '39', districtCode: '34' },
  { code: '57300', name: 'с.Горняк', regionCode: '39', districtCode: '34' },
  { code: '59100', name: 'с.Карасу', regionCode: '39', districtCode: '34' },
  {
    code: '59180',
    name: 'с.им.Абу Сыздыкова',
    regionCode: '39',
    districtCode: '34'
  },
  { code: '59200', name: 'с.Агайдар', regionCode: '39', districtCode: '34' },
  { code: '59300', name: 'с.Бестобе', regionCode: '39', districtCode: '34' },
  { code: '59400', name: 'с.Есенбаев', regionCode: '39', districtCode: '34' },
  { code: '61100', name: 'с.Кумкешу', regionCode: '39', districtCode: '34' },
  { code: '61200', name: 'с.Айтбай', regionCode: '39', districtCode: '34' },
  { code: '61300', name: 'с.Кустобе', regionCode: '39', districtCode: '34' },
  { code: '65100', name: 'с.Урпек', regionCode: '39', districtCode: '34' },
  { code: '65200', name: 'с.Агаштыколь', regionCode: '39', districtCode: '34' },
  { code: '65300', name: 'с.Карашатобе', regionCode: '39', districtCode: '34' },
  { code: '65400', name: 'с.Косжан', regionCode: '39', districtCode: '34' },
  { code: '73100', name: 'с.Степняк', regionCode: '39', districtCode: '34' },
  { code: '75100', name: 'с.Тасты', regionCode: '39', districtCode: '34' },
  { code: '77100', name: 'с.Уштогай', regionCode: '39', districtCode: '34' },
  { code: '30100', name: 'с.Аулиеколь', regionCode: '39', districtCode: '36' },
  {
    code: '31100',
    name: 'с.Аманкарагай',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '31200', name: 'с.Жилгородок', regionCode: '39', districtCode: '36' },
  { code: '31300', name: 'с.Лесное', regionCode: '39', districtCode: '36' },
  { code: '31400', name: 'с.Озерное', regionCode: '39', districtCode: '36' },
  {
    code: '31500',
    name: 'с.Тургайский пролив',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '33100', name: 'п.Кушмурун', regionCode: '39', districtCode: '36' },
  { code: '33200', name: 'с.Речное', regionCode: '39', districtCode: '36' },
  { code: '33300', name: 'с.Кирова', regionCode: '39', districtCode: '36' },
  { code: '35100', name: 'с.Диевка', regionCode: '39', districtCode: '36' },
  { code: '35200', name: 'с.Косколь', regionCode: '39', districtCode: '36' },
  { code: '35300', name: 'с.Ушкарасу', regionCode: '39', districtCode: '36' },
  {
    code: '37100',
    name: 'с.Октябрьское',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '37200', name: 'с.Баганалы', regionCode: '39', districtCode: '36' },
  { code: '37300', name: 'с.Дангербай', regionCode: '39', districtCode: '36' },
  { code: '37400', name: 'с.Казанбасы', regionCode: '39', districtCode: '36' },
  { code: '37500', name: 'с.Каракалпак', regionCode: '39', districtCode: '36' },
  { code: '39100', name: 'с.Косагал', regionCode: '39', districtCode: '36' },
  { code: '41100', name: 'с.Москалевка', regionCode: '39', districtCode: '36' },
  { code: '41300', name: 'с.Жалтырколь', regionCode: '39', districtCode: '36' },
  {
    code: '43100',
    name: 'с.Новонежинка',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '43200', name: 'с.Калинин', regionCode: '39', districtCode: '36' },
  {
    code: '43280',
    name: 'с.Лаврентьевка',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '43300', name: 'с.Миалы', regionCode: '39', districtCode: '36' },
  {
    code: '45100',
    name: 'с.Новоселовка',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '45200', name: 'с.Аккудук', regionCode: '39', districtCode: '36' },
  { code: '45300', name: 'с.Кургуус', regionCode: '39', districtCode: '36' },
  { code: '45400', name: 'с.Сосновка', regionCode: '39', districtCode: '36' },
  { code: '47100', name: 'с.Юльевка', regionCode: '39', districtCode: '36' },
  { code: '47200', name: 'с.Федосеевка', regionCode: '39', districtCode: '36' },
  { code: '47300', name: 'с.Чили', regionCode: '39', districtCode: '36' },
  { code: '49100', name: 'с.Тимофеевка', regionCode: '39', districtCode: '36' },
  { code: '49200', name: 'с.Булаксор', regionCode: '39', districtCode: '36' },
  { code: '51100', name: 'с.Черниговка', regionCode: '39', districtCode: '36' },
  { code: '51200', name: 'с.Жаргатыз', regionCode: '39', districtCode: '36' },
  { code: '51300', name: 'с.Дузбай', regionCode: '39', districtCode: '36' },
  { code: '51400', name: 'с.Харьковка', regionCode: '39', districtCode: '36' },
  {
    code: '53100',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '55100', name: 'с.Шагала', regionCode: '39', districtCode: '36' },
  { code: '55200', name: 'с.Коктал', regionCode: '39', districtCode: '36' },
  { code: '55300', name: 'с.Карагансай', regionCode: '39', districtCode: '36' },
  {
    code: '57100',
    name: 'с.им.Кабидолла Тургумбаева',
    regionCode: '39',
    districtCode: '36'
  },
  { code: '30100', name: 'с.Денисовка', regionCode: '39', districtCode: '40' },
  { code: '33100', name: 'с.Жалтырколь', regionCode: '39', districtCode: '40' },
  {
    code: '33200',
    name: 'с.Архангельское',
    regionCode: '39',
    districtCode: '40'
  },
  { code: '35100', name: 'с.Аршалы', regionCode: '39', districtCode: '40' },
  { code: '35200', name: 'с.Алаколь', regionCode: '39', districtCode: '40' },
  { code: '35300', name: 'с.Георгиевка', regionCode: '39', districtCode: '40' },
  { code: '35400', name: 'с.Набережное', regionCode: '39', districtCode: '40' },
  { code: '37100', name: 'с.Аятское', regionCode: '39', districtCode: '40' },
  { code: '37200', name: 'с.Аксу', regionCode: '39', districtCode: '40' },
  { code: '37300', name: 'с.Синегорск', regionCode: '39', districtCode: '40' },
  { code: '37400', name: 'с.Тастыколь', regionCode: '39', districtCode: '40' },
  { code: '39100', name: 'с.Зааятское', regionCode: '39', districtCode: '40' },
  { code: '39300', name: 'с.Караоба', regionCode: '39', districtCode: '40' },
  { code: '43100', name: 'с.Комаровка', regionCode: '39', districtCode: '40' },
  {
    code: '43300',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '40'
  },
  {
    code: '45100',
    name: 'с.Фрунзенское',
    regionCode: '39',
    districtCode: '40'
  },
  {
    code: '45200',
    name: 'с.Кочержиновка',
    regionCode: '39',
    districtCode: '40'
  },
  {
    code: '45300',
    name: 'с.Красноармейское',
    regionCode: '39',
    districtCode: '40'
  },
  { code: '45400', name: 'с.Тавриченка', regionCode: '39', districtCode: '40' },
  { code: '47100', name: 'с.Крымское', regionCode: '39', districtCode: '40' },
  { code: '47200', name: 'с.Озерное', regionCode: '39', districtCode: '40' },
  { code: '49100', name: 'с.Некрасовка', regionCode: '39', districtCode: '40' },
  { code: '49200', name: 'с.Гришенка', regionCode: '39', districtCode: '40' },
  { code: '49300', name: 'с.Калиновка', regionCode: '39', districtCode: '40' },
  { code: '49400', name: 'с.Целинное', regionCode: '39', districtCode: '40' },
  { code: '55100', name: 'с.Перелески', regionCode: '39', districtCode: '40' },
  { code: '57100', name: 'с.Покровка', regionCode: '39', districtCode: '40' },
  { code: '57200', name: 'с.Досовка', regionCode: '39', districtCode: '40' },
  { code: '59100', name: 'с.Приреченка', regionCode: '39', districtCode: '40' },
  { code: '59200', name: 'с.Окраинка', regionCode: '39', districtCode: '40' },
  { code: '63100', name: 'с.Свердловка', regionCode: '39', districtCode: '40' },
  { code: '63300', name: 'с.Подгорное', regionCode: '39', districtCode: '40' },
  { code: '63400', name: 'с.Приречное', regionCode: '39', districtCode: '40' },
  { code: '65100', name: 'с.Антоновка', regionCode: '39', districtCode: '40' },
  { code: '65200', name: 'с.Алчановка', regionCode: '39', districtCode: '40' },
  { code: '65400', name: 'с.Чебендовка', regionCode: '39', districtCode: '40' },
  { code: '65500', name: 'с.Шункырколь', regionCode: '39', districtCode: '40' },
  { code: '67100', name: 'с.Глебовка', regionCode: '39', districtCode: '40' },
  { code: '67400', name: 'с.Шукубай', regionCode: '39', districtCode: '40' },
  { code: '30100', name: 'с.Торгай', regionCode: '39', districtCode: '42' },
  { code: '33100', name: 'аул Акколь', regionCode: '39', districtCode: '42' },
  { code: '37100', name: 'с.Акшиганак', regionCode: '39', districtCode: '42' },
  { code: '37500', name: 'с.Туйемойнак', regionCode: '39', districtCode: '42' },
  { code: '39100', name: 'с.Кокалат', regionCode: '39', districtCode: '42' },
  { code: '39500', name: 'с.Колкамыс', regionCode: '39', districtCode: '42' },
  { code: '43100', name: 'с.Шеген', regionCode: '39', districtCode: '42' },
  { code: '43300', name: 'с.Каргалы', regionCode: '39', districtCode: '42' },
  { code: '45100', name: 'с.Бидайык', regionCode: '39', districtCode: '42' },
  { code: '47100', name: 'а.Аралбай', regionCode: '39', districtCode: '42' },
  { code: '49100', name: 'с.Тауыш', regionCode: '39', districtCode: '42' },
  { code: '49200', name: 'с.Сарысу', regionCode: '39', districtCode: '42' },
  { code: '49300', name: 'с.Тентексай', regionCode: '39', districtCode: '42' },
  { code: '49400', name: 'с.Токанай', regionCode: '39', districtCode: '42' },
  {
    code: '53100',
    name: 'с.Каламкарасу',
    regionCode: '39',
    districtCode: '42'
  },
  { code: '53300', name: 'с.Шубалан', regionCode: '39', districtCode: '42' },
  { code: '55100', name: 'с.Карасу', regionCode: '39', districtCode: '42' },
  { code: '57100', name: 'с.Милысай', regionCode: '39', districtCode: '42' },
  { code: '59100', name: 'с.Сага', regionCode: '39', districtCode: '42' },
  { code: '59200', name: 'с.Кумшик', regionCode: '39', districtCode: '42' },
  { code: '59300', name: 'с.Ошаганды', regionCode: '39', districtCode: '42' },
  { code: '59400', name: 'с.Узынкарасу', regionCode: '39', districtCode: '42' },
  { code: '63100', name: 'а.Сужарган', regionCode: '39', districtCode: '42' },
  { code: '65100', name: 'с.Шили', regionCode: '39', districtCode: '42' },
  {
    code: '31100',
    name: 'а.Пригородное',
    regionCode: '39',
    districtCode: '44'
  },
  { code: '33100', name: 'с.Аккарга', regionCode: '39', districtCode: '44' },
  { code: '35100', name: 'с.Тургеновка', regionCode: '39', districtCode: '44' },
  { code: '35300', name: 'с.Кусакан', regionCode: '39', districtCode: '44' },
  { code: '35400', name: 'с.Хозрет', regionCode: '39', districtCode: '44' },
  { code: '35500', name: 'с.Тасыбай', regionCode: '39', districtCode: '44' },
  {
    code: '37100',
    name: 'с.Волгоградское',
    regionCode: '39',
    districtCode: '44'
  },
  { code: '43100', name: 'с.Забеловка', regionCode: '39', districtCode: '44' },
  { code: '45100', name: 'с.Милютинка', regionCode: '39', districtCode: '44' },
  { code: '47100', name: 'с.Муктиколь', regionCode: '39', districtCode: '44' },
  { code: '47200', name: 'с.Кондыбай', regionCode: '39', districtCode: '44' },
  { code: '47300', name: 'с.Жалтырколь', regionCode: '39', districtCode: '44' },
  { code: '52100', name: 'с.Приречное', regionCode: '39', districtCode: '44' },
  { code: '53100', name: 'с.Тимирязево', regionCode: '39', districtCode: '44' },
  { code: '55100', name: 'с.Степное', regionCode: '39', districtCode: '44' },
  { code: '57100', name: 'с.Тохтарово', regionCode: '39', districtCode: '44' },
  { code: '57300', name: 'с.Львовка', regionCode: '39', districtCode: '44' },
  { code: '57400', name: 'с.Максимовка', regionCode: '39', districtCode: '44' },
  { code: '59100', name: 'а.Чайковское', regionCode: '39', districtCode: '44' },
  {
    code: '63100',
    name: 'с.Шевченковка',
    regionCode: '39',
    districtCode: '44'
  },
  { code: '65100', name: 'с.Ырсай', regionCode: '39', districtCode: '44' },
  { code: '30100', name: 'с.Камысты', regionCode: '39', districtCode: '48' },
  { code: '30200', name: 'с.Мечетное', regionCode: '39', districtCode: '48' },
  {
    code: '33100',
    name: 'с.Алтынсарино',
    regionCode: '39',
    districtCode: '48'
  },
  { code: '35100', name: 'с.Аралколь', regionCode: '39', districtCode: '48' },
  { code: '37100', name: 'с.Бестобе', regionCode: '39', districtCode: '48' },
  { code: '37200', name: 'с.Коянда', regionCode: '39', districtCode: '48' },
  { code: '37300', name: 'с.Оразкопа', regionCode: '39', districtCode: '48' },
  { code: '39100', name: 'с.Фрунзе', regionCode: '39', districtCode: '48' },
  { code: '39200', name: 'с.Богдановка', regionCode: '39', districtCode: '48' },
  { code: '43100', name: 'с.Адаевка', regionCode: '39', districtCode: '48' },
  { code: '43300', name: 'с.Целинное', regionCode: '39', districtCode: '48' },
  { code: '45100', name: 'с.Дружба', regionCode: '39', districtCode: '48' },
  { code: '47100', name: 'с.Жаилма', regionCode: '39', districtCode: '48' },
  { code: '47300', name: 'с.Сахаровка', regionCode: '39', districtCode: '48' },
  { code: '49100', name: 'с.Клочково', regionCode: '39', districtCode: '48' },
  { code: '51100', name: 'с.Арка', regionCode: '39', districtCode: '48' },
  { code: '53100', name: 'с.Карабатыр', regionCode: '39', districtCode: '48' },
  { code: '55100', name: 'с.Ливановка', regionCode: '39', districtCode: '48' },
  { code: '57100', name: 'с.Уркаш', regionCode: '39', districtCode: '48' },
  { code: '57500', name: 'с.Тауксор', regionCode: '39', districtCode: '48' },
  { code: '59100', name: 'с.Пушкино', regionCode: '39', districtCode: '48' },
  { code: '65100', name: 'с.Свободное', regionCode: '39', districtCode: '48' },
  { code: '65200', name: 'с.Попович', regionCode: '39', districtCode: '48' },
  { code: '67100', name: 'с.Талдыколь', regionCode: '39', districtCode: '48' },
  { code: '30100', name: 'п.Карабалык', regionCode: '39', districtCode: '50' },
  { code: '33100', name: 'с.Белоглинка', regionCode: '39', districtCode: '50' },
  { code: '33200', name: 'с.Научное', regionCode: '39', districtCode: '50' },
  {
    code: '33300',
    name: 'с.Святославка',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '35100', name: 'с.Босколь', regionCode: '39', districtCode: '50' },
  { code: '35200', name: 'с.Саманы', regionCode: '39', districtCode: '50' },
  { code: '35300', name: 'с.Талапкер', regionCode: '39', districtCode: '50' },
  { code: '37100', name: 'с.Бурли', regionCode: '39', districtCode: '50' },
  { code: '37200', name: 'с.Песчаное', regionCode: '39', districtCode: '50' },
  { code: '37300', name: 'с.Талды', regionCode: '39', districtCode: '50' },
  { code: '37400', name: 'с.Тастыозек', regionCode: '39', districtCode: '50' },
  { code: '39100', name: 'с.Лесное', regionCode: '39', districtCode: '50' },
  { code: '39200', name: 'с.Есенколь', regionCode: '39', districtCode: '50' },
  { code: '39300', name: 'с.Славянка', regionCode: '39', districtCode: '50' },
  { code: '43100', name: 'с.Кособа', regionCode: '39', districtCode: '50' },
  {
    code: '43200',
    name: 'с.Березовское',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '43300', name: 'с.Карачаколь', regionCode: '39', districtCode: '50' },
  { code: '45100', name: 'с.Веренка', regionCode: '39', districtCode: '50' },
  {
    code: '45200',
    name: 'с.Ворошиловка',
    regionCode: '39',
    districtCode: '50'
  },
  {
    code: '45300',
    name: 'с.Гурьяновское',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '45400', name: 'с.Ельшанское', regionCode: '39', districtCode: '50' },
  {
    code: '45500',
    name: 'с.Котлованное',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '45600', name: 'с.Надеждинка', regionCode: '39', districtCode: '50' },
  { code: '45700', name: 'с.Сарыколь', regionCode: '39', districtCode: '50' },
  { code: '45900', name: 'с.Целинное', regionCode: '39', districtCode: '50' },
  { code: '47100', name: 'с.Михайловка', regionCode: '39', districtCode: '50' },
  { code: '47200', name: 'с.Лесное', regionCode: '39', districtCode: '50' },
  { code: '47300', name: 'с.Светлое', regionCode: '39', districtCode: '50' },
  {
    code: '47400',
    name: 'с.Терентьевка',
    regionCode: '39',
    districtCode: '50'
  },
  {
    code: '49100',
    name: 'с.Новотроицкое',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '49200', name: 'с.Аккудук', regionCode: '39', districtCode: '50' },
  { code: '49400', name: 'с.Жанааул', regionCode: '39', districtCode: '50' },
  { code: '49500', name: 'с.Каерак', regionCode: '39', districtCode: '50' },
  { code: '49600', name: 'с.Магнай', regionCode: '39', districtCode: '50' },
  { code: '53100', name: 'с.Приречное', regionCode: '39', districtCode: '50' },
  { code: '16100', name: 'г.Аркалык', regionCode: '39', districtCode: '2' },
  { code: '20100', name: 'г.Лисаковск', regionCode: '39', districtCode: '3' },
  { code: '24100', name: 'г.Рудный', regionCode: '39', districtCode: '4' },
  { code: '30100', name: 'с.Убаганское', regionCode: '39', districtCode: '32' },
  {
    code: '35100',
    name: 'с.Большая Чураковка',
    regionCode: '39',
    districtCode: '32'
  },
  {
    code: '35200',
    name: 'с.Новониколаевка',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '35300', name: 'с.Осиповка', regionCode: '39', districtCode: '32' },
  {
    code: '37100',
    name: 'с.Танабаевское',
    regionCode: '39',
    districtCode: '32'
  },
  {
    code: '37200',
    name: 'с.Воробьевское',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '39100', name: 'с.Докучаевка', regionCode: '39', districtCode: '32' },
  { code: '39300', name: 'а.Шокай', regionCode: '39', districtCode: '32' },
  {
    code: '41100',
    name: 'с.Красный Кордон',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '43100', name: 'с.Лермонтово', regionCode: '39', districtCode: '32' },
  { code: '43200', name: 'с.Жанасу', regionCode: '39', districtCode: '32' },
  { code: '43400', name: 'с.Степное', regionCode: '39', districtCode: '32' },
  {
    code: '45100',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '45200', name: 'с.Кызылагаш', regionCode: '39', districtCode: '32' },
  {
    code: '45300',
    name: 'с.Темир Казык',
    regionCode: '39',
    districtCode: '32'
  },
  {
    code: '47100',
    name: 'с.Новоалексеевка',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '47200', name: 'с.Анновка', regionCode: '39', districtCode: '32' },
  { code: '53100', name: 'с.Приозерное', regionCode: '39', districtCode: '32' },
  { code: '53300', name: 'с.Кубековка', regionCode: '39', districtCode: '32' },
  { code: '55100', name: 'с.Свердловка', regionCode: '39', districtCode: '32' },
  {
    code: '57100',
    name: 'с.Силантьевка',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '57200', name: 'с.Бирюковка', regionCode: '39', districtCode: '32' },
  { code: '57300', name: 'с.Зуевка', regionCode: '39', districtCode: '32' },
  {
    code: '57400',
    name: 'с.Малая Чураковка',
    regionCode: '39',
    districtCode: '32'
  },
  { code: '59100', name: 'с.Щербаково', regionCode: '39', districtCode: '32' },
  { code: '59200', name: 'с.Басбек', regionCode: '39', districtCode: '32' },
  { code: '59300', name: 'с.Сатай', regionCode: '39', districtCode: '32' },
  { code: '59400', name: 'с.Коскудук', regionCode: '39', districtCode: '32' },
  { code: '30100', name: 'с.Амангельды', regionCode: '39', districtCode: '34' },
  { code: '33100', name: 'с.Аксай', regionCode: '39', districtCode: '34' },
  { code: '35100', name: 'с.Есир', regionCode: '39', districtCode: '34' },
  { code: '35300', name: 'с.Аккиси', regionCode: '39', districtCode: '34' },
  { code: '35400', name: 'с.Кемер', regionCode: '39', districtCode: '34' },
  { code: '35500', name: 'с.Когалыколь', regionCode: '39', districtCode: '34' },
  { code: '35700', name: 'с.Мукур', regionCode: '39', districtCode: '34' },
  { code: '37100', name: 'с.Амантогай', regionCode: '39', districtCode: '34' },
  { code: '37280', name: 'с.Жалдама', regionCode: '39', districtCode: '34' },
  { code: '37400', name: 'с.Каражар', regionCode: '39', districtCode: '34' },
  { code: '37500', name: 'с.Каракудук', regionCode: '39', districtCode: '34' },
  { code: '43100', name: 'с.Байгабыл', regionCode: '39', districtCode: '34' },
  { code: '43200', name: 'с.Жанатурмыс', regionCode: '39', districtCode: '34' },
  { code: '43300', name: 'с.Жетибай', regionCode: '39', districtCode: '34' },
  { code: '55200', name: 'с.Крыловка', regionCode: '39', districtCode: '62' },
  { code: '55300', name: 'с.Мелитополь', regionCode: '39', districtCode: '62' },
  { code: '55400', name: 'с.Островное', regionCode: '39', districtCode: '62' },
  { code: '57100', name: 'с.Тагильское', regionCode: '39', districtCode: '62' },
  { code: '57200', name: 'с.Дудаковка', regionCode: '39', districtCode: '62' },
  { code: '57300', name: 'с.Ермаковка', regionCode: '39', districtCode: '62' },
  { code: '57500', name: 'с.Соналы', regionCode: '39', districtCode: '62' },
  {
    code: '59100',
    name: 'с.Тимирязевка',
    regionCode: '39',
    districtCode: '62'
  },
  {
    code: '59300',
    name: 'с.Павлыш Спасское',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '59400', name: 'с.Целинное', regionCode: '39', districtCode: '62' },
  { code: '63100', name: 'с.Урожайное', regionCode: '39', districtCode: '62' },
  { code: '63200', name: 'с.Акчаколь', regionCode: '39', districtCode: '62' },
  { code: '63300', name: 'с.Анновка', regionCode: '39', districtCode: '62' },
  {
    code: '30100',
    name: 'с.Тарановское',
    regionCode: '39',
    districtCode: '64'
  },
  {
    code: '30200',
    name: 'с.Воронежское',
    regionCode: '39',
    districtCode: '64'
  },
  {
    code: '30400',
    name: 'с.Оренбургское',
    regionCode: '39',
    districtCode: '64'
  },
  {
    code: '35100',
    name: 'с.Асенкритовка',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '35200', name: 'с.Баталы', regionCode: '39', districtCode: '64' },
  { code: '35300', name: 'с.Варваринка', regionCode: '39', districtCode: '64' },
  { code: '35400', name: 'с.Кызылжар', regionCode: '39', districtCode: '64' },
  { code: '35500', name: 'с.Николаевка', regionCode: '39', districtCode: '64' },
  { code: '35600', name: 'с.Майлин', regionCode: '39', districtCode: '64' },
  {
    code: '39100',
    name: 'с.Кайындыколь',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '39200', name: 'с.Жамбасколь', regionCode: '39', districtCode: '64' },
  { code: '43100', name: 'с.Евгеновка', regionCode: '39', districtCode: '64' },
  { code: '45100', name: 'с.Береговое', regionCode: '39', districtCode: '64' },
  { code: '45300', name: 'с.Нагорное', regionCode: '39', districtCode: '64' },
  { code: '47100', name: 'с.Приозерное', regionCode: '39', districtCode: '64' },
  {
    code: '49100',
    name: 'с.Красносельское',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '49200', name: 'с.Аятское', regionCode: '39', districtCode: '64' },
  { code: '49300', name: 'с.Журавлевка', regionCode: '39', districtCode: '64' },
  { code: '49400', name: 'с.Шербиновка', regionCode: '39', districtCode: '64' },
  { code: '51100', name: 'с.Максут', regionCode: '39', districtCode: '64' },
  { code: '51200', name: 'с.Достияр', regionCode: '39', districtCode: '64' },
  { code: '53100', name: 'с.Майское', regionCode: '39', districtCode: '64' },
  {
    code: '53200',
    name: 'с.Приреченское',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '55100', name: 'с.Набережное', regionCode: '39', districtCode: '64' },
  {
    code: '55300',
    name: 'с.Елизаветинка',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '57100', name: 'с.Нелюбинка', regionCode: '39', districtCode: '64' },
  { code: '57200', name: 'с.Барсуковка', regionCode: '39', districtCode: '64' },
  {
    code: '59100',
    name: 'с.Новоильиновка',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '59200', name: 'с.Аксуатское', regionCode: '39', districtCode: '64' },
  {
    code: '59300',
    name: 'с.Богородское',
    regionCode: '39',
    districtCode: '64'
  },
  {
    code: '59400',
    name: 'с.Валерьяновка',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '59500', name: 'с.Козыревка', regionCode: '39', districtCode: '64' },
  { code: '59580', name: 'с.Ленинское', regionCode: '39', districtCode: '64' },
  { code: '59600', name: 'с.Мирное', regionCode: '39', districtCode: '64' },
  {
    code: '59700',
    name: 'с.Притобольское',
    regionCode: '39',
    districtCode: '64'
  },
  { code: '59800', name: 'с.Увальное', regionCode: '39', districtCode: '64' },
  { code: '63100', name: 'с.Павловка', regionCode: '39', districtCode: '64' },
  { code: '63200', name: 'с.Апановка', regionCode: '39', districtCode: '64' },
  { code: '63300', name: 'с.Коржынколь', regionCode: '39', districtCode: '64' },
  { code: '69100', name: 'с.Смайловка', regionCode: '39', districtCode: '64' },
  { code: '73100', name: 'п.Тобол', regionCode: '39', districtCode: '64' },
  { code: '75100', name: 'с.Юбилейное', regionCode: '39', districtCode: '64' },
  { code: '30100', name: 'с.Узунколь', regionCode: '39', districtCode: '66' },
  { code: '33100', name: 'с.Бауманское', regionCode: '39', districtCode: '66' },
  { code: '33200', name: 'с.Королевка', regionCode: '39', districtCode: '66' },
  { code: '35100', name: 'с.Ершовка', regionCode: '39', districtCode: '66' },
  { code: '35200', name: 'с.Отынагаш', regionCode: '39', districtCode: '66' },
  { code: '37100', name: 'с.Сокол', regionCode: '39', districtCode: '66' },
  {
    code: '37200',
    name: 'с.Карла Маркса',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '37300', name: 'с.Сибирка', regionCode: '39', districtCode: '66' },
  {
    code: '39100',
    name: 'с.Миролюбовка',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '39200', name: 'с.Абай', regionCode: '39', districtCode: '66' },
  { code: '39300', name: 'с.Долинка', regionCode: '39', districtCode: '66' },
  { code: '39400', name: 'с.Косколь', regionCode: '39', districtCode: '66' },
  { code: '41100', name: 'с.Кировское', regionCode: '39', districtCode: '66' },
  {
    code: '41200',
    name: 'с.Иваноровное',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '41300', name: 'с.Ксеньевка', regionCode: '39', districtCode: '66' },
  { code: '41400', name: 'с.Моховое', regionCode: '39', districtCode: '66' },
  { code: '43100', name: 'с.Варваровка', regionCode: '39', districtCode: '66' },
  { code: '43200', name: 'с.Каратал', regionCode: '39', districtCode: '66' },
  {
    code: '47100',
    name: 'с.Новопокровка',
    regionCode: '39',
    districtCode: '66'
  },
  {
    code: '47200',
    name: 'с.Воскресеновка',
    regionCode: '39',
    districtCode: '66'
  },
  {
    code: '47300',
    name: 'с.Нововасильевка',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '47400', name: 'с.Уйкескен', regionCode: '39', districtCode: '66' },
  { code: '49100', name: 'с.Белоглинка', regionCode: '39', districtCode: '66' },
  { code: '49200', name: 'с.Борки', regionCode: '39', districtCode: '66' },
  { code: '49300', name: 'с.Камышловка', regionCode: '39', districtCode: '66' },
  {
    code: '49400',
    name: 'с.Комендантское',
    regionCode: '39',
    districtCode: '66'
  },
  {
    code: '49500',
    name: 'с.Красный Борок',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '49600', name: 'с.Починовка', regionCode: '39', districtCode: '66' },
  {
    code: '51100',
    name: 'с.Пресногорьковка',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '51200', name: 'с.Волна', regionCode: '39', districtCode: '66' },
  { code: '51300', name: 'с.Гренадерка', regionCode: '39', districtCode: '66' },
  { code: '51400', name: 'с.Крутоярка', regionCode: '39', districtCode: '66' },
  {
    code: '51600',
    name: 'с.Октябрьское',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '51700', name: 'с.Первомайка', regionCode: '39', districtCode: '66' },
  { code: '51800', name: 'с.Песчанка', regionCode: '39', districtCode: '66' },
  { code: '53100', name: 'с.Тайсойган', regionCode: '39', districtCode: '66' },
  { code: '53200', name: 'с.Березово', regionCode: '39', districtCode: '66' },
  { code: '53300', name: 'с.Убаган', regionCode: '39', districtCode: '66' },
  { code: '55100', name: 'с.Ряжское', regionCode: '39', districtCode: '66' },
  { code: '57100', name: 'с.Суворово', regionCode: '39', districtCode: '66' },
  { code: '57200', name: 'с.Казанка', regionCode: '39', districtCode: '66' },
  { code: '57300', name: 'с.Пилкино', regionCode: '39', districtCode: '66' },
  {
    code: '59100',
    name: 'с.Троебратский',
    regionCode: '39',
    districtCode: '66'
  },
  { code: '61100', name: 'с.Вершковое', regionCode: '39', districtCode: '66' },
  { code: '61200', name: 'с.Есмырза', regionCode: '39', districtCode: '66' },
  { code: '61300', name: 'с.Павловка', regionCode: '39', districtCode: '66' },
  { code: '63100', name: 'с.Федоровка', regionCode: '39', districtCode: '66' },
  { code: '63200', name: 'с.Укаткан', regionCode: '39', districtCode: '66' },
  { code: '65100', name: 'с.Речное', regionCode: '39', districtCode: '66' },
  { code: '65200', name: 'с.Амречье', regionCode: '39', districtCode: '66' },
  { code: '65300', name: 'с.Каратомар', regionCode: '39', districtCode: '66' },
  { code: '65400', name: 'с.Огузбалык', regionCode: '39', districtCode: '66' },
  { code: '30100', name: 'с.Федоровка', regionCode: '39', districtCode: '68' },
  { code: '35100', name: 'с.Банновка', regionCode: '39', districtCode: '68' },
  { code: '35200', name: 'с.Каракопа', regionCode: '39', districtCode: '68' },
  { code: '35300', name: 'с.Цабелевка', regionCode: '39', districtCode: '68' },
  { code: '35400', name: 'с.Чеховка', regionCode: '39', districtCode: '68' },
  { code: '37100', name: 'с.Вишневое', regionCode: '39', districtCode: '68' },
  { code: '37200', name: 'с.Балыкты', regionCode: '39', districtCode: '68' },
  { code: '37300', name: 'с.Белояровка', regionCode: '39', districtCode: '68' },
  { code: '37400', name: 'с.Уйское', regionCode: '39', districtCode: '68' },
  { code: '37500', name: 'с.Усаковка', regionCode: '39', districtCode: '68' },
  {
    code: '39100',
    name: 'с.Придорожное',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '39300', name: 'с.Лысановка', regionCode: '39', districtCode: '68' },
  { code: '39400', name: 'с.Успеновка', regionCode: '39', districtCode: '68' },
  { code: '43100', name: 'с.Жарколь', regionCode: '39', districtCode: '68' },
  {
    code: '43200',
    name: 'с.Александрополь',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '43300', name: 'с.Андреевка', regionCode: '39', districtCode: '68' },
  { code: '43400', name: 'с.Владыкинка', regionCode: '39', districtCode: '68' },
  { code: '43500', name: 'с.Затышенка', regionCode: '39', districtCode: '68' },
  { code: '43600', name: 'с.Копыченка', regionCode: '39', districtCode: '68' },
  { code: '43700', name: 'с.Приозерное', regionCode: '39', districtCode: '68' },
  {
    code: '45100',
    name: 'с.Чистый Чандак',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '45200', name: 'с.Алабутала', regionCode: '39', districtCode: '68' },
  {
    code: '45400',
    name: 'с.Камышный Чандак',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '45500', name: 'с.Северное', regionCode: '39', districtCode: '68' },
  {
    code: '47100',
    name: 'с.Костряковка',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '47200', name: 'с.Волковка', regionCode: '39', districtCode: '68' },
  { code: '47300', name: 'с.Грачевка', regionCode: '39', districtCode: '68' },
  { code: '47400', name: 'с.Запасное', regionCode: '39', districtCode: '68' },
  {
    code: '47500',
    name: 'с.Ивангородское',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '47600', name: 'с.Курское', regionCode: '39', districtCode: '68' },
  { code: '49100', name: 'с.Лесное', regionCode: '39', districtCode: '68' },
  { code: '49200', name: 'с.Березовка', regionCode: '39', districtCode: '68' },
  { code: '51100', name: 'с.Кенарал', regionCode: '39', districtCode: '68' },
  { code: '51200', name: 'с.Жыланды', regionCode: '39', districtCode: '68' },
  { code: '51500', name: 'с.Турагаш', regionCode: '39', districtCode: '68' },
  { code: '53100', name: 'с.Ленино', regionCode: '39', districtCode: '68' },
  { code: '53200', name: 'с.Байкаин', regionCode: '39', districtCode: '68' },
  { code: '53300', name: 'с.Жанакой', regionCode: '39', districtCode: '68' },
  { code: '53400', name: 'с.Заозерное', regionCode: '39', districtCode: '68' },
  { code: '55100', name: 'с.Новошумное', regionCode: '39', districtCode: '68' },
  {
    code: '55300',
    name: 'с.Старошумное',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '55400', name: 'с.Тогузак', regionCode: '39', districtCode: '68' },
  {
    code: '57100',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '57400', name: 'с.Трактовое', regionCode: '39', districtCode: '68' },
  { code: '59100', name: 'с.Пешковка', regionCode: '39', districtCode: '68' },
  { code: '59200', name: 'с.Большое', regionCode: '39', districtCode: '68' },
  { code: '59400', name: 'с.Калиновка', regionCode: '39', districtCode: '68' },
  { code: '59500', name: 'с.Кравцово', regionCode: '39', districtCode: '68' },
  { code: '59700', name: 'с.Полтавка', regionCode: '39', districtCode: '68' },
  {
    code: '63100',
    name: 'с.Малороссийка',
    regionCode: '39',
    districtCode: '68'
  },
  { code: '63400', name: 'с.Дубровка', regionCode: '39', districtCode: '68' },
  { code: '65100', name: 'с.Мирное', regionCode: '39', districtCode: '68' },
  { code: '65300', name: 'с.Дорожное', regionCode: '39', districtCode: '68' },
  { code: '65400', name: 'с.Крамское', regionCode: '39', districtCode: '68' },
  { code: '10100', name: 'г.Костанай', regionCode: '39', districtCode: '1' },
  { code: '30100', name: 'г.Тобыл', regionCode: '39', districtCode: '54' },
  { code: '20100', name: 'г.Жетикара', regionCode: '39', districtCode: '44' },
  { code: '49700', name: 'с.Подгородка', regionCode: '39', districtCode: '50' },
  { code: '37700', name: 'с.Шакпак', regionCode: '39', districtCode: '34' },
  { code: '53300', name: 'с.Каракопа', regionCode: '39', districtCode: '50' },
  {
    code: '53400',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '53500', name: 'с.Урнек', regionCode: '39', districtCode: '50' },
  { code: '55100', name: 'с.Победа', regionCode: '39', districtCode: '50' },
  { code: '55400', name: 'с.Жамбыл', regionCode: '39', districtCode: '50' },
  { code: '55500', name: 'с.Магнай', regionCode: '39', districtCode: '50' },
  { code: '57100', name: 'с.Славенка', regionCode: '39', districtCode: '50' },
  {
    code: '57400',
    name: 'с.Октябрьское',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '57500', name: 'с.Шингиль', regionCode: '39', districtCode: '50' },
  { code: '59100', name: 'с.Смирновка', regionCode: '39', districtCode: '50' },
  { code: '59200', name: 'с.Батмановка', regionCode: '39', districtCode: '50' },
  { code: '59300', name: 'с.Приозерное', regionCode: '39', districtCode: '50' },
  { code: '59400', name: 'с.Рыбкино', regionCode: '39', districtCode: '50' },
  {
    code: '63100',
    name: 'с.Станционное',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '63200', name: 'с.Дальнее', regionCode: '39', districtCode: '50' },
  {
    code: '63300',
    name: 'с.Приуральское',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '63400', name: 'с.Фадеевка', regionCode: '39', districtCode: '50' },
  {
    code: '63500',
    name: 'с.Шадыксаевка',
    regionCode: '39',
    districtCode: '50'
  },
  { code: '65100', name: 'с.Тогузак', regionCode: '39', districtCode: '50' },
  { code: '30100', name: 'с.Карасу', regionCode: '39', districtCode: '52' },
  { code: '31100', name: 'с.Айдарлы', regionCode: '39', districtCode: '52' },
  { code: '31200', name: 'с.Дружба', regionCode: '39', districtCode: '52' },
  { code: '31300', name: 'с.Герцено', regionCode: '39', districtCode: '52' },
  { code: '31500', name: 'с.Степное', regionCode: '39', districtCode: '52' },
  { code: '33100', name: 'с.Амангельды', regionCode: '39', districtCode: '52' },
  { code: '33200', name: 'с.Целинное', regionCode: '39', districtCode: '52' },
  { code: '36100', name: 'с.Восток', regionCode: '39', districtCode: '52' },
  { code: '36200', name: 'с.Алыкпаш', regionCode: '39', districtCode: '52' },
  { code: '36300', name: 'с.Жумагул', regionCode: '39', districtCode: '52' },
  { code: '36500', name: 'с.Козубай', regionCode: '39', districtCode: '52' },
  { code: '36700', name: 'с.Майское', regionCode: '39', districtCode: '52' },
  { code: '36900', name: 'с.Тюнтюгур', regionCode: '39', districtCode: '52' },
  { code: '41100', name: 'с.Жамбыл', regionCode: '39', districtCode: '52' },
  { code: '41200', name: 'с.Западное', regionCode: '39', districtCode: '52' },
  {
    code: '43100',
    name: 'с.Железнодорожное',
    regionCode: '39',
    districtCode: '52'
  },
  { code: '43300', name: 'с.Братское', regionCode: '39', districtCode: '52' },
  {
    code: '47100',
    name: 'с.Комсомольское',
    regionCode: '39',
    districtCode: '52'
  },
  { code: '47300', name: 'с.Кызкеткен', regionCode: '39', districtCode: '52' },
  { code: '51100', name: 'с.Карамырза', regionCode: '39', districtCode: '52' },
  { code: '51300', name: 'с.Кошевое', regionCode: '39', districtCode: '52' },
  { code: '51500', name: 'с.Молодежное', regionCode: '39', districtCode: '52' },
  { code: '51700', name: 'с.Суйгенсай', regionCode: '39', districtCode: '52' },
  { code: '53100', name: 'с.Койбагар', regionCode: '39', districtCode: '52' },
  { code: '55100', name: 'с.Люблинка', regionCode: '39', districtCode: '52' },
  { code: '55300', name: 'с.Корниловка', regionCode: '39', districtCode: '52' },
  { code: '55400', name: 'с.Носовка', regionCode: '39', districtCode: '52' },
  {
    code: '55500',
    name: 'с.Симферополь',
    regionCode: '39',
    districtCode: '52'
  },
  {
    code: '61100',
    name: 'с.Новопавловка',
    regionCode: '39',
    districtCode: '52'
  },
  {
    code: '63100',
    name: 'с.Новоселовка',
    regionCode: '39',
    districtCode: '52'
  },
  { code: '63300', name: 'с.Кундузда', regionCode: '39', districtCode: '52' },
  { code: '65100', name: 'с.Жалгыскан', regionCode: '39', districtCode: '52' },
  {
    code: '67100',
    name: 'с.Октябрьское',
    regionCode: '39',
    districtCode: '52'
  },
  { code: '69100', name: 'с.Павловское', regionCode: '39', districtCode: '52' },
  { code: '77100', name: 'с.Теректы', regionCode: '39', districtCode: '52' },
  { code: '77180', name: 'с.Жекеколь', regionCode: '39', districtCode: '52' },
  { code: '77200', name: 'с.Куленсай', regionCode: '39', districtCode: '52' },
  { code: '81100', name: 'с.Ушаково', regionCode: '39', districtCode: '52' },
  { code: '81300', name: 'с.Заря', regionCode: '39', districtCode: '52' },
  { code: '81500', name: 'с.Панфилово', regionCode: '39', districtCode: '52' },
  { code: '83100', name: 'с.Целинное', regionCode: '39', districtCode: '52' },
  { code: '83500', name: 'с.Прогресс', regionCode: '39', districtCode: '52' },
  { code: '85100', name: 'с.Челгаши', regionCode: '39', districtCode: '52' },
  { code: '85200', name: 'с.Жаныспай', regionCode: '39', districtCode: '52' },
  { code: '87100', name: 'с.Ленино', regionCode: '39', districtCode: '52' },
  { code: '87200', name: 'с.Белозерка', regionCode: '39', districtCode: '52' },
  { code: '87300', name: 'с.Зеленовка', regionCode: '39', districtCode: '52' },
  { code: '87500', name: 'с.Маршановка', regionCode: '39', districtCode: '52' },
  { code: '87600', name: 'с.Тучковка', regionCode: '39', districtCode: '52' },
  { code: '87700', name: 'с.Черняевка', regionCode: '39', districtCode: '52' },
  { code: '31100', name: 'Заречное с.', regionCode: '39', districtCode: '54' },
  { code: '31200', name: 'с.Абай', regionCode: '39', districtCode: '54' },
  {
    code: '31300',
    name: 'с.Новоселовка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '31400', name: 'с.Осиновка', regionCode: '39', districtCode: '54' },
  { code: '31500', name: 'с.Рыспай', regionCode: '39', districtCode: '54' },
  { code: '31600', name: 'с.Талапкер', regionCode: '39', districtCode: '54' },
  {
    code: '33100',
    name: 'с.Александровка',
    regionCode: '39',
    districtCode: '54'
  },
  {
    code: '33200',
    name: 'с.Давыденовка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '33300', name: 'с.Жуковка', regionCode: '39', districtCode: '54' },
  { code: '35100', name: 'с.Белозерка', regionCode: '39', districtCode: '54' },
  { code: '35200', name: 'с.Балыкты', regionCode: '39', districtCode: '54' },
  { code: '35300', name: 'с.Сергеевка', regionCode: '39', districtCode: '54' },
  {
    code: '37100',
    name: 'с.Борис-Романовка',
    regionCode: '39',
    districtCode: '54'
  },
  {
    code: '39100',
    name: 'с.Владимировка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '39200', name: 'с.Сормовка', regionCode: '39', districtCode: '54' },
  { code: '39300', name: 'с.Янушевка', regionCode: '39', districtCode: '54' },
  {
    code: '41100',
    name: 'с.Воскресеновка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '43100', name: 'с.Глазуновка', regionCode: '39', districtCode: '54' },
  { code: '43200', name: 'с.Семеновка', regionCode: '39', districtCode: '54' },
  { code: '43300', name: 'с.Степное', regionCode: '39', districtCode: '54' },
  { code: '45100', name: 'с.Ждановка', regionCode: '39', districtCode: '54' },
  { code: '45300', name: 'с.Аккабак', regionCode: '39', districtCode: '54' },
  { code: '45400', name: 'с.Васильевка', regionCode: '39', districtCode: '54' },
  { code: '45600', name: 'с.Кировка', regionCode: '39', districtCode: '54' },
  { code: '45800', name: 'с.Семилетка', regionCode: '39', districtCode: '54' },
  { code: '47100', name: 'с.Майколь', regionCode: '39', districtCode: '54' },
  { code: '47200', name: 'с.Арман', regionCode: '39', districtCode: '54' },
  { code: '47400', name: 'с.Рязановка', regionCode: '39', districtCode: '54' },
  {
    code: '47500',
    name: 'с.Шеминовское',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '49100', name: 'с.Московское', regionCode: '39', districtCode: '54' },
  {
    code: '49300',
    name: 'с.Светлый Жарколь',
    regionCode: '39',
    districtCode: '54'
  },
  {
    code: '51100',
    name: 'с.Мичуринское',
    regionCode: '39',
    districtCode: '54'
  },
  {
    code: '51200',
    name: 'с.Алтынсарино',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '51300', name: 'с.Садовое', regionCode: '39', districtCode: '54' },
  { code: '53100', name: 'с.Надеждинка', regionCode: '39', districtCode: '54' },
  { code: '53200', name: 'с.Майалап', regionCode: '39', districtCode: '54' },
  { code: '55100', name: 'с.Озерное', regionCode: '39', districtCode: '54' },
  {
    code: '57100',
    name: 'с.Половниковка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '57200', name: 'с.Жаксылык', regionCode: '39', districtCode: '54' },
  { code: '59100', name: 'с.Жамбыл', regionCode: '39', districtCode: '54' },
  { code: '59200', name: 'с.Алтын дала', regionCode: '39', districtCode: '54' },
  { code: '59300', name: 'с.Самир', regionCode: '39', districtCode: '54' },
  { code: '63100', name: 'с.Садчиковка', regionCode: '39', districtCode: '54' },
  {
    code: '63200',
    name: 'с.Константиновка',
    regionCode: '39',
    districtCode: '54'
  },
  {
    code: '65100',
    name: 'с.Октябрьское',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '65200', name: 'с.Лиманное', regionCode: '39', districtCode: '54' },
  {
    code: '65300',
    name: 'с.Молокановка',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '65400', name: 'с.Нечаевка', regionCode: '39', districtCode: '54' },
  { code: '65500', name: 'с.Рыбное', regionCode: '39', districtCode: '54' },
  { code: '65600', name: 'с.Шоккарагай', regionCode: '39', districtCode: '54' },
  {
    code: '67100',
    name: 'с.Ульяновское',
    regionCode: '39',
    districtCode: '54'
  },
  { code: '67200', name: 'с.Бегежан', regionCode: '39', districtCode: '54' },
  { code: '69100', name: 'с.Шишкинское', regionCode: '39', districtCode: '54' },
  { code: '69200', name: 'с.Суриковка', regionCode: '39', districtCode: '54' },
  { code: '30100', name: 'с.Боровской', regionCode: '39', districtCode: '56' },
  { code: '33100', name: 'с.Молодежное', regionCode: '39', districtCode: '56' },
  { code: '33200', name: 'с.Алешинка', regionCode: '39', districtCode: '56' },
  { code: '33300', name: 'с.Алкау', regionCode: '39', districtCode: '56' },
  { code: '35100', name: 'с.Борки', regionCode: '39', districtCode: '56' },
  { code: '35400', name: 'с.Татьяновка', regionCode: '39', districtCode: '56' },
  { code: '39100', name: 'с.Буденновка', regionCode: '39', districtCode: '56' },
  { code: '39200', name: 'с.Кызыл Ту', regionCode: '39', districtCode: '56' },
  { code: '43100', name: 'с.Введенка', regionCode: '39', districtCode: '56' },
  { code: '43200', name: 'с.Загаринка', regionCode: '39', districtCode: '56' },
  { code: '43300', name: 'с.Каменка', regionCode: '39', districtCode: '56' },
  { code: '43500', name: 'с.Милютинка', regionCode: '39', districtCode: '56' },
  {
    code: '45100',
    name: 'с.Каменскуральское',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '45300', name: 'с.Аксуат', regionCode: '39', districtCode: '56' },
  { code: '45400', name: 'с.Жусалы', regionCode: '39', districtCode: '56' },
  {
    code: '47100',
    name: 'с.Красная Пресня',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '47200', name: 'с.Балыкты', regionCode: '39', districtCode: '56' },
  { code: '47300', name: 'с.Лоба', regionCode: '39', districtCode: '56' },
  { code: '47400', name: 'с.Молодежное', regionCode: '39', districtCode: '56' },
  { code: '49100', name: 'с.Узынагаш', regionCode: '39', districtCode: '56' },
  { code: '49200', name: 'с.Байгожа', regionCode: '39', districtCode: '56' },
  { code: '49400', name: 'с.Жаркайын', regionCode: '39', districtCode: '56' },
  { code: '49600', name: 'с.Кульчукай', regionCode: '39', districtCode: '56' },
  { code: '49700', name: 'с.Туленгут', regionCode: '39', districtCode: '56' },
  { code: '53100', name: 'с.Каскат', regionCode: '39', districtCode: '56' },
  { code: '53200', name: 'с.Коктерек', regionCode: '39', districtCode: '56' },
  { code: '53280', name: 'с.Каражар', regionCode: '39', districtCode: '56' },
  { code: '53300', name: 'с.Карамай', regionCode: '39', districtCode: '56' },
  { code: '53400', name: 'с.Лютинка', regionCode: '39', districtCode: '56' },
  { code: '53600', name: 'с.Шиели', regionCode: '39', districtCode: '56' },
  { code: '55100', name: 'с.Михайловка', regionCode: '39', districtCode: '56' },
  { code: '55200', name: 'с.Архиповка', regionCode: '39', districtCode: '56' },
  { code: '55300', name: 'с.Степановка', regionCode: '39', districtCode: '56' },
  {
    code: '57100',
    name: 'с.Первомайское',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '57200', name: 'с.Долбушка', regionCode: '39', districtCode: '56' },
  { code: '57300', name: 'с.Ивановка', regionCode: '39', districtCode: '56' },
  {
    code: '57400',
    name: 'с.Красносельское',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '57500', name: 'с.Лесное', regionCode: '39', districtCode: '56' },
  { code: '57700', name: 'с.Русское', regionCode: '39', districtCode: '56' },
  { code: '57800', name: 'с.Чернышевка', regionCode: '39', districtCode: '56' },
  {
    code: '59100',
    name: 'с.Харьковское',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '59200', name: 'с.Никитинка', regionCode: '39', districtCode: '56' },
  { code: '59300', name: 'с.Приозерное', regionCode: '39', districtCode: '56' },
  { code: '59400', name: 'с.Сосна', regionCode: '39', districtCode: '56' },
  {
    code: '63100',
    name: 'с.Тенизовское',
    regionCode: '39',
    districtCode: '56'
  },
  {
    code: '63200',
    name: 'с.Новониколаевка',
    regionCode: '39',
    districtCode: '56'
  },
  { code: '30100', name: 'с.Караменды', regionCode: '39', districtCode: '58' },
  { code: '30300', name: 'с.Жамбыл', regionCode: '39', districtCode: '58' },
  {
    code: '33100',
    name: 'с.Буревестник',
    regionCode: '39',
    districtCode: '58'
  },
  { code: '33200', name: 'с.Акбулак', regionCode: '39', districtCode: '58' },
  { code: '37100', name: 'аул Дамды', regionCode: '39', districtCode: '58' },
  { code: '45100', name: 'с.Мереке', regionCode: '39', districtCode: '58' },
  { code: '45300', name: 'с.Кайга', regionCode: '39', districtCode: '58' },
  { code: '47100', name: 'с.Кожа', regionCode: '39', districtCode: '58' },
  { code: '49100', name: 'аул Уленды', regionCode: '39', districtCode: '58' },
  { code: '51100', name: 'с.Раздольное', regionCode: '39', districtCode: '58' },
  { code: '57100', name: 'с.Шолаксай', regionCode: '39', districtCode: '58' },
  { code: '59100', name: 'с.Шили', regionCode: '39', districtCode: '58' },
  { code: '30100', name: 'п.Сарыколь', regionCode: '39', districtCode: '62' },
  { code: '33100', name: 'с.Барвиновка', regionCode: '39', districtCode: '62' },
  {
    code: '33200',
    name: 'с.Новобарвиновка',
    regionCode: '39',
    districtCode: '62'
  },
  {
    code: '35100',
    name: 'с.Веселый Подол',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '35200', name: 'с.Ананьевка', regionCode: '39', districtCode: '62' },
  { code: '37100', name: 'с.Златоуст', regionCode: '39', districtCode: '62' },
  { code: '37200', name: 'с.Кунтимес', regionCode: '39', districtCode: '62' },
  {
    code: '39100',
    name: 'с.Комсомольское',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '39200', name: 'с.Косколь', regionCode: '39', districtCode: '62' },
  { code: '39300', name: 'с.Ленинское', regionCode: '39', districtCode: '62' },
  { code: '39400', name: 'с.Чапаевка', regionCode: '39', districtCode: '62' },
  { code: '43100', name: 'с.Новое', regionCode: '39', districtCode: '62' },
  { code: '43200', name: 'с.Караоба', regionCode: '39', districtCode: '62' },
  {
    code: '45100',
    name: 'с.Ленинградское',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '45200', name: 'с.Вишневка', regionCode: '39', districtCode: '62' },
  { code: '45400', name: 'с.Карашилик', regionCode: '39', districtCode: '62' },
  {
    code: '47100',
    name: 'с.Большие Дубравы',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '47300', name: 'с.Енбек', regionCode: '39', districtCode: '62' },
  { code: '47400', name: 'с.Ковалевка', regionCode: '39', districtCode: '62' },
  { code: '49100', name: 'с.Маяк', regionCode: '39', districtCode: '62' },
  { code: '49200', name: 'с.Басагаш', regionCode: '39', districtCode: '62' },
  {
    code: '53100',
    name: 'с.Севастополь',
    regionCode: '39',
    districtCode: '62'
  },
  { code: '53200', name: 'с.Дубинка', regionCode: '39', districtCode: '62' },
  { code: '55100', name: 'с.Сорочинка', regionCode: '39', districtCode: '62' },
  {
    code: '61300',
    name: 'Кирпичный завод',
    regionCode: '43',
    districtCode: '52'
  },
  { code: '61400', name: 'рзд.18', regionCode: '43', districtCode: '52' },
  { code: '61500', name: 'Ферма 2', regionCode: '43', districtCode: '52' },
  {
    code: '62100',
    name: 'а.Абдильда Тажибаева',
    regionCode: '43',
    districtCode: '52'
  },
  {
    code: '63100',
    name: 'с.Ш.Кодаманова',
    regionCode: '43',
    districtCode: '52'
  },
  { code: '67100', name: 'с.Ортакшыл', regionCode: '43', districtCode: '52' },
  { code: '67500', name: 'с.Кызылкаин', regionCode: '43', districtCode: '52' },
  { code: '43300', name: 'с.Шалкар', regionCode: '43', districtCode: '46' },
  { code: '45100', name: 'с.Торебай би', regionCode: '43', districtCode: '46' },
  { code: '53100', name: 'с.Иркольское', regionCode: '43', districtCode: '46' },
  {
    code: '55100',
    name: 'с.им.Комекбаева',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '55200', name: 'с.Кекирели', regionCode: '43', districtCode: '46' },
  {
    code: '55700',
    name: 'с.Шобанказган',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '57100', name: 'с.Абыла', regionCode: '43', districtCode: '46' },
  { code: '57300', name: 'с.Анаколь', regionCode: '43', districtCode: '46' },
  { code: '57400', name: 'с.Кызылтам', regionCode: '43', districtCode: '46' },
  { code: '59100', name: 'с.Куандария', regionCode: '43', districtCode: '46' },
  { code: '59200', name: 'с.Тургантамы', regionCode: '43', districtCode: '46' },
  { code: '63100', name: 'с.Торетам', regionCode: '43', districtCode: '46' },
  {
    code: '65100',
    name: 'с.3 интернационал',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '65200', name: 'с.Бирлик', regionCode: '43', districtCode: '46' },
  { code: '30100', name: 'с.Теренозек', regionCode: '43', districtCode: '48' },
  { code: '33100', name: 'с.Айдарлы', regionCode: '43', districtCode: '48' },
  { code: '35100', name: 'с.Акжарма', regionCode: '43', districtCode: '48' },
  { code: '37100', name: 'с.Амангельды', regionCode: '43', districtCode: '48' },
  { code: '39100', name: 'с.Бесарык', regionCode: '43', districtCode: '48' },
  { code: '41100', name: 'с.Жетиколь', regionCode: '43', districtCode: '48' },
  {
    code: '43100',
    name: 'с.им.H.Ильясова',
    regionCode: '43',
    districtCode: '48'
  },
  {
    code: '44100',
    name: 'с.им.Калжан Ахуна',
    regionCode: '43',
    districtCode: '48'
  },
  { code: '45100', name: 'с.Когалыколь', regionCode: '43', districtCode: '48' },
  { code: '46100', name: 'с.Малибаев', regionCode: '43', districtCode: '48' },
  { code: '47100', name: 'с.Сейфуллин', regionCode: '43', districtCode: '48' },
  {
    code: '49100',
    name: 'с.им.А.Токмаганбетова',
    regionCode: '43',
    districtCode: '48'
  },
  { code: '49200', name: 'рзд.8', regionCode: '43', districtCode: '48' },
  { code: '49300', name: 'рзд.9', regionCode: '43', districtCode: '48' },
  { code: '53100', name: 'с.Шаган', regionCode: '43', districtCode: '48' },
  { code: '55100', name: 'с.Ширкейли', regionCode: '43', districtCode: '48' },
  { code: '57100', name: 'с.Инкардарья', regionCode: '43', districtCode: '48' },
  { code: '30100', name: 'с.Шиели', regionCode: '43', districtCode: '52' },
  { code: '33100', name: 'с.Акмая', regionCode: '43', districtCode: '52' },
  { code: '33500', name: 'Полуказарма', regionCode: '43', districtCode: '52' },
  { code: '34100', name: 'с.Досбол би', regionCode: '43', districtCode: '52' },
  { code: '35100', name: 'с.Алмалы', regionCode: '43', districtCode: '52' },
  { code: '35400', name: 'с.Лесхоз', regionCode: '43', districtCode: '52' },
  { code: '35500', name: 'рзд.20', regionCode: '43', districtCode: '52' },
  { code: '35600', name: 'рзд.21', regionCode: '43', districtCode: '52' },
  { code: '37100', name: 'с.Байгекум', regionCode: '43', districtCode: '52' },
  { code: '38100', name: 'с.Бестам', regionCode: '43', districtCode: '52' },
  { code: '39100', name: 'с.Бидайколь', regionCode: '43', districtCode: '52' },
  { code: '39200', name: 'с.Актам', regionCode: '43', districtCode: '52' },
  { code: '39300', name: 'рзд.22', regionCode: '43', districtCode: '52' },
  { code: '41100', name: 'с.Байсын', regionCode: '43', districtCode: '52' },
  { code: '43100', name: 'с.Енбекши', regionCode: '43', districtCode: '52' },
  { code: '43200', name: 'с.Косуйенки', regionCode: '43', districtCode: '52' },
  { code: '44100', name: 'с.Жиделиарык', regionCode: '43', districtCode: '52' },
  { code: '45100', name: 'с.Жолек', regionCode: '43', districtCode: '52' },
  { code: '45200', name: 'с.Жуантобе', regionCode: '43', districtCode: '52' },
  { code: '47100', name: 'с.Алгабас', regionCode: '43', districtCode: '52' },
  {
    code: '49100',
    name: 'с.им.И.Жакаева',
    regionCode: '43',
    districtCode: '52'
  },
  { code: '49300', name: 'с.Жансеит', regionCode: '43', districtCode: '52' },
  {
    code: '53100',
    name: 'с.им.H.Бекежанова',
    regionCode: '43',
    districtCode: '52'
  },
  {
    code: '55100',
    name: 'с.Буланбайбауы',
    regionCode: '43',
    districtCode: '52'
  },
  { code: '56100', name: 'с.Майлытогай', regionCode: '43', districtCode: '52' },
  { code: '57100', name: 'с.Сулутюбе', regionCode: '43', districtCode: '52' },
  { code: '57200', name: 'с.1 Мамыр', regionCode: '43', districtCode: '52' },
  { code: '57300', name: 'с.Бирлестик', regionCode: '43', districtCode: '52' },
  { code: '57500', name: 'рзд.16', regionCode: '43', districtCode: '52' },
  { code: '58100', name: 'с.Ботабай', regionCode: '43', districtCode: '52' },
  { code: '59100', name: 'с.Бала би', regionCode: '43', districtCode: '52' },
  { code: '59200', name: 'рзд.19', regionCode: '43', districtCode: '52' },
  { code: '61100', name: 'с.Тартогай', regionCode: '43', districtCode: '52' },
  { code: '67100', name: 'а.Манап', regionCode: '43', districtCode: '40' },
  { code: '67500', name: 'ст.Талап', regionCode: '43', districtCode: '40' },
  { code: '23100', name: 'г.Казалинск', regionCode: '43', districtCode: '44' },
  { code: '30100', name: 'п.Айтеке би', regionCode: '43', districtCode: '44' },
  { code: '31100', name: 'с.Майдаколь', regionCode: '43', districtCode: '44' },
  { code: '32100', name: 'с.Туктибаев', regionCode: '43', districtCode: '44' },
  { code: '33100', name: 'с.Кожабахы', regionCode: '43', districtCode: '44' },
  { code: '33200', name: 'с.Аранды', regionCode: '43', districtCode: '44' },
  {
    code: '35100',
    name: 'с.им.Жанкожа батыра',
    regionCode: '43',
    districtCode: '44'
  },
  { code: '36100', name: 'с.Басыкара', regionCode: '43', districtCode: '44' },
  { code: '36700', name: 'рзд.98', regionCode: '43', districtCode: '44' },
  { code: '37100', name: 'с.Бозколь', regionCode: '43', districtCode: '44' },
  { code: '39100', name: 'с.Бирлик', regionCode: '43', districtCode: '44' },
  {
    code: '41100',
    name: 'с.Жалантос батыр',
    regionCode: '43',
    districtCode: '44'
  },
  { code: '41300', name: 'с.Водокачка', regionCode: '43', districtCode: '44' },
  { code: '41500', name: 'ст.Кубек', regionCode: '43', districtCode: '44' },
  { code: '41600', name: 'с.Уйрек', regionCode: '43', districtCode: '44' },
  {
    code: '42100',
    name: 'с.им.Актан батыра',
    regionCode: '43',
    districtCode: '44'
  },
  { code: '43100', name: 'с.Пиримов', regionCode: '43', districtCode: '44' },
  { code: '43180', name: 'рзд.Алтай', regionCode: '43', districtCode: '44' },
  { code: '43480', name: 'с.Кожаказган', regionCode: '43', districtCode: '44' },
  { code: '43600', name: 'с.Мадениет', regionCode: '43', districtCode: '44' },
  { code: '43780', name: 'рзд.Ойында', regionCode: '43', districtCode: '44' },
  { code: '43880', name: 'с.Тапа', regionCode: '43', districtCode: '44' },
  { code: '45100', name: 'с.Каукей', regionCode: '43', districtCode: '44' },
  { code: '45200', name: 'с.Ажар', regionCode: '43', districtCode: '44' },
  {
    code: '47100',
    name: 'с.Бекарыстан би',
    regionCode: '43',
    districtCode: '44'
  },
  { code: '49100', name: 'с.Аксуат', regionCode: '43', districtCode: '44' },
  { code: '49280', name: 'с.Майлыбас', regionCode: '43', districtCode: '44' },
  { code: '49300', name: 'с.Байкожа', regionCode: '43', districtCode: '44' },
  { code: '49380', name: 'с.Бирлик', regionCode: '43', districtCode: '44' },
  { code: '49680', name: 'рзд.99', regionCode: '43', districtCode: '44' },
  { code: '49800', name: 'рзд.102', regionCode: '43', districtCode: '44' },
  { code: '49900', name: 'рзд.103', regionCode: '43', districtCode: '44' },
  { code: '50100', name: 'с.Муратбаев', regionCode: '43', districtCode: '44' },
  { code: '50300', name: 'рзд.96 Кенес', regionCode: '43', districtCode: '44' },
  { code: '51100', name: 'с.Уркендеу', regionCode: '43', districtCode: '44' },
  { code: '53100', name: 'с.Сарбулак', regionCode: '43', districtCode: '44' },
  { code: '49100', name: 'с.Жаланаш', regionCode: '43', districtCode: '32' },
  { code: '49700', name: 'рзд.101', regionCode: '43', districtCode: '44' },
  { code: '53400', name: 'с.Сортубек', regionCode: '43', districtCode: '44' },
  { code: '55100', name: 'с.Абай', regionCode: '43', districtCode: '44' },
  { code: '55300', name: 'с.Жубан', regionCode: '43', districtCode: '44' },
  { code: '59100', name: 'с.Тасарык', regionCode: '43', districtCode: '44' },
  { code: '59400', name: 'с.Лакалы', regionCode: '43', districtCode: '44' },
  { code: '59700', name: 'с.Отгон', regionCode: '43', districtCode: '44' },
  { code: '65100', name: 'с.Шакен', regionCode: '43', districtCode: '44' },
  { code: '65400', name: 'с.Шили', regionCode: '43', districtCode: '44' },
  { code: '65500', name: 'с.Шолкум', regionCode: '43', districtCode: '44' },
  { code: '30100', name: 'с.Жосалы', regionCode: '43', districtCode: '46' },
  {
    code: '30200',
    name: 'ст.Дирментобе',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '30400', name: 'с.Кемесалган', regionCode: '43', districtCode: '46' },
  { code: '30600', name: 'ст.Коркыт', regionCode: '43', districtCode: '46' },
  { code: '30700', name: 'с.Ордазы', regionCode: '43', districtCode: '46' },
  {
    code: '30800',
    name: 'рзд.Сарытогай',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '30900', name: 'с.Шошкаколь', regionCode: '43', districtCode: '46' },
  { code: '33100', name: 'с.Акай', regionCode: '43', districtCode: '46' },
  { code: '35100', name: 'с.Акжар', regionCode: '43', districtCode: '46' },
  { code: '35200', name: 'с.Таншапагы', regionCode: '43', districtCode: '46' },
  { code: '37100', name: 'с.Актобе', regionCode: '43', districtCode: '46' },
  {
    code: '38100',
    name: 'с.им.Алдашбай Ахуна',
    regionCode: '43',
    districtCode: '46'
  },
  {
    code: '39100',
    name: 'с.Турмаганбет',
    regionCode: '43',
    districtCode: '46'
  },
  { code: '43100', name: 'с.Дур Онгар', regionCode: '43', districtCode: '46' },
  { code: '43200', name: 'с.Смаилтамы', regionCode: '43', districtCode: '46' },
  {
    code: '57600',
    name: 'рзд.82 Курылык',
    regionCode: '43',
    districtCode: '32'
  },
  {
    code: '57680',
    name: 'рзд.83 Тербенбес',
    regionCode: '43',
    districtCode: '32'
  },
  {
    code: '57700',
    name: 'рзд.84 Кумсагиз',
    regionCode: '43',
    districtCode: '32'
  },
  {
    code: '57800',
    name: 'рзд.85 Сарышыганак',
    regionCode: '43',
    districtCode: '32'
  },
  {
    code: '57900',
    name: 'рзд.86 Жалгызагаш',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '59100', name: 'ст.Сапак', regionCode: '43', districtCode: '32' },
  {
    code: '59300',
    name: 'рзд.87 Алтыкудык',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '59500', name: 'с.Коктем', regionCode: '43', districtCode: '32' },
  {
    code: '59700',
    name: 'рзд.88 Тасбогет',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '30100', name: 'с.Жалагаш', regionCode: '43', districtCode: '36' },
  { code: '33100', name: 'с.Аккум', regionCode: '43', districtCode: '36' },
  { code: '35100', name: 'с.Аккыр', regionCode: '43', districtCode: '36' },
  { code: '36100', name: 'с.Аксу', regionCode: '43', districtCode: '36' },
  { code: '37100', name: 'с.Аламесек', regionCode: '43', districtCode: '36' },
  {
    code: '39100',
    name: 'с.им.Бухарбай батыра',
    regionCode: '43',
    districtCode: '36'
  },
  { code: '43100', name: 'с.Енбек', regionCode: '43', districtCode: '36' },
  { code: '44100', name: 'с.Жанадарья', regionCode: '43', districtCode: '36' },
  { code: '45100', name: 'с.Каракеткен', regionCode: '43', districtCode: '36' },
  { code: '45300', name: 'с.Далдабай', regionCode: '43', districtCode: '36' },
  { code: '46100', name: 'с.Жанаталап', regionCode: '43', districtCode: '36' },
  { code: '47100', name: 'с.Макпалколь', regionCode: '43', districtCode: '36' },
  { code: '49100', name: 'с.Мадениет', regionCode: '43', districtCode: '36' },
  { code: '49300', name: 'с.Сатбай', regionCode: '43', districtCode: '36' },
  {
    code: '51100',
    name: 'с.Мырзабай ахуна',
    regionCode: '43',
    districtCode: '36'
  },
  { code: '53100', name: 'с.Тан', regionCode: '43', districtCode: '36' },
  { code: '53200', name: 'с.Жанаконыс', regionCode: '43', districtCode: '36' },
  { code: '55100', name: 'с.Шаменов', regionCode: '43', districtCode: '36' },
  { code: '30100', name: 'с.Жанакорган', regionCode: '43', districtCode: '40' },
  { code: '31100', name: 'с.Акжол', regionCode: '43', districtCode: '40' },
  { code: '33100', name: 'с.Тугискен', regionCode: '43', districtCode: '40' },
  { code: '35100', name: 'с.Бирлик', regionCode: '43', districtCode: '40' },
  { code: '37100', name: 'с.Байкенже', regionCode: '43', districtCode: '40' },
  { code: '37200', name: 'с.Билибай', regionCode: '43', districtCode: '40' },
  { code: '39100', name: 'с.Бесарык', regionCode: '43', districtCode: '40' },
  { code: '39200', name: 'с.Апанкак', regionCode: '43', districtCode: '40' },
  { code: '39400', name: 'с.Кенес', regionCode: '43', districtCode: '40' },
  { code: '40100', name: 'с.Екпинди', regionCode: '43', districtCode: '40' },
  { code: '41100', name: 'с.Жайылма', regionCode: '43', districtCode: '40' },
  { code: '42100', name: 'с.Жанарык', regionCode: '43', districtCode: '40' },
  { code: '43100', name: 'с.Кейден', regionCode: '43', districtCode: '40' },
  { code: '43200', name: 'с.Аккум', regionCode: '43', districtCode: '40' },
  { code: '43300', name: 'с.Кауык', regionCode: '43', districtCode: '40' },
  { code: '45100', name: 'с.Келинтобе', regionCode: '43', districtCode: '40' },
  { code: '46100', name: 'с.Коктобе', regionCode: '43', districtCode: '40' },
  { code: '47100', name: 'с.Кандоз', regionCode: '43', districtCode: '40' },
  { code: '47300', name: 'с.Калгансыр', regionCode: '43', districtCode: '40' },
  { code: '47400', name: 'с.Кашканколь', regionCode: '43', districtCode: '40' },
  { code: '49100', name: 'с.Баспакколь', regionCode: '43', districtCode: '40' },
  { code: '51100', name: 'с.Кожамберди', regionCode: '43', districtCode: '40' },
  { code: '53100', name: 'с.Кожакент', regionCode: '43', districtCode: '40' },
  { code: '54100', name: 'с.Косуйенки', regionCode: '43', districtCode: '40' },
  { code: '55100', name: 'с.Абдигаппар', regionCode: '43', districtCode: '40' },
  { code: '55500', name: 'с.Корасан', regionCode: '43', districtCode: '40' },
  {
    code: '56100',
    name: 'с.Кызылмакташы',
    regionCode: '43',
    districtCode: '40'
  },
  { code: '57100', name: 'с.Озгент', regionCode: '43', districtCode: '40' },
  { code: '57300', name: 'с.Аксуат', regionCode: '43', districtCode: '40' },
  { code: '59100', name: 'с.Сунаката', regionCode: '43', districtCode: '40' },
  { code: '59200', name: 'с.Енбек', regionCode: '43', districtCode: '40' },
  { code: '61100', name: 'с.Такырколь', regionCode: '43', districtCode: '40' },
  { code: '62100', name: 'ст.Бесарык', regionCode: '43', districtCode: '40' },
  { code: '62600', name: 'рзд.Сатымсай', regionCode: '43', districtCode: '40' },
  { code: '63100', name: 'с.Томенарык', regionCode: '43', districtCode: '40' },
  { code: '65100', name: 'с.Шалкия', regionCode: '43', districtCode: '40' },
  { code: '65300', name: 'с.Куттыкожа', regionCode: '43', districtCode: '40' },
  { code: '2', name: 'с.Акжарма', regionCode: '43', districtCode: '43' },
  { code: '3', name: 'с.Калгандарья', regionCode: '43', districtCode: '43' },
  { code: '4', name: 'с.Кубас', regionCode: '43', districtCode: '43' },
  { code: '5', name: 'с.Талдыарал', regionCode: '43', districtCode: '43' },
  { code: '6', name: 'с.Махамбетова', regionCode: '43', districtCode: '43' },
  { code: '7', name: 'п.Белколь', regionCode: '43', districtCode: '43' },
  { code: '8', name: 'с.Бирказан', regionCode: '43', districtCode: '43' },
  { code: '9', name: 'с.Караултобе', regionCode: '43', districtCode: '43' },
  { code: '10', name: 'с.Кызылжарма', regionCode: '43', districtCode: '43' },
  { code: '11', name: 'с.Караозек', regionCode: '43', districtCode: '43' },
  { code: '12', name: 'с.Айнаколь', regionCode: '43', districtCode: '43' },
  { code: '13', name: 'ст.Караозек', regionCode: '43', districtCode: '43' },
  { code: '14', name: 'п.Тасбугет', regionCode: '43', districtCode: '43' },
  { code: '15', name: 'с.Ирколь', regionCode: '43', districtCode: '43' },
  { code: '10100', name: 'г.Кызылорда', regionCode: '43', districtCode: '1' },
  { code: '19100', name: 'г.Байконыр', regionCode: '43', districtCode: '2' },
  { code: '20100', name: 'г.Аральск', regionCode: '43', districtCode: '32' },
  { code: '31100', name: 'с.Акбай', regionCode: '43', districtCode: '32' },
  { code: '32100', name: 'с.Жинишкекум', regionCode: '43', districtCode: '32' },
  { code: '32200', name: 'с.Атанши', regionCode: '43', districtCode: '32' },
  { code: '33100', name: 'с.Аманоткель', regionCode: '43', districtCode: '32' },
  { code: '33300', name: 'с.Аккулак', regionCode: '43', districtCode: '32' },
  { code: '33400', name: 'с.Акшатау', regionCode: '43', districtCode: '32' },
  { code: '33700', name: 'с.Хан', regionCode: '43', districtCode: '32' },
  { code: '34100', name: 'ст.Аралкум', regionCode: '43', districtCode: '32' },
  { code: '34400', name: 'с.Мойнак', regionCode: '43', districtCode: '32' },
  { code: '34700', name: 'ст.Шомиш', regionCode: '43', districtCode: '32' },
  { code: '35100', name: 'с.Боген', regionCode: '43', districtCode: '32' },
  { code: '35200', name: 'с.Коне Боген', regionCode: '43', districtCode: '32' },
  { code: '35300', name: 'с.Карашалан', regionCode: '43', districtCode: '32' },
  {
    code: '36100',
    name: 'с.Жанакурылыс',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '37100', name: 'с.Жаксыкылыш', regionCode: '43', districtCode: '32' },
  { code: '38100', name: 'ст.Бекбауыл', regionCode: '43', districtCode: '32' },
  { code: '38500', name: 'с.Кумбазар', regionCode: '43', districtCode: '32' },
  {
    code: '38700',
    name: 'рзд.93 Укулисай',
    regionCode: '43',
    districtCode: '32'
  },
  {
    code: '39100',
    name: 'ст.Камыстыбас',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '39800', name: 'рзд.91', regionCode: '43', districtCode: '32' },
  { code: '39880', name: 'рзд.92', regionCode: '43', districtCode: '32' },
  { code: '41100', name: 'с.Токабай', regionCode: '43', districtCode: '32' },
  { code: '42100', name: 'с.Раим', regionCode: '43', districtCode: '32' },
  { code: '42300', name: 'с.Водокачка', regionCode: '43', districtCode: '32' },
  { code: '42500', name: 'с.Ескиура', regionCode: '43', districtCode: '32' },
  { code: '43100', name: 'с.Абай', regionCode: '43', districtCode: '32' },
  {
    code: '43300',
    name: 'с.Еримбетжага',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '43500', name: 'с.Кокаша', regionCode: '43', districtCode: '32' },
  { code: '44100', name: 'с.Куланды', regionCode: '43', districtCode: '32' },
  { code: '45100', name: 'с.Каратерен', regionCode: '43', districtCode: '32' },
  { code: '45200', name: 'с.Колжага', regionCode: '43', districtCode: '32' },
  { code: '45300', name: 'с.Жанаконыс', regionCode: '43', districtCode: '32' },
  { code: '45400', name: 'с.Тастак', regionCode: '43', districtCode: '32' },
  { code: '46100', name: 'с.Косаман', regionCode: '43', districtCode: '32' },
  { code: '46200', name: 'с.Акеспе', regionCode: '43', districtCode: '32' },
  { code: '46300', name: 'с.Бердыколь', regionCode: '43', districtCode: '32' },
  { code: '47100', name: 'с.Акбасты', regionCode: '43', districtCode: '32' },
  { code: '48100', name: 'с.Косжар', regionCode: '43', districtCode: '32' },
  { code: '49200', name: 'с.Тастубек', regionCode: '43', districtCode: '32' },
  { code: '53100', name: 'с.Шижага', regionCode: '43', districtCode: '32' },
  { code: '53300', name: 'с.Куршек', regionCode: '43', districtCode: '32' },
  { code: '55100', name: 'с.Кызылжар', regionCode: '43', districtCode: '32' },
  { code: '55600', name: 'с.Шомишколь', regionCode: '43', districtCode: '32' },
  { code: '56100', name: 'с.Сазды', regionCode: '43', districtCode: '32' },
  {
    code: '57100',
    name: 'с.Саксаульский',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '57400', name: 'ст.Конту', regionCode: '43', districtCode: '32' },
  {
    code: '57580',
    name: 'Куландинский конный завод',
    regionCode: '43',
    districtCode: '32'
  },
  { code: '3', name: 'с.Кызылсай', regionCode: '47', districtCode: '47' },
  { code: '42000', name: 'с.Батыр', regionCode: '47', districtCode: '50' },
  { code: '35100', name: 'с.Болашак', regionCode: '47', districtCode: '42' },
  { code: '39100', name: 'с.Боранкул', regionCode: '47', districtCode: '36' },
  {
    code: '475220100',
    name: 'Форт-Шевченко',
    regionCode: '47',
    districtCode: '52'
  },
  { code: '10100', name: 'г.Актау', regionCode: '47', districtCode: '1' },
  { code: '18100', name: 'г.Жанаозен', regionCode: '47', districtCode: '2' },
  { code: '30100', name: 'с.Бейнеу', regionCode: '47', districtCode: '36' },
  { code: '33100', name: 'с.Акжигит', regionCode: '47', districtCode: '36' },
  { code: '37100', name: 'с.Сарга', regionCode: '47', districtCode: '36' },
  { code: '41100', name: 'с.Коркол', regionCode: '47', districtCode: '36' },
  { code: '42100', name: 'с.Hогайты', regionCode: '47', districtCode: '36' },
  { code: '43100', name: 'с.Сынгырлау', regionCode: '47', districtCode: '36' },
  { code: '44100', name: 'с.Кызыласкер', regionCode: '47', districtCode: '36' },
  { code: '45100', name: 'с.Толеп', regionCode: '47', districtCode: '36' },
  { code: '46100', name: 'аул Тажен', regionCode: '47', districtCode: '36' },
  { code: '47100', name: 'с.Турыш', regionCode: '47', districtCode: '36' },
  { code: '30100', name: 'с.Курык', regionCode: '47', districtCode: '42' },
  { code: '33100', name: 'с.Бостан', regionCode: '47', districtCode: '42' },
  { code: '33200', name: 'с.Бостанкум', regionCode: '47', districtCode: '42' },
  { code: '33400', name: 'с.Кызылсу', regionCode: '47', districtCode: '42' },
  { code: '39100', name: 'п.Жетыбай', regionCode: '47', districtCode: '42' },
  { code: '41100', name: 'с.Куланды', regionCode: '47', districtCode: '42' },
  { code: '41200', name: 'с.Толеп', regionCode: '47', districtCode: '42' },
  { code: '45100', name: 'п.Мунайшы', regionCode: '47', districtCode: '42' },
  { code: '49100', name: 'с.Сенек', regionCode: '47', districtCode: '42' },
  { code: '49200', name: 'с.Аккудук', regionCode: '47', districtCode: '42' },
  { code: '30100', name: 'с.Шетпе', regionCode: '47', districtCode: '46' },
  { code: '33100', name: 'с.Уштаган', regionCode: '47', districtCode: '46' },
  { code: '33200', name: 'с.Жарма', regionCode: '47', districtCode: '46' },
  { code: '33300', name: 'с.Сазды', regionCode: '47', districtCode: '46' },
  { code: '34100', name: 'с.Акшимирау', regionCode: '47', districtCode: '46' },
  { code: '35100', name: 'с.Жармыш', regionCode: '47', districtCode: '46' },
  { code: '37100', name: 'с.Жынгылды', regionCode: '47', districtCode: '46' },
  { code: '39100', name: 'с.Кызан', regionCode: '47', districtCode: '46' },
  { code: '43100', name: 'с.Онды', regionCode: '47', districtCode: '46' },
  { code: '43200', name: 'с.Баскудук', regionCode: '47', districtCode: '46' },
  { code: '43300', name: 'с.Беки', regionCode: '47', districtCode: '46' },
  { code: '44100', name: 'с.Тущыбек', regionCode: '47', districtCode: '46' },
  { code: '44200', name: 'с.15 бекет', regionCode: '47', districtCode: '46' },
  { code: '45100', name: 'с.Сайотес', regionCode: '47', districtCode: '46' },
  { code: '45400', name: 'с.Боздак', regionCode: '47', districtCode: '46' },
  { code: '47100', name: 'с.Тущыкудук', regionCode: '47', districtCode: '46' },
  { code: '47200', name: 'с.Киякты', regionCode: '47', districtCode: '46' },
  { code: '49100', name: 'с.Шайыр', regionCode: '47', districtCode: '46' },
  { code: '49200', name: 'с.Тасмурын', regionCode: '47', districtCode: '46' },
  { code: '49300', name: 'с.Тиген', regionCode: '47', districtCode: '46' },
  { code: '51100', name: 'с.Шебир', regionCode: '47', districtCode: '46' },
  { code: '30100', name: 'с.Мангистау', regionCode: '47', districtCode: '50' },
  { code: '32100', name: 'с.Атамекен', regionCode: '47', districtCode: '50' },
  { code: '34100', name: 'с.Баскудук', regionCode: '47', districtCode: '50' },
  { code: '36100', name: 'с.Баянды', regionCode: '47', districtCode: '50' },
  { code: '38100', name: 'с.Даулет', regionCode: '47', districtCode: '50' },
  { code: '40100', name: 'с.Кызылтобе', regionCode: '47', districtCode: '50' },
  { code: '40200', name: 'с.Бирлик', regionCode: '47', districtCode: '50' },
  { code: '33100', name: 'с.Акшукур', regionCode: '47', districtCode: '52' },
  { code: '35100', name: 'п.Баутино', regionCode: '47', districtCode: '52' },
  { code: '37100', name: 'с.Кызылозен', regionCode: '47', districtCode: '52' },
  {
    code: '38100',
    name: 'с.Саина Шапагатова',
    regionCode: '47',
    districtCode: '52'
  },
  { code: '39100', name: 'с.Таушык', regionCode: '47', districtCode: '52' },
  { code: '39200', name: 'с.Балтасап', regionCode: '55', districtCode: '32' },
  { code: '39300', name: 'с.Карасу', regionCode: '55', districtCode: '32' },
  { code: '41100', name: 'с.Жолболды', regionCode: '55', districtCode: '32' },
  { code: '41200', name: 'с.Шиликты', regionCode: '55', districtCode: '32' },
  { code: '41300', name: 'с.Шуга', regionCode: '55', districtCode: '32' },
  { code: '43100', name: 'с.Караоба', regionCode: '55', districtCode: '32' },
  { code: '43200', name: 'с.Есентерек', regionCode: '55', districtCode: '32' },
  { code: '43300', name: 'с.Жанааул', regionCode: '55', districtCode: '32' },
  {
    code: '43400',
    name: 'с.Красная Поляна',
    regionCode: '55',
    districtCode: '32'
  },
  { code: '43500', name: 'с.Спартак', regionCode: '55', districtCode: '32' },
  { code: '45100', name: 'с.Баскамыс', regionCode: '55', districtCode: '32' },
  { code: '45300', name: 'с.Каракога', regionCode: '55', districtCode: '32' },
  { code: '47100', name: 'с.Кожамжар', regionCode: '55', districtCode: '32' },
  { code: '47200', name: 'с.Жамбыл', regionCode: '55', districtCode: '32' },
  { code: '47300', name: 'с.Кайран', regionCode: '55', districtCode: '32' },
  { code: '47400', name: 'с.Караой', regionCode: '55', districtCode: '32' },
  { code: '49100', name: 'с.Муткенова', regionCode: '55', districtCode: '32' },
  { code: '49200', name: 'с.Абжан', regionCode: '55', districtCode: '32' },
  { code: '49300', name: 'с.Жанатап', regionCode: '55', districtCode: '32' },
  { code: '49400', name: 'с.Жанабет', regionCode: '55', districtCode: '32' },
  { code: '49500', name: 'с.Естая', regionCode: '55', districtCode: '32' },
  { code: '49600', name: 'с.Шокпар', regionCode: '55', districtCode: '32' },
  {
    code: '53100',
    name: 'с.Приреченское',
    regionCode: '55',
    districtCode: '32'
  },
  { code: '53200', name: 'с.Жоламан', regionCode: '55', districtCode: '32' },
  { code: '53300', name: 'с.Камбар', regionCode: '55', districtCode: '32' },
  { code: '53500', name: 'с.Тортай', regionCode: '55', districtCode: '32' },
  {
    code: '55100',
    name: 'с.Андриановка',
    regionCode: '55',
    districtCode: '32'
  },
  { code: '55200', name: 'с.Разумовка', regionCode: '55', districtCode: '32' },
  { code: '57100', name: 'с.Харьковка', regionCode: '55', districtCode: '32' },
  { code: '57200', name: 'с.Карабузау', regionCode: '55', districtCode: '32' },
  { code: '59100', name: 'с.Шолаксор', regionCode: '55', districtCode: '32' },
  { code: '35300', name: 'с.Травянка', regionCode: '55', districtCode: '64' },
  { code: '37100', name: 'с.Ковалевка', regionCode: '55', districtCode: '64' },
  { code: '39100', name: 'с.Каратай', regionCode: '55', districtCode: '64' },
  { code: '43100', name: 'с.Лозовое', regionCode: '55', districtCode: '64' },
  {
    code: '43200',
    name: 'с.Екатеринославка',
    regionCode: '55',
    districtCode: '64'
  },
  { code: '45100', name: 'с.Hадаровка', regionCode: '55', districtCode: '64' },
  { code: '45300', name: 'с.Вознесенка', regionCode: '55', districtCode: '64' },
  { code: '45700', name: 'с.Чистополь', regionCode: '55', districtCode: '64' },
  { code: '47100', name: 'с.Галицкое', regionCode: '55', districtCode: '64' },
  {
    code: '47300',
    name: 'с.Hовопокровка',
    regionCode: '55',
    districtCode: '64'
  },
  { code: '49100', name: 'с.Ольгино', regionCode: '55', districtCode: '64' },
  { code: '49400', name: 'с.Ольховка', regionCode: '55', districtCode: '64' },
  { code: '53100', name: 'с.Коныр Озек', regionCode: '55', districtCode: '64' },
  { code: '53200', name: 'с.Дмитриевка', regionCode: '55', districtCode: '64' },
  {
    code: '55100',
    name: 'с.Константиновка',
    regionCode: '55',
    districtCode: '64'
  },
  { code: '55200', name: 'с.Равнополь', regionCode: '55', districtCode: '64' },
  { code: '57100', name: 'с.Таволжан', regionCode: '55', districtCode: '64' },
  { code: '59100', name: 'с.Тимирязево', regionCode: '55', districtCode: '64' },
  { code: '67700', name: 'с.Чушкалы', regionCode: '55', districtCode: '68' },
  { code: '30100', name: 'с.Шарбакты', regionCode: '55', districtCode: '68' },
  {
    code: '33100',
    name: 'с.Александровка',
    regionCode: '55',
    districtCode: '68'
  },
  { code: '33200', name: 'с.Жанааул', regionCode: '55', districtCode: '68' },
  { code: '35100', name: 'с.Алексеевка', regionCode: '55', districtCode: '68' },
  { code: '35200', name: 'с.Hиколаевка', regionCode: '55', districtCode: '68' },
  { code: '35300', name: 'с.Куркамыс', regionCode: '55', districtCode: '68' },
  { code: '35400', name: 'с. Бҙріктал', regionCode: '55', districtCode: '68' },
  { code: '37100', name: 'с.Галкино', regionCode: '55', districtCode: '68' },
  { code: '37200', name: 'с.Арбигень', regionCode: '55', districtCode: '68' },
  { code: '37300', name: 'с.Ботабас', regionCode: '55', districtCode: '68' },
  { code: '37400', name: 'с.Кулат', regionCode: '55', districtCode: '68' },
  { code: '39100', name: 'с.Жылыбулак', regionCode: '55', districtCode: '68' },
  { code: '39300', name: 'с.Коскудук', regionCode: '55', districtCode: '68' },
  {
    code: '43100',
    name: 'с.Богодаровка',
    regionCode: '55',
    districtCode: '68'
  },
  { code: '43200', name: 'с.Аникино', regionCode: '55', districtCode: '68' },
  { code: '45100', name: 'с.Красиловка', regionCode: '55', districtCode: '68' },
  { code: '47100', name: 'с.Сахновка', regionCode: '55', districtCode: '68' },
  { code: '47200', name: 'с.Марьяновка', regionCode: '55', districtCode: '68' },
  { code: '49100', name: 'с.Hазаровка', regionCode: '55', districtCode: '68' },
  { code: '49200', name: 'с.Каховка', regionCode: '55', districtCode: '68' },
  { code: '53100', name: 'с.Орловка', regionCode: '55', districtCode: '68' },
  { code: '55100', name: 'с.Сынтас', regionCode: '55', districtCode: '68' },
  { code: '57100', name: 'с.Сосновка', regionCode: '55', districtCode: '68' },
  { code: '57400', name: 'с.Заборовка', regionCode: '55', districtCode: '68' },
  { code: '57600', name: 'с.Сретенка', regionCode: '55', districtCode: '68' },
  { code: '57700', name: 'с.Софиевка', regionCode: '55', districtCode: '68' },
  { code: '59100', name: 'с.Татьяновка', regionCode: '55', districtCode: '68' },
  { code: '59300', name: 'с.Малиновка', regionCode: '55', districtCode: '68' },
  {
    code: '63100',
    name: 'с.Хмельницкое',
    regionCode: '55',
    districtCode: '68'
  },
  { code: '63200', name: 'с.Кольбулак', regionCode: '55', districtCode: '68' },
  { code: '63300', name: 'ст.Маралды', regionCode: '55', districtCode: '68' },
  {
    code: '65100',
    name: 'с.Чигириновка',
    regionCode: '55',
    districtCode: '68'
  },
  { code: '65200', name: 'с.Есильбай', regionCode: '55', districtCode: '68' },
  { code: '67100', name: 'с.Шалдай', regionCode: '55', districtCode: '68' },
  { code: '67200', name: 'с.Бозалан', regionCode: '55', districtCode: '68' },
  { code: '67300', name: 'с.Садыкащи', regionCode: '55', districtCode: '68' },
  { code: '67400', name: 'с.Сугур', regionCode: '55', districtCode: '68' },
  { code: '10100', name: 'г.Павлодар', regionCode: '55', districtCode: '1' },
  { code: '16100', name: 'г.Аксу', regionCode: '55', districtCode: '2' },
  { code: '22100', name: 'г.Экибастуз', regionCode: '55', districtCode: '3' },
  { code: '30100', name: 'с.Актогай', regionCode: '55', districtCode: '32' },
  { code: '35100', name: 'с.Ауельбек', regionCode: '55', districtCode: '32' },
  { code: '35300', name: 'с.Утес', regionCode: '55', districtCode: '32' },
  { code: '37100', name: 'с.Барлыбай', regionCode: '55', districtCode: '32' },
  { code: '39100', name: 'с.Ивановка', regionCode: '55', districtCode: '32' },
  {
    code: '33100',
    name: 'с.Большой Акжар',
    regionCode: '55',
    districtCode: '56'
  },
  {
    code: '35100',
    name: 'с.Жана Акшиман',
    regionCode: '55',
    districtCode: '56'
  },
  { code: '37100', name: 'с.Басколь', regionCode: '55', districtCode: '56' },
  { code: '37200', name: 'с.Бозша', regionCode: '55', districtCode: '56' },
  { code: '37300', name: 'с.Жанатлек', regionCode: '55', districtCode: '56' },
  { code: '39100', name: 'с.Кентубек', regionCode: '55', districtCode: '56' },
  { code: '39200', name: 'ферма 1', regionCode: '55', districtCode: '56' },
  { code: '39400', name: 'ферма 3', regionCode: '55', districtCode: '56' },
  { code: '43100', name: 'с.Жумыскер', regionCode: '55', districtCode: '56' },
  { code: '43300', name: 'с.Кызыленбек', regionCode: '55', districtCode: '56' },
  { code: '45100', name: 'с.Каратерек', regionCode: '55', districtCode: '56' },
  {
    code: '45200',
    name: 'с.Орджоникидзе',
    regionCode: '55',
    districtCode: '56'
  },
  { code: '45300', name: 'Отд. 8 Марта', regionCode: '55', districtCode: '56' },
  { code: '47100', name: 'с.Майское', regionCode: '55', districtCode: '56' },
  { code: '47200', name: 'с.Енбекши', regionCode: '55', districtCode: '56' },
  { code: '49100', name: 'с.Майтубек', regionCode: '55', districtCode: '56' },
  { code: '51100', name: 'с.Малайсары', regionCode: '55', districtCode: '56' },
  { code: '51200', name: 'ферма 1', regionCode: '55', districtCode: '56' },
  { code: '51300', name: 'ферма 2', regionCode: '55', districtCode: '56' },
  { code: '53100', name: 'с.Саты', regionCode: '55', districtCode: '56' },
  {
    code: '53300',
    name: 'с.Кызылоктябрь',
    regionCode: '55',
    districtCode: '56'
  },
  { code: '31100', name: 'с.Пресное', regionCode: '55', districtCode: '60' },
  { code: '35100', name: 'с.Hабережное', regionCode: '55', districtCode: '60' },
  { code: '35200', name: 'с.Жана кала', regionCode: '55', districtCode: '60' },
  { code: '37100', name: 'с.Ефремовка', regionCode: '55', districtCode: '60' },
  { code: '37200', name: 'с.Даниловка', regionCode: '55', districtCode: '60' },
  { code: '39100', name: 'с.Жетекши', regionCode: '55', districtCode: '60' },
  { code: '43100', name: 'с.Зангар', regionCode: '55', districtCode: '60' },
  { code: '43400', name: 'с.Коряковка', regionCode: '55', districtCode: '60' },
  { code: '45100', name: 'с.Заря', regionCode: '55', districtCode: '60' },
  { code: '45200', name: 'с.Бирлик', regionCode: '55', districtCode: '60' },
  { code: '45300', name: 'с.Жертумсык', regionCode: '55', districtCode: '60' },
  { code: '45400', name: 'с.Подстепное', regionCode: '55', districtCode: '60' },
  {
    code: '47100',
    name: 'с.Hовоямышево',
    regionCode: '55',
    districtCode: '60'
  },
  {
    code: '47200',
    name: 'с.Айтім ауылы',
    regionCode: '55',
    districtCode: '60'
  },
  { code: '47300', name: 'с.Каратогай', regionCode: '55', districtCode: '60' },
  {
    code: '49100',
    name: 'с.Красноармейка',
    regionCode: '55',
    districtCode: '60'
  },
  {
    code: '49300',
    name: 'ст.Красноармейка',
    regionCode: '55',
    districtCode: '60'
  },
  { code: '49400', name: 'с.Шанды', regionCode: '55', districtCode: '60' },
  { code: '53100', name: 'с.Луганск', regionCode: '55', districtCode: '60' },
  { code: '53200', name: 'с.Богдановка', regionCode: '55', districtCode: '60' },
  { code: '53300', name: 'с.Аккудык', regionCode: '55', districtCode: '60' },
  { code: '55100', name: 'с.Мичурино', regionCode: '55', districtCode: '60' },
  {
    code: '55200',
    name: 'с.Госплемстанция',
    regionCode: '55',
    districtCode: '60'
  },
  { code: '55300', name: 'с.Березовка', regionCode: '55', districtCode: '60' },
  { code: '57100', name: 'с.Ольгинка', regionCode: '55', districtCode: '60' },
  { code: '59100', name: 'с.Розовка', regionCode: '55', districtCode: '60' },
  {
    code: '59200',
    name: 'с.Рождественка',
    regionCode: '55',
    districtCode: '60'
  },
  { code: '59300', name: 'с.Максимовка', regionCode: '55', districtCode: '60' },
  { code: '63100', name: 'с.Маралды', regionCode: '55', districtCode: '60' },
  { code: '65100', name: 'с.Чернорецк', regionCode: '55', districtCode: '60' },
  { code: '65200', name: 'с.Достык', regionCode: '55', districtCode: '60' },
  { code: '65300', name: 'с.Караколь', regionCode: '55', districtCode: '60' },
  {
    code: '67100',
    name: 'с.Hовочерноярка',
    regionCode: '55',
    districtCode: '60'
  },
  { code: '67200', name: 'с.Сычевка', regionCode: '55', districtCode: '60' },
  { code: '67300', name: 'с.Черноярка', regionCode: '55', districtCode: '60' },
  { code: '69100', name: 'с.Шакат', regionCode: '55', districtCode: '60' },
  { code: '69200', name: 'с.Заозерный', regionCode: '55', districtCode: '60' },
  { code: '69300', name: 'с.Коктобе', regionCode: '55', districtCode: '60' },
  { code: '69400', name: 'с.Толубай', regionCode: '55', districtCode: '60' },
  { code: '30100', name: 'с.Успенка', regionCode: '55', districtCode: '64' },
  { code: '30200', name: 'с.Белоусовка', regionCode: '55', districtCode: '64' },
  { code: '33100', name: 'с.Богатырь', regionCode: '55', districtCode: '64' },
  { code: '35100', name: 'с.Козыкеткен', regionCode: '55', districtCode: '64' },
  {
    code: '35200',
    name: 'с.Зеленая Роща',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '35300', name: 'с.Луговое', regionCode: '55', districtCode: '48' },
  { code: '35400', name: 'с.Осьмерыжск', regionCode: '55', districtCode: '48' },
  {
    code: '35500',
    name: 'с.Тихомировка',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '37100', name: 'с.Березовка', regionCode: '55', districtCode: '48' },
  { code: '37200', name: 'с.Маймасор', regionCode: '55', districtCode: '48' },
  {
    code: '37300',
    name: 'с.Малые Березняки',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '39100', name: 'с.Жанабет', regionCode: '55', districtCode: '48' },
  { code: '39200', name: 'с.Боброво', regionCode: '55', districtCode: '48' },
  { code: '39300', name: 'с.Жаскайрат', regionCode: '55', districtCode: '48' },
  { code: '43100', name: 'с.Львовка', regionCode: '55', districtCode: '48' },
  { code: '43200', name: 'с.Тимофеевка', regionCode: '55', districtCode: '48' },
  {
    code: '45100',
    name: 'с.Воскресенка',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '47100', name: 'с.Трофимовка', regionCode: '55', districtCode: '48' },
  { code: '47200', name: 'с.Жанакурлыс', regionCode: '55', districtCode: '48' },
  { code: '47300', name: 'с.Пахомовка', regionCode: '55', districtCode: '48' },
  { code: '47400', name: 'с.Покровка', regionCode: '55', districtCode: '48' },
  { code: '47500', name: 'с.Тегистик', regionCode: '55', districtCode: '48' },
  { code: '49100', name: 'с.Ивановка', regionCode: '55', districtCode: '48' },
  {
    code: '49200',
    name: 'с.Hовоспасовка',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '53100', name: 'с.Калиновка', regionCode: '55', districtCode: '48' },
  { code: '53200', name: 'с.Каратал', regionCode: '55', districtCode: '48' },
  { code: '53300', name: 'с.Кызылдау', regionCode: '55', districtCode: '48' },
  {
    code: '55100',
    name: 'с.Фрументьевка',
    regionCode: '55',
    districtCode: '48'
  },
  {
    code: '59100',
    name: 'с.Октябрьское',
    regionCode: '55',
    districtCode: '48'
  },
  {
    code: '59200',
    name: 'с.Благовещенка',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '59300', name: 'с.Лесное', regionCode: '55', districtCode: '48' },
  { code: '59400', name: 'с.Мотогул', regionCode: '55', districtCode: '48' },
  {
    code: '59500',
    name: 'с.Первомайское',
    regionCode: '55',
    districtCode: '48'
  },
  { code: '63100', name: 'с.Песчаное', regionCode: '55', districtCode: '48' },
  { code: '63300', name: 'с.Карасук', regionCode: '55', districtCode: '48' },
  { code: '63400', name: 'с.Песчанский', regionCode: '55', districtCode: '48' },
  { code: '65100', name: 'с.Федоровка', regionCode: '55', districtCode: '48' },
  { code: '65200', name: 'с.Воронцовка', regionCode: '55', districtCode: '48' },
  { code: '65300', name: 'с.Конторка', regionCode: '55', districtCode: '48' },
  { code: '30100', name: 'а.Акку', regionCode: '55', districtCode: '52' },
  {
    code: '35100',
    name: 'с.им.Абылхаира Баймульдина',
    regionCode: '55',
    districtCode: '52'
  },
  { code: '35200', name: 'с.Такыр', regionCode: '55', districtCode: '52' },
  { code: '35300', name: 'с.Теренколь', regionCode: '55', districtCode: '52' },
  { code: '39100', name: 'с.Жамбыл', regionCode: '55', districtCode: '52' },
  { code: '39200', name: 'с.Жанатан', regionCode: '55', districtCode: '52' },
  { code: '39300', name: 'с.Айтей', regionCode: '55', districtCode: '52' },
  { code: '39400', name: 'с.Широкое', regionCode: '55', districtCode: '52' },
  { code: '43100', name: 'с.Казы', regionCode: '55', districtCode: '52' },
  { code: '45100', name: 'с.Бескарагай', regionCode: '55', districtCode: '52' },
  { code: '47100', name: 'с.Черное', regionCode: '55', districtCode: '52' },
  { code: '47200', name: 'с.Кумсуат', regionCode: '55', districtCode: '52' },
  { code: '47300', name: 'с.Шамши', regionCode: '55', districtCode: '52' },
  { code: '47400', name: 'с.Шабар', regionCode: '55', districtCode: '52' },
  { code: '53100', name: 'с.Майкарагай', regionCode: '55', districtCode: '52' },
  { code: '53400', name: 'с.Мергалым', regionCode: '55', districtCode: '52' },
  { code: '55100', name: 'с.Малыбай', regionCode: '55', districtCode: '52' },
  { code: '55200', name: 'с.Казантай', regionCode: '55', districtCode: '52' },
  { code: '57100', name: 'с.Шака', regionCode: '55', districtCode: '52' },
  { code: '57200', name: 'с.Баимбет', regionCode: '55', districtCode: '52' },
  { code: '57500', name: 'с.Шоктал', regionCode: '55', districtCode: '52' },
  { code: '59100', name: 'с.Шарбакты', regionCode: '55', districtCode: '52' },
  { code: '59180', name: 'с.Жабаглы', regionCode: '55', districtCode: '52' },
  { code: '59200', name: 'с.Тосагаш', regionCode: '55', districtCode: '52' },
  { code: '63100', name: 'с.Ямышево', regionCode: '55', districtCode: '52' },
  { code: '63300', name: 'с.Кызылкогам', regionCode: '55', districtCode: '52' },
  { code: '63400', name: 'с.Тлектес', regionCode: '55', districtCode: '52' },
  { code: '30100', name: 'с.Коктюбе', regionCode: '55', districtCode: '56' },
  {
    code: '30200',
    name: 'Белогорский ХПП',
    regionCode: '55',
    districtCode: '56'
  },
  { code: '43200', name: 'с.Обозное', regionCode: '55', districtCode: '42' },
  {
    code: '47100',
    name: 'с.Жана жулдыз',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '47200', name: 'с.Ескара', regionCode: '55', districtCode: '42' },
  { code: '47300', name: 'с.Екишек', regionCode: '55', districtCode: '42' },
  { code: '49100', name: 'с.Лесное', regionCode: '55', districtCode: '42' },
  { code: '49200', name: 'с.Крупское', regionCode: '55', districtCode: '42' },
  {
    code: '49300',
    name: 'с.Октябрьское',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '49400', name: 'с.Раздельное', regionCode: '55', districtCode: '42' },
  { code: '53100', name: 'с.Михайловка', regionCode: '55', districtCode: '42' },
  {
    code: '53200',
    name: 'с.Благодатное',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '53300', name: 'с.Красновка', regionCode: '55', districtCode: '42' },
  { code: '53400', name: 'с.Мынколь', regionCode: '55', districtCode: '42' },
  {
    code: '53500',
    name: 'с.Петропавловка',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '55100', name: 'с.Церковное', regionCode: '55', districtCode: '42' },
  { code: '55200', name: 'с.Маркатай', regionCode: '55', districtCode: '42' },
  { code: '57100', name: 'с.Озерное', regionCode: '55', districtCode: '42' },
  { code: '57200', name: 'с.Жамбыл', regionCode: '55', districtCode: '42' },
  { code: '57300', name: 'с.Жанабет', regionCode: '55', districtCode: '42' },
  {
    code: '59100',
    name: 'с.Прииртышское',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '59200', name: 'с.Безводное', regionCode: '55', districtCode: '42' },
  { code: '59300', name: 'с.Груздевка', regionCode: '55', districtCode: '42' },
  { code: '59400', name: 'с.Степное', regionCode: '55', districtCode: '42' },
  { code: '59500', name: 'с.Урлютюб', regionCode: '55', districtCode: '42' },
  { code: '30100', name: 'с.Иртышск', regionCode: '55', districtCode: '46' },
  { code: '33100', name: 'с.Голубовка', regionCode: '55', districtCode: '46' },
  { code: '35100', name: 'с.Агашорын', regionCode: '55', districtCode: '46' },
  { code: '35200', name: 'с.Бескепе', regionCode: '55', districtCode: '46' },
  { code: '37100', name: 'с.Амангельды', regionCode: '55', districtCode: '46' },
  {
    code: '39100',
    name: 'с.Иса Байзакова',
    regionCode: '55',
    districtCode: '46'
  },
  { code: '39200', name: 'с.Шубарат', regionCode: '55', districtCode: '46' },
  { code: '39300', name: 'с.Костомар', regionCode: '55', districtCode: '46' },
  { code: '39400', name: 'с.Ульгули', regionCode: '55', districtCode: '46' },
  { code: '45100', name: 'с.Каракудук', regionCode: '55', districtCode: '46' },
  { code: '45200', name: 'с.Кенес', regionCode: '55', districtCode: '46' },
  { code: '45300', name: 'с.Караоткель', regionCode: '55', districtCode: '46' },
  { code: '45500', name: 'а.Ынтымак', regionCode: '55', districtCode: '46' },
  { code: '47100', name: 'с.Косагаш', regionCode: '55', districtCode: '46' },
  { code: '47300', name: 'с.Таскудук', regionCode: '55', districtCode: '46' },
  { code: '49100', name: 'с.Косколь', regionCode: '55', districtCode: '46' },
  { code: '51100', name: 'с.Кызылжар', regionCode: '55', districtCode: '46' },
  { code: '51300', name: 'с.Тогузак', regionCode: '55', districtCode: '46' },
  { code: '53100', name: 'с.Кызылкак', regionCode: '55', districtCode: '46' },
  { code: '55100', name: 'с.Ленино', regionCode: '55', districtCode: '46' },
  { code: '57100', name: 'с.Луговое', regionCode: '55', districtCode: '46' },
  { code: '57300', name: 'с.Акбетей', regionCode: '55', districtCode: '46' },
  { code: '59100', name: 'с.Майконыр', regionCode: '55', districtCode: '46' },
  { code: '63100', name: 'с.Панфилово', regionCode: '55', districtCode: '46' },
  { code: '65100', name: 'с.Северное', regionCode: '55', districtCode: '46' },
  { code: '65300', name: 'с.Караагаш', regionCode: '55', districtCode: '46' },
  { code: '65400', name: 'с.Степное', regionCode: '55', districtCode: '46' },
  { code: '65500', name: 'с.Тобелес', regionCode: '55', districtCode: '46' },
  { code: '67100', name: 'с.Селеты', regionCode: '55', districtCode: '46' },
  { code: '67200', name: 'с.Буланбай', regionCode: '55', districtCode: '46' },
  { code: '67300', name: 'с.Кызылагаш', regionCode: '55', districtCode: '46' },
  { code: '69100', name: 'с.Тохта', regionCode: '55', districtCode: '46' },
  { code: '73100', name: 'с.Узынсу', regionCode: '55', districtCode: '46' },
  { code: '73400', name: 'с.Актайлак', regionCode: '55', districtCode: '46' },
  { code: '30100', name: 'с.Теренколь', regionCode: '55', districtCode: '48' },
  { code: '30200', name: 'с.Ынталы', regionCode: '55', districtCode: '48' },
  { code: '30700', name: 'с.Юбилейное', regionCode: '55', districtCode: '48' },
  { code: '33100', name: 'с.Байконыс', regionCode: '55', districtCode: '48' },
  { code: '33200', name: 'с.Кызылтан', regionCode: '55', districtCode: '48' },
  { code: '33300', name: 'с.Тлеубай', regionCode: '55', districtCode: '48' },
  { code: '35100', name: 'с.Береговое', regionCode: '55', districtCode: '48' },
  { code: '68', name: 'с.Суыккудук', regionCode: '55', districtCode: '55' },
  { code: '69', name: 'с.Куандык', regionCode: '55', districtCode: '55' },
  { code: '70', name: 'п.Солнечный', regionCode: '55', districtCode: '55' },
  { code: '71', name: 'п.Шидерты', regionCode: '55', districtCode: '55' },
  { code: '59200', name: 'с.Кырыкуй', regionCode: '55', districtCode: '32' },
  { code: '30100', name: 'с.Баянаул', regionCode: '55', districtCode: '36' },
  { code: '30400', name: 'с.Шонай', regionCode: '55', districtCode: '36' },
  { code: '33100', name: 'с.Аксан', regionCode: '55', districtCode: '36' },
  { code: '33380', name: 'с.Каражар', regionCode: '55', districtCode: '36' },
  { code: '33800', name: 'с.Октябрь', regionCode: '55', districtCode: '36' },
  { code: '37100', name: 'с.Бирлик', regionCode: '55', districtCode: '36' },
  { code: '37200', name: 'с.Акмектеп', regionCode: '55', districtCode: '36' },
  { code: '39100', name: 'с.Жанажол', regionCode: '55', districtCode: '36' },
  { code: '39200', name: 'с.Буркутты', regionCode: '55', districtCode: '36' },
  { code: '39500', name: 'с.Карашокы', regionCode: '55', districtCode: '36' },
  { code: '41100', name: 'с.Жанатилек', regionCode: '55', districtCode: '36' },
  { code: '41500', name: 'с.Мурынтал', regionCode: '55', districtCode: '36' },
  { code: '43100', name: 'с.Каратомар', regionCode: '55', districtCode: '36' },
  { code: '43200', name: 'с.Белагаш', regionCode: '55', districtCode: '36' },
  { code: '45100', name: 'с.Кундыколь', regionCode: '55', districtCode: '36' },
  { code: '45300', name: 'с.Биржанколь', regionCode: '55', districtCode: '36' },
  {
    code: '45400',
    name: 'с.Егиндыбулак',
    regionCode: '55',
    districtCode: '36'
  },
  { code: '47100', name: 'с.Куркели', regionCode: '55', districtCode: '36' },
  { code: '47300', name: 'с.Большевик', regionCode: '55', districtCode: '36' },
  { code: '47500', name: 'с.Желтау', regionCode: '55', districtCode: '36' },
  { code: '47700', name: 'с.Койтас', regionCode: '55', districtCode: '36' },
  { code: '47800', name: 'с.Жарылгап', regionCode: '55', districtCode: '36' },
  { code: '49100', name: 'с.Жуантобе', regionCode: '55', districtCode: '36' },
  { code: '49280', name: 'с.Акши', regionCode: '55', districtCode: '36' },
  { code: '49980', name: 'ТЭЦ', regionCode: '55', districtCode: '36' },
  { code: '53100', name: 'с.Лекер', regionCode: '55', districtCode: '36' },
  { code: '55100', name: 'п.Майкаин', regionCode: '55', districtCode: '36' },
  { code: '55300', name: 'Ушкулун с.', regionCode: '55', districtCode: '36' },
  { code: '57100', name: 'с.Караши', regionCode: '55', districtCode: '36' },
  { code: '57400', name: 'с.Кокдомбак', regionCode: '55', districtCode: '36' },
  { code: '57500', name: 'с.Тендик', regionCode: '55', districtCode: '36' },
  {
    code: '59100',
    name: 'с.Торайгырова',
    regionCode: '55',
    districtCode: '36'
  },
  {
    code: '59200',
    name: 'с.Александровка',
    regionCode: '55',
    districtCode: '36'
  },
  { code: '59600', name: 'с.Кызылшилик', regionCode: '55', districtCode: '36' },
  { code: '63100', name: 'с.Узунбулак', regionCode: '55', districtCode: '36' },
  { code: '63500', name: 'с.Карабулак', regionCode: '55', districtCode: '36' },
  { code: '63600', name: 'с.Акши', regionCode: '55', districtCode: '36' },
  { code: '65100', name: 'с.ЦЭС', regionCode: '55', districtCode: '36' },
  { code: '65500', name: 'с.Служон', regionCode: '55', districtCode: '36' },
  { code: '65700', name: 'с.Шоптыколь', regionCode: '55', districtCode: '36' },
  { code: '30100', name: 'с.Железинка', regionCode: '55', districtCode: '42' },
  { code: '30200', name: 'с.Захаровка', regionCode: '55', districtCode: '42' },
  { code: '30300', name: 'с.Аккайын', regionCode: '55', districtCode: '42' },
  { code: '30400', name: 'с.Моисеевка', regionCode: '55', districtCode: '42' },
  { code: '30500', name: 'с.Пятирыжск', regionCode: '55', districtCode: '42' },
  { code: '33100', name: 'с.Березовка', regionCode: '55', districtCode: '42' },
  { code: '33300', name: 'с.Жолтаптык', regionCode: '55', districtCode: '42' },
  { code: '35100', name: 'с.Алаколь', regionCode: '55', districtCode: '42' },
  { code: '35200', name: 'с.Шипкуль', regionCode: '55', districtCode: '42' },
  { code: '37100', name: 'с.Башмачное', regionCode: '55', districtCode: '42' },
  { code: '37200', name: 'с.Абай', regionCode: '55', districtCode: '42' },
  { code: '37300', name: 'с.Береговое', regionCode: '55', districtCode: '42' },
  { code: '37500', name: 'с.Кузьмино', regionCode: '55', districtCode: '42' },
  { code: '39100', name: 'с.Валиханово', regionCode: '55', districtCode: '42' },
  {
    code: '41100',
    name: 'с.Веселая Роща',
    regionCode: '55',
    districtCode: '42'
  },
  { code: '41200', name: 'с.Дюсеке', regionCode: '55', districtCode: '42' },
  { code: '41300', name: 'с.Жанабирлик', regionCode: '55', districtCode: '42' },
  { code: '41400', name: 'с.Славяновка', regionCode: '55', districtCode: '42' },
  { code: '43100', name: 'с.Енбекши', regionCode: '55', districtCode: '42' },
  { code: '4', name: 'с.Павлодарское', regionCode: '55', districtCode: '55' },
  { code: '5', name: 'с.Кенжеколь', regionCode: '55', districtCode: '55' },
  { code: '6', name: 'с.Байдала', regionCode: '55', districtCode: '55' },
  { code: '7', name: 'с.Долгое', regionCode: '55', districtCode: '55' },
  { code: '8', name: 'п.Ленинский', regionCode: '55', districtCode: '55' },
  { code: '9', name: 'с.Муялды', regionCode: '55', districtCode: '55' },
  { code: '10', name: 'Подхоз', regionCode: '55', districtCode: '55' },
  { code: '11', name: 'с.Жетекши', regionCode: '55', districtCode: '55' },
  { code: '12', name: 'п.Аксу', regionCode: '55', districtCode: '55' },
  { code: '13', name: 'с.Алгабас', regionCode: '55', districtCode: '55' },
  { code: '14', name: 'с.Айнаколь', regionCode: '55', districtCode: '55' },
  { code: '15', name: 'с.Карабай', regionCode: '55', districtCode: '55' },
  { code: '16', name: 'с.Коктас', regionCode: '55', districtCode: '55' },
  { code: '17', name: 'с.Сынтас', regionCode: '55', districtCode: '55' },
  { code: '18', name: 'с.Жолкудук', regionCode: '55', districtCode: '55' },
  { code: '19', name: 'с.Караколь', regionCode: '55', districtCode: '55' },
  { code: '20', name: 'с.Ребровка', regionCode: '55', districtCode: '55' },
  { code: '21', name: 'с.Достык', regionCode: '55', districtCode: '55' },
  { code: '22', name: 'с.Торткудук', regionCode: '55', districtCode: '55' },
  { code: '23', name: 'с.Пограничник', regionCode: '55', districtCode: '55' },
  { code: '24', name: 'с.Евгеньевка', regionCode: '55', districtCode: '55' },
  { code: '25', name: 'с.Сольветка', regionCode: '55', districtCode: '55' },
  { code: '26', name: 'с.Уштерек', regionCode: '55', districtCode: '55' },
  {
    code: '27',
    name: 'с.им.Мамаита Омарова',
    regionCode: '55',
    districtCode: '55'
  },
  { code: '28', name: 'с.Евден', regionCode: '55', districtCode: '55' },
  { code: '29', name: 'с.Донентаев', regionCode: '55', districtCode: '55' },
  { code: '30', name: 'с.Енбек', regionCode: '55', districtCode: '55' },
  { code: '31', name: 'с.Коктерек', regionCode: '55', districtCode: '55' },
  { code: '32', name: 'с.Сырлыкала', regionCode: '55', districtCode: '55' },
  { code: '33', name: 'с.Курколь', regionCode: '55', districtCode: '55' },
  { code: '34', name: 'с.Путь Ильича', regionCode: '55', districtCode: '55' },
  { code: '35', name: 'с.Калкаман', regionCode: '55', districtCode: '55' },
  { code: '36', name: 'с.Акжол', regionCode: '55', districtCode: '55' },
  { code: '37', name: 'с.Юбилейное', regionCode: '55', districtCode: '55' },
  { code: '38', name: 'с.Кызылжар', regionCode: '55', districtCode: '55' },
  { code: '39', name: 'с.Борыктал', regionCode: '55', districtCode: '55' },
  { code: '40', name: 'с.Жанашаруа', regionCode: '55', districtCode: '55' },
  { code: '41', name: 'с.Сарышыганак', regionCode: '55', districtCode: '55' },
  { code: '42', name: 'с.Суатколь', regionCode: '55', districtCode: '55' },
  { code: '43', name: 'Аккольский с.о.', regionCode: '55', districtCode: '55' },
  { code: '44', name: 'с.Акколь', regionCode: '55', districtCode: '55' },
  { code: '45', name: 'с.Присовхозный', regionCode: '55', districtCode: '55' },
  { code: '46', name: 'с.Жаксат', regionCode: '55', districtCode: '55' },
  { code: '47', name: 'с.Зеленая Роща', regionCode: '55', districtCode: '55' },
  { code: '48', name: 'с.Байет', regionCode: '55', districtCode: '55' },
  { code: '49', name: 'с.Атыгай', regionCode: '55', districtCode: '55' },
  { code: '50', name: 'с.Тортуй', regionCode: '55', districtCode: '55' },
  { code: '51', name: 'с.Акши', regionCode: '55', districtCode: '55' },
  { code: '52', name: 'с.Мынтамыр', regionCode: '55', districtCode: '55' },
  { code: '53', name: 'с.Каражар', regionCode: '55', districtCode: '55' },
  { code: '54', name: 'с.Коксиыр', regionCode: '55', districtCode: '55' },
  { code: '55', name: 'с.Тай', regionCode: '55', districtCode: '55' },
  { code: '56', name: 'с.Жартас', regionCode: '55', districtCode: '55' },
  { code: '57', name: 'с.Талдыкамыс', regionCode: '55', districtCode: '55' },
  { code: '58', name: 'с.Кулаколь', regionCode: '55', districtCode: '55' },
  { code: '59', name: 'с.Шикылдак', regionCode: '55', districtCode: '55' },
  {
    code: '60',
    name: 'с.им.Алькея Маргулана',
    regionCode: '55',
    districtCode: '55'
  },
  { code: '61', name: 'с.Қоянды', regionCode: '55', districtCode: '55' },
  { code: '62', name: 'с.Құрылысшы', regionCode: '55', districtCode: '55' },
  { code: '63', name: 'с.Теміртас', regionCode: '55', districtCode: '55' },
  { code: '64', name: 'с.Бескауга', regionCode: '55', districtCode: '55' },
  { code: '65', name: 'с.Кудайколь', regionCode: '55', districtCode: '55' },
  { code: '66', name: 'с.Карасор', regionCode: '55', districtCode: '55' },
  { code: '67', name: 'с.Сарыкамыс', regionCode: '55', districtCode: '55' },
  {
    code: '66400',
    name: 'с.Краматоровка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '66500', name: 'с.Макашевка', regionCode: '59', districtCode: '60' },
  {
    code: '66600',
    name: 'с.Октябрьское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '66800', name: 'с.Сарыбай', regionCode: '59', districtCode: '60' },
  { code: '67100', name: 'с.Тендик', regionCode: '59', districtCode: '60' },
  { code: '67200', name: 'с.Бирлик', regionCode: '59', districtCode: '60' },
  { code: '67500', name: 'с.Козашар', regionCode: '59', districtCode: '60' },
  {
    code: '67600',
    name: 'с.Кантемировское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '67700', name: 'с.Котовское', regionCode: '59', districtCode: '60' },
  {
    code: '68100',
    name: 'с.Тихоокеанское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '68300', name: 'с.Алабота', regionCode: '59', districtCode: '60' },
  { code: '68700', name: 'с.Шункырколь', regionCode: '59', districtCode: '60' },
  {
    code: '69100',
    name: 'с.Чермошнянка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '69200', name: 'с.Бахмут', regionCode: '59', districtCode: '60' },
  { code: '69400', name: 'с.Леонидовка', regionCode: '59', districtCode: '60' },
  { code: '69480', name: 'с.Hагорное', regionCode: '59', districtCode: '60' },
  {
    code: '69580',
    name: 'с.Многоцветное',
    regionCode: '59',
    districtCode: '60'
  },
  {
    code: '69680',
    name: 'с.Hовоивановка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '69800', name: 'с.Теннис', regionCode: '59', districtCode: '60' },
  { code: '73100', name: 'с.Чкалово', regionCode: '59', districtCode: '60' },
  {
    code: '73600',
    name: 'с.Hовоберезовка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '73700', name: 'с.Петровка', regionCode: '59', districtCode: '60' },
  {
    code: '75100',
    name: 'с.Ясная Поляна',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '75200', name: 'с.Вишневка', regionCode: '59', districtCode: '60' },
  {
    code: '75300',
    name: 'с.Дашко-Hиколаевка',
    regionCode: '59',
    districtCode: '60'
  },
  {
    code: '75400',
    name: 'с.Hоводворовка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '30100', name: 'с.Тимирязево', regionCode: '59', districtCode: '62' },
  { code: '30200', name: 'с.Рассвет', regionCode: '59', districtCode: '62' },
  { code: '33100', name: 'с.Аксуат', regionCode: '59', districtCode: '62' },
  {
    code: '34100',
    name: 'с.Белоградовка',
    regionCode: '59',
    districtCode: '62'
  },
  { code: '34300', name: 'с.Аксу', regionCode: '59', districtCode: '62' },
  {
    code: '35100',
    name: 'с.Дзержинское',
    regionCode: '59',
    districtCode: '62'
  },
  { code: '37100', name: 'с.Дмитриевка', regionCode: '59', districtCode: '62' },
  { code: '37200', name: 'с.Жаркен', regionCode: '59', districtCode: '62' },
  { code: '37300', name: 'с.Интымак', regionCode: '59', districtCode: '62' },
  { code: '39100', name: 'с.Докучаево', regionCode: '59', districtCode: '62' },
  { code: '39200', name: 'с.Северное', regionCode: '59', districtCode: '62' },
  { code: '43100', name: 'а.Есиль', regionCode: '59', districtCode: '62' },
  { code: '43200', name: 'а.Нарынгуль', regionCode: '59', districtCode: '62' },
  { code: '44100', name: 'с.Дружба', regionCode: '59', districtCode: '62' },
  {
    code: '45100',
    name: 'с.Комсомольское',
    regionCode: '59',
    districtCode: '62'
  },
  {
    code: '45200',
    name: 'с.Первомайское',
    regionCode: '59',
    districtCode: '62'
  },
  { code: '47100', name: 'с.Ленинское', regionCode: '59', districtCode: '62' },
  { code: '49100', name: 'с.Мичурино', regionCode: '59', districtCode: '62' },
  {
    code: '51100',
    name: 'с.Москворецкое',
    regionCode: '59',
    districtCode: '62'
  },
  { code: '53100', name: 'с.Акжан', regionCode: '59', districtCode: '62' },
  { code: '53200', name: 'с.Приозерное', regionCode: '59', districtCode: '62' },
  { code: '55100', name: 'с.Степное', regionCode: '59', districtCode: '62' },
  { code: '55300', name: 'с.Ракитное', regionCode: '59', districtCode: '62' },
  {
    code: '59100',
    name: 'с.Хмельницкое',
    regionCode: '59',
    districtCode: '62'
  },
  { code: '63100', name: 'с.Целинное', regionCode: '59', districtCode: '62' },
  {
    code: '30100',
    name: 'с.Кишкенеколь',
    regionCode: '59',
    districtCode: '64'
  },
  { code: '33100', name: 'с.Актуесай', regionCode: '59', districtCode: '64' },
  { code: '33200', name: 'с.Кузексай', regionCode: '59', districtCode: '64' },
  { code: '33300', name: 'а. Кондыбай', regionCode: '59', districtCode: '64' },
  { code: '34100', name: 'с.Амангельды', regionCode: '59', districtCode: '64' },
  { code: '34500', name: 'аул Тлеусай', regionCode: '59', districtCode: '64' },
  { code: '35100', name: 'а.Бидайык', regionCode: '59', districtCode: '64' },
  { code: '35200', name: 'с.Жамбыл', regionCode: '59', districtCode: '64' },
  { code: '35300', name: 'с.Жумысшы', regionCode: '59', districtCode: '64' },
  { code: '35400', name: 'с.Ондирис', regionCode: '59', districtCode: '64' },
  { code: '37100', name: 'с.Мортык', regionCode: '59', districtCode: '64' },
  { code: '37180', name: 'с.Коктерек', regionCode: '59', districtCode: '64' },
  { code: '20100', name: 'г.Тайынша', regionCode: '59', districtCode: '60' },
  { code: '33100', name: 'с.Караагаш', regionCode: '59', districtCode: '60' },
  { code: '33200', name: 'с.Калиновка', regionCode: '59', districtCode: '60' },
  {
    code: '33300',
    name: 'с.Константиновка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '33700', name: 'с.Тапшил', regionCode: '59', districtCode: '60' },
  { code: '35100', name: 'с.Аккудук', regionCode: '59', districtCode: '60' },
  {
    code: '35400',
    name: 'с.Золоторунное',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '35500', name: 'с.Сугурбай', regionCode: '59', districtCode: '60' },
  { code: '35600', name: 'с.Талдыколь', regionCode: '59', districtCode: '60' },
  { code: '35700', name: 'с.Целинное', regionCode: '59', districtCode: '60' },
  { code: '36100', name: 'с.Амандык', regionCode: '59', districtCode: '60' },
  { code: '36400', name: 'с.Жанадаур', regionCode: '59', districtCode: '60' },
  { code: '36500', name: 'с.Ильичевка', regionCode: '59', districtCode: '60' },
  { code: '36600', name: 'с.Аймак', regionCode: '59', districtCode: '60' },
  {
    code: '37100',
    name: 'с.Большой Изюм',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '37300', name: 'с.Кенес', regionCode: '59', districtCode: '60' },
  {
    code: '37500',
    name: 'с.Hовоприречное',
    regionCode: '59',
    districtCode: '60'
  },
  {
    code: '37600',
    name: 'с.Октябрьское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '37700', name: 'с.Приречное', regionCode: '59', districtCode: '60' },
  { code: '37800', name: 'с.Северное', regionCode: '59', districtCode: '60' },
  { code: '37900', name: 'с.Терновка', regionCode: '59', districtCode: '60' },
  { code: '39100', name: 'с.Донецкое', regionCode: '59', districtCode: '60' },
  { code: '39200', name: 'с.Белоярка', regionCode: '59', districtCode: '60' },
  {
    code: '39300',
    name: 'с.Краснокиевка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '39400', name: 'с.Озерное', regionCode: '59', districtCode: '60' },
  { code: '39500', name: 'с.Подольское', regionCode: '59', districtCode: '60' },
  {
    code: '41100',
    name: 'с.Драгомировка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '41200', name: 'с.Иван-город', regionCode: '59', districtCode: '60' },
  { code: '41300', name: 'с.Любимовка', regionCode: '59', districtCode: '60' },
  { code: '41400', name: 'с.Обуховка', regionCode: '59', districtCode: '60' },
  {
    code: '53100',
    name: 'с.Зеленый Гай',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '53200', name: 'с.Жаркайын', regionCode: '59', districtCode: '60' },
  {
    code: '53300',
    name: 'с.Hовогречановка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '55100', name: 'с.Келлеровка', regionCode: '59', districtCode: '60' },
  {
    code: '55200',
    name: 'с.Богатыровка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '55400', name: 'с.Кременчуг', regionCode: '59', districtCode: '60' },
  { code: '55500', name: 'с.Липовка', regionCode: '59', districtCode: '60' },
  {
    code: '56100',
    name: 'с.Красная Поляна',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '56200', name: 'с.Глубокое', regionCode: '59', districtCode: '60' },
  {
    code: '56300',
    name: 'с.Доброжановка',
    regionCode: '59',
    districtCode: '60'
  },
  {
    code: '56400',
    name: 'с.Краснодольское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '56500', name: 'с.Озерное', regionCode: '59', districtCode: '60' },
  { code: '56700', name: 'с.Степное', regionCode: '59', districtCode: '60' },
  {
    code: '56800',
    name: 'с.Черниговское',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '56900', name: 'с.Южное', regionCode: '59', districtCode: '60' },
  { code: '59100', name: 'с.Кирово', regionCode: '59', districtCode: '60' },
  { code: '59200', name: 'с.Агроном', regionCode: '59', districtCode: '60' },
  { code: '59300', name: 'с.Восточное', regionCode: '59', districtCode: '60' },
  { code: '59400', name: 'с.Ильич', regionCode: '59', districtCode: '60' },
  { code: '59500', name: 'с.Мирное', regionCode: '59', districtCode: '60' },
  { code: '59600', name: 'с.Трудовое', regionCode: '59', districtCode: '60' },
  {
    code: '61100',
    name: 'с.Краснокаменка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '61600', name: 'с.Мадениет', regionCode: '59', districtCode: '60' },
  { code: '61800', name: 'с.Талап', regionCode: '59', districtCode: '60' },
  { code: '63100', name: 'с.Летовочное', regionCode: '59', districtCode: '60' },
  { code: '63400', name: 'с.Горькое', regionCode: '59', districtCode: '60' },
  { code: '63700', name: 'с.Подлесное', regionCode: '59', districtCode: '60' },
  { code: '64100', name: 'с.Мироновка', regionCode: '59', districtCode: '60' },
  {
    code: '64300',
    name: 'с.Виноградовка',
    regionCode: '59',
    districtCode: '60'
  },
  { code: '64400', name: 'с.Заречное', regionCode: '59', districtCode: '60' },
  { code: '64600', name: 'с.Hадеждинка', regionCode: '59', districtCode: '60' },
  { code: '66100', name: 'с.Рощинское', regionCode: '59', districtCode: '60' },
  { code: '66200', name: 'с.Димитровка', regionCode: '59', districtCode: '60' },
  {
    code: '66300',
    name: 'с.Комсомольское',
    regionCode: '59',
    districtCode: '60'
  },
  {
    code: '37300',
    name: 'с.Коноваловка',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '38100', name: 'с.Жанажол', regionCode: '59', districtCode: '56' },
  { code: '38300', name: 'с.Жанаталап', regionCode: '59', districtCode: '56' },
  { code: '38500', name: 'с.Кенес', regionCode: '59', districtCode: '56' },
  {
    code: '39100',
    name: 'с.Кривощеково',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '39200', name: 'с.Алкаагаш', regionCode: '59', districtCode: '56' },
  { code: '39300', name: 'с.Ровное', regionCode: '59', districtCode: '56' },
  { code: '39400', name: 'с.Социал', regionCode: '59', districtCode: '56' },
  { code: '39500', name: 'с.Соколовка', regionCode: '59', districtCode: '56' },
  {
    code: '43100',
    name: 'с.Hовопокровка',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '43200', name: 'с.Аксу', regionCode: '59', districtCode: '56' },
  { code: '43300', name: 'с.Белоглинка', regionCode: '59', districtCode: '56' },
  { code: '43400', name: 'с.Енбек', regionCode: '59', districtCode: '56' },
  { code: '43500', name: 'с.Жанасу', regionCode: '59', districtCode: '56' },
  { code: '45100', name: 'а. Узынжар', regionCode: '59', districtCode: '56' },
  { code: '45200', name: 'с.Куртай', regionCode: '59', districtCode: '56' },
  { code: '45300', name: 'с.Тельманово', regionCode: '59', districtCode: '56' },
  { code: '47100', name: 'с.Повозочное', regionCode: '59', districtCode: '56' },
  { code: '47200', name: 'с.Бирлик', regionCode: '59', districtCode: '56' },
  { code: '47400', name: 'с.Меней', regionCode: '59', districtCode: '56' },
  { code: '47500', name: 'с.Ортаколь', regionCode: '59', districtCode: '56' },
  { code: '49100', name: 'с.Семиполка', regionCode: '59', districtCode: '56' },
  { code: '49200', name: 'с.Балуан', regionCode: '59', districtCode: '56' },
  { code: '51100', name: 'с.Ступинка', regionCode: '59', districtCode: '56' },
  { code: '51400', name: 'с.Жалтыр', regionCode: '59', districtCode: '56' },
  { code: '51500', name: 'с.Остаган', regionCode: '59', districtCode: '56' },
  {
    code: '53100',
    name: 'с.Сухорабовка',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '53200', name: 'с.Hеждановка', regionCode: '59', districtCode: '56' },
  { code: '53300', name: 'с.Ольгинка', regionCode: '59', districtCode: '56' },
  { code: '55100', name: 'с.Крещенка', regionCode: '59', districtCode: '56' },
  {
    code: '55200',
    name: 'с.Белоградовка',
    regionCode: '59',
    districtCode: '56'
  },
  {
    code: '55300',
    name: 'с.Куприяновка',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '30100', name: 'с.Смирново', regionCode: '59', districtCode: '58' },
  { code: '33100', name: 'с.Аралагаш', regionCode: '59', districtCode: '58' },
  { code: '33200', name: 'с.Амангельды', regionCode: '59', districtCode: '58' },
  { code: '33300', name: 'с.Рублевка', regionCode: '59', districtCode: '58' },
  { code: '35100', name: 'с.Астраханка', regionCode: '59', districtCode: '58' },
  { code: '35200', name: 'с.Каратомар', regionCode: '59', districtCode: '58' },
  { code: '37100', name: 'с.Власовка', regionCode: '59', districtCode: '58' },
  { code: '37200', name: 'с.Безлесное', regionCode: '59', districtCode: '58' },
  { code: '37300', name: 'с.Сенное', regionCode: '59', districtCode: '58' },
  { code: '39100', name: 'с.Трудовое', regionCode: '59', districtCode: '58' },
  {
    code: '39200',
    name: 'с.Григорьевка',
    regionCode: '59',
    districtCode: '58'
  },
  { code: '39300', name: 'с.Коктерек', regionCode: '59', districtCode: '58' },
  { code: '39400', name: 'с.Кенжегалы', regionCode: '59', districtCode: '58' },
  { code: '43100', name: 'с.Ивановка', regionCode: '59', districtCode: '58' },
  { code: '43300', name: 'с.Ульги', regionCode: '59', districtCode: '58' },
  { code: '45100', name: 'с.Киялы', regionCode: '59', districtCode: '58' },
  { code: '45200', name: 'с.Барыколь', regionCode: '59', districtCode: '58' },
  { code: '45500', name: 'с.Кучковка', regionCode: '59', districtCode: '58' },
  { code: '47100', name: 'с.Ленинское', regionCode: '59', districtCode: '58' },
  { code: '47200', name: 'с.Дайындык', regionCode: '59', districtCode: '58' },
  { code: '49100', name: 'с.Полтавка', regionCode: '59', districtCode: '58' },
  { code: '49200', name: 'с.Борки', regionCode: '59', districtCode: '58' },
  {
    code: '49300',
    name: 'с.Лесные Поляны',
    regionCode: '59',
    districtCode: '58'
  },
  { code: '57100', name: 'с.Токуши', regionCode: '59', districtCode: '58' },
  { code: '57200', name: 'с.Камышлово', regionCode: '59', districtCode: '58' },
  { code: '57500', name: 'с.Тюменка', regionCode: '59', districtCode: '58' },
  { code: '58100', name: 'а.Шагалалы', regionCode: '59', districtCode: '58' },
  { code: '58400', name: 'с.Степное', regionCode: '59', districtCode: '58' },
  { code: '58600', name: 'с.Южное', regionCode: '59', districtCode: '58' },
  { code: '59100', name: 'с.Черкасское', regionCode: '59', districtCode: '58' },
  {
    code: '59200',
    name: 'с.Добровольское',
    regionCode: '59',
    districtCode: '58'
  },
  {
    code: '59300',
    name: 'с.Hовороссийское',
    regionCode: '59',
    districtCode: '58'
  },
  { code: '65200', name: 'с.Байсал', regionCode: '59', districtCode: '50' },
  { code: '65400', name: 'с.Метлишино', regionCode: '59', districtCode: '50' },
  {
    code: '65500',
    name: 'с.Hовоникольское',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '65600', name: 'с.Янцено', regionCode: '59', districtCode: '50' },
  { code: '67100', name: 'с.Соколовка', regionCode: '59', districtCode: '50' },
  { code: '69100', name: 'с.Якорь', regionCode: '59', districtCode: '50' },
  { code: '69200', name: 'с.Вишневка', regionCode: '59', districtCode: '50' },
  { code: '69300', name: 'с.Вознесенка', regionCode: '59', districtCode: '50' },
  { code: '69400', name: 'с.Ольшанка', regionCode: '59', districtCode: '50' },
  { code: '20100', name: 'г.Мамлютка', regionCode: '59', districtCode: '52' },
  { code: '31100', name: 'с.Андреевка', regionCode: '59', districtCode: '52' },
  { code: '31200', name: 'с.Бостандык', regionCode: '59', districtCode: '52' },
  {
    code: '31300',
    name: 'с.Владимировка',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '33100', name: 'с.Белое', regionCode: '59', districtCode: '52' },
  { code: '33200', name: 'с.Коваль', regionCode: '59', districtCode: '52' },
  { code: '33300', name: 'с.Прогресс', regionCode: '59', districtCode: '52' },
  { code: '33400', name: 'с.Сливное', regionCode: '59', districtCode: '52' },
  { code: '33500', name: 'с.Студеное', regionCode: '59', districtCode: '52' },
  { code: '33600', name: 'с.Чистое', regionCode: '59', districtCode: '52' },
  { code: '33700', name: 'с.Щучье', regionCode: '59', districtCode: '52' },
  {
    code: '35100',
    name: 'с.Воскресеновка',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '35200', name: 'с.Искра', regionCode: '59', districtCode: '52' },
  { code: '35400', name: 'с.Становое', regionCode: '59', districtCode: '52' },
  { code: '37100', name: 'с.Дубровное', regionCode: '59', districtCode: '52' },
  { code: '37200', name: 'с.Михайловка', regionCode: '59', districtCode: '52' },
  {
    code: '37300',
    name: 'с.Hоводубровное',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '37400', name: 'с.Пчелино', regionCode: '59', districtCode: '52' },
  {
    code: '39100',
    name: 'с.Краснознаменное',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '39200', name: 'с.Беловка', regionCode: '59', districtCode: '52' },
  { code: '39300', name: 'с.Калугино', regionCode: '59', districtCode: '52' },
  { code: '41100', name: 'с.Кызыласкер', regionCode: '59', districtCode: '52' },
  { code: '41300', name: 'с.Раздольное', regionCode: '59', districtCode: '52' },
  { code: '41400', name: 'с.Степное', regionCode: '59', districtCode: '52' },
  { code: '43100', name: 'с.Леденево', regionCode: '59', districtCode: '52' },
  {
    code: '43200',
    name: 'с.Hовоандреевка',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '45100', name: 'с.Ленино', regionCode: '59', districtCode: '52' },
  { code: '45200', name: 'с.Дачное', regionCode: '59', districtCode: '52' },
  { code: '45300', name: 'с.Октябрь', regionCode: '59', districtCode: '52' },
  {
    code: '47100',
    name: 'с.Hовомихайловка',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '47200', name: 'с.Бексеит', regionCode: '59', districtCode: '52' },
  { code: '47300', name: 'с.Минкесер', regionCode: '59', districtCode: '52' },
  { code: '47400', name: 'с.Катанай', regionCode: '59', districtCode: '52' },
  { code: '47500', name: 'с.Токаревка', regionCode: '59', districtCode: '52' },
  { code: '49100', name: 'с.Покровка', regionCode: '59', districtCode: '52' },
  {
    code: '49200',
    name: 'с.Красный Октябрь',
    regionCode: '59',
    districtCode: '52'
  },
  {
    code: '49400',
    name: 'Ост.пункт 2591 км',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '51100', name: 'с.Афонькино', regionCode: '59', districtCode: '52' },
  {
    code: '51300',
    name: 'с.Hовоукраинка',
    regionCode: '59',
    districtCode: '52'
  },
  {
    code: '51400',
    name: 'с.Пробуждение',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '51500', name: 'с.Орел', regionCode: '59', districtCode: '52' },
  {
    code: '51600',
    name: 'Ост.пункт Орленок',
    regionCode: '59',
    districtCode: '52'
  },
  {
    code: '51700',
    name: 'Ост.пункт 2574км',
    regionCode: '59',
    districtCode: '52'
  },
  { code: '20100', name: 'г.Сергеевка', regionCode: '59', districtCode: '56' },
  {
    code: '33100',
    name: 'с.Афанасьевка',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '33200', name: 'с.Двойники', regionCode: '59', districtCode: '56' },
  { code: '33400', name: 'с.Рясинка', regionCode: '59', districtCode: '56' },
  { code: '33500', name: 'с.Садовка', regionCode: '59', districtCode: '56' },
  { code: '35100', name: 'с.Каратал', regionCode: '59', districtCode: '56' },
  { code: '35200', name: 'с.Аканбарак', regionCode: '59', districtCode: '56' },
  { code: '35300', name: 'с.Коктерек', regionCode: '59', districtCode: '56' },
  {
    code: '35500',
    name: 'с.Ыскака Ыбыраева',
    regionCode: '59',
    districtCode: '56'
  },
  { code: '35600', name: 'а. Мерген', regionCode: '59', districtCode: '56' },
  { code: '37100', name: 'с.Городецкое', regionCode: '59', districtCode: '56' },
  { code: '37200', name: 'с.Баганаты', regionCode: '59', districtCode: '56' },
  { code: '37400', name: 'с.Гончаровка', regionCode: '59', districtCode: '50' },
  { code: '65300', name: 'с.Князевка', regionCode: '59', districtCode: '66' },
  { code: '65500', name: 'с.Симоновка', regionCode: '59', districtCode: '66' },
  { code: '65600', name: 'с.Ялты', regionCode: '59', districtCode: '66' },
  { code: '67100', name: 'с.Шоптыколь', regionCode: '59', districtCode: '66' },
  {
    code: '67200',
    name: 'с.Большой Талсай',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '67300', name: 'с.Жарколь', regionCode: '59', districtCode: '66' },
  { code: '67400', name: 'с.Конырсу', regionCode: '59', districtCode: '66' },
  { code: '67500', name: 'с.Разгульное', regionCode: '59', districtCode: '66' },
  { code: '69100', name: 'с.Шукырколь', regionCode: '59', districtCode: '66' },
  { code: '69300', name: 'с.Карагаш', regionCode: '59', districtCode: '66' },
  {
    code: '69500',
    name: 'с.15 лет Казахстана',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '37600', name: 'с.Ташкентка', regionCode: '59', districtCode: '50' },
  { code: '41100', name: 'с.Бугровое', regionCode: '59', districtCode: '50' },
  {
    code: '41200',
    name: 'с.Красноперовка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '41400', name: 'с.Hиколаевка', regionCode: '59', districtCode: '50' },
  {
    code: '41500',
    name: 'с.Hовогеоргиевка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '41600', name: 'с.Сосновка', regionCode: '59', districtCode: '50' },
  { code: '43100', name: 'с.Вагулино', regionCode: '59', districtCode: '50' },
  { code: '43300', name: 'с.Желяково', regionCode: '59', districtCode: '50' },
  { code: '43400', name: 'с.Красноярка', regionCode: '59', districtCode: '50' },
  { code: '43500', name: 'с.Кустовое', regionCode: '59', districtCode: '50' },
  {
    code: '45100',
    name: 'с.Виноградовка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '45200', name: 'с.Исаковка', regionCode: '59', districtCode: '50' },
  { code: '45400', name: 'с.Сумное', regionCode: '59', districtCode: '50' },
  { code: '47100', name: 'с.Долматово', regionCode: '59', districtCode: '50' },
  { code: '47200', name: 'с.Красный Яр', regionCode: '59', districtCode: '50' },
  { code: '49100', name: 'с.Боголюбово', regionCode: '59', districtCode: '50' },
  { code: '49200', name: 'с.Вознесенка', regionCode: '59', districtCode: '50' },
  { code: '49300', name: 'с.Hадежка', regionCode: '59', districtCode: '50' },
  { code: '50100', name: 'а.Байтерек', regionCode: '59', districtCode: '50' },
  { code: '50300', name: 'с.Карлуга', regionCode: '59', districtCode: '50' },
  { code: '50400', name: 'с.Приишимка', regionCode: '59', districtCode: '50' },
  { code: '50500', name: 'с.Подгорное', regionCode: '59', districtCode: '50' },
  {
    code: '50600',
    name: 'с.Трудовая Hива',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '50800', name: 'с.Чапаево', regionCode: '59', districtCode: '50' },
  { code: '51100', name: 'с.Пресновка', regionCode: '59', districtCode: '50' },
  { code: '51200', name: 'с.Глубокое', regionCode: '59', districtCode: '50' },
  { code: '53100', name: 'с.Hалобино', regionCode: '59', districtCode: '50' },
  { code: '53200', name: 'с.Дубровное', regionCode: '59', districtCode: '50' },
  { code: '53300', name: 'с.Лебедки', regionCode: '59', districtCode: '50' },
  { code: '53400', name: 'с.Hиколаевка', regionCode: '59', districtCode: '50' },
  { code: '53500', name: 'с.Гайдуково', regionCode: '59', districtCode: '50' },
  {
    code: '55100',
    name: 'с.Hовоникольское',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '55200',
    name: 'с.Hовоалександровка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '55300', name: 'с.Трудовое', regionCode: '59', districtCode: '50' },
  { code: '57100', name: 'с.Петерфельд', regionCode: '59', districtCode: '50' },
  { code: '57200', name: 'с.Боровское', regionCode: '59', districtCode: '50' },
  { code: '57300', name: 'с.Затон', regionCode: '59', districtCode: '50' },
  { code: '57400', name: 'с.Измайловка', regionCode: '59', districtCode: '50' },
  {
    code: '57500',
    name: 'с.Кондратовка',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '57600',
    name: 'с.Кривоозерка',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '57700',
    name: 'Ост.пункт 2603 км',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '59100', name: 'с.Прибрежное', regionCode: '59', districtCode: '50' },
  { code: '59200', name: 'с.Тепличное', regionCode: '59', districtCode: '50' },
  { code: '59300', name: 'с.Шаховское', regionCode: '59', districtCode: '50' },
  { code: '63100', name: 'с.Рассвет', regionCode: '59', districtCode: '50' },
  {
    code: '63200',
    name: 'с.Водопроводное',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '63300',
    name: 'с.Красная Горка',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '63400',
    name: 'с.Семипалатное',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '64100', name: 'с.Пеньково', regionCode: '59', districtCode: '50' },
  { code: '64300', name: 'с.Белое', regionCode: '59', districtCode: '50' },
  { code: '64400', name: 'с.Березовка', regionCode: '59', districtCode: '50' },
  { code: '65100', name: 'с.Знаменское', regionCode: '59', districtCode: '50' },
  {
    code: '35200',
    name: 'а.Баймаганбета Изтолина',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '35300', name: 'с.Муромское', regionCode: '59', districtCode: '46' },
  {
    code: '37100',
    name: 'с.Благовещенка',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '37200', name: 'с.Богдановка', regionCode: '59', districtCode: '46' },
  { code: '37300', name: 'с.Майбалык', regionCode: '59', districtCode: '46' },
  { code: '37400', name: 'с.Талпын', regionCode: '59', districtCode: '46' },
  { code: '39100', name: 'с.Жамбыл', regionCode: '59', districtCode: '46' },
  { code: '39200', name: 'с.Амангельды', regionCode: '59', districtCode: '46' },
  { code: '39300', name: 'а.Есперли', regionCode: '59', districtCode: '46' },
  { code: '39400', name: 'с.Караагаш', regionCode: '59', districtCode: '46' },
  { code: '39500', name: 'с.Суатколь', regionCode: '59', districtCode: '46' },
  { code: '41100', name: 'с.Железное', regionCode: '59', districtCode: '46' },
  { code: '41200', name: 'с.Богатое', regionCode: '59', districtCode: '46' },
  { code: '41300', name: 'с.Лапушки', regionCode: '59', districtCode: '46' },
  { code: '43100', name: 'с.Кладбинка', regionCode: '59', districtCode: '46' },
  { code: '43200', name: 'с.Сенжарка', regionCode: '59', districtCode: '46' },
  { code: '43300', name: 'с.Симаки', regionCode: '59', districtCode: '46' },
  { code: '43400', name: 'с.Уткино', regionCode: '59', districtCode: '46' },
  { code: '45100', name: 'с.Казанка', regionCode: '59', districtCode: '46' },
  {
    code: '45200',
    name: 'с.Екатериновка',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '45300', name: 'с.Матросово', regionCode: '59', districtCode: '46' },
  { code: '45400', name: 'с.Светлое', regionCode: '59', districtCode: '46' },
  { code: '45500', name: 'с.Усердное', regionCode: '59', districtCode: '46' },
  { code: '47100', name: 'с.Кайранколь', regionCode: '59', districtCode: '46' },
  { code: '47200', name: 'с.Hовое', regionCode: '59', districtCode: '46' },
  { code: '47300', name: 'с.Украинское', regionCode: '59', districtCode: '46' },
  {
    code: '49100',
    name: 'с.Святодуховка',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '49200', name: 'с.Жанажол', regionCode: '59', districtCode: '46' },
  { code: '49300', name: 'с.Жалтырша', regionCode: '59', districtCode: '46' },
  { code: '49500', name: 'с.Ольговка', regionCode: '59', districtCode: '46' },
  { code: '49600', name: 'с.Сабит', regionCode: '59', districtCode: '46' },
  { code: '51100', name: 'с.Мирное', regionCode: '59', districtCode: '46' },
  { code: '51200', name: 'с.Айымжан', regionCode: '59', districtCode: '46' },
  { code: '51300', name: 'с.Узынколь', regionCode: '59', districtCode: '46' },
  { code: '51400', name: 'с.Петровка', regionCode: '59', districtCode: '46' },
  {
    code: '51500',
    name: 'с.Рождественка',
    regionCode: '59',
    districtCode: '46'
  },
  {
    code: '53100',
    name: 'с.Hоворыбинка',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '53200', name: 'с.Миролюбово', regionCode: '59', districtCode: '46' },
  { code: '55100', name: 'с.Озерное', regionCode: '59', districtCode: '46' },
  { code: '55200', name: 'с.Акбалык', regionCode: '59', districtCode: '46' },
  { code: '55300', name: 'с.Бауманское', regionCode: '59', districtCode: '46' },
  { code: '55400', name: 'с.Каракамыс', regionCode: '59', districtCode: '46' },
  { code: '57100', name: 'с.Буденное', regionCode: '59', districtCode: '46' },
  { code: '57200', name: 'с.Калиновка', regionCode: '59', districtCode: '46' },
  { code: '57300', name: 'с.Кабань', regionCode: '59', districtCode: '46' },
  { code: '57400', name: 'с.Чапаевка', regionCode: '59', districtCode: '46' },
  {
    code: '61100',
    name: 'с.Пресноредуть',
    regionCode: '59',
    districtCode: '46'
  },
  { code: '61200', name: 'а. Нурымбет', regionCode: '59', districtCode: '46' },
  { code: '61300', name: 'с.Макарьевка', regionCode: '59', districtCode: '46' },
  { code: '61400', name: 'с.Песчанка', regionCode: '59', districtCode: '46' },
  { code: '61500', name: 'с.Семиозерка', regionCode: '59', districtCode: '46' },
  { code: '61600', name: 'с.Ястребинка', regionCode: '59', districtCode: '46' },
  { code: '63100', name: 'с.Троицкое', regionCode: '59', districtCode: '46' },
  { code: '63200', name: 'с.Орталык', regionCode: '59', districtCode: '46' },
  { code: '30100', name: 'а.Бесколь', regionCode: '59', districtCode: '50' },
  {
    code: '33100',
    name: 'с.Архангельское',
    regionCode: '59',
    districtCode: '50'
  },
  {
    code: '33200',
    name: 'с.Hовокаменка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '35100', name: 'с.Асаново', regionCode: '59', districtCode: '50' },
  { code: '35300', name: 'с.Михайловка', regionCode: '59', districtCode: '50' },
  {
    code: '35400',
    name: 'с.Малое Белое',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '35500', name: 'с.Плоское', regionCode: '59', districtCode: '50' },
  { code: '35600', name: 'с.Толмачевка', regionCode: '59', districtCode: '50' },
  {
    code: '37100',
    name: 'с.Большая Малышка',
    regionCode: '59',
    districtCode: '50'
  },
  { code: '37200', name: 'с.Барневка', regionCode: '59', districtCode: '50' },
  { code: '85300', name: 'с.Украинка', regionCode: '59', districtCode: '36' },
  { code: '85400', name: 'с.Урожайное', regionCode: '59', districtCode: '36' },
  { code: '33100', name: 'с.Орнек', regionCode: '59', districtCode: '42' },
  { code: '33200', name: 'с.Жаркайын', regionCode: '59', districtCode: '42' },
  { code: '33300', name: 'с.Мектеп', regionCode: '59', districtCode: '42' },
  {
    code: '35100',
    name: 'с.Амангельдинское',
    regionCode: '59',
    districtCode: '42'
  },
  { code: '35200', name: 'с.Калиновка', regionCode: '59', districtCode: '42' },
  { code: '35300', name: 'с.Поляковка', regionCode: '59', districtCode: '42' },
  { code: '35400', name: 'с.Талапкер', regionCode: '59', districtCode: '42' },
  { code: '37100', name: 'с.Бескудук', regionCode: '59', districtCode: '42' },
  { code: '37200', name: 'с.Алабие', regionCode: '59', districtCode: '42' },
  { code: '37300', name: 'с.Тамамбай', regionCode: '59', districtCode: '42' },
  { code: '37400', name: 'с.Черуновка', regionCode: '59', districtCode: '42' },
  { code: '39100', name: 'с.Булак', regionCode: '59', districtCode: '42' },
  { code: '39200', name: 'с.Актас', regionCode: '59', districtCode: '42' },
  { code: '39300', name: 'с.Карагай', regionCode: '59', districtCode: '42' },
  { code: '41100', name: 'с.Волошинка', regionCode: '59', districtCode: '42' },
  {
    code: '41200',
    name: 'с.Ивано-Петровка',
    regionCode: '59',
    districtCode: '42'
  },
  { code: '41300', name: 'с.Лузинка', regionCode: '59', districtCode: '42' },
  { code: '43100', name: 'с.Заградовка', regionCode: '59', districtCode: '42' },
  { code: '43200', name: 'с.Горное', regionCode: '59', districtCode: '42' },
  { code: '43300', name: 'с.Жамбыл', regionCode: '59', districtCode: '42' },
  { code: '43500', name: 'с.Славянка', regionCode: '59', districtCode: '42' },
  {
    code: '43600',
    name: 'с.Тонкошуровка',
    regionCode: '59',
    districtCode: '42'
  },
  { code: '45100', name: 'с.Чириковка', regionCode: '59', districtCode: '42' },
  { code: '45300', name: 'с.Гурьяновка', regionCode: '59', districtCode: '42' },
  { code: '45400', name: 'с.Жаналык', regionCode: '59', districtCode: '42' },
  { code: '45500', name: 'с.Караагаш', regionCode: '59', districtCode: '42' },
  { code: '45600', name: 'с.Луговое', regionCode: '59', districtCode: '42' },
  { code: '45700', name: 'с.Орталык', regionCode: '59', districtCode: '42' },
  { code: '47100', name: 'с.Ильинка', regionCode: '59', districtCode: '42' },
  { code: '47200', name: 'с.Амангельды', regionCode: '59', districtCode: '42' },
  {
    code: '47300',
    name: 'с.Александровка',
    regionCode: '59',
    districtCode: '42'
  },
  { code: '49100', name: 'с.Корнеевка', regionCode: '59', districtCode: '42' },
  { code: '49200', name: 'с.Леонидовка', regionCode: '59', districtCode: '42' },
  { code: '49300', name: 'с.Hовоузенка', regionCode: '59', districtCode: '42' },
  { code: '49400', name: 'с.Советское', regionCode: '59', districtCode: '42' },
  { code: '51100', name: 'с.Hиколаевка', regionCode: '59', districtCode: '42' },
  { code: '51200', name: 'с.Каратал', regionCode: '59', districtCode: '42' },
  { code: '53100', name: 'с.Петровка', regionCode: '59', districtCode: '42' },
  { code: '53200', name: 'с.Бирлик', regionCode: '59', districtCode: '42' },
  { code: '53300', name: 'с.Жекеколь', regionCode: '59', districtCode: '42' },
  { code: '53400', name: 'с.Мадениет', regionCode: '59', districtCode: '42' },
  { code: '53500', name: 'с.Оседлое', regionCode: '59', districtCode: '42' },
  { code: '55100', name: 'с.Покровка', regionCode: '59', districtCode: '42' },
  { code: '55200', name: 'с.Енбек', regionCode: '59', districtCode: '42' },
  { code: '55300', name: 'с.Есильское', regionCode: '59', districtCode: '42' },
  { code: '55400', name: 'с.Мальцево', regionCode: '59', districtCode: '42' },
  { code: '56100', name: 'с.Спасовка', regionCode: '59', districtCode: '42' },
  { code: '56300', name: 'с.Сарыман', regionCode: '59', districtCode: '42' },
  { code: '56500', name: 'с.Тауагаш', regionCode: '59', districtCode: '42' },
  { code: '57100', name: 'с.Тарангул', regionCode: '59', districtCode: '42' },
  { code: '57200', name: 'с.Двинск', regionCode: '59', districtCode: '42' },
  { code: '57300', name: 'с.Иверск', regionCode: '59', districtCode: '42' },
  { code: '57400', name: 'с.Сарыколь', regionCode: '59', districtCode: '42' },
  { code: '61100', name: 'с.Ясновка', regionCode: '59', districtCode: '42' },
  {
    code: '61200',
    name: 'с.Карабеловка',
    regionCode: '59',
    districtCode: '42'
  },
  {
    code: '61300',
    name: 'с.Стрельниковка',
    regionCode: '59',
    districtCode: '42'
  },
  { code: '30100', name: 'с.Пресновка', regionCode: '59', districtCode: '46' },
  { code: '30200', name: 'с.Островка', regionCode: '59', districtCode: '46' },
  { code: '33100', name: 'с.Архангелка', regionCode: '59', districtCode: '46' },
  { code: '33200', name: 'с.Айтуар', regionCode: '59', districtCode: '46' },
  { code: '33400', name: 'с.Ульги', regionCode: '59', districtCode: '46' },
  { code: '35100', name: 'с.Баян', regionCode: '59', districtCode: '46' },
  {
    code: '35100',
    name: 'с.Александровка',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '35200', name: 'а.Алуа', regionCode: '59', districtCode: '36' },
  { code: '37100', name: 'с.Бастомар', regionCode: '59', districtCode: '36' },
  {
    code: '37200',
    name: 'с.Екатериновка',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '39100', name: 'с.Возвышенка', regionCode: '59', districtCode: '36' },
  { code: '39200', name: 'с.Изобильное', regionCode: '59', districtCode: '36' },
  {
    code: '39300',
    name: 'с.Малая Возвышенка',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '43100', name: 'с.Гаврино', regionCode: '59', districtCode: '36' },
  { code: '43200', name: 'с.Зарослое', regionCode: '59', districtCode: '36' },
  {
    code: '45100',
    name: 'с.Золотая Hива',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '47100', name: 'с.Конюхово', regionCode: '59', districtCode: '36' },
  { code: '47300', name: 'с.Камышлово', regionCode: '59', districtCode: '36' },
  { code: '47400', name: 'с.Куломзино', regionCode: '59', districtCode: '36' },
  { code: '49100', name: 'а.Караганды', regionCode: '59', districtCode: '36' },
  { code: '51100', name: 'с.Каракога', regionCode: '59', districtCode: '36' },
  { code: '51200', name: 'с.Hогайбай', regionCode: '59', districtCode: '36' },
  { code: '51400', name: 'с.Образец', regionCode: '59', districtCode: '36' },
  { code: '51500', name: 'с.Чистое', regionCode: '59', districtCode: '36' },
  { code: '53100', name: 'с.Лебяжье', regionCode: '59', districtCode: '36' },
  { code: '53200', name: 'с.Круглое', regionCode: '59', districtCode: '36' },
  { code: '53300', name: 'с.Куралай', regionCode: '59', districtCode: '36' },
  { code: '55100', name: 'с.Майбалык', regionCode: '59', districtCode: '36' },
  { code: '55300', name: 'а.Сейфолла', regionCode: '59', districtCode: '36' },
  { code: '57100', name: 'с.Молодежное', regionCode: '59', districtCode: '36' },
  { code: '57200', name: 'с.Сарытомар', regionCode: '59', districtCode: '36' },
  {
    code: '59100',
    name: 'с.Молодогвардейское',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '63100', name: 'с.Hадежка', regionCode: '59', districtCode: '36' },
  { code: '63200', name: 'а.Бинаш', regionCode: '59', districtCode: '36' },
  { code: '63300', name: 'с.Дюсеке', regionCode: '59', districtCode: '36' },
  { code: '63400', name: 'с.Еремеевка', regionCode: '59', districtCode: '36' },
  {
    code: '65100',
    name: 'с.Октябрьское',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '65200', name: 'с.Мичурино', regionCode: '59', districtCode: '36' },
  { code: '65300', name: 'с.Суворовка', regionCode: '59', districtCode: '36' },
  { code: '65400', name: 'с.Хлебороб', regionCode: '59', districtCode: '36' },
  { code: '67100', name: 'с.Писаревка', regionCode: '59', districtCode: '36' },
  { code: '67200', name: 'с.Веселовка', regionCode: '59', districtCode: '36' },
  { code: '67300', name: 'а.Байшилик', regionCode: '59', districtCode: '36' },
  { code: '69100', name: 'с.Полудино', regionCode: '59', districtCode: '36' },
  { code: '69200', name: 'с.Ганькино', regionCode: '59', districtCode: '36' },
  { code: '69300', name: 'ст.Ганькино', regionCode: '59', districtCode: '36' },
  { code: '69400', name: 'с.Скворцовка', regionCode: '59', districtCode: '36' },
  { code: '71100', name: 'с.Пролетарка', regionCode: '59', districtCode: '36' },
  { code: '71200', name: 'с.Барашки', regionCode: '59', districtCode: '36' },
  { code: '71300', name: 'с.Моховое', regionCode: '59', districtCode: '36' },
  { code: '71400', name: 'с.Тельманово', regionCode: '59', districtCode: '36' },
  { code: '73100', name: 'с.Советское', regionCode: '59', districtCode: '36' },
  {
    code: '73200',
    name: 'с.Придорожное',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '73300', name: 'с.Силекти', regionCode: '59', districtCode: '36' },
  { code: '75100', name: 'с.Таманское', regionCode: '59', districtCode: '36' },
  {
    code: '75200',
    name: 'с.Пулеметовка',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '77100', name: 'с.Успенка', regionCode: '59', districtCode: '36' },
  { code: '77200', name: 'с.Косколь', regionCode: '59', districtCode: '36' },
  { code: '77300', name: 'с.Рощино', regionCode: '59', districtCode: '36' },
  { code: '77400', name: 'с.Сулышок', regionCode: '59', districtCode: '36' },
  { code: '77500', name: 'с.Уваковское', regionCode: '59', districtCode: '36' },
  { code: '79100', name: 'а.Узынколь', regionCode: '59', districtCode: '36' },
  { code: '79200', name: 'с.Косколь', regionCode: '59', districtCode: '36' },
  { code: '79300', name: 'с.Шандак', regionCode: '59', districtCode: '36' },
  { code: '83100', name: 'а. Байтерек', regionCode: '59', districtCode: '36' },
  {
    code: '83200',
    name: 'с.Hовотроицкое',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '83300', name: 'с.Новый Быт', regionCode: '59', districtCode: '36' },
  { code: '83400', name: 'с.Рявкино', regionCode: '59', districtCode: '36' },
  { code: '85100', name: 'с.Чистовское', regionCode: '59', districtCode: '36' },
  { code: '85200', name: 'с.Тищенко', regionCode: '59', districtCode: '36' },
  {
    code: '45680',
    name: 'с.Hикольско-Бурлукское',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '45700', name: 'с.Hикольское', regionCode: '59', districtCode: '32' },
  { code: '45780', name: 'с.Прекрасное', regionCode: '59', districtCode: '32' },
  { code: '46100', name: 'с.Каратал', regionCode: '59', districtCode: '32' },
  { code: '46200', name: 'с.Ботай', regionCode: '59', districtCode: '32' },
  { code: '46300', name: 'с.Высокое', regionCode: '59', districtCode: '32' },
  { code: '46500', name: 'с.Косколь', regionCode: '59', districtCode: '32' },
  { code: '46600', name: 'с.Сарыозек', regionCode: '59', districtCode: '32' },
  { code: '46800', name: 'а.Шукирлик', regionCode: '59', districtCode: '32' },
  {
    code: '47100',
    name: 'с.Hижний Бурлук',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '47400', name: 'с.Алтынбулак', regionCode: '59', districtCode: '32' },
  {
    code: '47500',
    name: 'а.Жаксы Жалгызтау',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '47700', name: 'с.Куспек', regionCode: '59', districtCode: '32' },
  { code: '48100', name: 'с.Лобаново', regionCode: '59', districtCode: '32' },
  { code: '48200', name: 'а. Альжан', regionCode: '59', districtCode: '32' },
  { code: '48400', name: 'с.Заря', regionCode: '59', districtCode: '32' },
  { code: '48700', name: 'с.Шалкар', regionCode: '59', districtCode: '32' },
  { code: '49100', name: 'с.Сырымбет', regionCode: '59', districtCode: '32' },
  { code: '49200', name: 'с.Даукара', regionCode: '59', districtCode: '32' },
  { code: '49300', name: 'а.Егиндыагаш', regionCode: '59', districtCode: '32' },
  { code: '49400', name: 'с.Качиловка', regionCode: '59', districtCode: '32' },
  { code: '49480', name: 'с.Каракамыс', regionCode: '59', districtCode: '32' },
  { code: '49500', name: 'с.Сарыбулак', regionCode: '59', districtCode: '32' },
  { code: '49600', name: 'с.Сулуколь', regionCode: '59', districtCode: '32' },
  { code: '49680', name: 'с.Шолакозек', regionCode: '59', districtCode: '32' },
  { code: '49700', name: 'с.Шоккарагай', regionCode: '59', districtCode: '32' },
  { code: '49800', name: 'с.Юдинка', regionCode: '59', districtCode: '32' },
  { code: '51100', name: 'с.Кирилловка', regionCode: '59', districtCode: '32' },
  { code: '51200', name: 'а.Бурлык', regionCode: '59', districtCode: '32' },
  {
    code: '51300',
    name: 'с.Каменный Брод',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '51400', name: 'с.Карловка', regionCode: '59', districtCode: '32' },
  { code: '51500', name: 'с.Кутузовка', regionCode: '59', districtCode: '32' },
  {
    code: '51600',
    name: 'с.Петропавловка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '51700', name: 'с.Сарысай', regionCode: '59', districtCode: '32' },
  { code: '51800', name: 'с.Сарытубек', regionCode: '59', districtCode: '32' },
  { code: '30100', name: 'с.Талшик', regionCode: '59', districtCode: '34' },
  { code: '30200', name: 'с.Казанское', regionCode: '59', districtCode: '34' },
  { code: '30500', name: 'с.Тугуржап', regionCode: '59', districtCode: '34' },
  { code: '30600', name: 'а.Ульгили', regionCode: '59', districtCode: '34' },
  {
    code: '32100',
    name: 'с.Айсаринское',
    regionCode: '59',
    districtCode: '34'
  },
  { code: '33100', name: 'а.Алкатерек', regionCode: '59', districtCode: '34' },
  { code: '35100', name: 'с.Восходское', regionCode: '59', districtCode: '34' },
  { code: '35200', name: 'а.Аксай', regionCode: '59', districtCode: '34' },
  { code: '36100', name: 'с.Кенащы', regionCode: '59', districtCode: '34' },
  { code: '36200', name: 'а.Байтус', regionCode: '59', districtCode: '34' },
  { code: '37100', name: 'с.Бостандык', regionCode: '59', districtCode: '34' },
  { code: '37300', name: 'с.Киевское', regionCode: '59', districtCode: '34' },
  { code: '38100', name: 'с.Кулыколь', regionCode: '59', districtCode: '34' },
  { code: '38300', name: 'с.Карашилик', regionCode: '59', districtCode: '34' },
  {
    code: '39100',
    name: 'с.Ленинградское',
    regionCode: '59',
    districtCode: '34'
  },
  { code: '39200', name: 'а.Дауит', regionCode: '59', districtCode: '34' },
  { code: '39300', name: 'а.Кызылту', regionCode: '59', districtCode: '34' },
  { code: '41100', name: 'с.Майское', regionCode: '59', districtCode: '34' },
  { code: '43100', name: 'с.Коммунизм', regionCode: '59', districtCode: '34' },
  {
    code: '43200',
    name: 'с.Горьковское',
    regionCode: '59',
    districtCode: '34'
  },
  { code: '45100', name: 'а.Акжаркын', regionCode: '59', districtCode: '34' },
  { code: '45200', name: 'с.Ащиколь', regionCode: '59', districtCode: '34' },
  { code: '49100', name: 'с.Уялы', regionCode: '59', districtCode: '34' },
  { code: '49400', name: 'с.Жаркын', regionCode: '59', districtCode: '34' },
  { code: '49800', name: 'а.Аксары', regionCode: '59', districtCode: '34' },
  { code: '20100', name: 'г.Булаево', regionCode: '59', districtCode: '36' },
  { code: '20200', name: 'с.Медвежка', regionCode: '59', districtCode: '36' },
  { code: '33100', name: 'с.Полтавка', regionCode: '59', districtCode: '36' },
  {
    code: '33200',
    name: 'с.Хлеборобное',
    regionCode: '59',
    districtCode: '36'
  },
  { code: '59500', name: 'с.Рухловка', regionCode: '59', districtCode: '66' },
  { code: '59700', name: 'с.Сазоновка', regionCode: '59', districtCode: '66' },
  { code: '63100', name: 'с.Червонное', regionCode: '59', districtCode: '66' },
  { code: '63300', name: 'с.Пески', regionCode: '59', districtCode: '66' },
  { code: '63500', name: 'с.Узынколь', regionCode: '59', districtCode: '66' },
  { code: '65100', name: 'с.Чистополье', regionCode: '59', districtCode: '66' },
  { code: '65200', name: 'с.Дубровка', regionCode: '59', districtCode: '66' },
  {
    code: '30100',
    name: 'с.Hовоишимское',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '10100',
    name: 'г.Петропавловск',
    regionCode: '59',
    districtCode: '1'
  },
  { code: '30100', name: 'с.Саумалколь', regionCode: '59', districtCode: '32' },
  { code: '33100', name: 'с.Антоновка', regionCode: '59', districtCode: '32' },
  {
    code: '30200',
    name: 'с.Hовоукраинка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '45200', name: 'с.Алка', regionCode: '59', districtCode: '42' },
  { code: '30100', name: 'с.Явленка', regionCode: '59', districtCode: '42' },
  { code: '33200', name: 'а.Акан сере', regionCode: '59', districtCode: '32' },
  { code: '33400', name: 'с.Жумысшы', regionCode: '59', districtCode: '32' },
  { code: '33480', name: 'с.Заря', regionCode: '59', districtCode: '32' },
  { code: '33580', name: 'с.Комаровка', regionCode: '59', districtCode: '32' },
  { code: '33680', name: 'с.Лавровка', regionCode: '59', districtCode: '32' },
  { code: '33800', name: 'с.Теренколь', regionCode: '59', districtCode: '32' },
  { code: '33900', name: 'ст.Уголки', regionCode: '59', districtCode: '32' },
  { code: '35100', name: 'с.Арыкбалык', regionCode: '59', districtCode: '32' },
  { code: '35200', name: 'с.Горное', regionCode: '59', districtCode: '32' },
  {
    code: '35300',
    name: 'а.Агынтай батыра',
    regionCode: '59',
    districtCode: '32'
  },
  {
    code: '35400',
    name: 'а.Карасай батыра',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '35500', name: 'а.Баян', regionCode: '59', districtCode: '32' },
  { code: '35600', name: 'с.Целинное', regionCode: '59', districtCode: '32' },
  { code: '39100', name: 'с.Гусаковка', regionCode: '59', districtCode: '32' },
  { code: '39200', name: 'с.Береславка', regionCode: '59', districtCode: '32' },
  { code: '39300', name: 'с.Карсаковка', regionCode: '59', districtCode: '32' },
  {
    code: '39500',
    name: 'с.Красный Кордон',
    regionCode: '59',
    districtCode: '32'
  },
  {
    code: '39600',
    name: 'с.Малосергеевка',
    regionCode: '59',
    districtCode: '32'
  },
  {
    code: '39800',
    name: 'с.Hовосветловка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '40100', name: 'с.Елецкое', regionCode: '59', districtCode: '32' },
  {
    code: '40300',
    name: 'с.Айыртауское',
    regionCode: '59',
    districtCode: '32'
  },
  {
    code: '40500',
    name: 'с.Колесниковка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '40700', name: 'с.Кругловка', regionCode: '59', districtCode: '32' },
  {
    code: '40800',
    name: 'с.Междуозерное',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '41100', name: 'с.Саумалколь', regionCode: '59', districtCode: '32' },
  { code: '41200', name: 'с.Айыртау', regionCode: '59', districtCode: '32' },
  {
    code: '41300',
    name: 'с.Воскресеновка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '41400', name: 'с.Галицино', regionCode: '59', districtCode: '32' },
  {
    code: '41680',
    name: 'с.Красногорка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '41780', name: 'с.Копа', regionCode: '59', districtCode: '32' },
  { code: '41900', name: 'с.Орловка', regionCode: '59', districtCode: '32' },
  {
    code: '42100',
    name: 'с.Константиновка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '42200', name: 'а.Аканбурлык', regionCode: '59', districtCode: '32' },
  { code: '42300', name: 'а.Акшокы', regionCode: '59', districtCode: '32' },
  { code: '42500', name: 'с.Красново', regionCode: '59', districtCode: '32' },
  { code: '42700', name: 'с.Матвеевка', regionCode: '59', districtCode: '32' },
  { code: '43100', name: 'с.Имантау', regionCode: '59', districtCode: '32' },
  {
    code: '43300',
    name: 'с.Верхний Бурлук',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '43600', name: 'с.Цуриковка', regionCode: '59', districtCode: '32' },
  { code: '44100', name: 'с.Карасевка', regionCode: '59', districtCode: '32' },
  { code: '44300', name: 'с.Бирлестик', regionCode: '59', districtCode: '32' },
  { code: '44400', name: 'а. Кумтоккен', regionCode: '59', districtCode: '32' },
  {
    code: '44500',
    name: 'с.Укили Ыбырай',
    regionCode: '59',
    districtCode: '32'
  },
  {
    code: '44600',
    name: 'с.Орлиногорское',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '44700', name: 'с.Светлое', regionCode: '59', districtCode: '32' },
  { code: '45100', name: 'с.Казанка', regionCode: '59', districtCode: '32' },
  { code: '45200', name: 'с.Аксеновка', regionCode: '59', districtCode: '32' },
  { code: '45300', name: 'а.Бурлык', regionCode: '59', districtCode: '32' },
  {
    code: '45400',
    name: 'с.Всеволодовка',
    regionCode: '59',
    districtCode: '32'
  },
  { code: '45500', name: 'с.Грачевка', regionCode: '59', districtCode: '32' },
  { code: '37200', name: 'с.Карамырза', regionCode: '59', districtCode: '64' },
  { code: '41100', name: 'с.Кайрат', regionCode: '59', districtCode: '64' },
  { code: '41500', name: 'с.Жаскайрат', regionCode: '59', districtCode: '64' },
  { code: '43100', name: 'а.Аккудык', regionCode: '59', districtCode: '64' },
  {
    code: '43580',
    name: 'с.Золотая Hива',
    regionCode: '59',
    districtCode: '64'
  },
  { code: '45100', name: 'с.Каратерек', regionCode: '59', districtCode: '64' },
  { code: '45400', name: 'а.Малкара', regionCode: '59', districtCode: '64' },
  { code: '46100', name: 'с.Кулыколь', regionCode: '59', districtCode: '64' },
  { code: '46200', name: 'с.Береке', regionCode: '59', districtCode: '64' },
  { code: '46300', name: 'с.Каратал', regionCode: '59', districtCode: '64' },
  { code: '47100', name: 'а.Тельжан', regionCode: '59', districtCode: '64' },
  { code: '47200', name: 'с.Кобенсай', regionCode: '59', districtCode: '64' },
  { code: '49100', name: 'а.Акбулак', regionCode: '59', districtCode: '64' },
  { code: '49200', name: 'с.Карашилик', regionCode: '59', districtCode: '64' },
  {
    code: '49300',
    name: 'с.Молодая Гвардия',
    regionCode: '59',
    districtCode: '64'
  },
  { code: '33100', name: 'с.Андреевка', regionCode: '59', districtCode: '66' },
  { code: '33200', name: 'с.Беспаловка', regionCode: '59', districtCode: '66' },
  { code: '33400', name: 'с.Жанасу', regionCode: '59', districtCode: '66' },
  { code: '33600', name: 'с.Раисовка', regionCode: '59', districtCode: '66' },
  { code: '35100', name: 'а.Бирлик', regionCode: '59', districtCode: '66' },
  { code: '35300', name: 'с.Старобелка', regionCode: '59', districtCode: '66' },
  { code: '37100', name: 'с.Возвышенка', regionCode: '59', districtCode: '66' },
  { code: '37200', name: 'с.Брилевка', regionCode: '59', districtCode: '66' },
  {
    code: '37300',
    name: 'с.Григорьевка',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '37400',
    name: 'с.Стерлитамак',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '37500',
    name: 'с.Чернозубовка',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '37700', name: 'с.Куйган', regionCode: '59', districtCode: '66' },
  { code: '39100', name: 'с.Гаршино', regionCode: '59', districtCode: '66' },
  { code: '39300', name: 'с.Шакпак', regionCode: '59', districtCode: '66' },
  { code: '43100', name: 'с.Дружба', regionCode: '59', districtCode: '66' },
  {
    code: '43200',
    name: 'с.Володарское',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '43400', name: 'с.Жарколь', regionCode: '59', districtCode: '66' },
  { code: '43500', name: 'с.Целинное', regionCode: '59', districtCode: '66' },
  { code: '44100', name: 'а. Кокалажар', regionCode: '59', districtCode: '66' },
  { code: '44500', name: 'а.Мадениет', regionCode: '59', districtCode: '66' },
  { code: '44700', name: 'с.Сарыбулак', regionCode: '59', districtCode: '66' },
  { code: '45100', name: 'с.Кырымбет', regionCode: '59', districtCode: '66' },
  { code: '45300', name: 'с.Мищенка', regionCode: '59', districtCode: '66' },
  {
    code: '45400',
    name: 'с.Сокологоровка',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '47100',
    name: 'с.Ломоносовка',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '47200',
    name: 'с.Ломоносовское',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '47300',
    name: 'с.Ставрополка',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '47400', name: 'с.Степное', regionCode: '59', districtCode: '66' },
  { code: '47500', name: 'с.Урожайное', regionCode: '59', districtCode: '66' },
  { code: '49100', name: 'с.Hежинка', regionCode: '59', districtCode: '66' },
  { code: '49200', name: 'с.Буденное', regionCode: '59', districtCode: '66' },
  { code: '49280', name: 'с.Ефимовка', regionCode: '59', districtCode: '66' },
  {
    code: '49400',
    name: 'аул Токсан би',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '49500',
    name: 'с.Куприяновка',
    regionCode: '59',
    districtCode: '66'
  },
  {
    code: '53100',
    name: 'с.Hовоселовка',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '53400', name: 'с.Мукур', regionCode: '59', districtCode: '66' },
  { code: '53500', name: 'с.Привольное', regionCode: '59', districtCode: '66' },
  { code: '57100', name: 'с.Рузаевка', regionCode: '59', districtCode: '66' },
  { code: '57200', name: 'с.Березовка', regionCode: '59', districtCode: '66' },
  { code: '57300', name: 'с.Золотоноша', regionCode: '59', districtCode: '66' },
  { code: '57500', name: 'с.Сарыадыр', regionCode: '59', districtCode: '66' },
  { code: '57600', name: 'с.Сивковка', regionCode: '59', districtCode: '66' },
  {
    code: '57700',
    name: 'с.Чернобаевка',
    regionCode: '59',
    districtCode: '66'
  },
  { code: '58100', name: 'с.Салкынколь', regionCode: '59', districtCode: '66' },
  { code: '58500', name: 'а.Токты', regionCode: '59', districtCode: '66' },
  { code: '59100', name: 'с.Тахтаброд', regionCode: '59', districtCode: '66' },
  { code: '59200', name: 'с.Ковыльное', regionCode: '59', districtCode: '66' },
  { code: '59300', name: 'с.Литвиновка', regionCode: '59', districtCode: '66' },
  { code: '59400', name: 'с.Привольное', regionCode: '59', districtCode: '66' },
  { code: '57480', name: 'с.Подгорное', regionCode: '63', districtCode: '50' },
  { code: '59100', name: 'с.Бигаш', regionCode: '63', districtCode: '50' },
  { code: '59200', name: 'с.Егинбулак', regionCode: '63', districtCode: '50' },
  { code: '59300', name: 'с.Комсомол', regionCode: '63', districtCode: '50' },
  { code: '59400', name: 'а.Каргалы', regionCode: '63', districtCode: '50' },
  {
    code: '41100',
    name: 'п.Октябрьский',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '41200', name: 'ст.Бухтарма', regionCode: '63', districtCode: '48' },
  { code: '41300', name: 'с.Сажаевка', regionCode: '63', districtCode: '48' },
  {
    code: '41400',
    name: 'ст.Селезневка',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '43100', name: 'с.Hикольск', regionCode: '63', districtCode: '48' },
  { code: '43200', name: 'с.Алтайка', regionCode: '63', districtCode: '48' },
  { code: '43300', name: 'с.Бородино', regionCode: '63', districtCode: '48' },
  { code: '43400', name: 'с.Кремнюха', regionCode: '63', districtCode: '48' },
  { code: '45100', name: 'с.Парыгино', regionCode: '63', districtCode: '48' },
  { code: '45200', name: 'с.Баяновск', regionCode: '63', districtCode: '48' },
  { code: '45500', name: 'с.Кутиха', regionCode: '63', districtCode: '48' },
  {
    code: '47100',
    name: 'с.Первороссийское',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '47200', name: 'с.Васильевка', regionCode: '63', districtCode: '48' },
  { code: '47300', name: 'с.Дородница', regionCode: '63', districtCode: '48' },
  { code: '49100', name: 'п.Прибрежный', regionCode: '63', districtCode: '48' },
  { code: '49200', name: 'с.Заводинка', regionCode: '63', districtCode: '48' },
  {
    code: '53100',
    name: 'с.Феклистовка',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '53200', name: 'с.Ермаковка', regionCode: '63', districtCode: '48' },
  { code: '53400', name: 'с.Северное', regionCode: '63', districtCode: '48' },
  { code: '55100', name: 'с.Соловьево', regionCode: '63', districtCode: '48' },
  { code: '55200', name: 'с.Бедаревка', regionCode: '63', districtCode: '48' },
  {
    code: '55300',
    name: 'с.Hово-Крестьянка',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '55400', name: 'с.Ленинск', regionCode: '63', districtCode: '48' },
  {
    code: '57100',
    name: 'с.Средигорное',
    regionCode: '63',
    districtCode: '48'
  },
  {
    code: '57200',
    name: 'с.Александровка',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '57300', name: 'с.Андреевка', regionCode: '63', districtCode: '48' },
  { code: '57400', name: 'с.Чиркаин', regionCode: '63', districtCode: '48' },
  { code: '59100', name: 'с.Тургусун', regionCode: '63', districtCode: '48' },
  { code: '61100', name: 'с.Чапаево', regionCode: '63', districtCode: '48' },
  { code: '61200', name: 'с.Крестовка', regionCode: '63', districtCode: '48' },
  { code: '61300', name: 'с.Орловка', regionCode: '63', districtCode: '48' },
  { code: '61400', name: 'с.Пролетарка', regionCode: '63', districtCode: '48' },
  { code: '61500', name: 'с.Снегирево', regionCode: '63', districtCode: '48' },
  { code: '30100', name: 'с.Кокпекты', regionCode: '63', districtCode: '50' },
  { code: '30300', name: 'а.Ажа', regionCode: '63', districtCode: '50' },
  { code: '30400', name: 'с.Узунбулак', regionCode: '63', districtCode: '50' },
  { code: '30500', name: 'а.Шариптогай', regionCode: '63', districtCode: '50' },
  { code: '30600', name: 'а.Толагай', regionCode: '63', districtCode: '50' },
  { code: '33100', name: 'с.Бастауши', regionCode: '63', districtCode: '50' },
  { code: '33200', name: 'с.Кокжота', regionCode: '63', districtCode: '50' },
  {
    code: '35100',
    name: 'а.Улкен Бокен',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '35200', name: 'с.Актас', regionCode: '63', districtCode: '50' },
  { code: '35300', name: 'с.Жалсары', regionCode: '63', districtCode: '50' },
  { code: '37100', name: 'с.Казнаковка', regionCode: '63', districtCode: '50' },
  { code: '37200', name: 'с.Кокжыра', regionCode: '63', districtCode: '50' },
  { code: '39100', name: 'а.Кокжайык', regionCode: '63', districtCode: '50' },
  { code: '39300', name: 'а.Акой', regionCode: '63', districtCode: '50' },
  { code: '39500', name: 'а.Карамойыл', regionCode: '63', districtCode: '50' },
  {
    code: '45100',
    name: 'с.Преображенка',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '45200', name: 'а.Укиликыз', regionCode: '63', districtCode: '50' },
  {
    code: '45300',
    name: 'с.Малая Буконь',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '45400', name: 'с.Черноярка', regionCode: '63', districtCode: '50' },
  {
    code: '47100',
    name: 'с.Карагандыколь',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '47300', name: 'с.Мамай', regionCode: '63', districtCode: '50' },
  {
    code: '49100',
    name: 'с.Hово-Тимофеевка',
    regionCode: '63',
    districtCode: '50'
  },
  {
    code: '49300',
    name: 'с.Hовостройка',
    regionCode: '63',
    districtCode: '50'
  },
  {
    code: '53100',
    name: 'с.Мариногорка',
    regionCode: '63',
    districtCode: '50'
  },
  {
    code: '53300',
    name: 'с.Малороссийка',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '53400', name: 'с.Московка', regionCode: '63', districtCode: '50' },
  {
    code: '55100',
    name: 'с.Миролюбовка',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '55400', name: 'с.Раздольное', regionCode: '63', districtCode: '50' },
  { code: '57100', name: 'с.Палатцы', regionCode: '63', districtCode: '50' },
  { code: '57280', name: 'с.Каракол', regionCode: '63', districtCode: '50' },
  { code: '57300', name: 'с.Песчанка', regionCode: '63', districtCode: '50' },
  { code: '79200', name: 'а.Былкылдак', regionCode: '63', districtCode: '44' },
  { code: '79300', name: 'а.Кентарлау', regionCode: '63', districtCode: '44' },
  { code: '81100', name: 'с.Кызылагаш', regionCode: '63', districtCode: '44' },
  { code: '81300', name: 'с.Карасу', regionCode: '63', districtCode: '44' },
  { code: '81400', name: 'с.Каратоган', regionCode: '63', districtCode: '44' },
  { code: '83100', name: 'с.Ушбиик', regionCode: '63', districtCode: '44' },
  { code: '83200', name: 'с.Енрекей', regionCode: '63', districtCode: '44' },
  { code: '83300', name: 'рзд.18 км', regionCode: '63', districtCode: '44' },
  { code: '85100', name: 'п.Суыкбулак', regionCode: '63', districtCode: '44' },
  {
    code: '85200',
    name: 'с.Дельбегетей',
    regionCode: '63',
    districtCode: '44'
  },
  {
    code: '87100',
    name: 'с.Теристанбалы',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '87200', name: 'с.Узунжал', regionCode: '63', districtCode: '44' },
  { code: '89100', name: 'с.Шалабай', regionCode: '63', districtCode: '44' },
  { code: '89200', name: 'с.Жанааул', regionCode: '63', districtCode: '44' },
  { code: '20100', name: 'г.Зайсан', regionCode: '63', districtCode: '46' },
  { code: '33100', name: 'а.Биржан', regionCode: '63', districtCode: '46' },
  { code: '33200', name: 'с.Акарал', regionCode: '63', districtCode: '46' },
  { code: '33300', name: 'с.Куаныш', regionCode: '63', districtCode: '46' },
  { code: '35100', name: 'с.Каратал', regionCode: '63', districtCode: '46' },
  { code: '35200', name: 'с.Жинишкесу', regionCode: '63', districtCode: '46' },
  { code: '35300', name: 'с.Кабыргатал', regionCode: '63', districtCode: '46' },
  { code: '35400', name: 'с.Коскора', regionCode: '63', districtCode: '46' },
  {
    code: '35500',
    name: 'с.Улкен Каратал',
    regionCode: '63',
    districtCode: '46'
  },
  { code: '37100', name: 'а.Кенсай', regionCode: '63', districtCode: '46' },
  { code: '37200', name: 'с.Бакасу', regionCode: '63', districtCode: '46' },
  { code: '37300', name: 'с.Жарсу', regionCode: '63', districtCode: '46' },
  { code: '37500', name: 'с.Сарыши', regionCode: '63', districtCode: '46' },
  { code: '37600', name: 'с.Сарыжыра', regionCode: '63', districtCode: '46' },
  { code: '39100', name: 'с.Карабулак', regionCode: '63', districtCode: '46' },
  { code: '39200', name: 'с.Дауал', regionCode: '63', districtCode: '46' },
  { code: '39500', name: 'с.Сатбай', regionCode: '63', districtCode: '46' },
  { code: '43100', name: 'а.Сарытерек', regionCode: '63', districtCode: '46' },
  { code: '43200', name: 'с.Аккойын', regionCode: '63', districtCode: '46' },
  { code: '43300', name: 'а.Шалкар', regionCode: '63', districtCode: '46' },
  { code: '43400', name: 'с.Жанабаз', regionCode: '63', districtCode: '46' },
  { code: '43600', name: 'с.Когедай', regionCode: '63', districtCode: '46' },
  { code: '45100', name: 'с.Айнабулак', regionCode: '63', districtCode: '46' },
  { code: '45200', name: 'с.Жанатурмыс', regionCode: '63', districtCode: '46' },
  { code: '45300', name: 'с.Талды', regionCode: '63', districtCode: '46' },
  { code: '45400', name: 'с.Кайнар', regionCode: '63', districtCode: '46' },
  { code: '45500', name: 'с.Сарытумсык', regionCode: '63', districtCode: '46' },
  { code: '45600', name: 'с.Чурчутсу', regionCode: '63', districtCode: '46' },
  { code: '47100', name: 'с.Дайыр', regionCode: '63', districtCode: '46' },
  { code: '47200', name: 'с.Жамбыл', regionCode: '63', districtCode: '46' },
  { code: '47300', name: 'а.Кокжыра', regionCode: '63', districtCode: '46' },
  { code: '49100', name: 'с.Шиликты', regionCode: '63', districtCode: '46' },
  { code: '49200', name: 'с.Жалшы', regionCode: '63', districtCode: '46' },
  { code: '49300', name: 'с.Какенталды', regionCode: '63', districtCode: '46' },
  { code: '49500', name: 'с.Карасай', regionCode: '63', districtCode: '46' },
  { code: '49600', name: 'с.Тасбастау', regionCode: '63', districtCode: '46' },
  {
    code: '33100',
    name: 'с.Березовское',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '33300', name: 'с.Ландман', regionCode: '63', districtCode: '48' },
  { code: '33400', name: 'с.Маяк', regionCode: '63', districtCode: '48' },
  { code: '33500', name: 'с.Подорленок', regionCode: '63', districtCode: '48' },
  { code: '33700', name: 'с.Восточное', regionCode: '63', districtCode: '48' },
  {
    code: '35100',
    name: 'п.Hовая Бухтарма',
    regionCode: '63',
    districtCode: '48'
  },
  {
    code: '35200',
    name: 'с.Александровка',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '35300', name: 'с.Березовка', regionCode: '63', districtCode: '48' },
  {
    code: '35400',
    name: 'Дом отдыха Голубой залив',
    regionCode: '63',
    districtCode: '48'
  },
  { code: '37100', name: 'п.Зубовка', regionCode: '63', districtCode: '48' },
  { code: '39100', name: 'с.Малеевск', regionCode: '63', districtCode: '48' },
  { code: '39200', name: 'с.Богатырево', regionCode: '63', districtCode: '48' },
  { code: '39300', name: 'с.Быково', regionCode: '63', districtCode: '48' },
  { code: '39500', name: 'с.Путинцево', regionCode: '63', districtCode: '48' },
  {
    code: '65200',
    name: 'с.Каменный Карьер',
    regionCode: '63',
    districtCode: '40'
  },
  {
    code: '65300',
    name: 'с.Комсомольское',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '65400', name: 'с.Степное', regionCode: '63', districtCode: '40' },
  { code: '67100', name: 'с.Тарханка', regionCode: '63', districtCode: '40' },
  { code: '67200', name: 'с.Веселое', regionCode: '63', districtCode: '40' },
  { code: '67300', name: 'с.Винное', regionCode: '63', districtCode: '40' },
  {
    code: '67500',
    name: 'с.Hовая Ульба',
    regionCode: '63',
    districtCode: '40'
  },
  {
    code: '67600',
    name: 'ст.Ульба перевалочная',
    regionCode: '63',
    districtCode: '40'
  },
  {
    code: '67700',
    name: 'с.Горная Ульбинка',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '67800', name: 'с.Топиха', regionCode: '63', districtCode: '40' },
  { code: '69100', name: 'с.Черемшанка', regionCode: '63', districtCode: '40' },
  { code: '21100', name: 'г.Шар', regionCode: '63', districtCode: '44' },
  { code: '21200', name: 'с.Еспе', regionCode: '63', districtCode: '44' },
  { code: '21300', name: 'с.Кезенсу', regionCode: '63', districtCode: '44' },
  { code: '21400', name: 'с.Кошек', regionCode: '63', districtCode: '44' },
  { code: '21700', name: 'с.Сарыарка', regionCode: '63', districtCode: '44' },
  { code: '21780', name: 'рзд.6', regionCode: '63', districtCode: '44' },
  { code: '21900', name: 'с.Суырлы', regionCode: '63', districtCode: '44' },
  { code: '30100', name: 'с.Калбатау', regionCode: '63', districtCode: '44' },
  { code: '30300', name: 'с.Бурлыагаш', regionCode: '63', districtCode: '44' },
  {
    code: '30400',
    name: 'с.Батыр Капай',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '30500', name: 'с.Женишке', regionCode: '63', districtCode: '44' },
  { code: '30700', name: 'а.Жанаозен', regionCode: '63', districtCode: '44' },
  { code: '30800', name: 'с.Ортабулак', regionCode: '63', districtCode: '44' },
  { code: '33100', name: 'с.Акжал', regionCode: '63', districtCode: '44' },
  { code: '33200', name: 'с.Боке', regionCode: '63', districtCode: '44' },
  { code: '35100', name: 'п.Ауэзов', regionCode: '63', districtCode: '44' },
  { code: '35200', name: 'с.Солнечное', regionCode: '63', districtCode: '44' },
  { code: '37100', name: 'с.Белтерек', regionCode: '63', districtCode: '44' },
  {
    code: '37200',
    name: 'с.Балыктыколь',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '37300', name: 'с.Карашокы', regionCode: '63', districtCode: '44' },
  { code: '37400', name: 'с.8 Марта', regionCode: '63', districtCode: '44' },
  { code: '39100', name: 'а.Салкынтобе', regionCode: '63', districtCode: '44' },
  { code: '39200', name: 'а.Каражал', regionCode: '63', districtCode: '44' },
  { code: '39300', name: 'с.Укили', regionCode: '63', districtCode: '44' },
  { code: '45100', name: 'а.Бирлик', regionCode: '63', districtCode: '44' },
  { code: '45200', name: 'с.Амангельды', regionCode: '63', districtCode: '44' },
  { code: '45400', name: 'а.Каракожа', regionCode: '63', districtCode: '44' },
  { code: '47100', name: 'с.Сулусары', regionCode: '63', districtCode: '44' },
  {
    code: '47300',
    name: 'с.Казан-чункур',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '47400', name: 'с.Койтас', regionCode: '63', districtCode: '44' },
  { code: '47500', name: 'а.Шымылдык', regionCode: '63', districtCode: '44' },
  { code: '53100', name: 'с.Конырбиик', regionCode: '63', districtCode: '44' },
  { code: '53400', name: 'с.Суыкбулак', regionCode: '63', districtCode: '44' },
  { code: '57100', name: 'п.Жангизтобе', regionCode: '63', districtCode: '44' },
  { code: '57300', name: 'рзд.10 км', regionCode: '63', districtCode: '44' },
  { code: '57400', name: 'с.Солнечное', regionCode: '63', districtCode: '44' },
  { code: '59100', name: 'с.Жайма', regionCode: '63', districtCode: '44' },
  { code: '63100', name: 'п.Жарма', regionCode: '63', districtCode: '44' },
  { code: '63200', name: 'с.Каракойтас', regionCode: '63', districtCode: '44' },
  { code: '63300', name: 'рзд.15 км', regionCode: '63', districtCode: '44' },
  { code: '65100', name: 'с.Жарык', regionCode: '63', districtCode: '44' },
  { code: '65200', name: 'с.Кызылкайын', regionCode: '63', districtCode: '44' },
  { code: '65300', name: 'с.Малай', regionCode: '63', districtCode: '44' },
  { code: '73100', name: 'а.Аршалы', regionCode: '63', districtCode: '44' },
  { code: '73200', name: 'а.Жарыктас', regionCode: '63', districtCode: '44' },
  { code: '75100', name: 'с.Капанбулак', regionCode: '63', districtCode: '44' },
  {
    code: '75200',
    name: 'с.Балыктыколь',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '75300', name: 'с.Егинбулак', regionCode: '63', districtCode: '44' },
  {
    code: '75400',
    name: 'ст.Капанбулак',
    regionCode: '63',
    districtCode: '44'
  },
  {
    code: '75500',
    name: 'с.Кызылжулдуз',
    regionCode: '63',
    districtCode: '44'
  },
  {
    code: '77100',
    name: 'с.Киши Карасу',
    regionCode: '63',
    districtCode: '44'
  },
  { code: '77200', name: 'с.Аскаралы', regionCode: '63', districtCode: '44' },
  { code: '79100', name: 'а.Каратобе', regionCode: '63', districtCode: '44' },
  { code: '57100', name: 'с.Ивановка', regionCode: '63', districtCode: '38' },
  {
    code: '57200',
    name: 'Подхоз Березовка',
    regionCode: '63',
    districtCode: '38'
  },
  {
    code: '57300',
    name: 'Санаторий Березовка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '57500', name: 'с.Сосновка', regionCode: '63', districtCode: '38' },
  {
    code: '59100',
    name: 'с.Hовопокровка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '59200', name: 'с.Арбузное', regionCode: '63', districtCode: '38' },
  { code: '59300', name: 'с.Сарногай', regionCode: '63', districtCode: '38' },
  {
    code: '73100',
    name: 'с.Hовая Шульба',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '73200', name: 'с.Ключики', regionCode: '63', districtCode: '38' },
  {
    code: '73300',
    name: 'с.Потапенково',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '73400', name: 'с.Пролетарка', regionCode: '63', districtCode: '38' },
  { code: '73600', name: 'с.Солоновка', regionCode: '63', districtCode: '38' },
  {
    code: '75100',
    name: 'с.Переменовка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '75200', name: 'с.Андроновка', regionCode: '63', districtCode: '38' },
  { code: '75300', name: 'с.Орловка', regionCode: '63', districtCode: '38' },
  { code: '75400', name: 'с.Ремки', regionCode: '63', districtCode: '38' },
  {
    code: '77100',
    name: 'с.Петропавловка',
    regionCode: '63',
    districtCode: '38'
  },
  {
    code: '77200',
    name: 'с.Воскресеновка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '77300', name: 'с.Изатулла', regionCode: '63', districtCode: '38' },
  { code: '77400', name: 'с.Мещанка', regionCode: '63', districtCode: '38' },
  { code: '79100', name: 'с.Камышенка', regionCode: '63', districtCode: '38' },
  { code: '79200', name: 'с.Михайловка', regionCode: '63', districtCode: '38' },
  { code: '79300', name: 'с.Романовка', regionCode: '63', districtCode: '38' },
  { code: '83100', name: 'с.Шелехово', regionCode: '63', districtCode: '38' },
  {
    code: '83200',
    name: 'с.Вознесеновка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '83300', name: 'с.Орловка', regionCode: '63', districtCode: '38' },
  { code: '83400', name: 'с.Троицкое', regionCode: '63', districtCode: '38' },
  { code: '85100', name: 'с.Буркотово', regionCode: '63', districtCode: '38' },
  { code: '85200', name: 'с.Богомолово', regionCode: '63', districtCode: '38' },
  {
    code: '85300',
    name: 'с.Кондратьевка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '85400', name: 'с.Сохновка', regionCode: '63', districtCode: '38' },
  {
    code: '89100',
    name: 'с.Уба-Форпост',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '89200', name: 'с.Девятка', regionCode: '63', districtCode: '38' },
  { code: '30100', name: 'п.Глубокое', regionCode: '63', districtCode: '40' },
  { code: '33100', name: 'п.Алтайский', regionCode: '63', districtCode: '40' },
  { code: '33200', name: 'с.Калинино', regionCode: '63', districtCode: '40' },
  { code: '37100', name: 'п.Белоусовка', regionCode: '63', districtCode: '40' },
  {
    code: '37200',
    name: 'с.Белокаменка',
    regionCode: '63',
    districtCode: '40'
  },
  {
    code: '37300',
    name: 'с.Hовомихайловка',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '37400', name: 'с.Планидовка', regionCode: '63', districtCode: '40' },
  { code: '39100', name: 'с.Бобровка', regionCode: '63', districtCode: '40' },
  { code: '39300', name: 'с.Солнечное', regionCode: '63', districtCode: '40' },
  { code: '41100', name: 'с.Веселовка', regionCode: '63', districtCode: '40' },
  { code: '41200', name: 'с.Заречное', regionCode: '63', districtCode: '40' },
  {
    code: '45100',
    name: 'п.Верхнеберезовка',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '47100', name: 'с.Березовка', regionCode: '63', districtCode: '40' },
  {
    code: '47200',
    name: 'с.Красная Заря',
    regionCode: '63',
    districtCode: '40'
  },
  {
    code: '49100',
    name: 'с.Прапорщиково',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '49300', name: 'рзд.226 км', regionCode: '63', districtCode: '40' },
  { code: '49400', name: 'с.Уварово', regionCode: '63', districtCode: '40' },
  { code: '49500', name: 'с.Черногорка', regionCode: '63', districtCode: '40' },
  { code: '51100', name: 'с.Кожохово', regionCode: '63', districtCode: '40' },
  { code: '51200', name: 'с.Прогресс', regionCode: '63', districtCode: '40' },
  { code: '51300', name: 'с.Сметанино', regionCode: '63', districtCode: '40' },
  { code: '53100', name: 'с.Предгорное', regionCode: '63', districtCode: '40' },
  {
    code: '53300',
    name: 'с.Перевальное',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '55100', name: 'с.Быструха', regionCode: '63', districtCode: '40' },
  { code: '55300', name: 'с.Зимовье', regionCode: '63', districtCode: '40' },
  {
    code: '57100',
    name: 'с.Мало-Убинка',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '57200', name: 'с.Волчиха', regionCode: '63', districtCode: '40' },
  { code: '57400', name: 'п.Карагужиха', regionCode: '63', districtCode: '40' },
  {
    code: '61100',
    name: 'с.Опытное поле',
    regionCode: '63',
    districtCode: '40'
  },
  { code: '63100', name: 'с.Секисовка', regionCode: '63', districtCode: '40' },
  { code: '65100', name: 'с.Ушаново', regionCode: '63', districtCode: '40' },
  { code: '87500', name: 'с.Ортаарал', regionCode: '63', districtCode: '34' },
  { code: '30100', name: 'с.Бескарагай', regionCode: '63', districtCode: '36' },
  {
    code: '33100',
    name: 'с.Hовая Hиколаевка',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '33200', name: 'с.Башкуль', regionCode: '63', districtCode: '36' },
  { code: '33300', name: 'с.Букебай', regionCode: '63', districtCode: '36' },
  { code: '35100', name: 'с.Бегень', regionCode: '63', districtCode: '36' },
  {
    code: '35200',
    name: 'Бегенский лесхоз',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '37100', name: 'с.Глуховка', regionCode: '63', districtCode: '36' },
  { code: '37200', name: 'с.Аккульск', regionCode: '63', districtCode: '36' },
  {
    code: '37300',
    name: 'с.Белокаменка',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '37400', name: 'с.Бирлик', regionCode: '63', districtCode: '36' },
  { code: '37500', name: 'с.Джеланды', regionCode: '63', districtCode: '36' },
  {
    code: '37600',
    name: 'с.Старая Крепость',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '37700', name: 'с.Стеклянка', regionCode: '63', districtCode: '36' },
  { code: '41100', name: 'с.Долонь', regionCode: '63', districtCode: '36' },
  { code: '41200', name: 'с.Бодене', regionCode: '63', districtCode: '36' },
  { code: '41300', name: 'с.Мостик', regionCode: '63', districtCode: '36' },
  { code: '41400', name: 'с.Черемушка', regionCode: '63', districtCode: '36' },
  { code: '43100', name: 'с.Канонерка', regionCode: '63', districtCode: '36' },
  { code: '43200', name: 'с.Карамырза', regionCode: '63', districtCode: '36' },
  {
    code: '45100',
    name: 'с.Малая Владимировка',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '45200', name: 'с.Бозтал', regionCode: '63', districtCode: '36' },
  { code: '47100', name: 'с.Семеновка', regionCode: '63', districtCode: '36' },
  { code: '47200', name: 'с.Ондирис', regionCode: '63', districtCode: '36' },
  { code: '49100', name: 'с.Семиярка', regionCode: '63', districtCode: '36' },
  { code: '49200', name: 'с.Кривинка', regionCode: '63', districtCode: '36' },
  { code: '49300', name: 'с.Лесное', regionCode: '63', districtCode: '36' },
  { code: '51100', name: 'с.Сосновка', regionCode: '63', districtCode: '36' },
  { code: '51200', name: 'с.Коянбай', regionCode: '63', districtCode: '36' },
  {
    code: '51300',
    name: 'Морозовский лесхоз',
    regionCode: '63',
    districtCode: '36'
  },
  { code: '51400', name: 'с.Полянка', regionCode: '63', districtCode: '36' },
  { code: '30100', name: 'с.Бородулиха', regionCode: '63', districtCode: '38' },
  { code: '30200', name: 'с.Барышовка', regionCode: '63', districtCode: '38' },
  { code: '30300', name: 'с.Знаменка', regionCode: '63', districtCode: '38' },
  {
    code: '30400',
    name: 'с.Поднебесное',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '30600', name: 'с.Успенка', regionCode: '63', districtCode: '38' },
  {
    code: '33100',
    name: 'с.Михайличенково',
    regionCode: '63',
    districtCode: '38'
  },
  {
    code: '33200',
    name: 'с.Петроградское',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '35100', name: 'с.Бель-Агач', regionCode: '63', districtCode: '38' },
  { code: '35300', name: 'с.Беккарьер', regionCode: '63', districtCode: '38' },
  { code: '35400', name: 'с.Бековка', regionCode: '63', districtCode: '38' },
  { code: '35600', name: 'рзд.Дюсакен', regionCode: '63', districtCode: '38' },
  { code: '35700', name: 'с.Зенковка', regionCode: '63', districtCode: '38' },
  { code: '35800', name: 'рзд.41', regionCode: '63', districtCode: '38' },
  { code: '35900', name: 'с.Умурзак', regionCode: '63', districtCode: '38' },
  { code: '37100', name: 'с.Коростели', regionCode: '63', districtCode: '38' },
  { code: '37200', name: 'ст.Аул', regionCode: '63', districtCode: '38' },
  { code: '37700', name: 'с.Тарск', regionCode: '63', districtCode: '38' },
  { code: '43100', name: 'с.Дмитриевка', regionCode: '63', districtCode: '38' },
  { code: '43200', name: 'с.Боровое', regionCode: '63', districtCode: '38' },
  { code: '45100', name: 'п.Жезкент', regionCode: '63', districtCode: '38' },
  { code: '47100', name: 'с.Жерновка', regionCode: '63', districtCode: '38' },
  { code: '47300', name: 'с.Боровлянка', regionCode: '63', districtCode: '38' },
  { code: '47500', name: 'с.Поллог', regionCode: '63', districtCode: '38' },
  { code: '49100', name: 'с.Зубаир', regionCode: '63', districtCode: '38' },
  { code: '49200', name: 'с.Байтанат', regionCode: '63', districtCode: '38' },
  { code: '49300', name: 'с.Жанаауыл', regionCode: '63', districtCode: '38' },
  { code: '51100', name: 'с.Красный Яр', regionCode: '63', districtCode: '38' },
  { code: '51200', name: 'с.Речное', regionCode: '63', districtCode: '38' },
  { code: '55100', name: 'с.Песчанка', regionCode: '63', districtCode: '38' },
  { code: '55200', name: 'с.Алексеевка', regionCode: '63', districtCode: '38' },
  {
    code: '55400',
    name: 'с.2 Пятилетка',
    regionCode: '63',
    districtCode: '38'
  },
  {
    code: '55600',
    name: 'с.Hово-Васильевка',
    regionCode: '63',
    districtCode: '38'
  },
  { code: '55800', name: 'с.Мурзово', regionCode: '63', districtCode: '38' },
  { code: '45100', name: 'с.Медеу', regionCode: '63', districtCode: '32' },
  { code: '47100', name: 'с.Кокбай', regionCode: '63', districtCode: '32' },
  { code: '49100', name: 'с.Токтамыс', regionCode: '63', districtCode: '32' },
  { code: '53100', name: 'с.Сарыжал', regionCode: '63', districtCode: '32' },
  { code: '39100', name: 'с.Айгыз', regionCode: '63', districtCode: '34' },
  { code: '39200', name: 'с.Борлы', regionCode: '63', districtCode: '34' },
  { code: '39300', name: 'с.Коксала', regionCode: '63', districtCode: '34' },
  { code: '41100', name: 'п.Актогай', regionCode: '63', districtCode: '34' },
  { code: '43100', name: 'с.Доненбай', regionCode: '63', districtCode: '34' },
  { code: '43200', name: 'с.Акклет', regionCode: '63', districtCode: '34' },
  { code: '43400', name: 'с.Колгутты', regionCode: '63', districtCode: '34' },
  { code: '43500', name: 'с.Коныртау', regionCode: '63', districtCode: '34' },
  { code: '45100', name: 'с.Акшаули', regionCode: '63', districtCode: '34' },
  { code: '45300', name: 'с.Карабулак', regionCode: '63', districtCode: '34' },
  { code: '47100', name: 'с.Акши', regionCode: '63', districtCode: '34' },
  { code: '47200', name: 'с.Актубек', regionCode: '63', districtCode: '34' },
  { code: '49100', name: 'с.Байкошкар', regionCode: '63', districtCode: '34' },
  { code: '51100', name: 'с.Баршатас', regionCode: '63', districtCode: '34' },
  { code: '53100', name: 'с.Бидайык', regionCode: '63', districtCode: '34' },
  { code: '53300', name: 'с.Сатай', regionCode: '63', districtCode: '34' },
  { code: '53400', name: 'с.Шаграй', regionCode: '63', districtCode: '34' },
  { code: '55100', name: 'с.Емелтау', regionCode: '63', districtCode: '34' },
  { code: '57100', name: 'с.Жорга', regionCode: '63', districtCode: '34' },
  { code: '59100', name: 'с.Караагаш', regionCode: '63', districtCode: '34' },
  { code: '59300', name: 'с.Каражал', regionCode: '63', districtCode: '34' },
  { code: '61100', name: 'с.Копа', regionCode: '63', districtCode: '34' },
  { code: '61200', name: 'с.Каракум', regionCode: '63', districtCode: '34' },
  { code: '61300', name: 'с.Карасу', regionCode: '63', districtCode: '34' },
  { code: '63100', name: 'с.Косагаш', regionCode: '63', districtCode: '34' },
  {
    code: '63200',
    name: 'с.Егиндыбулак',
    regionCode: '63',
    districtCode: '34'
  },
  { code: '63300', name: 'с.Карабулак', regionCode: '63', districtCode: '34' },
  { code: '65100', name: 'с.Мадениет', regionCode: '63', districtCode: '34' },
  { code: '65200', name: 'с.Коктал', regionCode: '63', districtCode: '34' },
  { code: '67100', name: 'с.Майлино', regionCode: '63', districtCode: '34' },
  { code: '67200', name: 'с.Карабулак', regionCode: '63', districtCode: '34' },
  {
    code: '67300',
    name: 'с.Старое Майлино',
    regionCode: '63',
    districtCode: '34'
  },
  { code: '67500', name: 'с.Топар', regionCode: '63', districtCode: '34' },
  { code: '69100', name: 'с.Корык', regionCode: '63', districtCode: '34' },
  { code: '71100', name: 'с.Ай', regionCode: '63', districtCode: '34' },
  { code: '71200', name: 'с.Актас', regionCode: '63', districtCode: '34' },
  {
    code: '71300',
    name: 'с.Ескенебулагы',
    regionCode: '63',
    districtCode: '34'
  },
  { code: '71400', name: 'с.Желдыкара', regionCode: '63', districtCode: '34' },
  { code: '71500', name: 'с.Кенколат', regionCode: '63', districtCode: '34' },
  { code: '73100', name: 'с.Шынкожа', regionCode: '63', districtCode: '34' },
  { code: '73200', name: 'с.Ай', regionCode: '63', districtCode: '34' },
  { code: '73400', name: 'с.Карааул', regionCode: '63', districtCode: '34' },
  { code: '73500', name: 'с.Толенды', regionCode: '63', districtCode: '34' },
  { code: '75100', name: 'с.Оркен', regionCode: '63', districtCode: '34' },
  { code: '79100', name: 'с.Сарыарка', regionCode: '63', districtCode: '34' },
  { code: '79200', name: 'с.Биесимас', regionCode: '63', districtCode: '34' },
  { code: '79400', name: 'с.Шубартос', regionCode: '63', districtCode: '34' },
  { code: '81100', name: 'с.Мамырсу', regionCode: '63', districtCode: '34' },
  { code: '81200', name: 'с.Батпак', regionCode: '63', districtCode: '34' },
  { code: '81300', name: 'с.Бозай', regionCode: '63', districtCode: '34' },
  { code: '85100', name: 'с.Тарлаулы', regionCode: '63', districtCode: '34' },
  { code: '85200', name: 'ст.Акбулак', regionCode: '63', districtCode: '34' },
  { code: '85300', name: 'с.Акший', regionCode: '63', districtCode: '34' },
  { code: '85400', name: 'ст.Жузагаш', regionCode: '63', districtCode: '34' },
  { code: '85500', name: 'с.Копа', regionCode: '63', districtCode: '34' },
  { code: '85700', name: 'ст.Тансык', regionCode: '63', districtCode: '34' },
  { code: '87100', name: 'с.Тарбагатай', regionCode: '63', districtCode: '34' },
  { code: '87200', name: 'с.Абден', regionCode: '63', districtCode: '34' },
  { code: '87300', name: 'с.Акшокы', regionCode: '63', districtCode: '34' },
  { code: '87400', name: 'с.Малтугел', regionCode: '63', districtCode: '34' },
  { code: '79500', name: 'с.Батпакты', regionCode: '63', districtCode: '64' },
  { code: '81100', name: 'с.Сегизбай', regionCode: '63', districtCode: '64' },
  { code: '81300', name: 'а.Карабуйрат', regionCode: '63', districtCode: '64' },
  { code: '83100', name: 'с.Шолпан', regionCode: '63', districtCode: '64' },
  { code: '20100', name: 'г.Шемонаиха', regionCode: '63', districtCode: '68' },
  { code: '35100', name: 'с.Камышинка', regionCode: '63', districtCode: '68' },
  { code: '35200', name: 'с.Горкуново', regionCode: '63', districtCode: '68' },
  { code: '35300', name: 'с.Кенюхово', regionCode: '63', districtCode: '68' },
  { code: '35400', name: 'с.Пруггерово', regionCode: '63', districtCode: '68' },
  { code: '35500', name: 'с.Сугатовка', regionCode: '63', districtCode: '68' },
  { code: '37100', name: 'с.Волчанка', regionCode: '63', districtCode: '68' },
  { code: '37200', name: 'с.Березовка', regionCode: '63', districtCode: '68' },
  { code: '37500', name: 'с.Кандыковка', regionCode: '63', districtCode: '68' },
  { code: '37600', name: 'с.Крюковка', regionCode: '63', districtCode: '68' },
  { code: '37700', name: 'с.Моисеевка', regionCode: '63', districtCode: '68' },
  { code: '37800', name: 'с.Трехгорное', regionCode: '63', districtCode: '68' },
  {
    code: '37900',
    name: 'с.Большая речка',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '39100', name: 'с.Выдриха', regionCode: '63', districtCode: '68' },
  { code: '39200', name: 'с.Межовка', regionCode: '63', districtCode: '68' },
  { code: '41100', name: 'с.Верх-Уба', regionCode: '63', districtCode: '68' },
  { code: '41200', name: 'с.Зауба', regionCode: '63', districtCode: '68' },
  { code: '43100', name: 'с.Зевакино', regionCode: '63', districtCode: '68' },
  {
    code: '43200',
    name: 'с.Hовая Убинка',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '43400', name: 'с.Убинка', regionCode: '63', districtCode: '68' },
  { code: '45100', name: 'с.Рассыпное', regionCode: '63', districtCode: '68' },
  { code: '45300', name: 'с.Коневка', regionCode: '63', districtCode: '68' },
  { code: '20100', name: 'г.Зыряновск', regionCode: '63', districtCode: '48' },
  { code: '45400', name: 'с.Михайловка', regionCode: '63', districtCode: '68' },
  { code: '45700', name: 'с.Рулиха', regionCode: '63', districtCode: '68' },
  { code: '45780', name: 'ст.Рулиха', regionCode: '63', districtCode: '68' },
  {
    code: '47100',
    name: 'с.Октябрьское',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '47300', name: 'с.Луговое', regionCode: '63', districtCode: '68' },
  { code: '47400', name: 'с.Садовое', regionCode: '63', districtCode: '68' },
  {
    code: '49100',
    name: 'с.Красная Шемонаиха',
    regionCode: '63',
    districtCode: '68'
  },
  {
    code: '49200',
    name: 'с.Белый Камень',
    regionCode: '63',
    districtCode: '68'
  },
  {
    code: '49300',
    name: 'р.Казахстанский',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '49400', name: 'с.Медведка', regionCode: '63', districtCode: '68' },
  {
    code: '57100',
    name: 'п.Первомайский',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '57200', name: 'с.Барашки', regionCode: '63', districtCode: '68' },
  {
    code: '57300',
    name: 'с.Hово-Ильинка',
    regionCode: '63',
    districtCode: '68'
  },
  {
    code: '57400',
    name: 'ст.Фестивальная',
    regionCode: '63',
    districtCode: '68'
  },
  {
    code: '63100',
    name: 'п.Усть-Таловка',
    regionCode: '63',
    districtCode: '68'
  },
  { code: '63200', name: 'с.Березовка', regionCode: '63', districtCode: '68' },
  { code: '63300', name: 'с.Заречное', regionCode: '63', districtCode: '68' },
  { code: '63400', name: 'с.Половинка', regionCode: '63', districtCode: '68' },
  { code: '23', name: 'с.Рулиха', regionCode: '63', districtCode: '63' },
  { code: '49300', name: 'с.Майемер', regionCode: '63', districtCode: '54' },
  { code: '47200', name: 'с.Южное', regionCode: '63', districtCode: '62' },
  { code: '53200', name: 'ст.Аврора', regionCode: '63', districtCode: '40' },
  { code: '39400', name: 'с.Мукашы', regionCode: '63', districtCode: '46' },
  { code: '63100', name: 'с.Самарское', regionCode: '63', districtCode: '50' },
  {
    code: '30100',
    name: 'п. Касыма Кайсенова',
    regionCode: '63',
    districtCode: '62'
  },
  {
    code: '10100',
    name: 'г.Усть-Каменогорск',
    regionCode: '63',
    districtCode: '1'
  },
  { code: '18100', name: 'г.Аягоз', regionCode: '63', districtCode: '2' },
  { code: '22100', name: 'г.Курчатов', regionCode: '63', districtCode: '4' },
  { code: '24100', name: 'г.Риддер', regionCode: '63', districtCode: '5' },
  { code: '28100', name: 'г.Семей', regionCode: '63', districtCode: '6' },
  { code: '30100', name: 'с.Карааул', regionCode: '63', districtCode: '32' },
  {
    code: '33100',
    name: 'а.Кенгирбай би',
    regionCode: '63',
    districtCode: '32'
  },
  { code: '35100', name: 'с.Архат', regionCode: '63', districtCode: '32' },
  { code: '35500', name: 'с.Орда', regionCode: '63', districtCode: '32' },
  { code: '39100', name: 'с.Каскабулак', regionCode: '63', districtCode: '32' },
  { code: '39400', name: 'с.Борлы', regionCode: '63', districtCode: '32' },
  { code: '43100', name: 'с.Журекадыр', regionCode: '63', districtCode: '32' },
  {
    code: '67200',
    name: 'с.Hово-Одесское',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '67300', name: 'с.Отрадное', regionCode: '63', districtCode: '62' },
  {
    code: '69100',
    name: 'с.Таврическое',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '69200', name: 'с.Актобе', regionCode: '63', districtCode: '62' },
  { code: '69300', name: 'с.Пролетарка', regionCode: '63', districtCode: '62' },
  { code: '73100', name: 'с.Таргын', regionCode: '63', districtCode: '62' },
  { code: '73200', name: 'с.Жантас', regionCode: '63', districtCode: '62' },
  {
    code: '73300',
    name: 'с.Верхние Таинты',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '73400', name: 'с.Манат', regionCode: '63', districtCode: '62' },
  {
    code: '73500',
    name: 'а.Изгутты Айтыков',
    regionCode: '63',
    districtCode: '62'
  },
  {
    code: '75100',
    name: 'с.Герасимовка',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '75300', name: 'с.Казачье', regionCode: '63', districtCode: '62' },
  { code: '75600', name: 'с.Украинка', regionCode: '63', districtCode: '62' },
  { code: '30100', name: 'с.Урджар', regionCode: '63', districtCode: '64' },
  { code: '30200', name: 'с.Бургон', regionCode: '63', districtCode: '64' },
  { code: '30300', name: 'с.Кызылту', regionCode: '63', districtCode: '64' },
  { code: '33100', name: 'с.Акжар', regionCode: '63', districtCode: '64' },
  { code: '33200', name: 'с.Амангельды', regionCode: '63', districtCode: '64' },
  { code: '33300', name: 'с.Карамойыл', regionCode: '63', districtCode: '64' },
  { code: '35100', name: 'с.Колденен', regionCode: '63', districtCode: '64' },
  { code: '37100', name: 'с.Акшокы', regionCode: '63', districtCode: '64' },
  { code: '37300', name: 'с.Подгорное', regionCode: '63', districtCode: '64' },
  { code: '39100', name: 'с.Алтыншокы', regionCode: '63', districtCode: '64' },
  { code: '39200', name: 'с.им.Айтбая', regionCode: '63', districtCode: '64' },
  { code: '39300', name: 'с.Лайбулак', regionCode: '63', districtCode: '64' },
  { code: '39400', name: 'с.Текебулак', regionCode: '63', districtCode: '64' },
  { code: '41100', name: 'с.Бахты', regionCode: '63', districtCode: '64' },
  { code: '43100', name: 'с.Бестерек', regionCode: '63', districtCode: '64' },
  { code: '43200', name: 'а.Казымбет', regionCode: '63', districtCode: '64' },
  { code: '43300', name: 'с.Кабанбай', regionCode: '63', districtCode: '64' },
  { code: '45100', name: 'с.Келдемурат', regionCode: '63', districtCode: '64' },
  {
    code: '45200',
    name: 'с.Кызылжулдуз',
    regionCode: '63',
    districtCode: '64'
  },
  { code: '47100', name: 'с.Жана тилек', regionCode: '63', districtCode: '64' },
  { code: '47200', name: 'с.Тасарык', regionCode: '63', districtCode: '64' },
  { code: '49100', name: 'с.Егинсу', regionCode: '63', districtCode: '64' },
  { code: '49200', name: 'с.Жанай', regionCode: '63', districtCode: '64' },
  { code: '51100', name: 'с.Елтай', regionCode: '63', districtCode: '64' },
  { code: '53100', name: 'с.Кабанбай', regionCode: '63', districtCode: '64' },
  { code: '55100', name: 'а.Кокозек', regionCode: '63', districtCode: '64' },
  { code: '57100', name: 'с.Каратума', regionCode: '63', districtCode: '64' },
  { code: '59100', name: 'с.Коктал', regionCode: '63', districtCode: '64' },
  { code: '61100', name: 'с.Коктерек', regionCode: '63', districtCode: '64' },
  { code: '61200', name: 'с.Кайынды', regionCode: '63', districtCode: '64' },
  { code: '61300', name: 'с.Кызылбулак', regionCode: '63', districtCode: '64' },
  { code: '63100', name: 'с.Карабута', regionCode: '63', districtCode: '64' },
  { code: '65100', name: 'с.Карабулак', regionCode: '63', districtCode: '64' },
  {
    code: '65200',
    name: 'с.Барлыкарасан',
    regionCode: '63',
    districtCode: '64'
  },
  { code: '67100', name: 'с.Каракол', regionCode: '63', districtCode: '64' },
  { code: '67180', name: 'ферма 1 Абай', regionCode: '63', districtCode: '64' },
  { code: '67400', name: 'с.Сагат', regionCode: '63', districtCode: '64' },
  { code: '67500', name: 'с.Сарытерек', regionCode: '63', districtCode: '64' },
  { code: '67600', name: 'ферма 3', regionCode: '63', districtCode: '64' },
  { code: '69100', name: 'с.Каратал', regionCode: '63', districtCode: '64' },
  { code: '69300', name: 'с.Бекет', regionCode: '63', districtCode: '64' },
  { code: '69400', name: 'с.Бугубай', regionCode: '63', districtCode: '64' },
  { code: '71100', name: 'с.Таскескен', regionCode: '63', districtCode: '64' },
  { code: '71200', name: 'с.Ушбулак', regionCode: '63', districtCode: '64' },
  { code: '73100', name: 'с.Маканчи', regionCode: '63', districtCode: '64' },
  { code: '75100', name: 'с.Hауалы', regionCode: '63', districtCode: '64' },
  { code: '75200', name: 'с.Малак', regionCode: '63', districtCode: '64' },
  {
    code: '77100',
    name: 'с.Жогаргы Егинсу',
    regionCode: '63',
    districtCode: '64'
  },
  {
    code: '79100',
    name: 'с.Hовоандреевка',
    regionCode: '63',
    districtCode: '64'
  },
  {
    code: '79300',
    name: 'с.Благодатное',
    regionCode: '63',
    districtCode: '64'
  },
  { code: '79400', name: 'с.Hекрасовка', regionCode: '63', districtCode: '64' },
  {
    code: '49300',
    name: 'с.Армандастар',
    regionCode: '63',
    districtCode: '58'
  },
  { code: '49400', name: 'с.Сарыбулак', regionCode: '63', districtCode: '58' },
  { code: '49500', name: 'с.Чан', regionCode: '63', districtCode: '58' },
  { code: '51100', name: 'с.Куйган', regionCode: '63', districtCode: '58' },
  { code: '51200', name: 'с.Жаланаш', regionCode: '63', districtCode: '58' },
  { code: '51300', name: 'с.Жамбыл', regionCode: '63', districtCode: '58' },
  { code: '53100', name: 'с.Кумголь', regionCode: '63', districtCode: '58' },
  { code: '53200', name: 'с.Кокбастау', regionCode: '63', districtCode: '58' },
  { code: '53300', name: 'а.Каргыба', regionCode: '63', districtCode: '58' },
  {
    code: '53400',
    name: 'с.Кызылжулдыз',
    regionCode: '63',
    districtCode: '58'
  },
  { code: '55100', name: 'с.Кызылкесек', regionCode: '63', districtCode: '58' },
  {
    code: '55200',
    name: 'с.Егиндибулак',
    regionCode: '63',
    districtCode: '58'
  },
  { code: '55400', name: 'с.Уштобе', regionCode: '63', districtCode: '58' },
  { code: '55500', name: 'с.Шетбогас', regionCode: '63', districtCode: '58' },
  { code: '57100', name: 'а.Манырак', regionCode: '63', districtCode: '58' },
  { code: '57400', name: 'с.Даулетбай', regionCode: '63', districtCode: '58' },
  { code: '57500', name: 'с.Жалгызтобе', regionCode: '63', districtCode: '58' },
  { code: '59100', name: 'с.Ойшилик', regionCode: '63', districtCode: '58' },
  { code: '59200', name: 'с.Айнабастау', regionCode: '63', districtCode: '58' },
  { code: '59300', name: 'с.Акжол', regionCode: '63', districtCode: '58' },
  { code: '59400', name: 'с.Есим', regionCode: '63', districtCode: '58' },
  { code: '59500', name: 'а.Танамырза', regionCode: '63', districtCode: '58' },
  { code: '59600', name: 'с.Томар', regionCode: '63', districtCode: '58' },
  { code: '61100', name: 'с.Сатпаев', regionCode: '63', districtCode: '58' },
  { code: '61200', name: 'с.Коктубек', regionCode: '63', districtCode: '58' },
  { code: '61300', name: 'с.Сулутал', regionCode: '63', districtCode: '58' },
  { code: '63100', name: 'п.Тугыл', regionCode: '63', districtCode: '58' },
  { code: '63200', name: 'с.Байтогас', regionCode: '63', districtCode: '58' },
  { code: '65100', name: 'с.Жантикей', regionCode: '63', districtCode: '58' },
  { code: '65300', name: 'с.Кожакельды', regionCode: '63', districtCode: '58' },
  { code: '65400', name: 'с.Уан', regionCode: '63', districtCode: '58' },
  { code: '33100', name: 'с.Сагыр', regionCode: '63', districtCode: '62' },
  { code: '33200', name: 'с.Бестерек', regionCode: '63', districtCode: '62' },
  {
    code: '33300',
    name: 'с.Мамай батыра',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '33400', name: 'с.Желдиозек', regionCode: '63', districtCode: '62' },
  {
    code: '35100',
    name: 'с.Hово-Азовое',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '35180', name: 'с.Азовое', regionCode: '63', districtCode: '62' },
  { code: '35200', name: 'с.Беткудук', regionCode: '63', districtCode: '62' },
  { code: '37100', name: 'с.Алмасай', regionCode: '63', districtCode: '62' },
  {
    code: '37200',
    name: 'а.Баяш Утепов',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '39100', name: 'п.Асубулак', regionCode: '63', districtCode: '62' },
  { code: '43100', name: 'с.Привольное', regionCode: '63', districtCode: '62' },
  {
    code: '43200',
    name: 'с.Митрофановка',
    regionCode: '63',
    districtCode: '62'
  },
  {
    code: '45100',
    name: 'п.Белогорский',
    regionCode: '63',
    districtCode: '62'
  },
  {
    code: '45200',
    name: 'с.Hижняя Таинта',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '47100', name: 'с.Гагарино', regionCode: '63', districtCode: '62' },
  { code: '49100', name: 'с.Уланское', regionCode: '63', districtCode: '62' },
  { code: '49200', name: 'с.Бурсак', regionCode: '63', districtCode: '62' },
  { code: '49300', name: 'с.Жанузак', regionCode: '63', districtCode: '62' },
  { code: '53100', name: 'с.Айыртау', regionCode: '63', districtCode: '62' },
  {
    code: '53200',
    name: 'с.Hовая Канайка',
    regionCode: '63',
    districtCode: '62'
  },
  { code: '55100', name: 'с.Каменка', regionCode: '63', districtCode: '62' },
  { code: '55300', name: 'с.Тройницкое', regionCode: '63', districtCode: '62' },
  { code: '57100', name: 'а.Бозанбай', regionCode: '63', districtCode: '62' },
  { code: '57200', name: 'с.Алгабас', regionCode: '63', districtCode: '62' },
  { code: '57300', name: 'с.Акжартас', regionCode: '63', districtCode: '62' },
  { code: '57400', name: 'а.Кызылсу', regionCode: '63', districtCode: '62' },
  { code: '63100', name: 'п.Огневка', regionCode: '63', districtCode: '62' },
  { code: '63200', name: 'с.Смолянка', regionCode: '63', districtCode: '62' },
  { code: '65100', name: 'с.Восточное', regionCode: '63', districtCode: '62' },
  { code: '65200', name: 'с.Донское', regionCode: '63', districtCode: '62' },
  { code: '65300', name: 'с.Макеевка', regionCode: '63', districtCode: '62' },
  { code: '65400', name: 'с.Мирное', regionCode: '63', districtCode: '62' },
  { code: '67100', name: 'с.Саратовка', regionCode: '63', districtCode: '62' },
  { code: '43500', name: 'с.Шынгыстай', regionCode: '63', districtCode: '54' },
  { code: '45100', name: 'с.Коробиха', regionCode: '63', districtCode: '54' },
  { code: '45200', name: 'с.Барлык', regionCode: '63', districtCode: '54' },
  { code: '45400', name: 'с.Ушбулак', regionCode: '63', districtCode: '54' },
  { code: '47100', name: 'а.Белкарагай', regionCode: '63', districtCode: '54' },
  { code: '47200', name: 'с.Орнек', regionCode: '63', districtCode: '54' },
  { code: '47300', name: 'с.Согорное', regionCode: '63', districtCode: '54' },
  { code: '47400', name: 'с.Топкаин', regionCode: '63', districtCode: '54' },
  {
    code: '49100',
    name: 'с.Hовоберезовка',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '49200', name: 'с.Жар', regionCode: '63', districtCode: '54' },
  { code: '49500', name: 'с.Уштобе', regionCode: '63', districtCode: '54' },
  {
    code: '53100',
    name: 'с.Hовополяковка',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '53200', name: 'с.Бесюй', regionCode: '63', districtCode: '54' },
  { code: '53400', name: 'с.Огнево', regionCode: '63', districtCode: '54' },
  { code: '53500', name: 'с.Сенное', regionCode: '63', districtCode: '54' },
  { code: '53600', name: 'с.Ульяновка', regionCode: '63', districtCode: '54' },
  {
    code: '55100',
    name: 'с.Hово-Хайрузовка',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '55200', name: 'с.Алыбай', regionCode: '63', districtCode: '54' },
  { code: '55300', name: 'а.Кундызды', regionCode: '63', districtCode: '54' },
  { code: '55400', name: 'с.Приморское', regionCode: '63', districtCode: '54' },
  { code: '57100', name: 'с.Урыль', regionCode: '63', districtCode: '54' },
  { code: '57200', name: 'с.Аршаты', regionCode: '63', districtCode: '54' },
  { code: '57300', name: 'с.Енбек', regionCode: '63', districtCode: '54' },
  { code: '61100', name: 'с.Солдатово', regionCode: '63', districtCode: '54' },
  { code: '63100', name: 'с.Солоновка', regionCode: '63', districtCode: '54' },
  {
    code: '63200',
    name: 'с.Мало Нарымка',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '65100', name: 'с.Аккайнар', regionCode: '63', districtCode: '54' },
  { code: '65200', name: 'а.Кайынды', regionCode: '63', districtCode: '54' },
  {
    code: '65300',
    name: 'с.Кызылжулдыз',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '65400', name: 'а.Акмарал', regionCode: '63', districtCode: '54' },
  { code: '30100', name: 'с.Аксуат', regionCode: '63', districtCode: '58' },
  { code: '33100', name: 'с.Акжар', regionCode: '63', districtCode: '58' },
  { code: '33200', name: 'а.Жаналык', regionCode: '63', districtCode: '58' },
  { code: '33300', name: 'а.Жанатилеу', regionCode: '63', districtCode: '58' },
  { code: '33500', name: 'с.Сагындык', regionCode: '63', districtCode: '58' },
  { code: '37100', name: 'с.Екпин', regionCode: '63', districtCode: '58' },
  { code: '37200', name: 'с.Аккала', regionCode: '63', districtCode: '58' },
  { code: '37300', name: 'с.Кокжол', regionCode: '63', districtCode: '58' },
  { code: '39100', name: 'с.Жанаауыл', regionCode: '63', districtCode: '58' },
  { code: '39200', name: 'с.Ахметбулак', regionCode: '63', districtCode: '58' },
  { code: '39300', name: 'с.Жанаталап', regionCode: '63', districtCode: '58' },
  { code: '39400', name: 'с.Сарыолен', regionCode: '63', districtCode: '58' },
  { code: '41100', name: 'а.Жетыарал', regionCode: '63', districtCode: '58' },
  { code: '41200', name: 'с.Асусай', regionCode: '63', districtCode: '58' },
  { code: '41300', name: 'с.Жангызтал', regionCode: '63', districtCode: '58' },
  { code: '41400', name: 'с.Камысты', regionCode: '63', districtCode: '58' },
  { code: '43100', name: 'а.Кабанбай', regionCode: '63', districtCode: '58' },
  { code: '43200', name: 'с.Казахстан', regionCode: '63', districtCode: '58' },
  { code: '43300', name: 'с.Тауке', regionCode: '63', districtCode: '58' },
  { code: '43400', name: 'с.Шенгельды', regionCode: '63', districtCode: '58' },
  { code: '43500', name: 'с.Шорга', regionCode: '63', districtCode: '58' },
  { code: '45100', name: 'с.Кокжыра', regionCode: '63', districtCode: '58' },
  { code: '45200', name: 'с.Базарга', regionCode: '63', districtCode: '58' },
  { code: '45300', name: 'с.Кызбай', regionCode: '63', districtCode: '58' },
  { code: '45500', name: 'с.Мурсалим', regionCode: '63', districtCode: '58' },
  { code: '45600', name: 'с.Сериктес', regionCode: '63', districtCode: '58' },
  { code: '47100', name: 'с.Карасу', regionCode: '63', districtCode: '58' },
  { code: '47200', name: 'с.Акмектеп', regionCode: '63', districtCode: '58' },
  { code: '47400', name: 'с.Жолкурылыс', regionCode: '63', districtCode: '58' },
  { code: '47600', name: 'с.Отеген', regionCode: '63', districtCode: '58' },
  { code: '47700', name: 'с.Шолакорда', regionCode: '63', districtCode: '58' },
  { code: '47800', name: 'с.Караой', regionCode: '63', districtCode: '58' },
  { code: '49100', name: 'с.Киндикты', regionCode: '63', districtCode: '58' },
  { code: '49200', name: 'с.Алгабас', regionCode: '63', districtCode: '58' },
  { code: '35500', name: 'с.Карашилик', regionCode: '63', districtCode: '52' },
  { code: '35600', name: 'с.Караой', regionCode: '63', districtCode: '52' },
  { code: '35700', name: 'а.Кайнарлы', regionCode: '63', districtCode: '52' },
  { code: '35780', name: 'с.Матабай', regionCode: '63', districtCode: '52' },
  { code: '35800', name: 'а.Мойылды', regionCode: '63', districtCode: '52' },
  { code: '35900', name: 'с.Тентек', regionCode: '63', districtCode: '52' },
  { code: '37100', name: 'с.Аксуат', regionCode: '63', districtCode: '52' },
  { code: '37200', name: 'с.Аманат', regionCode: '63', districtCode: '52' },
  { code: '37300', name: 'с.Жолнускау', regionCode: '63', districtCode: '52' },
  { code: '39100', name: 'а.Тоскаин', regionCode: '63', districtCode: '52' },
  {
    code: '39200',
    name: 'а.Балыктыбулак',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '39300', name: 'а.Бугумуюз', regionCode: '63', districtCode: '52' },
  {
    code: '39500',
    name: 'а.Карагайлыбулак',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '39600', name: 'с.Урунхайка', regionCode: '63', districtCode: '52' },
  { code: '39700', name: 'а.Шаганатты', regionCode: '63', districtCode: '52' },
  { code: '43100', name: 'с.Буран', regionCode: '63', districtCode: '52' },
  { code: '43200', name: 'с.Жанааул', regionCode: '63', districtCode: '52' },
  { code: '43300', name: 'а.Жиделы', regionCode: '63', districtCode: '52' },
  { code: '43400', name: 'а.Игилик', regionCode: '63', districtCode: '52' },
  { code: '43500', name: 'с.Казахстан', regionCode: '63', districtCode: '52' },
  { code: '45100', name: 'а.Акбулак', regionCode: '63', districtCode: '52' },
  { code: '45200', name: 'а.Алтай', regionCode: '63', districtCode: '52' },
  {
    code: '45300',
    name: 'а.Кунгей-Бокенбай',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '45400', name: 'с.Майтерек', regionCode: '63', districtCode: '52' },
  {
    code: '45500',
    name: 'а.Терскей-Бокенбай',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '49100', name: 'с.Каратогай', regionCode: '63', districtCode: '52' },
  { code: '49200', name: 'с.Акчий', regionCode: '63', districtCode: '52' },
  {
    code: '49300',
    name: 'а.Егиндыбулак',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '49500', name: 'с.Жылытау', regionCode: '63', districtCode: '52' },
  { code: '55100', name: 'с.Куйган', regionCode: '63', districtCode: '52' },
  { code: '55200', name: 'а.Кайнар', regionCode: '63', districtCode: '52' },
  { code: '55300', name: 'а.Карабулак', regionCode: '63', districtCode: '52' },
  { code: '55400', name: 'с.Кайынды', regionCode: '63', districtCode: '52' },
  { code: '55500', name: 'с.Чердояк', regionCode: '63', districtCode: '52' },
  { code: '57100', name: 'а.Маралды', regionCode: '63', districtCode: '52' },
  {
    code: '57300',
    name: 'с.Курчумкистауы',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '57500', name: 'а.Ушбулак', regionCode: '63', districtCode: '52' },
  { code: '59100', name: 'а.Сарыолен', regionCode: '63', districtCode: '52' },
  { code: '59300', name: 'с.Бирлик', regionCode: '63', districtCode: '52' },
  {
    code: '59400',
    name: 'с.Барак батыра',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '63100', name: 'а.Калжыр', regionCode: '63', districtCode: '52' },
  {
    code: '63200',
    name: 'с.Правый Усть-Кальжыр',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '63300', name: 'с.Такыр', regionCode: '63', districtCode: '52' },
  { code: '63400', name: 'с.Шенгельды', regionCode: '63', districtCode: '52' },
  {
    code: '30100',
    name: 'с.Улкен Нарын',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '30200', name: 'с.Балгын', regionCode: '63', districtCode: '54' },
  { code: '30300', name: 'с.Жулдыз', regionCode: '63', districtCode: '54' },
  { code: '30400', name: 'с.Коктерек', regionCode: '63', districtCode: '54' },
  { code: '30500', name: 'с.Свинчатка', regionCode: '63', districtCode: '54' },
  { code: '30600', name: 'с.Юбилейное', regionCode: '63', districtCode: '54' },
  { code: '33100', name: 'с.Аксу', regionCode: '63', districtCode: '54' },
  { code: '33200', name: 'с.Жазаба', regionCode: '63', districtCode: '54' },
  { code: '33300', name: 'с.Акшарбак', regionCode: '63', districtCode: '54' },
  { code: '33400', name: 'с.Бекалка', regionCode: '63', districtCode: '54' },
  { code: '33500', name: 'с.Талды', regionCode: '63', districtCode: '54' },
  { code: '35100', name: 'с.Жамбыл', regionCode: '63', districtCode: '54' },
  { code: '35200', name: 'с.Берель', regionCode: '63', districtCode: '54' },
  { code: '35400', name: 'а.Маралды', regionCode: '63', districtCode: '54' },
  {
    code: '35500',
    name: 'с.Рахмановские ключи',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '35600', name: 'с.Шубарагаш', regionCode: '63', districtCode: '54' },
  {
    code: '43100',
    name: 'с.Катон-Карагай',
    regionCode: '63',
    districtCode: '54'
  },
  { code: '43200', name: 'с.Жана-Ульга', regionCode: '63', districtCode: '54' },
  { code: '43300', name: 'с.Кабырга', regionCode: '63', districtCode: '54' },
  { code: '43400', name: 'а.Мойылды', regionCode: '63', districtCode: '54' },
  { code: '25', name: 'с.Октябрьское', regionCode: '63', districtCode: '63' },
  { code: '26', name: 'с.Лазовое', regionCode: '63', districtCode: '63' },
  { code: '27', name: 'с.Луговое', regionCode: '63', districtCode: '63' },
  { code: '28', name: 'с.Садовое', regionCode: '63', districtCode: '63' },
  {
    code: '29',
    name: 'с.Красная Шемонаиха',
    regionCode: '63',
    districtCode: '63'
  },
  { code: '30', name: 'р.Казахстанский', regionCode: '63', districtCode: '63' },
  { code: '31', name: 'с.Белый Камень', regionCode: '63', districtCode: '63' },
  { code: '32', name: 'с.Медведка', regionCode: '63', districtCode: '63' },
  { code: '33', name: 'с.Первомайский', regionCode: '63', districtCode: '63' },
  { code: '34', name: 'с.Барашки', regionCode: '63', districtCode: '63' },
  { code: '35', name: 'с.Ново-Ильинка', regionCode: '63', districtCode: '63' },
  { code: '36', name: 'с.Усть-Таловка', regionCode: '63', districtCode: '63' },
  { code: '37', name: 'с.Березовка', regionCode: '63', districtCode: '63' },
  { code: '38', name: 'с.Заречное', regionCode: '63', districtCode: '63' },
  { code: '39', name: 'с.Половинка', regionCode: '63', districtCode: '63' },
  { code: '5', name: 'г.Шемонаиха', regionCode: '63', districtCode: '63' },
  { code: '6', name: 'с.Камышинка', regionCode: '63', districtCode: '63' },
  { code: '7', name: 'с.Горкуново', regionCode: '63', districtCode: '63' },
  { code: '8', name: 'с.Пруггерово', regionCode: '63', districtCode: '63' },
  { code: '9', name: 'с.Березовка', regionCode: '63', districtCode: '63' },
  { code: '10', name: 'с.Трехгорное', regionCode: '63', districtCode: '63' },
  { code: '11', name: 'с.Кандыковка', regionCode: '63', districtCode: '63' },
  { code: '12', name: 'с.Крюковка', regionCode: '63', districtCode: '63' },
  { code: '13', name: 'с.Большая речка', regionCode: '63', districtCode: '63' },
  { code: '14', name: 'с.Выдриха', regionCode: '63', districtCode: '63' },
  { code: '15', name: 'с.Межовка', regionCode: '63', districtCode: '63' },
  { code: '16', name: 'с.Верх-Уба', regionCode: '63', districtCode: '63' },
  { code: '17', name: 'с.Зауба', regionCode: '63', districtCode: '63' },
  { code: '18', name: 'с.Зевакино', regionCode: '63', districtCode: '63' },
  { code: '19', name: 'с.Новая Убинка', regionCode: '63', districtCode: '63' },
  { code: '20', name: 'с.Убинка', regionCode: '63', districtCode: '63' },
  { code: '21', name: 'с.Волчовка', regionCode: '63', districtCode: '63' },
  { code: '22', name: 'с.Новоселово', regionCode: '63', districtCode: '63' },
  { code: '24', name: 'с.Шапорево', regionCode: '63', districtCode: '63' },
  { code: '63300', name: 'с.Кайынды', regionCode: '63', districtCode: '50' },
  {
    code: '63500',
    name: 'с.Пантелеймоновка',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '65100', name: 'а.Тассай', regionCode: '63', districtCode: '50' },
  { code: '65200', name: 'с.Аксу', regionCode: '63', districtCode: '50' },
  { code: '65300', name: 'с.Кайнар', regionCode: '63', districtCode: '50' },
  { code: '65500', name: 'с.Ушкумей', regionCode: '63', districtCode: '50' },
  { code: '67100', name: 'с.Теректы', regionCode: '63', districtCode: '50' },
  { code: '67200', name: 'с.Каменка', regionCode: '63', districtCode: '50' },
  {
    code: '67300',
    name: 'с.Кызылжулдыз',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '67400', name: 'с.Орнек', regionCode: '63', districtCode: '50' },
  {
    code: '69100',
    name: 'с.Ульгули-Малши',
    regionCode: '63',
    districtCode: '50'
  },
  { code: '69400', name: 'с.Hура', regionCode: '63', districtCode: '50' },
  { code: '69500', name: 'с.Сулеймен', regionCode: '63', districtCode: '50' },
  { code: '73100', name: 'с.Белое', regionCode: '63', districtCode: '50' },
  { code: '73200', name: 'с.Жанажол', regionCode: '63', districtCode: '50' },
  { code: '73300', name: 'с.Караткуль', regionCode: '63', districtCode: '50' },
  { code: '73400', name: 'с.Койтас', regionCode: '63', districtCode: '50' },
  { code: '77100', name: 'с.Шугылбай', regionCode: '63', districtCode: '50' },
  { code: '77300', name: 'с.Мелитополь', regionCode: '63', districtCode: '50' },
  { code: '30100', name: 'с.Курчум', regionCode: '63', districtCode: '52' },
  { code: '30200', name: 'а.Алгабас', regionCode: '63', districtCode: '52' },
  { code: '30300', name: 'с.Дынгек', regionCode: '63', districtCode: '52' },
  { code: '30400', name: 'с.Топтерек', regionCode: '63', districtCode: '52' },
  { code: '33100', name: 'с.Бурабай', regionCode: '63', districtCode: '52' },
  { code: '33300', name: 'с.Койтас', regionCode: '63', districtCode: '52' },
  {
    code: '33400',
    name: 'с.Теректыбулак',
    regionCode: '63',
    districtCode: '52'
  },
  { code: '33500', name: 'а.Таскайын', regionCode: '63', districtCode: '52' },
  { code: '35100', name: 'с.Теректы', regionCode: '63', districtCode: '52' },
  { code: '35200', name: 'а.Акжайлау', regionCode: '63', districtCode: '52' },
  {
    code: '35400',
    name: 'с.Булгартабыты',
    regionCode: '63',
    districtCode: '52'
  },
  {
    code: '33300',
    name: 'с.Алтын кемер',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '33400', name: 'с.Отан', regionCode: '61', districtCode: '38' },
  {
    code: '33500',
    name: 'с.Бейбитшилик',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '33600', name: 'с. Атажурт', regionCode: '61', districtCode: '38' },
  { code: '39100', name: 'с.Абай', regionCode: '61', districtCode: '38' },
  { code: '39200', name: 'с.Дихан', regionCode: '61', districtCode: '38' },
  { code: '39300', name: 'с.Ауэзово', regionCode: '61', districtCode: '38' },
  { code: '39500', name: 'с.Жетикубыр', regionCode: '61', districtCode: '38' },
  { code: '39580', name: 'с.Байтерек', regionCode: '61', districtCode: '38' },
  { code: '39680', name: 'с.Жетиказына', regionCode: '61', districtCode: '38' },
  { code: '39880', name: 'с.Жанадауир', regionCode: '61', districtCode: '38' },
  {
    code: '43000',
    name: 'Асыкатинская п.а.',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '43100', name: 'п. Асыката', regionCode: '61', districtCode: '38' },
  { code: '49100', name: 'с.Джамбул', regionCode: '61', districtCode: '38' },
  { code: '49200', name: 'с.Зердели', regionCode: '61', districtCode: '38' },
  { code: '49300', name: 'с.Достык', regionCode: '61', districtCode: '38' },
  { code: '49400', name: 'с.Жанадала', regionCode: '61', districtCode: '38' },
  { code: '49500', name: 'с.Алпамыс', regionCode: '61', districtCode: '38' },
  { code: '49600', name: 'с.Куришти', regionCode: '61', districtCode: '38' },
  { code: '49700', name: 'с.Сырабат', regionCode: '61', districtCode: '38' },
  { code: '53100', name: 'с.Атаконыс', regionCode: '61', districtCode: '38' },
  { code: '53200', name: 'с.Мырзашол', regionCode: '61', districtCode: '38' },
  { code: '53300', name: 'с.Абдихалык', regionCode: '61', districtCode: '38' },
  { code: '53400', name: 'с.Караой', regionCode: '61', districtCode: '38' },
  { code: '53500', name: 'с.Жанаауыл', regionCode: '61', districtCode: '38' },
  { code: '53600', name: 'с.Ынтымак', regionCode: '61', districtCode: '38' },
  { code: '57100', name: 'с.Аль-Фараби', regionCode: '61', districtCode: '38' },
  { code: '57200', name: 'с.Байконыс', regionCode: '61', districtCode: '38' },
  { code: '57400', name: 'с.Жылы су', regionCode: '61', districtCode: '38' },
  { code: '57500', name: 'с.Мырзашокы', regionCode: '61', districtCode: '38' },
  { code: '57600', name: 'с.Сейфуллино', regionCode: '61', districtCode: '38' },
  { code: '65300', name: 'с.Гарышкер', regionCode: '61', districtCode: '38' },
  { code: '71380', name: 'с.Акжайлау', regionCode: '61', districtCode: '38' },
  { code: '71980', name: 'с.Костакыр', regionCode: '61', districtCode: '38' },
  { code: '79600', name: 'с.Дархан', regionCode: '61', districtCode: '38' },
  { code: '87502', name: 'с.Победа', regionCode: '61', districtCode: '38' },
  { code: '87600', name: 'с.Аден ата', regionCode: '61', districtCode: '38' },
  { code: '89100', name: 'с.Казыбек би', regionCode: '61', districtCode: '38' },
  { code: '89700', name: 'с.Абибола', regionCode: '61', districtCode: '38' },
  { code: '30100', name: 'с.Абай', regionCode: '61', districtCode: '39' },
  { code: '37100', name: 'с.Жуантобе', regionCode: '61', districtCode: '39' },
  { code: '37200', name: 'с.Акжар', regionCode: '61', districtCode: '39' },
  { code: '37300', name: 'с.Жанадауир', regionCode: '61', districtCode: '39' },
  { code: '37400', name: 'с.Ескикорган', regionCode: '61', districtCode: '39' },
  { code: '37500', name: 'с.Каратобе', regionCode: '61', districtCode: '39' },
  { code: '37600', name: 'с.Кызыласкер', regionCode: '61', districtCode: '39' },
  { code: '37700', name: 'с.Муратбаево', regionCode: '61', districtCode: '39' },
  { code: '37780', name: 'с.Куйган', regionCode: '61', districtCode: '39' },
  { code: '37800', name: 'с.Кокбулак', regionCode: '61', districtCode: '39' },
  { code: '41100', name: 'с.Бозай', regionCode: '61', districtCode: '39' },
  { code: '41300', name: 'с.Тентексай', regionCode: '61', districtCode: '39' },
  {
    code: '43100',
    name: 'с.28 гвардейцев',
    regionCode: '61',
    districtCode: '39'
  },
  { code: '43200', name: 'с.Казахстан', regionCode: '61', districtCode: '39' },
  { code: '43300', name: 'с.Дихан', regionCode: '61', districtCode: '39' },
  { code: '43400', name: 'с.Берекели', regionCode: '61', districtCode: '39' },
  { code: '45100', name: 'с.Бирлик', regionCode: '61', districtCode: '39' },
  {
    code: '45200',
    name: 'с.Жанатиршилик',
    regionCode: '61',
    districtCode: '39'
  },
  {
    code: '36000',
    name: 'с.о.Жибек жолы',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '37404', name: 'Бишоракора', regionCode: '61', districtCode: '40' },
  { code: '37405', name: 'Жакыпкора', regionCode: '61', districtCode: '40' },
  { code: '37409', name: 'Ошакбайкора', regionCode: '61', districtCode: '40' },
  { code: '43103', name: 'Актаскора', regionCode: '61', districtCode: '40' },
  { code: '43105', name: 'Алибайкора', regionCode: '61', districtCode: '40' },
  { code: '43107', name: 'Анешкора', regionCode: '61', districtCode: '40' },
  { code: '43109', name: 'Байсынкора', regionCode: '61', districtCode: '40' },
  { code: '43111', name: 'Балтабайкора', regionCode: '61', districtCode: '40' },
  { code: '43115', name: 'Водхозуй', regionCode: '61', districtCode: '40' },
  { code: '43117', name: 'Диханкора', regionCode: '61', districtCode: '40' },
  { code: '43119', name: 'Жанысбеккора', regionCode: '61', districtCode: '40' },
  { code: '43121', name: 'Жылкыкора', regionCode: '61', districtCode: '40' },
  {
    code: '43123',
    name: 'Кедейжетпескора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '43127', name: 'Кыркымкора', regionCode: '61', districtCode: '40' },
  { code: '43129', name: 'ЛСИ', regionCode: '61', districtCode: '40' },
  { code: '43131', name: 'МТФ', regionCode: '61', districtCode: '40' },
  { code: '43133', name: 'Hуржанкора', regionCode: '61', districtCode: '40' },
  {
    code: '43135',
    name: 'Водная станция',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '43137', name: 'Уйреккора', regionCode: '61', districtCode: '40' },
  {
    code: '43139',
    name: 'Шалданбайкора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '43200', name: 'с.Зангар', regionCode: '61', districtCode: '40' },
  { code: '43300', name: 'с.Сырлысай', regionCode: '61', districtCode: '40' },
  { code: '45103', name: 'ТСФ', regionCode: '61', districtCode: '40' },
  { code: '45205', name: 'ТСФ', regionCode: '61', districtCode: '40' },
  { code: '45207', name: 'Ушуй', regionCode: '61', districtCode: '40' },
  {
    code: '45305',
    name: 'Тансыкбайкора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '45307', name: 'Териилеуцех', regionCode: '61', districtCode: '40' },
  { code: '45403', name: 'Апакудыккора', regionCode: '61', districtCode: '40' },
  { code: '45405', name: 'Кагазкора', regionCode: '61', districtCode: '40' },
  { code: '45406', name: 'Кайнаркора', regionCode: '61', districtCode: '40' },
  {
    code: '45407',
    name: 'Кызылбулаккора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '45408', name: 'Кызылкора', regionCode: '61', districtCode: '40' },
  { code: '45411', name: 'Медеткора', regionCode: '61', districtCode: '40' },
  { code: '45413', name: 'Садыкора', regionCode: '61', districtCode: '40' },
  { code: '45415', name: 'Усипбайкора', regionCode: '61', districtCode: '40' },
  {
    code: '37203',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '37303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45403',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45583',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45603',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45703',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45803',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45883',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '45903',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '49103',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '49203',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '49303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '49403',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '49503',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '53103',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '53203',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '53303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '53503',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '53603',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '55103',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '55203',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '55303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '59203',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '59303',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  {
    code: '59703',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  { code: '20100', name: 'г.Жетысай', regionCode: '61', districtCode: '38' },
  {
    code: '33100',
    name: 'с.Халыктардостыгы',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '33200', name: 'с.Жузимдик', regionCode: '61', districtCode: '38' },
  { code: '57205', name: 'МТФ', regionCode: '61', districtCode: '20' },
  {
    code: '57206',
    name: 'Дом Оспанова-Кудайбергенова',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '57207', name: 'Откорм база', regionCode: '61', districtCode: '20' },
  { code: '57300', name: 'с. Аша', regionCode: '61', districtCode: '20' },
  {
    code: '57303',
    name: 'Дом Жоламанова Е.',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '57400', name: 'рзд.32', regionCode: '61', districtCode: '20' },
  {
    code: '37103',
    name: 'Чабанский жил.дом',
    regionCode: '61',
    districtCode: '36'
  },
  { code: '71600', name: 'с.Кошкарата', regionCode: '61', districtCode: '39' },
  { code: '71680', name: 'с. Байтерек', regionCode: '61', districtCode: '39' },
  { code: '71700', name: 'с.Махташа', regionCode: '61', districtCode: '39' },
  { code: '71780', name: 'с.Первое Мая', regionCode: '61', districtCode: '39' },
  { code: '71800', name: 'с.Ушкын', regionCode: '61', districtCode: '39' },
  { code: '71900', name: 'с.Шыныр', regionCode: '61', districtCode: '39' },
  { code: '75200', name: 'с.Кауыншы', regionCode: '61', districtCode: '39' },
  { code: '77100', name: 'с.Ошакты', regionCode: '61', districtCode: '39' },
  { code: '77200', name: 'с.Атаконыс', regionCode: '61', districtCode: '39' },
  { code: '77300', name: 'с.Енбек', regionCode: '61', districtCode: '39' },
  { code: '77400', name: 'с.Жетитобе', regionCode: '61', districtCode: '39' },
  { code: '77500', name: 'с.Береке', regionCode: '61', districtCode: '39' },
  { code: '77580', name: 'с.Каратал', regionCode: '61', districtCode: '39' },
  { code: '77600', name: 'с.Коныртобе', regionCode: '61', districtCode: '39' },
  { code: '77680', name: 'с.Бакышсай', regionCode: '61', districtCode: '39' },
  {
    code: '77700',
    name: 'с.Орджиникидзе',
    regionCode: '61',
    districtCode: '39'
  },
  { code: '77800', name: 'с.Санырау', regionCode: '61', districtCode: '39' },
  { code: '77880', name: 'с.Сарыжылга', regionCode: '61', districtCode: '39' },
  { code: '77900', name: 'с.Ынталы', regionCode: '61', districtCode: '39' },
  { code: '77980', name: 'с.Жидели', regionCode: '61', districtCode: '39' },
  { code: '83100', name: 'с.Достык', regionCode: '61', districtCode: '39' },
  { code: '83200', name: 'с.Ушкын', regionCode: '61', districtCode: '39' },
  { code: '83300', name: 'с.Коралас', regionCode: '61', districtCode: '39' },
  { code: '30200', name: 'с.Ашыбулак', regionCode: '61', districtCode: '40' },
  { code: '30203', name: 'Дача', regionCode: '61', districtCode: '40' },
  { code: '30209', name: 'Телевышка', regionCode: '61', districtCode: '40' },
  { code: '30300', name: 'с.Кезенбулак', regionCode: '61', districtCode: '40' },
  { code: '30309', name: 'Телевышка', regionCode: '61', districtCode: '40' },
  { code: '30400', name: 'с.Молбулак', regionCode: '61', districtCode: '40' },
  { code: '33505', name: 'Ащыкора', regionCode: '61', districtCode: '40' },
  { code: '33519', name: 'Срайылкора', regionCode: '61', districtCode: '40' },
  { code: '33521', name: 'Таженкора', regionCode: '61', districtCode: '40' },
  { code: '33605', name: 'Кормоцех', regionCode: '61', districtCode: '40' },
  { code: '35205', name: 'Таскора', regionCode: '61', districtCode: '40' },
  { code: '35403', name: 'Комсомолкора', regionCode: '61', districtCode: '40' },
  {
    code: '35405',
    name: 'Сейсентеккора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '35407', name: 'Социалкора', regionCode: '61', districtCode: '40' },
  { code: '35504', name: 'Кыркымкора', regionCode: '61', districtCode: '40' },
  { code: '35603', name: 'Кормоцех', regionCode: '61', districtCode: '40' },
  { code: '35605', name: 'Мамедкора', regionCode: '61', districtCode: '40' },
  { code: '36203', name: 'Амантайкора', regionCode: '61', districtCode: '40' },
  {
    code: '36205',
    name: 'Бейсенколькора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '36219', name: 'Тауыккора 1', regionCode: '61', districtCode: '40' },
  { code: '36221', name: 'Тауыккора 2', regionCode: '61', districtCode: '40' },
  { code: '36703', name: 'Акрамкора', regionCode: '61', districtCode: '40' },
  { code: '36705', name: 'Амиркора', regionCode: '61', districtCode: '40' },
  { code: '36707', name: 'Жакайкора', regionCode: '61', districtCode: '40' },
  { code: '36709', name: 'Жанайкора', regionCode: '61', districtCode: '40' },
  { code: '36713', name: 'Кыркымкора', regionCode: '61', districtCode: '40' },
  { code: '36719', name: 'Полаткора', regionCode: '61', districtCode: '40' },
  { code: '36727', name: 'Шалкаркора', regionCode: '61', districtCode: '40' },
  { code: '37105', name: 'Алпыскора', regionCode: '61', districtCode: '40' },
  { code: '37107', name: 'Анарбайкора', regionCode: '61', districtCode: '40' },
  { code: '37111', name: 'Аселькора', regionCode: '61', districtCode: '40' },
  { code: '37117', name: 'Калайханкора', regionCode: '61', districtCode: '40' },
  { code: '37135', name: 'Социалкора', regionCode: '61', districtCode: '40' },
  { code: '37402', name: 'Аклаккора', regionCode: '61', districtCode: '40' },
  { code: '33600', name: 'с.Онтам', regionCode: '61', districtCode: '16' },
  { code: '35300', name: 'с.Жосалы', regionCode: '61', districtCode: '16' },
  { code: '35500', name: 'с.Кокжиде', regionCode: '61', districtCode: '16' },
  { code: '37200', name: 'с.Саналы', regionCode: '61', districtCode: '16' },
  { code: '37300', name: 'с.Каражантак', regionCode: '61', districtCode: '16' },
  { code: '37400', name: 'с.Орманды', regionCode: '61', districtCode: '16' },
  { code: '37500', name: 'рзд.40', regionCode: '61', districtCode: '16' },
  { code: '37700', name: 'с.Темиржолшы', regionCode: '61', districtCode: '16' },
  {
    code: '37800',
    name: 'с. Кызылкопир',
    regionCode: '61',
    districtCode: '16'
  },
  { code: '39100', name: 'с.Жидели', regionCode: '61', districtCode: '16' },
  { code: '39200', name: 'с.Аккала', regionCode: '61', districtCode: '16' },
  { code: '45400', name: 'с.Кабылсай', regionCode: '61', districtCode: '16' },
  { code: '45500', name: 'с.Кожатогай', regionCode: '61', districtCode: '16' },
  { code: '45600', name: 'рзд.42', regionCode: '61', districtCode: '16' },
  { code: '45700', name: 'с.Тогансай', regionCode: '61', districtCode: '16' },
  { code: '47100', name: 'с.Кожатогай', regionCode: '61', districtCode: '16' },
  { code: '47200', name: 'с.Байтогай', regionCode: '61', districtCode: '16' },
  { code: '47300', name: 'с.Булак', regionCode: '61', districtCode: '16' },
  { code: '47400', name: 'с.Дарбаза', regionCode: '61', districtCode: '16' },
  { code: '47500', name: 'с.Сырдарья', regionCode: '61', districtCode: '16' },
  { code: '47700', name: 'с.Шогирли', regionCode: '61', districtCode: '16' },
  { code: '10000', name: 'г.Кентау', regionCode: '61', districtCode: '20' },
  { code: '33100', name: 'с.Ачисай', regionCode: '61', districtCode: '20' },
  {
    code: '34100',
    name: 'с.Бабайкурган',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '34200', name: 'с.Абай', regionCode: '61', districtCode: '20' },
  { code: '34206', name: 'Дом чабана 1', regionCode: '61', districtCode: '20' },
  { code: '34207', name: 'Дом чабана 2', regionCode: '61', districtCode: '20' },
  { code: '34400', name: 'с.Ульгили', regionCode: '61', districtCode: '20' },
  { code: '36200', name: 'рзд.30', regionCode: '61', districtCode: '20' },
  {
    code: '36204',
    name: 'Дом чабана Жылысу',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '39200', name: 'с.Бургем', regionCode: '61', districtCode: '20' },
  { code: '41113', name: 'Подземвод', regionCode: '61', districtCode: '20' },
  { code: '41200', name: 'с.Ойык', regionCode: '61', districtCode: '20' },
  { code: '42100', name: 'с.Жуйнек', regionCode: '61', districtCode: '20' },
  { code: '42200', name: 'с.Шекербулак', regionCode: '61', districtCode: '20' },
  { code: '42300', name: 'с.Чипан', regionCode: '61', districtCode: '20' },
  { code: '43100', name: 'с.Шойтобе', regionCode: '61', districtCode: '20' },
  {
    code: '43106',
    name: 'Санаторий водолечебница',
    regionCode: '61',
    districtCode: '20'
  },
  {
    code: '43107',
    name: 'Чабанские дома',
    regionCode: '61',
    districtCode: '20'
  },
  {
    code: '43200',
    name: 'с.Енбекшидихан',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '45300', name: 'с. Каратобе', regionCode: '61', districtCode: '20' },
  { code: '45400', name: 'с.Кумтиым', regionCode: '61', districtCode: '20' },
  {
    code: '45405',
    name: 'Дома райавтодора',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '47100', name: 'с.Ынталы', regionCode: '61', districtCode: '20' },
  {
    code: '47106',
    name: 'Водохранилище',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '47200', name: 'с.Егизкара', regionCode: '61', districtCode: '20' },
  { code: '47300', name: 'с.Каражон', regionCode: '61', districtCode: '20' },
  { code: '49105', name: 'Радиоцентр', regionCode: '61', districtCode: '20' },
  {
    code: '49107',
    name: 'Дома Салимбаевых',
    regionCode: '61',
    districtCode: '20'
  },
  {
    code: '49109',
    name: 'Дома Шаходжаевых',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '49200', name: 'с.Бостандык', regionCode: '61', districtCode: '20' },
  { code: '49400', name: 'с.Кошкорган', regionCode: '61', districtCode: '20' },
  { code: '53100', name: 'с.Жалантос', regionCode: '61', districtCode: '20' },
  {
    code: '53103',
    name: 'Дом лесничего',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '53200', name: 'с.Hуртас', regionCode: '61', districtCode: '20' },
  {
    code: '53300',
    name: 'с.Султанбека Кожанова',
    regionCode: '61',
    districtCode: '20'
  },
  {
    code: '53305',
    name: 'Дом лесничего',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '53403', name: 'МТФ', regionCode: '61', districtCode: '20' },
  { code: '55203', name: 'АТК', regionCode: '61', districtCode: '20' },
  { code: '55205', name: 'МТФ', regionCode: '61', districtCode: '20' },
  {
    code: '57103',
    name: 'Подстанция РЭС',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '57200', name: 'с. Космезгил', regionCode: '61', districtCode: '20' },
  { code: '57203', name: 'АТК', regionCode: '61', districtCode: '20' },
  {
    code: '57204',
    name: 'Дом Акешаева Б.',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '71200', name: 'с.Бескубыр', regionCode: '61', districtCode: '39' },
  { code: '71300', name: 'с.Аманжар', regionCode: '61', districtCode: '39' },
  { code: '71400', name: 'с.Джамбул', regionCode: '61', districtCode: '39' },
  { code: '71480', name: 'с.Жанаконыс', regionCode: '61', districtCode: '39' },
  { code: '71500', name: 'с. Бесауыл', regionCode: '61', districtCode: '39' },
  {
    code: '71580',
    name: 'с.Карабура аулие',
    regionCode: '61',
    districtCode: '39'
  },
  { code: '47107', name: 'Жанакора', regionCode: '61', districtCode: '40' },
  { code: '47111', name: 'Кумискора', regionCode: '61', districtCode: '40' },
  { code: '47205', name: 'Камыскора', regionCode: '61', districtCode: '40' },
  { code: '47207', name: 'Куанышкора', regionCode: '61', districtCode: '40' },
  {
    code: '47303',
    name: 'Боранбай ушуй',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '49103', name: 'Телевышка', regionCode: '61', districtCode: '40' },
  { code: '49207', name: 'Дом чабана', regionCode: '61', districtCode: '40' },
  { code: '49209', name: 'Дом чабана', regionCode: '61', districtCode: '40' },
  {
    code: '49311',
    name: 'Орталык газуй',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '49411', name: 'Кубка', regionCode: '61', districtCode: '40' },
  { code: '49413', name: 'Тауыккора', regionCode: '61', districtCode: '40' },
  { code: '49421', name: 'Дом чабана 1', regionCode: '61', districtCode: '40' },
  { code: '49423', name: 'Дом чабана 2', regionCode: '61', districtCode: '40' },
  { code: '49425', name: 'Дом чабана 3', regionCode: '61', districtCode: '40' },
  { code: '49705', name: 'Заготскот', regionCode: '61', districtCode: '40' },
  { code: '49708', name: 'Ток 4', regionCode: '61', districtCode: '40' },
  { code: '53103', name: 'Акбастаукора', regionCode: '61', districtCode: '40' },
  { code: '53105', name: 'Енбеккора', regionCode: '61', districtCode: '40' },
  {
    code: '53107',
    name: 'Койрылкарынкора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '53109', name: 'МТФ', regionCode: '61', districtCode: '40' },
  { code: '53111', name: 'Парикатакора', regionCode: '61', districtCode: '40' },
  { code: '53113', name: 'Сергазыкора', regionCode: '61', districtCode: '40' },
  { code: '53115', name: 'Сталинкора', regionCode: '61', districtCode: '40' },
  { code: '53119', name: 'Тулкисайкора', regionCode: '61', districtCode: '40' },
  { code: '53121', name: 'Ушагаткора', regionCode: '61', districtCode: '40' },
  {
    code: '53305',
    name: 'Бугыбайкора 1',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '53306',
    name: 'Бугыбайкора 2',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '53307', name: 'МТФ 2', regionCode: '61', districtCode: '40' },
  { code: '53308', name: 'Hурматкора', regionCode: '61', districtCode: '40' },
  { code: '53403', name: 'Бакиркора', regionCode: '61', districtCode: '40' },
  { code: '53404', name: 'Жылкыкора', regionCode: '61', districtCode: '40' },
  {
    code: '53405',
    name: 'Кокбастаукора',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '53406', name: 'Кыркымкора', regionCode: '61', districtCode: '40' },
  { code: '53407', name: 'Сапарлыкора', regionCode: '61', districtCode: '40' },
  { code: '53408', name: 'Шошкакора', regionCode: '61', districtCode: '40' },
  { code: '57203', name: 'Дом чабана 2', regionCode: '61', districtCode: '40' },
  { code: '57205', name: 'Дом чабана 3', regionCode: '61', districtCode: '40' },
  { code: '36100', name: 'с.Сауран', regionCode: '61', districtCode: '20' },
  { code: '38100', name: 'с.Староикан', regionCode: '61', districtCode: '20' },
  { code: '63700', name: 'с.Чайхана', regionCode: '61', districtCode: '54' },
  { code: '41100', name: 'с.Ибата', regionCode: '61', districtCode: '20' },
  { code: '71680', name: 'с.Кызылту', regionCode: '61', districtCode: '38' },
  { code: '39400', name: 'с.Шойтобе', regionCode: '61', districtCode: '20' },
  { code: '45100', name: 'с.Карашик', regionCode: '61', districtCode: '20' },
  { code: '49100', name: 'с.Урангай', regionCode: '61', districtCode: '20' },
  { code: '39300', name: 'с.Кушата', regionCode: '61', districtCode: '20' },
  { code: '53400', name: 'с.Теке', regionCode: '61', districtCode: '20' },
  {
    code: '55200',
    name: 'с.30 лет Казахстана',
    regionCode: '61',
    districtCode: '20'
  },
  { code: '55300', name: 'с.Шоктас', regionCode: '61', districtCode: '20' },
  { code: '55400', name: 'с.Бершинтобе', regionCode: '61', districtCode: '20' },
  { code: '55100', name: 'с.Чага', regionCode: '61', districtCode: '20' },
  { code: '57100', name: 'с.Чернак', regionCode: '61', districtCode: '20' },
  { code: '10000', name: 'г.Туркестан', regionCode: '61', districtCode: '10' },
  { code: '10000', name: 'г.Арысь', regionCode: '61', districtCode: '16' },
  { code: '33200', name: 'с.Акын Жакып', regionCode: '61', districtCode: '16' },
  {
    code: '33300',
    name: 'с.Пакентай Арапов',
    regionCode: '61',
    districtCode: '16'
  },
  { code: '33400', name: 'с.Тахирколь', regionCode: '61', districtCode: '16' },
  { code: '33500', name: 'с.Тогайлы', regionCode: '61', districtCode: '16' },
  { code: '79500', name: 'с.Жибек жолы', regionCode: '61', districtCode: '38' },
  { code: '79580', name: 'с.Алмалы', regionCode: '61', districtCode: '38' },
  { code: '79700', name: 'с.Саркырама', regionCode: '61', districtCode: '38' },
  { code: '79800', name: 'с.Тын', regionCode: '61', districtCode: '38' },
  { code: '79900', name: 'с.Чехово', regionCode: '61', districtCode: '38' },
  { code: '87100', name: 'с.Корикты', regionCode: '61', districtCode: '38' },
  { code: '87200', name: 'с.Агынсай', regionCode: '61', districtCode: '38' },
  { code: '87300', name: 'с.Ушкопир', regionCode: '61', districtCode: '38' },
  { code: '87500', name: 'с.Оркенды', regionCode: '61', districtCode: '38' },
  { code: '87700', name: 'с.Талапты', regionCode: '61', districtCode: '38' },
  { code: '87800', name: 'с.Акниет', regionCode: '61', districtCode: '38' },
  { code: '87900', name: 'с.Hураул', regionCode: '61', districtCode: '38' },
  { code: '89200', name: 'с.Алгабас', regionCode: '61', districtCode: '38' },
  {
    code: '89300',
    name: 'с.Алькен Оспанова',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '89400', name: 'с.Джамбул', regionCode: '61', districtCode: '38' },
  {
    code: '89500',
    name: 'с.Карла Маркса',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '89600', name: 'с.Курманата', regionCode: '61', districtCode: '38' },
  { code: '37380', name: 'с.Горький', regionCode: '61', districtCode: '39' },
  { code: '37480', name: 'с.Когерту', regionCode: '61', districtCode: '39' },
  { code: '37580', name: 'с.Кияжол', regionCode: '61', districtCode: '39' },
  { code: '37680', name: 'с.Бозсу', regionCode: '61', districtCode: '39' },
  { code: '37900', name: 'с.Ынтымак', regionCode: '61', districtCode: '39' },
  { code: '41200', name: 'с.Тартогай', regionCode: '61', districtCode: '39' },
  { code: '41400', name: 'с.Шолантобе', regionCode: '61', districtCode: '39' },
  { code: '47280', name: 'с.Амангельды', regionCode: '61', districtCode: '39' },
  { code: '47680', name: 'с.Игилик', regionCode: '61', districtCode: '39' },
  { code: '47700', name: 'с.Курылыс', regionCode: '61', districtCode: '39' },
  { code: '47880', name: 'с.Биртилек', regionCode: '61', districtCode: '39' },
  { code: '47900', name: 'с.Шукырсай', regionCode: '61', districtCode: '39' },
  { code: '47980', name: 'с.Енбекши', regionCode: '61', districtCode: '39' },
  { code: '75100', name: 'с.Ленинжолы', regionCode: '61', districtCode: '39' },
  { code: '33100', name: 'с.Акдала', regionCode: '61', districtCode: '16' },
  { code: '35100', name: 'с.Баиркум', regionCode: '61', districtCode: '16' },
  { code: '37100', name: 'с.Дармино', regionCode: '61', districtCode: '16' },
  { code: '45100', name: 'с.Монтайтас', regionCode: '61', districtCode: '16' },
  { code: '45200', name: 'с.Актас', regionCode: '61', districtCode: '16' },
  { code: '45300', name: 'с.Бакырша', regionCode: '61', districtCode: '16' },
  { code: '45800', name: 'с.Шагыр', regionCode: '61', districtCode: '16' },
  { code: '35100', name: 'с.Баялдыр', regionCode: '61', districtCode: '20' },
  { code: '37100', name: 'с.Кантаги', regionCode: '61', districtCode: '20' },
  { code: '39100', name: 'с.Карнак', regionCode: '61', districtCode: '20' },
  { code: '34300', name: 'с.Кумайлыкас', regionCode: '61', districtCode: '20' },
  { code: '45300', name: 'с.Коммунизм', regionCode: '61', districtCode: '39' },
  { code: '45400', name: 'с.Курозек', regionCode: '61', districtCode: '39' },
  { code: '45500', name: 'с.Мадениет', regionCode: '61', districtCode: '39' },
  { code: '45600', name: 'с. Косоткел', regionCode: '61', districtCode: '39' },
  { code: '45700', name: 'с.Ушагаш', regionCode: '61', districtCode: '39' },
  { code: '47100', name: 'с.Шырылдак', regionCode: '61', districtCode: '39' },
  { code: '47200', name: 'с.Аккурган', regionCode: '61', districtCode: '39' },
  {
    code: '47300',
    name: 'с.Азербайджан',
    regionCode: '61',
    districtCode: '39'
  },
  { code: '47380', name: 'с.Жабайытобе', regionCode: '61', districtCode: '39' },
  { code: '47400', name: 'с.Димитрово', regionCode: '61', districtCode: '39' },
  { code: '47600', name: 'с.Жолбасшы', regionCode: '61', districtCode: '39' },
  { code: '47780', name: 'с.Керегетас', regionCode: '61', districtCode: '39' },
  { code: '53100', name: 'с.Бекбота', regionCode: '61', districtCode: '39' },
  { code: '53200', name: 'с.Ашикуль', regionCode: '61', districtCode: '39' },
  { code: '53300', name: 'с.Байгабыл', regionCode: '61', districtCode: '39' },
  { code: '53400', name: 'с.Калгансыр', regionCode: '61', districtCode: '39' },
  { code: '53500', name: 'с.Майдабозай', regionCode: '61', districtCode: '39' },
  { code: '59100', name: 'с.Бирлесу', regionCode: '61', districtCode: '39' },
  { code: '59200', name: 'с. Аксу', regionCode: '61', districtCode: '39' },
  { code: '59300', name: 'с.Жузумдик', regionCode: '61', districtCode: '39' },
  { code: '59400', name: 'с.Онтустик', regionCode: '61', districtCode: '39' },
  { code: '71100', name: 'с.Алгабас', regionCode: '61', districtCode: '39' },
  { code: '47300', name: 'с.Шабырлы', regionCode: '61', districtCode: '64' },
  { code: '53100', name: 'с.Узыната', regionCode: '61', districtCode: '64' },
  { code: '55100', name: 'с.Целинное', regionCode: '61', districtCode: '64' },
  { code: '55200', name: 'с.Казахстан', regionCode: '61', districtCode: '64' },
  { code: '57100', name: 'с.Чардара', regionCode: '61', districtCode: '64' },
  { code: '57200', name: 'с.Акберди', regionCode: '61', districtCode: '64' },
  { code: '57300', name: 'с.Бимырза', regionCode: '61', districtCode: '64' },
  { code: '57400', name: 'с.Бозей', regionCode: '61', districtCode: '64' },
  { code: '57500', name: 'с.Куанкудук', regionCode: '61', districtCode: '64' },
  { code: '57600', name: 'с.Пшентобе', regionCode: '61', districtCode: '64' },
  { code: '39280', name: 'с.Жазыксай', regionCode: '61', districtCode: '38' },
  { code: '39400', name: 'с.Жагажай', regionCode: '61', districtCode: '38' },
  { code: '39600', name: 'с.Коктобе', regionCode: '61', districtCode: '38' },
  { code: '39700', name: 'с.Муратбаево', regionCode: '61', districtCode: '38' },
  { code: '39800', name: 'с.Арай', regionCode: '61', districtCode: '38' },
  { code: '39900', name: 'с.Сейфуллино', regionCode: '61', districtCode: '38' },
  { code: '39980', name: 'с.Утиртобе', regionCode: '61', districtCode: '38' },
  { code: '49280', name: 'с.Бирлик', regionCode: '61', districtCode: '38' },
  { code: '49480', name: 'с.Байдала', regionCode: '61', districtCode: '38' },
  { code: '49580', name: 'с.Кемер', regionCode: '61', districtCode: '38' },
  { code: '49680', name: 'с.Кызылтан', regionCode: '61', districtCode: '38' },
  { code: '49800', name: 'с.Сайлау', regionCode: '61', districtCode: '38' },
  { code: '49900', name: 'с.Сулубулак', regionCode: '61', districtCode: '38' },
  { code: '57700', name: 'с.Бакконыс', regionCode: '61', districtCode: '38' },
  { code: '65100', name: 'с.Атамекен', regionCode: '61', districtCode: '38' },
  { code: '65200', name: 'с.Алимбетово', regionCode: '61', districtCode: '38' },
  { code: '65400', name: 'с.Габдуллино', regionCode: '61', districtCode: '38' },
  { code: '65500', name: 'с.Жемисти', regionCode: '61', districtCode: '38' },
  { code: '65580', name: 'с.Жибекши', regionCode: '61', districtCode: '38' },
  {
    code: '65600',
    name: 'с.40 лет Победы',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '65680', name: 'с.Калпаксай', regionCode: '61', districtCode: '38' },
  { code: '65700', name: 'с.Когалы', regionCode: '61', districtCode: '38' },
  { code: '65780', name: 'с.Макташы', regionCode: '61', districtCode: '38' },
  { code: '65800', name: 'с.Прали', regionCode: '61', districtCode: '38' },
  { code: '65880', name: 'с.Талапты', regionCode: '61', districtCode: '38' },
  { code: '65980', name: 'с.Тындала', regionCode: '61', districtCode: '38' },
  {
    code: '67100',
    name: 'с.Каракайское',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '67200', name: 'с.Батырхан', regionCode: '61', districtCode: '38' },
  { code: '67300', name: 'с.Енбек', regionCode: '61', districtCode: '38' },
  { code: '67400', name: 'с.Жорабек', regionCode: '61', districtCode: '38' },
  { code: '67500', name: 'с.Сатпаева', regionCode: '61', districtCode: '38' },
  { code: '67600', name: 'с.Караозек', regionCode: '61', districtCode: '38' },
  { code: '67700', name: 'с.Орыскудук', regionCode: '61', districtCode: '38' },
  { code: '67800', name: 'с.Серикбай', regionCode: '61', districtCode: '38' },
  { code: '67900', name: 'с.Кетебай', regionCode: '61', districtCode: '38' },
  { code: '71100', name: 'с.Датка', regionCode: '61', districtCode: '38' },
  { code: '71200', name: 'с.Актобе', regionCode: '61', districtCode: '38' },
  { code: '71280', name: 'с.Алгабас', regionCode: '61', districtCode: '38' },
  { code: '71300', name: 'с.Коскудык', regionCode: '61', districtCode: '38' },
  { code: '71400', name: 'с.Кызылкум', regionCode: '61', districtCode: '38' },
  { code: '71480', name: 'с.Кирово', regionCode: '61', districtCode: '38' },
  { code: '71500', name: 'с.Карасакал', regionCode: '61', districtCode: '38' },
  { code: '71580', name: 'с.Жалпаккум', regionCode: '61', districtCode: '38' },
  { code: '71600', name: 'с.Туркебай', regionCode: '61', districtCode: '38' },
  { code: '71700', name: 'с.Молшылык', regionCode: '61', districtCode: '38' },
  { code: '71780', name: 'с.Макталы', regionCode: '61', districtCode: '38' },
  {
    code: '71800',
    name: 'с.Первомайское',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '71880', name: 'с.Кобек', regionCode: '61', districtCode: '38' },
  { code: '71900', name: 'с.Енбекши', regionCode: '61', districtCode: '38' },
  { code: '79100', name: 'с.Макталы', regionCode: '61', districtCode: '38' },
  {
    code: '79200',
    name: 'с.Алтынсарино',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '79300', name: 'с.Жайлауколь', regionCode: '61', districtCode: '38' },
  {
    code: '79400',
    name: 'с.Шолпанкудук',
    regionCode: '61',
    districtCode: '38'
  },
  { code: '79480', name: 'с.Темиржол', regionCode: '61', districtCode: '38' },
  { code: '39300', name: 'с.Кокбулак', regionCode: '61', districtCode: '60' },
  { code: '39400', name: 'с.Урбулак', regionCode: '61', districtCode: '60' },
  { code: '39500', name: 'с.Шарафкент', regionCode: '61', districtCode: '60' },
  { code: '43100', name: 'с.Абаил', regionCode: '61', districtCode: '60' },
  { code: '43200', name: 'с.Джабаглы', regionCode: '61', districtCode: '60' },
  { code: '43300', name: 'рзд.115', regionCode: '61', districtCode: '60' },
  { code: '45100', name: 'с.Жаскешу', regionCode: '61', districtCode: '60' },
  { code: '45200', name: 'с.Жанзаково', regionCode: '61', districtCode: '60' },
  { code: '45300', name: 'с.Рыскул', regionCode: '61', districtCode: '60' },
  { code: '45400', name: 'с.Пстели', regionCode: '61', districtCode: '60' },
  {
    code: '47100',
    name: 'с.Кельтемашат',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '47200', name: 'с.Аксай', regionCode: '61', districtCode: '60' },
  { code: '47300', name: 'с.Даубаба', regionCode: '61', districtCode: '60' },
  { code: '47400', name: 'с.Жиынбая', regionCode: '61', districtCode: '60' },
  { code: '47500', name: 'с.Кершетас', regionCode: '61', districtCode: '60' },
  { code: '47600', name: 'с.Когалы', regionCode: '61', districtCode: '60' },
  { code: '47700', name: 'с.Сеславино', regionCode: '61', districtCode: '60' },
  {
    code: '49100',
    name: 'с.Кемербастау',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '49200', name: 'с.Алгабас', regionCode: '61', districtCode: '60' },
  {
    code: '49300',
    name: 'с.Мантая Жаримбетова',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '49400', name: 'с.Ельтай', regionCode: '61', districtCode: '60' },
  {
    code: '49500',
    name: 'с.Кумысбастау',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '49600', name: 'с.Майликент', regionCode: '61', districtCode: '60' },
  { code: '49700', name: 'рзд.117', regionCode: '61', districtCode: '60' },
  { code: '53100', name: 'с.Машат', regionCode: '61', districtCode: '60' },
  { code: '53200', name: 'с.Енбек', regionCode: '61', districtCode: '60' },
  { code: '53300', name: 'с.Енбекши', regionCode: '61', districtCode: '60' },
  { code: '53400', name: 'с.Жанакогам', regionCode: '61', districtCode: '60' },
  {
    code: '53500',
    name: 'с.Кызылбастау',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '55100', name: 'с.Майтобе', regionCode: '61', districtCode: '60' },
  { code: '55200', name: 'с.Коксагыз', regionCode: '61', districtCode: '60' },
  { code: '55300', name: 'с.Таусагыз', regionCode: '61', districtCode: '60' },
  { code: '55400', name: 'с.Кожамберды', regionCode: '61', districtCode: '60' },
  { code: '57100', name: 'с.Азатлык', regionCode: '61', districtCode: '60' },
  { code: '57200', name: 'с.Жанаталап', regionCode: '61', districtCode: '60' },
  { code: '57300', name: 'с.Тастыбулак', regionCode: '61', districtCode: '60' },
  { code: '57400', name: 'с.Чукурбулак', regionCode: '61', districtCode: '60' },
  { code: '59100', name: 'с.Састобе', regionCode: '61', districtCode: '60' },
  { code: '59200', name: 'с.Кзылту', regionCode: '61', districtCode: '60' },
  { code: '59300', name: 'с.Ынтымак', regionCode: '61', districtCode: '60' },
  { code: '61100', name: 'с.Тастумсык', regionCode: '61', districtCode: '60' },
  { code: '61200', name: 'с.Амангельды', regionCode: '61', districtCode: '60' },
  { code: '61400', name: 'с.Жыланды', regionCode: '61', districtCode: '60' },
  { code: '61600', name: 'с.Кабанбай', regionCode: '61', districtCode: '60' },
  { code: '61700', name: 'с.Карабастау', regionCode: '61', districtCode: '60' },
  {
    code: '63100',
    name: 'аул Тюлькубас',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '63300', name: 'с.Коктерек', regionCode: '61', districtCode: '60' },
  {
    code: '65100',
    name: 'с.Шакпак баба',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '65200', name: 'рзд.114', regionCode: '61', districtCode: '60' },
  { code: '33100', name: 'с.Акалтын', regionCode: '61', districtCode: '64' },
  { code: '33200', name: 'с. Егизкум', regionCode: '61', districtCode: '64' },
  { code: '35100', name: 'с.Достык', regionCode: '61', districtCode: '64' },
  { code: '37100', name: 'с.Жаушикум', regionCode: '61', districtCode: '64' },
  { code: '37200', name: 'с.Багисколь', regionCode: '61', districtCode: '64' },
  { code: '37300', name: 'с.Жаушикум', regionCode: '61', districtCode: '64' },
  { code: '37400', name: 'с.Калгансыр', regionCode: '61', districtCode: '64' },
  { code: '37500', name: 'с.Куйган', regionCode: '61', districtCode: '64' },
  { code: '39100', name: 'с.Коксу', regionCode: '61', districtCode: '64' },
  {
    code: '39200',
    name: 'с.Айдарколь кашары',
    regionCode: '61',
    districtCode: '64'
  },
  { code: '39300', name: 'с.Басланды', regionCode: '61', districtCode: '64' },
  { code: '39400', name: 'с.Жоласар', regionCode: '61', districtCode: '64' },
  { code: '43100', name: 'с.Коссейит', regionCode: '61', districtCode: '64' },
  { code: '45100', name: 'с.Кызылкум', regionCode: '61', districtCode: '64' },
  { code: '47100', name: 'с.Сюткент', regionCode: '61', districtCode: '64' },
  { code: '35100', name: 'с.Жанауйым', regionCode: '61', districtCode: '58' },
  { code: '35200', name: 'с.Аккум', regionCode: '61', districtCode: '58' },
  { code: '35300', name: 'с.Момынай', regionCode: '61', districtCode: '58' },
  { code: '37100', name: 'с.Алатау', regionCode: '61', districtCode: '58' },
  { code: '37200', name: 'с.Екпинди', regionCode: '61', districtCode: '58' },
  { code: '37300', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '58' },
  { code: '37400', name: 'с.Кайнар', regionCode: '61', districtCode: '58' },
  { code: '37500', name: 'с.Корган', regionCode: '61', districtCode: '58' },
  { code: '37580', name: 'с.Косагаш', regionCode: '61', districtCode: '58' },
  { code: '37600', name: 'с.Hысамбек', regionCode: '61', districtCode: '58' },
  { code: '37700', name: 'с.Бургулюк', regionCode: '61', districtCode: '58' },
  { code: '37800', name: 'с.Шатыртобе', regionCode: '61', districtCode: '58' },
  { code: '37900', name: 'с.Шубарагаш', regionCode: '61', districtCode: '58' },
  {
    code: '39100',
    name: 'с.Биринши Мамыр',
    regionCode: '61',
    districtCode: '58'
  },
  { code: '39200', name: 'с.Алгабас', regionCode: '61', districtCode: '58' },
  { code: '39300', name: 'с.Бейнеткеш', regionCode: '61', districtCode: '58' },
  { code: '39400', name: 'с.Жанажол', regionCode: '61', districtCode: '58' },
  { code: '39500', name: 'с.Загамбар', regionCode: '61', districtCode: '58' },
  { code: '39800', name: 'с.Тагайна', regionCode: '61', districtCode: '58' },
  { code: '39900', name: 'с.Ынтымак', regionCode: '61', districtCode: '58' },
  { code: '43100', name: 'с.Зертас', regionCode: '61', districtCode: '58' },
  { code: '43200', name: 'с.Жанакуш', regionCode: '61', districtCode: '58' },
  { code: '45100', name: 'с.Мадани', regionCode: '61', districtCode: '58' },
  { code: '45200', name: 'с.Саркырама', regionCode: '61', districtCode: '58' },
  { code: '46100', name: 'с.Абай', regionCode: '61', districtCode: '58' },
  { code: '46200', name: 'с.Акбастау', regionCode: '61', districtCode: '58' },
  { code: '46300', name: 'с.Ангарата', regionCode: '61', districtCode: '58' },
  { code: '46500', name: 'с.Уйымшыл', regionCode: '61', districtCode: '58' },
  { code: '47100', name: 'с.Коксаек', regionCode: '61', districtCode: '58' },
  {
    code: '47200',
    name: 'с.Алтынбастау',
    regionCode: '61',
    districtCode: '58'
  },
  { code: '47300', name: 'с.Жинишке', regionCode: '61', districtCode: '58' },
  { code: '47500', name: 'с.Казахстан', regionCode: '61', districtCode: '58' },
  { code: '48100', name: 'с.Достык', regionCode: '61', districtCode: '58' },
  { code: '48200', name: 'с.Акайдар', regionCode: '61', districtCode: '58' },
  { code: '48300', name: 'с.Киелитас', regionCode: '61', districtCode: '58' },
  {
    code: '48500',
    name: 'с.Султанрабат',
    regionCode: '61',
    districtCode: '58'
  },
  { code: '53100', name: 'с.Балдыберек', regionCode: '61', districtCode: '58' },
  { code: '53200', name: 'с.Костобе', regionCode: '61', districtCode: '58' },
  { code: '53300', name: 'с.Майбулак', regionCode: '61', districtCode: '58' },
  { code: '53400', name: 'с.Каратобе', regionCode: '61', districtCode: '58' },
  { code: '53500', name: 'с.Тонкерис', regionCode: '61', districtCode: '58' },
  {
    code: '55100',
    name: 'с.Жогаргы Каскасу',
    regionCode: '61',
    districtCode: '58'
  },
  { code: '55200', name: 'с.Каскасу', regionCode: '61', districtCode: '58' },
  { code: '55300', name: 'с.Керегетас', regionCode: '61', districtCode: '58' },
  { code: '55400', name: 'с.Конесарык', regionCode: '61', districtCode: '58' },
  { code: '57100', name: 'с.Алшалы', regionCode: '61', districtCode: '58' },
  { code: '57200', name: 'с.Диханкуль', regionCode: '61', districtCode: '58' },
  { code: '57400', name: 'с.Узунарык', regionCode: '61', districtCode: '58' },
  { code: '59100', name: 'с.Тасарык', regionCode: '61', districtCode: '58' },
  { code: '59200', name: 'с.Жамбыл', regionCode: '61', districtCode: '58' },
  { code: '59400', name: 'с.Онтустик', regionCode: '61', districtCode: '58' },
  { code: '59500', name: 'с.Ханарык', regionCode: '61', districtCode: '58' },
  {
    code: '30100',
    name: 'с.им.Турара Рыскулова',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '30180', name: 'с.Ирсу', regionCode: '61', districtCode: '60' },
  { code: '30200', name: 'с.Бакыбека', regionCode: '61', districtCode: '60' },
  { code: '30300', name: 'с.Караагашты', regionCode: '61', districtCode: '60' },
  { code: '33100', name: 'с.Акбиик', regionCode: '61', districtCode: '60' },
  { code: '33200', name: 'с.Кулан', regionCode: '61', districtCode: '60' },
  { code: '33300', name: 'с.Сарытур', regionCode: '61', districtCode: '60' },
  { code: '37100', name: 'с.Кереит', regionCode: '61', districtCode: '60' },
  { code: '37200', name: 'с.Кайыршакты', regionCode: '61', districtCode: '60' },
  { code: '37300', name: 'с.Махталы', regionCode: '61', districtCode: '60' },
  { code: '39100', name: 'с.Балыкты', regionCode: '61', districtCode: '60' },
  { code: '39200', name: 'с.Абай', regionCode: '61', districtCode: '60' },
  { code: '65280', name: 'с.Ак уй', regionCode: '61', districtCode: '54' },
  { code: '65300', name: 'с.Бескудук', regionCode: '61', districtCode: '54' },
  { code: '65380', name: 'с.Дархан', regionCode: '61', districtCode: '54' },
  { code: '65400', name: 'с.Жанаарык', regionCode: '61', districtCode: '54' },
  { code: '65480', name: 'с.Жанаталап', regionCode: '61', districtCode: '54' },
  { code: '65500', name: 'с. Енкес', regionCode: '61', districtCode: '54' },
  { code: '65580', name: 'с.Келес', regionCode: '61', districtCode: '54' },
  { code: '65600', name: 'с.Култума', regionCode: '61', districtCode: '54' },
  { code: '65680', name: 'с. Жылысу', regionCode: '61', districtCode: '54' },
  { code: '65700', name: 'с. Нурлыжол', regionCode: '61', districtCode: '54' },
  { code: '65780', name: 'с.Береке', regionCode: '61', districtCode: '54' },
  { code: '65800', name: 'с. Куркелес', regionCode: '61', districtCode: '54' },
  { code: '65880', name: 'с. Дастан', regionCode: '61', districtCode: '54' },
  { code: '67100', name: 'аул Коктерек', regionCode: '61', districtCode: '54' },
  { code: '69100', name: 'с.Кабыланбек', regionCode: '61', districtCode: '54' },
  { code: '69200', name: 'с.Жанаарык', regionCode: '61', districtCode: '54' },
  { code: '69300', name: 'с.Зах', regionCode: '61', districtCode: '54' },
  { code: '69400', name: 'с.Акниет', regionCode: '61', districtCode: '54' },
  { code: '69500', name: 'с.Канагат', regionCode: '61', districtCode: '54' },
  { code: '69600', name: 'с.Таскулак', regionCode: '61', districtCode: '54' },
  { code: '69700', name: 'с. Тынтобе', regionCode: '61', districtCode: '54' },
  { code: '69800', name: 'с.Чичерино', regionCode: '61', districtCode: '54' },
  { code: '73100', name: 'с.Кызылжар', regionCode: '61', districtCode: '54' },
  { code: '73300', name: 'с.Жаскешу', regionCode: '61', districtCode: '54' },
  { code: '79100', name: 'с.Тегисшиль', regionCode: '61', districtCode: '54' },
  { code: '79200', name: 'с.Таскескен', regionCode: '61', districtCode: '54' },
  { code: '79300', name: 'с.Коктобе', regionCode: '61', districtCode: '54' },
  { code: '79400', name: 'с.Мадениет', regionCode: '61', districtCode: '54' },
  {
    code: '30100',
    name: 'с.Чулаккурган',
    regionCode: '61',
    districtCode: '56'
  },
  { code: '30200', name: 'с.Абай', regionCode: '61', districtCode: '56' },
  { code: '30300', name: 'с.Балдысу', regionCode: '61', districtCode: '56' },
  { code: '30400', name: 'с.Жеткеншек', regionCode: '61', districtCode: '56' },
  { code: '30500', name: 'с.Карабулак', regionCode: '61', districtCode: '56' },
  { code: '30700', name: 'с.Терискей', regionCode: '61', districtCode: '56' },
  { code: '33100', name: 'с.Жартытобе', regionCode: '61', districtCode: '56' },
  { code: '33200', name: 'с.Акколтык', regionCode: '61', districtCode: '56' },
  { code: '33300', name: 'с.Бабаата', regionCode: '61', districtCode: '56' },
  { code: '35100', name: 'с.Жуантобе', regionCode: '61', districtCode: '56' },
  { code: '35300', name: 'с.Конратарык', regionCode: '61', districtCode: '56' },
  { code: '37100', name: 'с.Каракур', regionCode: '61', districtCode: '56' },
  { code: '37200', name: 'с.Ран', regionCode: '61', districtCode: '56' },
  { code: '37400', name: 'с.Шага', regionCode: '61', districtCode: '56' },
  { code: '39100', name: 'с.Аксумбе', regionCode: '61', districtCode: '56' },
  { code: '39200', name: 'с.Бакырлы', regionCode: '61', districtCode: '56' },
  { code: '39300', name: 'с.Сарыжаз', regionCode: '61', districtCode: '56' },
  { code: '43100', name: 'с.Кумкент', regionCode: '61', districtCode: '56' },
  { code: '43200', name: 'с.Кызылканат', regionCode: '61', districtCode: '56' },
  { code: '43300', name: 'с.Кызылколь', regionCode: '61', districtCode: '56' },
  { code: '45100', name: 'аул Кыземшек', regionCode: '61', districtCode: '56' },
  { code: '45200', name: 'с.Тайконыр', regionCode: '61', districtCode: '56' },
  { code: '47100', name: 'с.Сузак', regionCode: '61', districtCode: '56' },
  { code: '47200', name: 'с.Коктобе', regionCode: '61', districtCode: '56' },
  { code: '47300', name: 'с.Какпансор', regionCode: '61', districtCode: '56' },
  { code: '47400', name: 'с.Шакырык', regionCode: '61', districtCode: '56' },
  {
    code: '47500',
    name: 'с.Ыбырая Жаукебаева',
    regionCode: '61',
    districtCode: '56'
  },
  { code: '49100', name: 'с.Сызган', regionCode: '61', districtCode: '56' },
  { code: '49200', name: 'с.Босбулак', regionCode: '61', districtCode: '56' },
  { code: '49400', name: 'с.Кайнар', regionCode: '61', districtCode: '56' },
  { code: '49500', name: 'с.Козмолдак', regionCode: '61', districtCode: '56' },
  { code: '53100', name: 'с.Тасты', regionCode: '61', districtCode: '56' },
  { code: '53200', name: 'с.Кылты', regionCode: '61', districtCode: '56' },
  { code: '55100', name: 'аул Таукент', regionCode: '61', districtCode: '56' },
  { code: '63100', name: 'с.Шу', regionCode: '61', districtCode: '56' },
  { code: '20100', name: 'г.Ленгер', regionCode: '61', districtCode: '58' },
  { code: '57100', name: 'с.Карасу', regionCode: '61', districtCode: '52' },
  { code: '57200', name: 'с.Акбай', regionCode: '61', districtCode: '52' },
  { code: '57300', name: 'с.Бескепе', regionCode: '61', districtCode: '52' },
  { code: '57400', name: 'с.Айтеке би', regionCode: '61', districtCode: '52' },
  { code: '57500', name: 'с.Акбастау', regionCode: '61', districtCode: '52' },
  { code: '57700', name: 'с.Ынтымак', regionCode: '61', districtCode: '52' },
  { code: '57800', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '52' },
  { code: '57900', name: 'с.Береке', regionCode: '61', districtCode: '52' },
  { code: '63100', name: 'с.Кутарыс', regionCode: '61', districtCode: '52' },
  { code: '63200', name: 'с.Кызылжар', regionCode: '61', districtCode: '52' },
  { code: '63300', name: 'с.Акарыс', regionCode: '61', districtCode: '52' },
  { code: '63400', name: 'с.Оймаут', regionCode: '61', districtCode: '52' },
  { code: '65100', name: 'с.Колкент', regionCode: '61', districtCode: '52' },
  { code: '65200', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '52' },
  { code: '65300', name: 'с.Аксуабат', regionCode: '61', districtCode: '52' },
  {
    code: '65400',
    name: 'с.Молыбая Оразалиева',
    regionCode: '61',
    districtCode: '52'
  },
  { code: '65500', name: 'с.Ханкорган', regionCode: '61', districtCode: '52' },
  { code: '65600', name: 'с.Косбулак', regionCode: '61', districtCode: '52' },
  { code: '65700', name: 'с.Теспе', regionCode: '61', districtCode: '52' },
  { code: '65800', name: 'с.Шапрашты', regionCode: '61', districtCode: '52' },
  { code: '67100', name: 'с.Манкент', regionCode: '61', districtCode: '52' },
  { code: '67200', name: 'с.Аккала', regionCode: '61', districtCode: '52' },
  { code: '20100', name: 'г.Сарыагаш', regionCode: '61', districtCode: '54' },
  { code: '35100', name: 'с.Акжар', regionCode: '61', districtCode: '54' },
  { code: '35200', name: 'с.Багыж', regionCode: '61', districtCode: '54' },
  { code: '39100', name: 'с.Алимтау', regionCode: '61', districtCode: '54' },
  {
    code: '39200',
    name: 'с.Жайдаккудук',
    regionCode: '61',
    districtCode: '54'
  },
  { code: '39300', name: 'с.Коктал', regionCode: '61', districtCode: '54' },
  { code: '39400', name: 'с.Таскудук', regionCode: '61', districtCode: '54' },
  { code: '49100', name: 'с.Дарбаза', regionCode: '61', districtCode: '54' },
  { code: '49200', name: 'с.Жанааул', regionCode: '61', districtCode: '54' },
  { code: '49300', name: 'с.Куруксай', regionCode: '61', districtCode: '54' },
  { code: '49400', name: 'рзд.50', regionCode: '61', districtCode: '54' },
  { code: '49500', name: 'рзд.51', regionCode: '61', districtCode: '54' },
  { code: '49600', name: 'с.Ердаулет', regionCode: '61', districtCode: '54' },
  { code: '49700', name: 'с.Сарысу', regionCode: '61', districtCode: '54' },
  { code: '49800', name: 'с.Таскудук', regionCode: '61', districtCode: '54' },
  { code: '51100', name: 'с.Дербисек', regionCode: '61', districtCode: '54' },
  { code: '51200', name: 'с.Атамекен', regionCode: '61', districtCode: '54' },
  { code: '55100', name: 'с.Бостандык', regionCode: '61', districtCode: '54' },
  { code: '55200', name: 'с.Курама', regionCode: '61', districtCode: '54' },
  { code: '55300', name: 'с.Достык', regionCode: '61', districtCode: '54' },
  { code: '55400', name: 'с.Тонкерис', regionCode: '61', districtCode: '54' },
  { code: '55500', name: 'с.Ынтымак', regionCode: '61', districtCode: '54' },
  { code: '57100', name: 'с.Жемисти', regionCode: '61', districtCode: '54' },
  { code: '57200', name: 'с.Тын', regionCode: '61', districtCode: '54' },
  { code: '61100', name: 'с.Жибек жолы', regionCode: '61', districtCode: '54' },
  { code: '61200', name: 'с. Зортобе', regionCode: '61', districtCode: '54' },
  { code: '61280', name: 'с.Дикан баба', regionCode: '61', districtCode: '54' },
  {
    code: '61300',
    name: 'с.Жанакурылыс',
    regionCode: '61',
    districtCode: '54'
  },
  { code: '61400', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '54' },
  { code: '61600', name: 'с. Саркырама', regionCode: '61', districtCode: '54' },
  { code: '61700', name: 'с. Карабау', regionCode: '61', districtCode: '54' },
  { code: '61800', name: 'с.Сок-Сок', regionCode: '61', districtCode: '54' },
  { code: '63100', name: 'с.Жилга', regionCode: '61', districtCode: '54' },
  { code: '63200', name: 'с.Капанза', regionCode: '61', districtCode: '54' },
  { code: '63300', name: 'с.Каракалпак', regionCode: '61', districtCode: '54' },
  { code: '63400', name: 'с.Кызыласу', regionCode: '61', districtCode: '54' },
  { code: '63500', name: 'рзд.49', regionCode: '61', districtCode: '54' },
  { code: '63600', name: 'с.Hурауыл', regionCode: '61', districtCode: '54' },
  { code: '63800', name: 'с.Ченгельды', regionCode: '61', districtCode: '54' },
  { code: '63900', name: 'с.Шымырбай', regionCode: '61', districtCode: '54' },
  { code: '65100', name: 'с. Акниет', regionCode: '61', districtCode: '54' },
  { code: '65200', name: 'с.Алгабас', regionCode: '61', districtCode: '54' },
  { code: '55300', name: 'с.Береке', regionCode: '61', districtCode: '46' },
  { code: '55400', name: 'с.Жусансай', regionCode: '61', districtCode: '46' },
  { code: '55500', name: 'с.Сарытогай', regionCode: '61', districtCode: '46' },
  { code: '55600', name: 'с.Токсансай', regionCode: '61', districtCode: '46' },
  { code: '57100', name: 'с.Шубарсу', regionCode: '61', districtCode: '46' },
  { code: '30100', name: 'с.Шаульдер', regionCode: '61', districtCode: '48' },
  { code: '33100', name: 'с.Аккум', regionCode: '61', districtCode: '48' },
  { code: '34100', name: 'с.Актобе', regionCode: '61', districtCode: '48' },
  { code: '35100', name: 'с.Балтаколь', regionCode: '61', districtCode: '48' },
  { code: '35200', name: 'с.Акколь', regionCode: '61', districtCode: '48' },
  { code: '35500', name: 'с.Колкудык', regionCode: '61', districtCode: '48' },
  { code: '36100', name: 'с.Каргалы', regionCode: '61', districtCode: '48' },
  { code: '36400', name: 'с.Отрар', regionCode: '61', districtCode: '48' },
  { code: '37100', name: 'с.Коксарай', regionCode: '61', districtCode: '48' },
  { code: '37200', name: 'с.Жанкел', regionCode: '61', districtCode: '48' },
  { code: '37300', name: 'с.Шенгельды', regionCode: '61', districtCode: '48' },
  { code: '37400', name: 'с.Ызаколь', regionCode: '61', districtCode: '48' },
  {
    code: '39100',
    name: 'с. Шамши Калдаякова',
    regionCode: '61',
    districtCode: '48'
  },
  { code: '39300', name: 'с.Арысь', regionCode: '61', districtCode: '48' },
  {
    code: '39500',
    name: 'с. Бесторангыл',
    regionCode: '61',
    districtCode: '48'
  },
  { code: '39600', name: 'с.Караконыр', regionCode: '61', districtCode: '48' },
  { code: '39700', name: 'с.Костуин', regionCode: '61', districtCode: '48' },
  { code: '39800', name: 'с.Сырдарья', regionCode: '61', districtCode: '48' },
  { code: '41100', name: 'с.Когам', regionCode: '61', districtCode: '48' },
  { code: '41300', name: 'с.Мыншункыр', regionCode: '61', districtCode: '48' },
  { code: '41500', name: 'с.Талапты', regionCode: '61', districtCode: '48' },
  { code: '45100', name: 'с.Маякум', regionCode: '61', districtCode: '48' },
  { code: '45200', name: 'с.Аккум', regionCode: '61', districtCode: '48' },
  { code: '45300', name: 'с.Бестам', regionCode: '61', districtCode: '48' },
  { code: '45500', name: 'с.Ешкикора', regionCode: '61', districtCode: '48' },
  { code: '45600', name: 'с.Костерек', regionCode: '61', districtCode: '48' },
  { code: '47100', name: 'с.Арысь', regionCode: '61', districtCode: '48' },
  {
    code: '47300',
    name: 'с. Молыке Шойманов',
    regionCode: '61',
    districtCode: '48'
  },
  { code: '49100', name: 'с.Кокмардан', regionCode: '61', districtCode: '48' },
  { code: '49500', name: 'с.Шытты', regionCode: '61', districtCode: '48' },
  { code: '49600', name: 'с.Сарыколь', regionCode: '61', districtCode: '48' },
  { code: '49700', name: 'с.Ынталы', regionCode: '61', districtCode: '48' },
  { code: '53100', name: 'с.Тимур', regionCode: '61', districtCode: '48' },
  { code: '53200', name: 'с.Акшокат', regionCode: '61', districtCode: '48' },
  { code: '53400', name: 'с.Отрабат', regionCode: '61', districtCode: '48' },
  { code: '53500', name: 'рзд.37', regionCode: '61', districtCode: '48' },
  { code: '53600', name: 'с.Узынкудук', regionCode: '61', districtCode: '48' },
  { code: '57100', name: 'с.Шилик', regionCode: '61', districtCode: '48' },
  {
    code: '57300',
    name: 'с.Старый Шилик',
    regionCode: '61',
    districtCode: '48'
  },
  { code: '30100', name: 'с.Аксу', regionCode: '61', districtCode: '52' },
  { code: '30200', name: 'с.Байтерек', regionCode: '61', districtCode: '52' },
  { code: '30300', name: 'с.Алаш', regionCode: '61', districtCode: '52' },
  { code: '33100', name: 'с.Акбулак', regionCode: '61', districtCode: '52' },
  { code: '37100', name: 'с.Кожакорган', regionCode: '61', districtCode: '52' },
  {
    code: '37200',
    name: 'с.Hуржанкорган',
    regionCode: '61',
    districtCode: '52'
  },
  { code: '47100', name: 'с.Машат', regionCode: '61', districtCode: '52' },
  { code: '47200', name: 'с.Жибек жолы', regionCode: '61', districtCode: '52' },
  { code: '47300', name: 'с.Сихым', regionCode: '61', districtCode: '52' },
  { code: '49200', name: 'с.Таскешу', regionCode: '61', districtCode: '52' },
  {
    code: '49300',
    name: 'с.Касымбек датка',
    regionCode: '61',
    districtCode: '52'
  },
  { code: '49400', name: 'с.Асиларык', regionCode: '61', districtCode: '52' },
  { code: '49500', name: 'с.Сарыарык', regionCode: '61', districtCode: '52' },
  { code: '49600', name: 'с.Курлык', regionCode: '61', districtCode: '52' },
  { code: '49700', name: 'с.Ошакты', regionCode: '61', districtCode: '52' },
  { code: '49800', name: 'с.Тоган', regionCode: '61', districtCode: '52' },
  { code: '49900', name: 'с.Чиркино', regionCode: '61', districtCode: '52' },
  { code: '53100', name: 'с.Карабулак', regionCode: '61', districtCode: '52' },
  { code: '55100', name: 'с.Карамурт', regionCode: '61', districtCode: '52' },
  { code: '55200', name: 'с.Низамабад', regionCode: '61', districtCode: '52' },
  {
    code: '47203',
    name: 'Отдельно стоящие дома',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '63303', name: 'с.Акбура', regionCode: '61', districtCode: '60' },
  { code: '20100', name: 'г.Шардара', regionCode: '61', districtCode: '64' },
  { code: '35103', name: 'Отд. 1', regionCode: '61', districtCode: '64' },
  { code: '35105', name: 'Отд. 2', regionCode: '61', districtCode: '64' },
  {
    code: '37403',
    name: 'Дом моториста',
    regionCode: '61',
    districtCode: '64'
  },
  { code: '39103', name: 'ЛСП', regionCode: '61', districtCode: '64' },
  { code: '39105', name: 'МТФ', regionCode: '61', districtCode: '64' },
  {
    code: '39107',
    name: 'Плодовое хозяйство',
    regionCode: '61',
    districtCode: '64'
  },
  {
    code: '39109',
    name: 'с.Сырдарьинское',
    regionCode: '61',
    districtCode: '64'
  },
  { code: '53103', name: 'Отд. 1', regionCode: '61', districtCode: '64' },
  { code: '53105', name: 'Отд. 2', regionCode: '61', districtCode: '64' },
  { code: '53107', name: 'Отд. 3', regionCode: '61', districtCode: '64' },
  { code: '53109', name: 'Отд. 4', regionCode: '61', districtCode: '64' },
  { code: '53113', name: 'Hасосная', regionCode: '61', districtCode: '64' },
  { code: '53115', name: 'ПХЦ', regionCode: '61', districtCode: '64' },
  { code: '53117', name: 'Телевышка', regionCode: '61', districtCode: '64' },
  { code: '55103', name: 'Hасосная', regionCode: '61', districtCode: '64' },
  { code: '55105', name: 'Пикет 618', regionCode: '61', districtCode: '64' },
  { code: '55203', name: 'Аэродром', regionCode: '61', districtCode: '64' },
  { code: '55205', name: 'Отд. 1', regionCode: '61', districtCode: '64' },
  { code: '55207', name: 'Отд. 2', regionCode: '61', districtCode: '64' },
  { code: '55209', name: 'Отд. 3', regionCode: '61', districtCode: '64' },
  { code: '49600', name: 'с.Маятас', regionCode: '61', districtCode: '58' },
  { code: '33900', name: 'с.Мамыр', regionCode: '61', districtCode: '46' },
  { code: '35100', name: 'с.Бугунь', regionCode: '61', districtCode: '46' },
  { code: '35200', name: 'с.Кемер', regionCode: '61', districtCode: '46' },
  { code: '37100', name: 'с.Бирлик', regionCode: '61', districtCode: '46' },
  { code: '37200', name: 'с.Джамбул', regionCode: '61', districtCode: '46' },
  { code: '37300', name: 'с.Кайнар', regionCode: '61', districtCode: '46' },
  { code: '37400', name: 'с.Калаш', regionCode: '61', districtCode: '46' },
  { code: '37500', name: 'с.Теспе', regionCode: '61', districtCode: '46' },
  { code: '37600', name: 'с.Уялыжар', regionCode: '61', districtCode: '46' },
  {
    code: '37700',
    name: 'с.Ыкыластемир',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '37800', name: 'с.Интымак', regionCode: '61', districtCode: '46' },
  { code: '39100', name: 'с.Женис', regionCode: '61', districtCode: '46' },
  { code: '39200', name: 'с.Дихан', regionCode: '61', districtCode: '46' },
  { code: '43100', name: 'с.Карааспан', regionCode: '61', districtCode: '46' },
  {
    code: '43280',
    name: 'с.Бейсен Онтаева',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '43300', name: 'с.Акжол', regionCode: '61', districtCode: '46' },
  {
    code: '43380',
    name: 'с.Берген Исаханова',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '43400', name: 'с.Жулдыз', regionCode: '61', districtCode: '46' },
  { code: '43480', name: 'с.Ынтымак', regionCode: '61', districtCode: '46' },
  { code: '43500', name: 'с.Тореарык', regionCode: '61', districtCode: '46' },
  { code: '43580', name: 'с.Кольтоган', regionCode: '61', districtCode: '46' },
  { code: '43600', name: 'с.Карааспан', regionCode: '61', districtCode: '46' },
  {
    code: '43680',
    name: 'с.Карааспанское',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '43700', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '46' },
  { code: '43780', name: 'с.Мадениет', regionCode: '61', districtCode: '46' },
  { code: '43800', name: 'с.Макташы', regionCode: '61', districtCode: '46' },
  { code: '43900', name: 'с.Сарыарык', regionCode: '61', districtCode: '46' },
  { code: '45100', name: 'с.Каракум', regionCode: '61', districtCode: '46' },
  { code: '53100', name: 'с.Торткуль', regionCode: '61', districtCode: '46' },
  { code: '53200', name: 'с.Аксоры', regionCode: '61', districtCode: '46' },
  { code: '53280', name: 'с.Арыстанды', regionCode: '61', districtCode: '46' },
  { code: '53300', name: 'с.Енбекши', regionCode: '61', districtCode: '46' },
  { code: '53400', name: 'с.Жайылма', regionCode: '61', districtCode: '46' },
  { code: '53500', name: 'с.Кызылжар', regionCode: '61', districtCode: '46' },
  {
    code: '53600',
    name: 'с.Елшибек батыр',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '53700', name: 'с.Кокарал', regionCode: '61', districtCode: '46' },
  { code: '53800', name: 'с.Hура', regionCode: '61', districtCode: '46' },
  { code: '53900', name: 'с.Спатаево', regionCode: '61', districtCode: '46' },
  { code: '55100', name: 'с.Чубар', regionCode: '61', districtCode: '46' },
  { code: '55200', name: 'с.Аккойлы', regionCode: '61', districtCode: '46' },
  { code: '77580', name: 'с.Оркениет', regionCode: '61', districtCode: '44' },
  { code: '77600', name: 'с.Тулпар', regionCode: '61', districtCode: '44' },
  { code: '77680', name: 'с.Игилик', regionCode: '61', districtCode: '44' },
  {
    code: '77700',
    name: 'с.40 лет Казахской ССР',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '77780', name: 'с.Береке', regionCode: '61', districtCode: '44' },
  { code: '77800', name: 'с.Кокарал', regionCode: '61', districtCode: '44' },
  { code: '77880', name: 'с.Азаттык', regionCode: '61', districtCode: '44' },
  { code: '77900', name: 'с.Бахыт', regionCode: '61', districtCode: '44' },
  { code: '83100', name: 'с.Жанажол', regionCode: '61', districtCode: '44' },
  { code: '83200', name: 'с.Жамбыл', regionCode: '61', districtCode: '44' },
  { code: '83300', name: 'с.Ленино', regionCode: '61', districtCode: '44' },
  { code: '83400', name: 'с. Торткуль', regionCode: '61', districtCode: '44' },
  { code: '83500', name: 'с. Атамура', regionCode: '61', districtCode: '44' },
  { code: '83600', name: 'с. Туран', regionCode: '61', districtCode: '44' },
  { code: '83700', name: 'с.Ульгили', regionCode: '61', districtCode: '44' },
  {
    code: '30100',
    name: 'с.Темирлановка',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '30200', name: 'с.Амангельды', regionCode: '61', districtCode: '46' },
  { code: '30300', name: 'с.Боралдай', regionCode: '61', districtCode: '46' },
  { code: '30400', name: 'с.Ынталы', regionCode: '61', districtCode: '46' },
  { code: '30500', name: 'с.Коктобе', regionCode: '61', districtCode: '46' },
  { code: '30600', name: 'с.Кажымухан', regionCode: '61', districtCode: '46' },
  {
    code: '30700',
    name: 'с.Кызылсенгир',
    regionCode: '61',
    districtCode: '46'
  },
  { code: '33100', name: 'с.Бадам', regionCode: '61', districtCode: '46' },
  { code: '33580', name: 'с.Карабастау', regionCode: '61', districtCode: '46' },
  { code: '33600', name: 'с.Дербес', regionCode: '61', districtCode: '46' },
  { code: '33700', name: 'с.Ордабасы', regionCode: '61', districtCode: '46' },
  { code: '33800', name: 'с.Акбулак', regionCode: '61', districtCode: '46' },
  { code: '38400', name: 'с.Жанаталап', regionCode: '61', districtCode: '44' },
  { code: '38500', name: 'с.Конырат', regionCode: '61', districtCode: '44' },
  { code: '38600', name: 'с.Табысты', regionCode: '61', districtCode: '44' },
  {
    code: '59000',
    name: 'Ильичевская п.а.',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '73103', name: 'МТФ', regionCode: '61', districtCode: '44' },
  { code: '83303', name: 'МТФ', regionCode: '61', districtCode: '44' },
  { code: '35103', name: 'с.Актам', regionCode: '61', districtCode: '48' },
  { code: '36103', name: 'с.Сулыкесын', regionCode: '61', districtCode: '48' },
  { code: '37103', name: 'с.Бестам', regionCode: '61', districtCode: '48' },
  { code: '37105', name: 'Дом отдыха', regionCode: '61', districtCode: '48' },
  { code: '49103', name: 'с.Жылкыауылы', regionCode: '61', districtCode: '48' },
  {
    code: '49203',
    name: 'Кашара Байгараева',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49205',
    name: 'Кашара Гаражаева',
    regionCode: '61',
    districtCode: '52'
  },
  { code: '49403', name: 'Кашара Дача', regionCode: '61', districtCode: '52' },
  {
    code: '49405',
    name: 'Кашара Махмудова',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49503',
    name: 'Кашара Озеро 1',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49505',
    name: 'Кашара Озеро 2',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49507',
    name: 'Кашара Озеро 3',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49603',
    name: 'Кашара Дача 1',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49803',
    name: 'Кашара Булак 1',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49805',
    name: 'Кашара Булак 2',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '49807',
    name: 'Кашара Булак 3',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '53103',
    name: 'Озеро Кулькент',
    regionCode: '61',
    districtCode: '52'
  },
  {
    code: '65105',
    name: 'Кашара Кадира',
    regionCode: '61',
    districtCode: '52'
  },
  { code: '65107', name: 'Кашара Якуба', regionCode: '61', districtCode: '52' },
  { code: '65303', name: 'Кашара Аксу', regionCode: '61', districtCode: '52' },
  { code: '65403', name: 'Кашара Аден', regionCode: '61', districtCode: '52' },
  {
    code: '33107',
    name: 'c.Таскомирсай',
    regionCode: '61',
    districtCode: '56'
  },
  { code: '55107', name: 'с.Айгене', regionCode: '61', districtCode: '56' },
  {
    code: '63107',
    name: 'с.Торыустаган',
    regionCode: '61',
    districtCode: '56'
  },
  { code: '46600', name: 'с.Каратобе', regionCode: '61', districtCode: '58' },
  { code: '46700', name: 'с.Каракия', regionCode: '61', districtCode: '58' },
  { code: '45103', name: 'рзд.Каракчи', regionCode: '61', districtCode: '60' },
  {
    code: '45107',
    name: 'Отдельно стоящие дома',
    regionCode: '61',
    districtCode: '60'
  },
  {
    code: '45109',
    name: 'Кашара Куанышты',
    regionCode: '61',
    districtCode: '60'
  },
  { code: '45303', name: 'ст.Коктерек', regionCode: '61', districtCode: '60' },
  { code: '45403', name: 'Лесхоз', regionCode: '61', districtCode: '60' },
  { code: '53100', name: 'с.Турбат', regionCode: '61', districtCode: '40' },
  { code: '53200', name: 'с.Енбек', regionCode: '61', districtCode: '40' },
  { code: '53300', name: 'с.Кызылдихан', regionCode: '61', districtCode: '40' },
  { code: '53400', name: 'с.Ондирис', regionCode: '61', districtCode: '40' },
  { code: '55100', name: 'с.Шанак', regionCode: '61', districtCode: '40' },
  { code: '55200', name: 'с.Акжар', regionCode: '61', districtCode: '40' },
  {
    code: '55300',
    name: 'с.Старый Шанак',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '55400', name: 'ст.Чанак', regionCode: '61', districtCode: '40' },
  { code: '55500', name: 'с.Ызабулак', regionCode: '61', districtCode: '40' },
  { code: '57100', name: 'с.Шарапхана', regionCode: '61', districtCode: '40' },
  { code: '57200', name: 'с.Бакабулак', regionCode: '61', districtCode: '40' },
  { code: '57300', name: 'с.Жинишке', regionCode: '61', districtCode: '40' },
  { code: '57400', name: 'с.Майлыошак', regionCode: '61', districtCode: '40' },
  {
    code: '57500',
    name: 'с.им.Махамбет Утемисова',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '57600', name: 'с.Талдыбулак', regionCode: '61', districtCode: '40' },
  { code: '63100', name: 'с.Шарбулак', regionCode: '61', districtCode: '40' },
  { code: '63500', name: 'с.Акбастау', regionCode: '61', districtCode: '40' },
  { code: '35100', name: 'с.Бескетик', regionCode: '61', districtCode: '44' },
  { code: '35200', name: 'с.Водное', regionCode: '61', districtCode: '44' },
  { code: '35300', name: 'с.Достык', regionCode: '61', districtCode: '44' },
  {
    code: '35400',
    name: 'с.Жолбарыса Калшораева',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '35500', name: 'с.Хайдар', regionCode: '61', districtCode: '44' },
  { code: '35600', name: 'с.Гулистан', regionCode: '61', districtCode: '44' },
  { code: '45100', name: 'с.Жантаксай', regionCode: '61', districtCode: '44' },
  { code: '45200', name: 'с.Жанатурмыс', regionCode: '61', districtCode: '44' },
  { code: '45300', name: 'с.Шугыла', regionCode: '61', districtCode: '44' },
  {
    code: '45400',
    name: 'с.Танирбергена Жайлыбаева',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '45500', name: 'с.Hурлытан', regionCode: '61', districtCode: '44' },
  { code: '47100', name: 'с.Жамбыл', regionCode: '61', districtCode: '44' },
  { code: '47200', name: 'с.Жалын', regionCode: '61', districtCode: '44' },
  { code: '47300', name: 'с.Кенесшилы', regionCode: '61', districtCode: '44' },
  { code: '47400', name: 'с.Кокпарсай', regionCode: '61', districtCode: '44' },
  { code: '55100', name: 'с.Арайлы', regionCode: '61', districtCode: '44' },
  { code: '55200', name: 'с.Достык', regionCode: '61', districtCode: '44' },
  { code: '55300', name: 'с.Женис', regionCode: '61', districtCode: '44' },
  { code: '55400', name: 'с.Оргебас', regionCode: '61', districtCode: '44' },
  {
    code: '55600',
    name: 'с.Hайман Бухарбай',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '55700', name: 'с.Акжол', regionCode: '61', districtCode: '44' },
  { code: '55800', name: 'с.Фирдоуси', regionCode: '61', districtCode: '44' },
  { code: '55900', name: 'с.Hурлыжол', regionCode: '61', districtCode: '44' },
  { code: '59100', name: 'п. Атакент', regionCode: '61', districtCode: '44' },
  { code: '63100', name: 'с.Шапагат', regionCode: '61', districtCode: '44' },
  { code: '63200', name: 'с.Азат', regionCode: '61', districtCode: '44' },
  { code: '63300', name: 'с.Ииржар', regionCode: '61', districtCode: '44' },
  { code: '63400', name: 'с.Азамат', regionCode: '61', districtCode: '44' },
  { code: '63500', name: 'с.Мактажан', regionCode: '61', districtCode: '44' },
  { code: '63600', name: 'с.Дикан', regionCode: '61', districtCode: '44' },
  { code: '63700', name: 'с.Наурыз', regionCode: '61', districtCode: '44' },
  { code: '63800', name: 'с.Алаш', regionCode: '61', districtCode: '44' },
  { code: '63900', name: 'с.Рахимово', regionCode: '61', districtCode: '44' },
  { code: '73100', name: 'с. Ынталы', regionCode: '61', districtCode: '44' },
  { code: '73200', name: 'с.Онимкер', regionCode: '61', districtCode: '44' },
  { code: '73300', name: 'с.Каракир', regionCode: '61', districtCode: '44' },
  { code: '73400', name: 'с.Ырысты', regionCode: '61', districtCode: '44' },
  { code: '73500', name: 'с. Мырзатобе', regionCode: '61', districtCode: '44' },
  { code: '73700', name: 'с. Оркен', regionCode: '61', districtCode: '44' },
  { code: '77100', name: 'с.Мадениет', regionCode: '61', districtCode: '44' },
  { code: '77200', name: 'с.Акалтын', regionCode: '61', districtCode: '44' },
  { code: '77280', name: 'с.Амангельды', regionCode: '61', districtCode: '44' },
  { code: '77300', name: 'с.Елконыс', regionCode: '61', districtCode: '44' },
  {
    code: '77380',
    name: 'с.Нурмухамеда Есентаева',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '77400', name: 'с.Шаттык', regionCode: '61', districtCode: '44' },
  { code: '77480', name: 'с.Енбекши', regionCode: '61', districtCode: '44' },
  { code: '77500', name: 'с.Жулдыз', regionCode: '61', districtCode: '44' },
  {
    code: '35600',
    name: 'с.20 лет Казахской ССР',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '35700', name: 'с.Карабастау', regionCode: '61', districtCode: '40' },
  { code: '35800', name: 'с.Тилектес', regionCode: '61', districtCode: '40' },
  { code: '35900', name: 'с.Улгили', regionCode: '61', districtCode: '40' },
  { code: '36100', name: 'с.Жигерген', regionCode: '61', districtCode: '40' },
  { code: '36200', name: 'с.Айнатас', regionCode: '61', districtCode: '40' },
  { code: '36400', name: 'с.Дикан', regionCode: '61', districtCode: '40' },
  { code: '36500', name: 'с.Кызылбулак', regionCode: '61', districtCode: '40' },
  { code: '36700', name: 'с.Тесиктобе', regionCode: '61', districtCode: '40' },
  { code: '36800', name: 'с.Угам', regionCode: '61', districtCode: '40' },
  { code: '37100', name: 'с.Кокебель', regionCode: '61', districtCode: '40' },
  { code: '37400', name: 'с.Кызылата', regionCode: '61', districtCode: '40' },
  { code: '37600', name: 'с.Майбулак', regionCode: '61', districtCode: '40' },
  { code: '43100', name: 'с.Какпак', regionCode: '61', districtCode: '40' },
  { code: '45100', name: 'с.Карабау', regionCode: '61', districtCode: '40' },
  { code: '45200', name: 'с.Сынтас', regionCode: '61', districtCode: '40' },
  { code: '45300', name: 'с.Жумысшы', regionCode: '61', districtCode: '40' },
  { code: '45400', name: 'с.Ушбулак', regionCode: '61', districtCode: '40' },
  { code: '47100', name: 'с.Тугыртас', regionCode: '61', districtCode: '40' },
  { code: '47200', name: 'с.Айнатас', regionCode: '61', districtCode: '40' },
  { code: '47300', name: 'с.Кызылкия', regionCode: '61', districtCode: '40' },
  { code: '47400', name: 'с.Ынталы', regionCode: '61', districtCode: '40' },
  {
    code: '47500',
    name: 'с.Кызылсенгир',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '49100', name: 'с.Рабат', regionCode: '61', districtCode: '40' },
  { code: '49200', name: 'с.Амангельды', regionCode: '61', districtCode: '40' },
  { code: '49300', name: 'с.Атбулак', regionCode: '61', districtCode: '40' },
  { code: '49400', name: 'с.Енбекши', regionCode: '61', districtCode: '40' },
  { code: '49500', name: 'с.Жанаталап', regionCode: '61', districtCode: '40' },
  { code: '57207', name: 'Дом чабана 4', regionCode: '61', districtCode: '40' },
  { code: '57209', name: 'Дом чабана 5', regionCode: '61', districtCode: '40' },
  { code: '57211', name: 'Дом чабана 6', regionCode: '61', districtCode: '40' },
  { code: '57213', name: 'Дом чабана 7', regionCode: '61', districtCode: '40' },
  {
    code: '57303',
    name: 'Дом чабана 12',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57305',
    name: 'Дом чабана 13',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57307',
    name: 'Дом чабана 14',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57309',
    name: 'Дом чабана 15',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57311',
    name: 'Дом чабана 16',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57313',
    name: 'Дом чабана 17',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57315',
    name: 'Дом чабана 18',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57403',
    name: 'Дом чабана 19',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57405',
    name: 'Дом чабана 20',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57407',
    name: 'Дом чабана 21',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57409',
    name: 'Дом чабана 22',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57411',
    name: 'Дом чабана 23',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57603',
    name: 'Дом чабана 24',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57605',
    name: 'Дом чабана 25',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57607',
    name: 'Дом чабана 26',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57609',
    name: 'Дом чабана 27',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57611',
    name: 'Дом чабана 28',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57613',
    name: 'Дом чабана 29',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57615',
    name: 'Дом чабана 30',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57617',
    name: 'Дом чабана 31',
    regionCode: '61',
    districtCode: '40'
  },
  {
    code: '57619',
    name: 'Дом чабана 32',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '63107', name: 'Дамешкора', regionCode: '61', districtCode: '40' },
  { code: '63115', name: 'Мунайоним', regionCode: '61', districtCode: '40' },
  { code: '63121', name: 'Тубдиспансер', regionCode: '61', districtCode: '40' },
  { code: '63123', name: 'Шевронкора', regionCode: '61', districtCode: '40' },
  {
    code: '30000',
    name: 'Мырзакентская п.а.',
    regionCode: '61',
    districtCode: '44'
  },
  { code: '30100', name: 'п. Мырзакент', regionCode: '61', districtCode: '44' },
  { code: '38100', name: 'с.Ленинжолы', regionCode: '61', districtCode: '44' },
  { code: '38200', name: 'с.Алгабас', regionCode: '61', districtCode: '44' },
  { code: '38300', name: 'с.Еркинабад', regionCode: '61', districtCode: '44' },
  {
    code: '49600',
    name: 'с. Кыдыр Мамбетулы',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '49700', name: 'с.Кызылдала', regionCode: '61', districtCode: '40' },
  { code: '30100', name: 'с.Чаян', regionCode: '61', districtCode: '36' },
  { code: '33100', name: 'с.Агибет', regionCode: '61', districtCode: '36' },
  { code: '33200', name: 'с.Алгабас', regionCode: '61', districtCode: '36' },
  { code: '33300', name: 'с.Жанаталап', regionCode: '61', districtCode: '36' },
  { code: '33400', name: 'с.Жулдыз', regionCode: '61', districtCode: '36' },
  { code: '35100', name: 'с.Акбастау', regionCode: '61', districtCode: '36' },
  { code: '35200', name: 'с.Жолгабас', regionCode: '61', districtCode: '36' },
  { code: '35400', name: 'с.Кенес', regionCode: '61', districtCode: '36' },
  { code: '35700', name: 'с.Туракты', regionCode: '61', districtCode: '36' },
  { code: '37100', name: 'с.Шакпак', regionCode: '61', districtCode: '36' },
  { code: '37200', name: 'с.Казата', regionCode: '61', districtCode: '36' },
  { code: '37300', name: 'с.Танатар', regionCode: '61', districtCode: '36' },
  { code: '37400', name: 'с.Усиктас', regionCode: '61', districtCode: '36' },
  { code: '39100', name: 'с.Алмалы', regionCode: '61', districtCode: '36' },
  { code: '39180', name: 'с.Байжансай', regionCode: '61', districtCode: '36' },
  { code: '39200', name: 'с.Жарыкбас', regionCode: '61', districtCode: '36' },
  {
    code: '39300',
    name: 'с.Байдибек ата',
    regionCode: '61',
    districtCode: '36'
  },
  { code: '45100', name: 'с.Боралдай', regionCode: '61', districtCode: '36' },
  { code: '45200', name: 'с.Амансай', regionCode: '61', districtCode: '36' },
  {
    code: '45300',
    name: 'с.Жогаргы Боралдай',
    regionCode: '61',
    districtCode: '36'
  },
  { code: '45400', name: 'с.Жыланды', regionCode: '61', districtCode: '36' },
  { code: '45500', name: 'с.Акжар', regionCode: '61', districtCode: '36' },
  { code: '45580', name: 'с.Каратас', regionCode: '61', districtCode: '36' },
  { code: '45600', name: 'с.Сарыбулак', regionCode: '61', districtCode: '36' },
  { code: '45700', name: 'с.Тайманова', regionCode: '61', districtCode: '36' },
  { code: '45800', name: 'с.Талап', regionCode: '61', districtCode: '36' },
  { code: '45880', name: 'с.Теректы', regionCode: '61', districtCode: '36' },
  { code: '45900', name: 'с.Туйетас', regionCode: '61', districtCode: '36' },
  { code: '47100', name: 'с.Актас', regionCode: '61', districtCode: '36' },
  { code: '47300', name: 'с.Кенсай', regionCode: '61', districtCode: '36' },
  { code: '47400', name: 'с.Кошкарата', regionCode: '61', districtCode: '36' },
  { code: '47600', name: 'с.Шукыршак', regionCode: '61', districtCode: '36' },
  { code: '49100', name: 'с.Шалдар', regionCode: '61', districtCode: '36' },
  { code: '49200', name: 'с.Бекбау', regionCode: '61', districtCode: '36' },
  { code: '49300', name: 'с.Екпенды', regionCode: '61', districtCode: '36' },
  { code: '49400', name: 'с.Жиенкум', regionCode: '61', districtCode: '36' },
  { code: '49500', name: 'с.Саркырама', regionCode: '61', districtCode: '36' },
  { code: '53100', name: 'с.Жамбыл', regionCode: '61', districtCode: '36' },
  { code: '53200', name: 'с.Жузумдик', regionCode: '61', districtCode: '36' },
  { code: '53300', name: 'с.Кызылжар', regionCode: '61', districtCode: '36' },
  { code: '53500', name: 'с.Таскудук', regionCode: '61', districtCode: '36' },
  { code: '53600', name: 'с.Шыбыт', regionCode: '61', districtCode: '36' },
  { code: '55100', name: 'с.Бирлик', regionCode: '61', districtCode: '36' },
  { code: '55200', name: 'с. Ынтымак', regionCode: '61', districtCode: '36' },
  { code: '55300', name: 'с.Кенестобе', regionCode: '61', districtCode: '36' },
  { code: '59100', name: 'с.Мынбулак', regionCode: '61', districtCode: '36' },
  { code: '59200', name: 'с.Акбулак', regionCode: '61', districtCode: '36' },
  { code: '59300', name: 'с.Бестогай', regionCode: '61', districtCode: '36' },
  {
    code: '59400',
    name: 'с.Кайнарбулак',
    regionCode: '61',
    districtCode: '36'
  },
  { code: '59500', name: 'с.Косбулак', regionCode: '61', districtCode: '36' },
  { code: '59600', name: 'с.Мадениет', regionCode: '61', districtCode: '36' },
  { code: '59700', name: 'с.Hура', regionCode: '61', districtCode: '36' },
  { code: '30100', name: 'с.Казыгурт', regionCode: '61', districtCode: '40' },
  { code: '33100', name: 'с.Алтынтобе', regionCode: '61', districtCode: '40' },
  { code: '33200', name: 'с.Аккум', regionCode: '61', districtCode: '40' },
  { code: '33400', name: 'с.Карабау', regionCode: '61', districtCode: '40' },
  { code: '33500', name: 'с.Каржан', regionCode: '61', districtCode: '40' },
  { code: '33600', name: 'с.Косагаш', regionCode: '61', districtCode: '40' },
  { code: '33700', name: 'с.Кырыккыз', regionCode: '61', districtCode: '40' },
  { code: '35100', name: 'с.Жанабазар', regionCode: '61', districtCode: '40' },
  {
    code: '35200',
    name: 'с.Верхний Жылыбулак',
    regionCode: '61',
    districtCode: '40'
  },
  { code: '35300', name: 'с.Жанажол', regionCode: '61', districtCode: '40' },
  { code: '35400', name: 'с.Жанаталап', regionCode: '61', districtCode: '40' },
  { code: '35500', name: 'с.Женис', regionCode: '61', districtCode: '40' }
]
